webpackJsonp([1],{

/***/ "+3jA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+9Ug":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABhWlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mSotUHOwgIpKhOlkQFREnqWIRLJS2QqsOJjd9QZOGJMXFUXAtOPhYrDq4OOvq4CoIgg8QNzcnRRcp8dyk0CLGA4f78d/zH849FxAaFaaaXeOAqllGKh4Ts7lVMfAKH4KUsxiWmKkn0osZeMbXPVVS3EV5L++6P6NXyZsM8InEc0w3LOIN4ulNS+e8TxxmJUkhPiceM2hA4keuyy6/cS46LPCeYSOTmicOE4vFDpY7mJUMlXiKOKKoGvUXsi4rnLc4q5Uaa83JXxjKaytprlMOIY4lJJCECBk1lFGBhSidGikmUnQf8/APOv4kuWRylcHIsYAqVEiOH/wPfu/WLExOuJ1CMaD7xbY/RoDALtCs2/b3sW03TwD/M3Cltf3VBjDzSXq9rUWOgL5t4OK6rcl7wOUOMPCkS4bkSH5KoVAA3s/om3JA/y3Qs+burXWP0wcgQ7tavgEODoHRIvVe93h3sHNv/9a09vcDgUFyrZPZIkwAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQflAQgCBgbONPcTAAAAGXRFWHRDb21tZW50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAARRJREFUaN7t2i8SgkAUBvBPx2gj6Rn0AJ4AD2AySaKoBzBR1K4cQA9go3ABkyYt0ixrkaTJsnYDM8Iu82bn+yoM8Jv9897O0NBaaziQJhwJIdLSKrx622ESxri+Tb1ugOVpC7/eEblgNTeJ+E2KKDxA2YcoPHK70yE/rzEa73BzYY18shiBAYyIxW4CI2bXqooRtf1WwYirI2UxIgtiGYzYyv4vRnSL8g9GfK/1yWIEsxSvSr2W1fjYnsx1XTWPiEKm7Dy5Zsgd+zDC8Vl3G28jjwTzYWL8CMATIiGEEEIIIYQQQgghhBBCCCGEEEIIIY5Buuh4gr7U66BbDtLHYjNFry0A0e5hulmgX3BLg38HEUJIYb4crVn4uadH8AAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+PNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComputeVolume__ = __webpack_require__("7BI4");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeVolumes',
  components: {
    ComputeVolume: __WEBPACK_IMPORTED_MODULE_0__ComputeVolume__["a" /* default */]
  },
  props: ['volumeContainerIds', 'computeOnlyIds']
});

/***/ }),

/***/ "+W2J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog-xxl",attrs:{"auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(" "+_vm._s(_vm.userVolumeName)+"\n       "),_c('a',{staticClass:"contextualHints",attrs:{"rel":"noopener","target":"_blank","href":_vm.shareUV,"title":"Help Sharing User Volume"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Help Sharing User Volume")])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Available SciServer Groups And Users")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered responsive hover order-column compact sciserver-datatable",attrs:{"id":"usersTable-shareFile"}},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Type")])])]),_vm._v(" "),_c('tbody')])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 setFreeSpace"},[_c('btn',{attrs:{"type":"primary","size":"lg","block":"","data-action":"auto-focus"},on:{"click":_vm.addMembers}},[_vm._v("Add")]),_vm._v(" "),_c('btn',{attrs:{"type":"primary","size":"lg","block":""},on:{"click":_vm.removeMembers}},[_vm._v("Remove Access")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Access Groups And Users")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered hover order-column compact sciserver-datatable",attrs:{"id":"membersTable-shareFile"}},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Permissions")])])]),_vm._v(" "),_c('tbody')])])])])])])]),_vm._v(" "),_c('span',[_vm._v("Make sure to click 'Save Changes' button to save your changes.")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.saveShared}},[_vm._v("Save Changes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Close")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+W60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingStatus_vue__ = __webpack_require__("AzAa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7ffa82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingStatus_vue__ = __webpack_require__("Nw6Z");
function injectStyle (ssrContext) {
  __webpack_require__("4anl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be7ffa82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7ffa82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/8ks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var parsed = __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search);
  if (parsed.token) {
    delete parsed.token;
    var newPath = '' + location.pathname + __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.stringify(parsed) + location.hash;

    history.replaceState({}, '', newPath);
  }
});

/***/ }),

/***/ "/WPw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/qBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"activityTab"}},[_c('div',{staticClass:"container-fluid wrap"},[(_vm.sciserverMessage)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"panel panel-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-body activityBody"},[_c('form',{staticClass:"form-group"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dateStart"}},[_vm._v("Start date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.from),expression:"from"}],attrs:{"name":"dateStart","id":"dateStart"},domProps:{"value":(_vm.from)},on:{"input":function($event){if($event.target.composing){ return; }_vm.from=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"dateEnd"}},[_vm._v("End date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.to),expression:"to"}],attrs:{"name":"dateEnd","id":"dateEnd"},domProps:{"value":(_vm.to)},on:{"input":function($event){if($event.target.composing){ return; }_vm.to=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Activities")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numberOfSciserverMessage),expression:"numberOfSciserverMessage"}],attrs:{"type":"number","placeholder":"100","min":"1","oninput":"validity.valid||(value='');"},domProps:{"value":(_vm.numberOfSciserverMessage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numberOfSciserverMessage=$event.target.value}}})]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("SciServer Applications")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedApplication),expression:"checkedApplication"}],staticClass:"form-control",attrs:{"id":"applicationMenu","multiple":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.checkedApplication=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.sortedApps),function(item){return _c('option',{key:item.app,domProps:{"value":item.app}},[_c('label',[_vm._v(_vm._s(item.name))])])}),0)])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"submitJobStartEnd"},on:{"click":_vm.loadMessages}},[_vm._v("Filter")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Activity Log")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.activityLog,"title":"More info on Activity Log"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("More info on Activity Log")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Refresh"},on:{"click":_vm.refreshActivity}},[_c('i',{staticClass:"fa fa-refresh",class:_vm.refreshActivitiesSpinner,attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"activityBody"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered sciserver-datatable",attrs:{"id":"sciserverTable"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin fa-5x",attrs:{"aria-hidden":"true"}})])])])])])])]):_vm._e(),_vm._v(" "),(!_vm.sciserverMessage)?_c('empty-state',{attrs:{"label":"Your Activities","description":"No activities to show.","action":false}}):_vm._e(),_vm._v(" "),_c('pop-up-dialog',{ref:"alertPopUp"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading panel-heading-style"},[_c('span',{staticClass:"panel-title"},[_vm._v("Filter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"tableHeader"},[_vm._v("Applications")]),_vm._v(" "),_c('th',{staticClass:"tableHeader"},[_vm._v("Activities")]),_vm._v(" "),_c('th',{staticClass:"tableHeader"},[_vm._v("Time")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0EwR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeNodes_vue__ = __webpack_require__("GHD6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2083944f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeNodes_vue__ = __webpack_require__("Rd+G");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeNodes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2083944f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeNodes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0PzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usersModal__ = __webpack_require__("vzr+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'addMembers',
  components: {
    usersModal: __WEBPACK_IMPORTED_MODULE_2__usersModal__["a" /* default */]
  },
  props: ['workspace', 'members'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['users'])),
  data: function data() {
    return {
      selectedUsers: [],
      name: '',
      description: '',
      owner: ''
    };
  },
  created: function created() {},

  methods: {
    selectUsers: function selectUsers(users) {
      this.selectedUsers = users;
    },
    requestAdd: function requestAdd(user, newRole, newStatus) {
      this.$emit('submitAddUsersRequest', user, newRole, newStatus);
    },
    addMembersToGroup: function addMembersToGroup() {
      __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$emit('addMembers');
      this.$refs.inviteUsersModal.startDialog();
    }
  }
});

/***/ }),

/***/ "0XGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emptyState_vue__ = __webpack_require__("lXIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f53a4b02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emptyState_vue__ = __webpack_require__("MwGA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emptyState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f53a4b02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emptyState_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0gtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":_vm.title,"auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._t("default",null,{info:_vm.info,groupInfo:_vm.groupInfo})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "18eA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1BhJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1DNd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Dxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.racmDomain)?_c('div',[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v(_vm._s(_vm.racmDomain.name))])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('span',{staticClass:"badge"},[_vm._v("RACM ID: "+_vm._s(_vm.racmDomain.id))]),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v("Compute ID: "+_vm._s(_vm.racmDomain.publisherDID))]),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[(_vm.computeDomain)?[_c('dt',[_vm._v("Name in Compute DB")]),_vm._v(" "),_c('dd',[_vm._v("\n            "+_vm._s(_vm.computeDomain.name)+"\n            "),(_vm.computeDomain.name !== _vm.racmDomain.name)?_c('span',{staticClass:"text-danger"},[_vm._v("- Different from RACM Name")]):_vm._e()]),_vm._v(" "),_c('dt',[_vm._v("Memory Limit")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("humanReadableLimit")(_vm.computeDomain.max_memory)))])]:_vm._e(),_vm._v(" "),_c('dt',[_vm._v("API Endpoint")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.racmDomain.apiEndpoint))]),_vm._v(" "),_c('dt',[_vm._v("Description")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.racmDomain.description))])],2)])]),_vm._v(" "),_c('compute-nodes',{attrs:{"node-ids":_vm.nodeIds}}),_vm._v(" "),_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading panel-headings-with-buttons"},[_c('span',[_vm._v("Compute Images")]),_vm._v(" "),(_vm.computeDomain && _vm.racmDomain)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","title":"Create New Compute Image"},on:{"click":_vm.newImage}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('compute-images',{attrs:{"image-ids":this.racmDomain.images,"compute-only-ids":_vm.imagesNotInRACM}})],1),_vm._v(" "),_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Data Volumes")]),_vm._v(" "),_c('compute-volumes',{attrs:{"volume-container-ids":this.racmDomain.volumes,"compute-only-ids":_vm.volumeContainersNotInRACM}})],1),_vm._v(" "),_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Linked Root Volumes")]),_vm._v(" "),_c('compute-root-volumes',{attrs:{"root-volume-on-compute-domain-ids":this.racmDomain.rootVolumes}})],1),_vm._v(" "),_c('register-image',{ref:"registerNewImage",attrs:{"compute-domain-id":_vm.computeDomainId,"racm-domain-id":_vm.selectedId},on:{"on-save":function($event){_vm.$emit('on-save')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1SNh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{attrs:{"for":"dateStart"}},[_vm._v("Start date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateFrom),expression:"dateFrom"}],staticStyle:{"width":"170px"},attrs:{"name":"dateStart","id":"dateStart"},domProps:{"value":(_vm.dateFrom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateFrom=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"dateEnd"}},[_vm._v("End date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dateTo),expression:"dateTo"}],staticStyle:{"width":"178px"},attrs:{"name":"dateEnd","id":"dateEnd"},domProps:{"value":(_vm.dateTo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dateTo=$event.target.value}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1qCt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Share User Volumes"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("User Volumes")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedResources),expression:"selectedResources"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedResources=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.uvResources),function(rootVolumeResources){return _c('optgroup',{key:rootVolumeResources[0].rootVolume.name,attrs:{"label":((rootVolumeResources[0].rootVolume.name) + " Volumes")}},_vm._l((rootVolumeResources),function(item){return _c('option',{key:item.id,domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.owner)+": "+_vm._s(item.name)+"\n          ")])}),0)}),0)])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-4 control-label"},[_vm._v("Allow this group to:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read")},on:{"change":function($event){_vm.checkedPrivilege="read"}}}),_vm._v("\n          Read\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write")},on:{"change":function($event){_vm.checkedPrivilege="read,write"}}}),_vm._v("\n          Read/Write\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write,delete"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write,delete")},on:{"change":function($event){_vm.checkedPrivilege="read,write,delete"}}}),_vm._v("\n          Read/Write and Delete this User Volume\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write,delete,grant"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write,delete,grant")},on:{"change":function($event){_vm.checkedPrivilege="read,write,delete,grant"}}}),_vm._v("\n          Read/Write/Delete and Share this User Volume\n        ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid},on:{"click":_vm.linkResources}},[_vm._v("Share")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1wrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareVolumeContainer',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    vcResources: function vcResources() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(this.getGrantableResources('VOLUMECONTAINER').sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (di) {
        return di.dockerComputeDomain.name;
      }).thenBy('name')), 'dockerComputeDomain.name');
    },
    isValid: function isValid() {
      return this.selectedResources && this.checkedPrivilege;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getGrantableResources'])), // computed
  data: function data() {
    return {
      selectedResources: undefined,
      checkedPrivilege: undefined,
      focused: false,
      open: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startDialog: function startDialog() {
      this.loadResources();
      this.selectedResources = undefined;
      this.checkedPrivilege = undefined;
      this.focused = true;
      this.open = true;
    },
    linkResources: function linkResources() {
      this.$emit('linkVCResources', this.selectedResources, this.checkedPrivilege);
      this.open = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadResources']))
}); // default

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2V0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareUserVolumeDialog_vue__ = __webpack_require__("joJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e24cae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareUserVolumeDialog_vue__ = __webpack_require__("1qCt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareUserVolumeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e24cae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareUserVolumeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2ZeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeTab"}},[_c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"header-content-inner"},[_c('h1',{attrs:{"id":"homeHeading"}},[_vm._v(_vm._s(_vm.applicationName)+" Dashboard")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.applicationTagline))])])])]),_vm._v(" "),_c('div',{attrs:{"id":"banner"}}),_vm._v(" "),_c('div',{staticClass:"container wrap"},[(_vm.oneclickNotebookPath && _vm.isNotebookFirstAlphaGroupMember)?_c('div',{staticClass:"row row-eq-height"},[_c('div',{staticClass:"col-md-2"},[_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v(" New (Alpha)! ")]),_vm._v(" "),_c('router-link',{attrs:{"to":("notebook/" + _vm.oneclickNotebookPath + "?copy=true")}},[_c('button',{staticClass:"btn btn-primary"},[_vm._v(" Quick Notebook ")])]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('recent-notebook-list',{ref:"recentNotebookList",attrs:{"shownum":"3","tight":"true"}})],1)]):_vm._e(),_vm._v(" "),_c('header',{directives:[{name:"show",rawName:"v-show",value:(_vm.showApplicationAppRow),expression:"showApplicationAppRow"}],staticClass:"hero-spacer"},[_c('h3',[_vm._v("Your Activities")])]),_vm._v(" "),_c('div',{staticClass:"row row-eq-height text-center"},[(_vm.isDisplayFilesTab)?_c('div',{class:_vm.tabclass},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/files","title":"Files tab"}},[_c('div',{staticClass:"thumbnail dashboard"},[(_vm.useIconsForActivities)?_c('i',{staticClass:"fa fa-file fa-3x",attrs:{"aria-hidden":"true"}}):_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"alt":"Files","src":__webpack_require__("+9Ug")}}),_vm._v(" "),_c('h4',[_vm._v("Files")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showApplicationAppRow),expression:"!showApplicationAppRow"}]},[_vm._v("Upload and access data volumes")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.getSharedVolumes)+" Shared User "+_vm._s(_vm._f("pluralize")(_vm.getSharedVolumes,'Volume'))+".")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.getOwnedVolumes)+" Owned User "+_vm._s(_vm._f("pluralize")(_vm.getOwnedVolumes,'Volume'))+".")])])])],1):_vm._e(),_vm._v(" "),_c('div',{class:_vm.tabclass},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/groups","title":"Groups tab"}},[_c('div',{staticClass:"thumbnail dashboard"},[(_vm.useIconsForActivities)?_c('i',{staticClass:"fa fa-users fa-3x",attrs:{"aria-hidden":"true"}}):_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"alt":"Groups","src":__webpack_require__("Uvt9")}}),_vm._v(" "),_c('h4',[_vm._v("Groups")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showApplicationAppRow),expression:"!showApplicationAppRow"}]},[_vm._v("Share files and other resources within a collaboration")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.invitedGroups)+" Group "+_vm._s(_vm._f("pluralize")(_vm.invitedGroups,'Invitation'))+".")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.ownerGroups)+" Owned "+_vm._s(_vm._f("pluralize")(_vm.ownerGroups,'Group'))+".")])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showApplicationAppRow),expression:"!showApplicationAppRow"}],class:_vm.tabclass},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.compute_URL,"title":"Go to Compute","rel":"noopener","target":"_blank"}},[_c('div',{staticClass:"thumbnail dashboard"},[(_vm.useIconsForActivities)?_c('i',{staticClass:"fa fa-microchip fa-3x",attrs:{"aria-hidden":"true"}}):_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"alt":"Compute","src":__webpack_require__("D/ym")}}),_vm._v(" "),_c('h4',[_vm._v("Compute")]),_vm._v(" "),_c('p',[_vm._v("Analyze data with interactive Jupyter notebooks")])])])]),_vm._v(" "),_c('div',{class:_vm.tabclass},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":_vm.computeJobs_URL,"title":"Go to Compute Jobs","rel":"noopener","target":"_blank"}},[_c('div',{staticClass:"thumbnail dashboard"},[(_vm.useIconsForActivities)?_c('i',{staticClass:"fa fa-server fa-3x",attrs:{"aria-hidden":"true"}}):_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"alt":"Compute Jobs","src":__webpack_require__("GbMj")}}),_vm._v(" "),_c('h4',[_vm._v("Compute Jobs")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showApplicationAppRow),expression:"!showApplicationAppRow"}]},[_vm._v("Submit non-interactive jobs in Python, R and others")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.runningJobs)+" "+_vm._s(_vm._f("pluralize")(_vm.runningJobs,'Job'))+" Running.")]),_vm._v(" "),_c('p',[_vm._v("You have "+_vm._s(_vm.completedJobs)+" "+_vm._s(_vm._f("pluralize")(_vm.completedJobs,'Job'))+" Completed in 24 hours.")])])])]),_vm._v(" "),(_vm.getScienceDomainLoadStatus)?_c('div',{class:_vm.tabclass},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/science","title":"Science Domains"}},[_c('div',{staticClass:"thumbnail dashboard"},[_c('i',{staticClass:"fa fa-book fa-3x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('h4',[_vm._v("Science Domains")]),_vm._v(" "),_c('p',[_vm._v("You have joined "+_vm._s(_vm.getJoinedScienceDomains)+" domains.")]),_vm._v(" "),_c('p',[_vm._v("There are "+_vm._s(_vm.getTotalScienceDomains)+" domains available.")])])])],1):_vm._e()]),_vm._v(" "),(_vm.showApplicationAppRow && _vm.appTiles.length > 0)?_c('header',{staticClass:"hero-spacer"},[_c('h3',[_vm._v(_vm._s(_vm.applicationName)+" Apps")])]):_vm._e(),_vm._v(" "),(_vm.showApplicationAppRow)?_c('div',{staticClass:"row row-eq-height text-center"},_vm._l((_vm.appTiles),function(app){return _c('div',{class:_vm.appCSS},[_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":app.serviceUrl,"title":("Go to " + (app.name)),"rel":"noopener","target":"_blank"}},[_c('div',{staticClass:"thumbnail sciserver-apps"},[_c('div',{staticClass:"image"},[('iconUrl' in app)?_c('img',{staticStyle:{"width":"35%","height":"32%"},attrs:{"alt":app.name,"src":app.iconUrl}}):('staticIcon' in app)?_c('img',{staticStyle:{"width":"35%","height":"32%"},attrs:{"alt":app.name,"src":_vm.staticImages[app.staticIcon]}}):_c('span',{class:app.glyph || 'fa fa-asterisk fa-3x'})]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(app.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(app.description))])])])])}),0):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://docs.google.com/document/d/1jmKkaOefxf2BMSpxYPMPBM3sNsoK_F3UK8k1pHmwVBc/edit","target":"_blank"}},[_c('span',{staticClass:"glyphicon glyphicon-question-sign",staticStyle:{"color":"#aaaaaa","padding-left":"10px"},attrs:{"title":"you are seeing this as a member of __SciserverNotebookFirstDemo__. Not yet General Availability"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2moA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hpcc_js_wasm__ = __webpack_require__("IurF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hpcc_js_wasm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__hpcc_js_wasm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__ = __webpack_require__("bNUd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_hpcc_js_wasm_dist_graphvizlib_wasm__ = __webpack_require__("ibVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_hpcc_js_wasm_dist_graphvizlib_wasm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_hpcc_js_wasm_dist_graphvizlib_wasm__);




var marked = __webpack_require__("EFqf");
var dompurify = __webpack_require__("OvQW");

dompurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

function extensionToModeMimeType(extension) {
    var ext = extension.toLowerCase();
    if (ext === 'py') {
        return 'text/x-python';
    } else if (ext === 'md') {
        return 'text/x-markdown';
    } else if (ext === 'java') {
        return 'text/x-java';
    } else if (ext === 'sh') {
        return 'text/x-sh';
    } else if (ext === 'js') {
        return 'text/javascript';
    } else if (ext === 'json') {
        return 'application/json';
    } else if (ext === 'scala') {
        return 'text/x-scala';
    } else if (ext === 'tex') {
        return 'text/x-stex';
    } else if (ext === 'sql') {
        return 'text/x-sql';
    } else if (ext === 'r') {
        return 'text/x-rsrc';
    } else if (ext === 'go') {
        return 'text/x-go';
    } else if (['xml', 'htm', 'html'].includes(ext)) {
        return 'text/html';
    } else if (['yaml', 'yml'].includes(ext)) {
        return 'text/x-yaml';
    } else if (['txt', 'csv', 'lis', 'dot'].includes(ext)) {
        return 'text/plain';
    }
    return null;
}

function getExtension(filename) {
    return filename.split('.').pop().toLowerCase();
}

function filenameToModeMimeType(filename) {
    return extensionToModeMimeType(getExtension(filename));
}

function extensionSupported(extension) {
    return extensionToModeMimeType(extension) !== null;
}

function fileSupported(filename) {
    return extensionSupported(getExtension(filename));
}

function isInlineExtension(extension) {
    return ['pdf', 'jpeg', 'jpg', 'gif', 'tiff', 'png', 'mov', 'mp4', 'avi', 'mp3', 'ogg', 'mpg', 'mkv', 'mpeg', 'wmv', 'swf'].includes(extension);
}

function shouldInline(filename) {
    return isInlineExtension(getExtension(filename));
}

function renderMarkdown(elem, code) {
    elem.innerHTML = dompurify.sanitize(marked(code, { headerPrefix: 'sciserverMd-hd_' }));
}

function renderHTML(elem, code) {
    elem.replaceChildren();
    var iframe = document.createElement('iframe');
    elem.appendChild(iframe);
    iframe.contentDocument.write(dompurify.sanitize(code, { FORCE_BODY: true }));
}

function renderSVG(elem, code) {
    elem.innerHTML = dompurify.sanitize(code);
    var svgElem = elem.getElementsByTagName('svg')[0];
    // the border style is unset here to enable the render error detection in graphviz, while the overflow is explicitly
    // unset as the svg pan/zoom allows navigation.
    svgElem.style.width = '100%';
    svgElem.style.height = '100%';
    elem.style.border = 'inherit';
    elem.style.overflow = 'hidden';
    var svgpan = __WEBPACK_IMPORTED_MODULE_1_svg_pan_zoom___default()(svgElem, { controlIconsEnabled: true });
    // There are a couple undersirables about this, in that a resize will lose the current focus point if the svg has
    // been moved around, but it is simple and always works (and in some ways better for a major resize). Optionally
    // could consider discovering pan/zoom of any existing svg prior to this, and update to that.
    var resizeObserver = new ResizeObserver(function () {
        svgpan.updateBBox();
        svgpan.resize();
        svgpan.fit();
        svgpan.center();
    });
    resizeObserver.observe(elem);
}

function renderDOT(elem, code) {
    __WEBPACK_IMPORTED_MODULE_0__hpcc_js_wasm__["graphviz"].layout(code, 'svg', 'dot').then(function (svg) {
        renderSVG(elem, svg);
    }).catch(function () {
        elem.style.border = '4px solid red';
    });
}

var renderFunctions = {
    md: renderMarkdown,
    svg: renderSVG,
    html: renderHTML,
    htm: renderHTML,
    dot: renderDOT
};

function getRenderFunction(filename) {
    return renderFunctions[getExtension(filename)];
}

/* harmony default export */ __webpack_exports__["a"] = ({
    extensionToModeMimeType: extensionToModeMimeType,
    getExtension: getExtension,
    filenameToModeMimeType: filenameToModeMimeType,
    extensionSupported: extensionSupported,
    fileSupported: fileSupported,
    shouldInline: shouldInline,
    getRenderFunction: getRenderFunction
});

/***/ }),

/***/ "3/lP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.name.$error }},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Compute Domain Name"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},function($event){_vm.$v.name.$touch()}],"focus":function($event){_vm.focused = true},"blur":[function($event){_vm.focused = false},function($event){_vm.$forceUpdate()}]}}),_vm._v(" "),(_vm.$v.name.$error && !_vm.$v.name.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.description.$error }},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.description),expression:"description",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"For example: compute capabilities of this domain"},domProps:{"value":(_vm.description)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.description=$event.target.value.trim()},function($event){_vm.$v.description.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.maxMemory.$error }},[_c('label',[_vm._v("Memory Limit Per Container (in bytes)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.maxMemory),expression:"maxMemory",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.maxMemory)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.maxMemory=$event.target.value.trim()},function($event){_vm.$v.maxMemory.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.maxMemory.$error && !_vm.$v.maxMemory.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Must specify an integer value. Set to 0 to not restrict memory.\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3H4Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3eRL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3epO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersList_vue__ = __webpack_require__("hyEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3405bf4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersList_vue__ = __webpack_require__("de2F");
function injectStyle (ssrContext) {
  __webpack_require__("bR8C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3405bf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MembersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3405bf4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MembersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3h7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageConfigurer_vue__ = __webpack_require__("F7q8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_147713a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageConfigurer_vue__ = __webpack_require__("aPBE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageConfigurer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_147713a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageConfigurer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3k/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeRootVolume',
  props: ['rootVolumeOnComputeDomainId'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    racmRootVolumeOnCD: function racmRootVolumeOnCD() {
      if (!this.rootVolumeOnComputeDomainId) return undefined;
      return this.$store.state.compute.racmRootVolumesOnCD[this.rootVolumeOnComputeDomainId];
    },
    rootVolume: function rootVolume() {
      return this.getMyRootVolumeById(this.racmRootVolumeOnCD.rootVolumeId);
    },
    classForConsistency: function classForConsistency() {
      return {
        'alert-success': this.consistentMetadata,
        'alert-warning': !this.consistentMetadata
      };
    },
    consistentMetadata: function consistentMetadata() {
      if (this.rootVolume === undefined || this.rootVolume.fileserviceObj === undefined) {
        return false;
      }
      return this.rootVolume.name === this.racmRootVolumeOnCD.displayName;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getMyRootVolumeById']))
});

/***/ }),

/***/ "3s5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',[_c('option'),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3wMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var jQuery = __webpack_require__("7t+N");
var apiCall = __webpack_require__("pBBg").default;

var $ = jQuery;

/* harmony default export */ __webpack_exports__["default"] = (function (_config, _divid, _resourcesManager) {
  var that = this;
  this.config = _config;
  this.rootdiv = jQuery('#' + _divid);
  this.resourcesManager = _resourcesManager;
  this.allUsers = that.config.users;
  this.allGroups = that.config.groups;
  this.initialized = false;
  // tables
  var usersAndGroupsTable = $('#usersAndGroupsTable');
  var actionsTable = $('#resourceActions');
  var rolesTable = $('#resourceRoles');
  var privilegesTable = $('#assignedPrivileges');
  var assignedRolesTable = $('#assignedRoles');

  this.resource = null;

  function addPrivilege(priv) {
    // check priv does not alreayd exist
    var privs = that.resource.privileges;
    var found = false;
    $.each(privs, function (index, value) {
      if (value.scisName === priv.scisName && value.scisType === priv.scisType && value.actionName === priv.actionName) {
        found = true;
      }
    });
    if (!found) {
      that.resource.privileges.push(priv);
    }
  }

  function refreshPrivileges() {
    var table = $('#assignedPrivileges').DataTable();
    table.clear().draw();

    var privs = that.resource.privileges;
    $.each(privs, function (index, value) {
      table.row.add([value.id == null ? '' : value.id, value.scisName, value.scisType, value.actionName]).draw(false);
    });
  }

  function addPrivileges() {
    var data = usersAndGroupsTable.DataTable().rows({
      selected: true
    }).data();
    var entities = [];
    for (var i = 0; i < data.length; i += 1) {
      var entity = { scisType: data[i][0], scisName: data[i][1] };
      entities.push(entity);
    }
    data = actionsTable.DataTable().rows({
      selected: true
    }).data();
    var actions = [];
    for (var _i = 0; _i < data.length; _i += 1) {
      var action = { id: data[_i][0], name: data[_i][1] };
      actions.push(action);
    }
    var el = entities.length;
    var al = actions.length;
    for (var ie = 0; ie < el; ie += 1) {
      var _entity = entities[ie];
      for (var ia = 0; ia < al; ia += 1) {
        var _action = actions[ia];
        var priv = {
          scisName: _entity.scisName,
          scisType: _entity.scisType,
          actionName: _action.name,
          id: null };
        addPrivilege(priv);
      }
    }
    refreshPrivileges();
  }

  function removePrivilege(priv) {
    $.each(that.resource.privileges, function (index, value) {
      if (value.scisName === priv.scisName && value.scisType === priv.scisType && value.actionName === priv.actionName) {
        that.resource.privileges.splice(index, 1);
        return false;
      }
      return undefined;
    });
  }

  function removePrivileges() {
    var data = privilegesTable.DataTable().rows({
      selected: true
    }).data();
    for (var i = 0; i < data.length; i += 1) {
      var priv = { scisName: data[i][1], scisType: data[i][2], actionName: data[i][3] };
      removePrivilege(priv);
    }
    refreshPrivileges();
  }

  function getSelectedUsersAndGroups() {
    var data = usersAndGroupsTable.DataTable().rows({
      selected: true
    }).data();
    var entities = [];
    for (var i = 0; i < data.length; i += 1) {
      var entity = { scisType: data[i][0], scisName: data[i][1] };
      entities.push(entity);
    }
    return entities;
  }

  function addRole(role) {
    // check priv does not alreayd exist
    var roles = that.resource.roles;
    var found = false;
    $.each(roles, function (index, value) {
      if (value.scisName === role.scisName && value.scisType === role.scisType && value.roleName === role.roleName) {
        found = true;
      }
    });
    if (!found) {
      that.resource.roles.push(role);
    }
  }

  function refreshRoles() {
    var table = $('#assignedRoles').DataTable();
    table.clear().draw();
    var privs = that.resource.roles;
    $.each(privs, function (index, value) {
      table.row.add([value.id, value.scisName, value.scisType, value.roleName]).draw(false);
    });
  }

  function addRoles() {
    var entities = getSelectedUsersAndGroups();
    var data = rolesTable.DataTable().rows({
      selected: true
    }).data();
    var roles = [];
    for (var i = 0; i < data.length; i += 1) {
      var role = { id: data[i][0], name: data[i][1] };
      roles.push(role);
    }
    var el = entities.length;
    var al = roles.length;
    for (var ie = 0; ie < el; ie += 1) {
      var entity = entities[ie];
      for (var ia = 0; ia < al; ia += 1) {
        var _role = roles[ia];
        var priv = {
          scisName: entity.scisName,
          scisType: entity.scisType,
          roleName: _role.name,
          id: null };
        addRole(priv);
      }
    }
    refreshRoles();
  }

  function removeRole(role) {
    $.each(that.resource.roles, function (index, value) {
      if (value.scisName === role.scisName && value.scisType === role.scisType && value.roleName === role.roleName) {
        that.resource.roles.splice(index, 1);
        return false;
      }
      return undefined;
    });
  }

  function removeRoles() {
    var data = assignedRolesTable.DataTable().rows({
      selected: true
    }).data();
    for (var i = 0; i < data.length; i += 1) {
      var role = { scisName: data[i][1], scisType: data[i][2], roleName: data[i][3] };
      removeRole(role);
    }
    refreshRoles();
  }

  function init() {
    $('#addPrivilegeButton').on('click', function () {
      return addPrivileges();
    });
    $('#removePrivilegeButton').on('click', function () {
      return removePrivileges();
    });
    $('#addRoleButton').on('click', function () {
      return addRoles();
    });
    $('#removeRoleButton').on('click', function () {
      return removeRoles();
    });
    if ($.fn.dataTable.isDataTable('#resourceActions')) {
      // trying to refresh the table
      $('#resourceActions').DataTable().clear();
    } else {
      $('#resourceActions').DataTable({
        select: true, bFilter: false, bInfo: false, bPaginate: false
      });
    }
    if ($.fn.dataTable.isDataTable('#resourceRoles')) {
      // trying to refresh the table
      $('#resourceRoles').DataTable().clear();
    } else {
      $('#resourceRoles').DataTable({
        select: true, bFilter: false, bInfo: false, bPaginate: false
      });
    }
    if ($.fn.dataTable.isDataTable('#assignedPrivileges')) {
      // trying to refresh the table
      $('#assignedPrivileges').DataTable().clear();
    } else {
      $('#assignedPrivileges').DataTable({
        select: true, bInfo: false
      });
    }
    if ($.fn.dataTable.isDataTable('#assignedRoles')) {
      // trying to refresh the table
      $('#assignedRoles').DataTable().clear();
    } else {
      $('#assignedRoles').DataTable({
        select: true, bInfo: false
      });
    }
    if ($.fn.dataTable.isDataTable('#usersAndGroupsTable')) {
      // trying to refresh the table
      $('#usersAndGroupsTable').DataTable().clear();
    } else {
      usersAndGroupsTable.DataTable({
        select: true, bInfo: false
      });
    }
  }

  function refreshUsersAndGroupsTable() {
    // storing the info in a global variable for later use.
    var table = usersAndGroupsTable.DataTable();
    var rows = [];

    table.clear();
    $.each(that.allGroups, function (index, value) {
      rows.push(['G', value.groupName, value.description ? value.description : '']);
    });
    $.each(that.allUsers, function (index, value) {
      rows.push(['U', value.username, '']);
    });
    table.rows.add(rows).draw();
  }

  function refresh(json) {
    that.resource = $.parseJSON(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
    $('#grant_resourceName').text(that.resource.resourceName);
    $('#grant_resourceid').text(that.resource.resourceId);
    $('#grant_contextclass').text(that.resource.contextClass);
    $('#grant_resourcetype').text(that.resource.rtm.name);
    $('#grant_contextuuid').text(that.resource.contextuuid);

    var rtm = that.resource.rtm;

    var table = $('#resourceActions').DataTable();
    table.clear();
    $.each(rtm.actions, function (index, value) {
      table.row.add([value.id, value.name]).draw(false);
    });

    table = rolesTable.DataTable();
    table.clear();
    $.each(rtm.roles, function (index, value) {
      table.row.add([value.id, value.name]).draw(false);
    });

    refreshPrivileges();
    refreshRoles();
  }

  function saveResourcePrivileges() {
    var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(that.resource);
    apiCall(that.config.postResourcesUrl, that.config.token, 'POST', body, refresh, null, null);
  }

  this.grant = function (resourceuuid) {
    if (!that.initialized) {
      refreshUsersAndGroupsTable();
      that.initialized = true;
    }
    var d = jQuery('#grantPrivilegesDialog').dialog({
      buttons: [{
        text: 'Save',
        click: function click() {
          saveResourcePrivileges();
          // updateCurrentGroup(that.groupManager.currentGroup);
        }
      }, {
        text: 'Close',
        click: function click() {
          jQuery(this).dialog('close');
        }
      }]
    });
    d.dialog('open');
    /*
    var req = {
    "resourceuuid" : resourceuuid
    }
    req = JSON.stringify(req);
    */
    apiCall(that.config.getPrivilegesUrl + '/?resourceuuid=' + resourceuuid, that.config.token, 'GET', null, refresh, null);
  };

  init();
});

/***/ }),

/***/ "4/hK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "48sQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resource_view_GrantPrivilegesDialog__ = __webpack_require__("mh0T");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var Config = __webpack_require__("fPVE").default;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResourcesTab',
  components: { GrantPrivilegesDialog: __WEBPACK_IMPORTED_MODULE_2__resource_view_GrantPrivilegesDialog__["a" /* default */] },
  created: function created() {
    this.$store.dispatch('loadScienceDomains', this.userProfile);
  },

  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['userProfile', 'token', 'configLinks', 'publicUsers', 'publicGroups'])),
  mounted: function mounted() {
    window.Config = new Config(this.userProfile, this.token);
  }
});

/***/ }),

/***/ "4Mhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaborationInfo_vue__ = __webpack_require__("Fhiy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d283dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaborationInfo_vue__ = __webpack_require__("E3JQ");
function injectStyle (ssrContext) {
  __webpack_require__("oia1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78d283dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollaborationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d283dc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CollaborationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4anl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "4jcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeConfigurer_vue__ = __webpack_require__("z/ze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3e92be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeConfigurer_vue__ = __webpack_require__("QEcu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeConfigurer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f3e92be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeConfigurer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4yJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumesStep_vue__ = __webpack_require__("IOKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12347235_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumesStep_vue__ = __webpack_require__("Q1Kn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumesStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12347235_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumesStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5KjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalizr__ = __webpack_require__("vNPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_flatMap__ = __webpack_require__("nfWN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_deep_extend__ = __webpack_require__("/+tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_deep_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_deep_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__files_utils__ = __webpack_require__("RswP");
















var _ = __webpack_require__("M4fF");

/* All API calls that are throttled will
wait at least this many milliseconds between calls */
var API_THROTTLE_TIME = 2000;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    fileservices: {},
    myFileserviceIdentifiers: [],
    rootVolumes: {},
    dataVolumes: {},
    userVolumes: {},
    serviceOwnedResources: [],
    /* structure:
       {
         <uservolumeId>: {
           '/some/path': { <jsonTree> },
           '/some/other/path': { <jsonTree> },
         },
         etc..
       } */
    jsonTreeCache: {},
    quotasPerFileservice: {},
    fileLinkStack: '',
    loading_status: false,
    hasFileService: true
  },
  mutations: {
    setServiceOwnedResources: function setServiceOwnedResources(state, serviceOwnedResources) {
      state.serviceOwnedResources = serviceOwnedResources;
    },
    setHasFileService: function setHasFileService(state, hasFileServiceStatus) {
      state.hasFileService = hasFileServiceStatus;
    },
    setMyFileservices: function setMyFileservices(state, listOfFileServiceIdentifiers) {
      state.myFileserviceIdentifiers = listOfFileServiceIdentifiers;
    },
    updateFileServices: function updateFileServices(state, newFileServices) {
      state.fileservices = __WEBPACK_IMPORTED_MODULE_13_deep_extend___default()({}, state.fileservices, newFileServices);
    },
    updateRootVolumes: function updateRootVolumes(state, newRootVolumes) {
      state.rootVolumes = __WEBPACK_IMPORTED_MODULE_13_deep_extend___default()({}, state.rootVolumes, newRootVolumes);
    },
    updateDataVolumes: function updateDataVolumes(state, newDataVolumes) {
      state.dataVolumes = __WEBPACK_IMPORTED_MODULE_13_deep_extend___default()({}, state.dataVolumes, newDataVolumes);
    },
    updateUserVolumes: function updateUserVolumes(state, newUserVolumes) {
      state.userVolumes = __WEBPACK_IMPORTED_MODULE_13_deep_extend___default()({}, state.userVolumes, newUserVolumes);
    },
    setJsonTreeCache: function setJsonTreeCache(state, _ref) {
      var userVolumeId = _ref.userVolumeId,
          path = _ref.path,
          jsonTree = _ref.jsonTree;

      if (!state.jsonTreeCache[userVolumeId]) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.jsonTreeCache, userVolumeId, {});
      }
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.jsonTreeCache[userVolumeId], path, jsonTree);
    },
    setQuotas: function setQuotas(state, _ref2) {
      var fileServiceIdentifier = _ref2.fileServiceIdentifier,
          listOfQuotas = _ref2.listOfQuotas;

      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state.quotasPerFileservice, fileServiceIdentifier, listOfQuotas);
    },
    updateFSLinkStack: function updateFSLinkStack(state, lastBrowsed) {
      state.fileLinkStack = lastBrowsed;
    },
    change: function change(state, loadingstat) {
      state.loading_status = loadingstat;
    }
  },
  getters: {
    getUserVolumeById: function getUserVolumeById(state) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(state.userVolumes, { id: id });
      };
    },
    getMyUserVolumeById: function getMyUserVolumeById(state, getters) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(getters.myUserVolumeObjects, { id: id });
      };
    },
    getMyDVUserVolumeById: function getMyDVUserVolumeById(state, getters) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(getters.myDataVolumeObjects, { id: id });
      };
    },
    getMyRootVolumeById: function getMyRootVolumeById(state, getters) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(getters.myRootVolumeObjects, { id: id });
      };
    },
    getRootVolumeById: function getRootVolumeById(state) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(state.rootVolumes, { id: id });
      };
    },
    getDataVolumeById: function getDataVolumeById(state) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(state.dataVolumes, { id: id });
      };
    },
    // getloadingstatus: {
    //   loading_status: state => state.loading_status,
    // },
    getFileserviceByIdentifier: function getFileserviceByIdentifier(state) {
      return function (identifier) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(state.fileservices, { identifier: identifier });
      };
    },
    /* These next three getters return a list of the original objects from the normalized JSON,
      with references to the containing object(s) */
    myFileSystemObjects: function myFileSystemObjects(state, getters) {
      return state.myFileserviceIdentifiers.map(getters.getFileserviceByIdentifier);
    },
    myRootVolumeObjects: function myRootVolumeObjects(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_11_lodash_flatMap___default()(getters.myFileSystemObjects, function (fs) {
        return __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(fs.rootVolumes, getters.getRootVolumeById).map(function (rv) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            fileserviceObj: fs
          }, rv);
        });
      });
    },
    myDataVolumeObjects: function myDataVolumeObjects(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_11_lodash_flatMap___default()(getters.myFileSystemObjects, function (fs) {
        return __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(fs.dataVolumes, getters.getDataVolumeById).map(function (dv) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            apiEndpoint: fs.apiEndpoint,
            fileserviceObj: fs,
            type: 'datavolumes'
          }, dv);
        });
      });
    },
    myUserVolumeObjects: function myUserVolumeObjects(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_11_lodash_flatMap___default()(getters.myRootVolumeObjects, function (rv) {
        return __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(rv.userVolumes, getters.getUserVolumeById).map(function (uv) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            rootVolumeObj: rv,
            fileserviceObj: rv.fileserviceObj,
            apiEndpoint: rv.fileserviceObj.apiEndpoint,
            rootVolumeName: rv.name,
            Rtype: 'USERVOLUME',
            type: 'uservolumes',
            urlSegment: rv.containsSharedVolumes ? rv.name + '/' + uv.owner + '/' + uv.name + '/' : rv.name + '/' + uv.owner + '/'
          }, uv);
        });
      });
    },
    myPersistentVol: function myPersistentVol(state, getters, rootState) {
      return _.find(getters.myUserVolumeObjects, { type: 'uservolumes', name: 'persistent', owner: rootState.userProfile.username });
    },
    myScratchVol: function myScratchVol(state, getters, rootState) {
      return _.find(getters.myUserVolumeObjects, { type: 'uservolumes', name: 'scratch', owner: rootState.userProfile.username });
    },
    lastRoute: function lastRoute(state) {
      return state.fileLinkStack;
    }
  },
  actions: {
    loadFileServices: __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default()(function (_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/storem/fileservices').then(function (response) {
        dispatch('loadExcludedResources');
        var allFileServices = __WEBPACK_IMPORTED_MODULE_8_lodash_keyBy___default()(response.data, 'identifier');
        commit('updateFileServices', allFileServices);
        commit('setMyFileservices', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(allFileServices));
        commit('setHasFileService', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(allFileServices).length !== 0);
      });
    }, API_THROTTLE_TIME, { trailing: false }),

    loadUserVolumesFromFileService: function loadUserVolumesFromFileService(_ref4, fileServiceEndpoint) {
      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get(fileServiceEndpoint + 'api/volumes/').then(function (response) {
        var userVolume = new __WEBPACK_IMPORTED_MODULE_6_normalizr__["schema"].Entity('userVolumes');
        var rootVolume = new __WEBPACK_IMPORTED_MODULE_6_normalizr__["schema"].Entity('rootVolumes', {
          userVolumes: [userVolume]
        });
        var dataVolume = new __WEBPACK_IMPORTED_MODULE_6_normalizr__["schema"].Entity('dataVolumes', {
          userVolumes: [userVolume]
        });
        var fileService = new __WEBPACK_IMPORTED_MODULE_6_normalizr__["schema"].Entity('fileservices', {
          rootVolumes: [rootVolume],
          dataVolumes: [dataVolume]
        }, { idAttribute: 'identifier' });

        var normalizedData = Object(__WEBPACK_IMPORTED_MODULE_6_normalizr__["normalize"])(response.body, fileService);
        commit('updateUserVolumes', normalizedData.entities.userVolumes);
        commit('updateRootVolumes', normalizedData.entities.rootVolumes);
        commit('updateDataVolumes', normalizedData.entities.dataVolumes);
        commit('updateFileServices', normalizedData.entities.fileservices);
      });
    },
    loadQuotaFromFileService: function loadQuotaFromFileService(_ref5, fileServiceIdentifier) {
      var getters = _ref5.getters,
          commit = _ref5.commit;

      var fileservice = getters.getFileserviceByIdentifier(fileServiceIdentifier);
      return __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get(fileservice.apiEndpoint + 'api/usage').then(function (response) {
        return commit('setQuotas', {
          fileServiceIdentifier: fileservice.identifier,
          listOfQuotas: response.body
        });
      });
    },

    loadAllQuotas: __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default()(function (_ref6) {
      var state = _ref6.state,
          dispatch = _ref6.dispatch;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(state.myFileserviceIdentifiers.map(function (id) {
        return dispatch('loadQuotaFromFileService', id);
      }));
    }, API_THROTTLE_TIME, { trailing: false }),
    loadExcludedResources: function loadExcludedResources(_ref7) {
      var commit = _ref7.commit;

      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/rest/myserviceownedresources').then(function (response) {
        commit('setServiceOwnedResources', __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(response.data.rows, function (x) {
          return x[3];
        }));
      });
    },

    loadAllUserVolumes: __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default()(function (_ref8) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch;
      return dispatch('loadFileServices').then(function () {
        return __WEBPACK_IMPORTED_MODULE_9_lodash_forEach___default()(state.fileservices, function (f) {
          return dispatch('loadUserVolumesFromFileService', f.apiEndpoint);
        });
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    loadJsonTree: function loadJsonTree(_ref9, _ref10) {
      var commit = _ref9.commit;
      var userVolumeObject = _ref10.userVolumeObject,
          path = _ref10.path;

      var url = __WEBPACK_IMPORTED_MODULE_14__files_utils__["default"].joinURLWithPath(userVolumeObject, 'api/jsontree/', path);
      var urlLevelTwo = url + '?level=2';
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].http.get(urlLevelTwo).then(function (response) {
        commit('setJsonTreeCache', {
          userVolumeId: userVolumeObject.id,
          path: path,
          jsonTree: response.body
        });
      });
    },
    createUV: function createUV(_ref11, _ref12) {
      var dispatch = _ref11.dispatch;
      var description = _ref12.description,
          path = _ref12.path,
          config = _ref12.config;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(path, { description: description }, config).then(function () {
        dispatch('loadAllUserVolumes');
      }, function (error) {
        alert('Error Message: ' + error.response.data.error);
      });
    },
    createFolder: function createFolder(_ref13, _ref14) {
      var dispatch = _ref13.dispatch;
      var path = _ref14.path,
          config = _ref14.config;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(path, '', config).then(function () {
        dispatch('loadAllUserVolumes');
      }, function (error) {
        alert('Error Message: ' + error.response.data.error);
      });
    },
    deleteFile: function deleteFile(_ref15, _ref16) {
      var dispatch = _ref15.dispatch;
      var path = _ref16.path,
          config = _ref16.config;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.delete(path, config).then(function () {
        dispatch('loadAllUserVolumes');
      }, function (error) {
        alert('Error Message: ' + error);
      });
    },
    loadLastPath: function loadLastPath(_ref17, path) {
      var commit = _ref17.commit;

      commit('updateFSLinkStack', path);
    },

    loadJsonTreeById: function loadJsonTreeById(_ref18, _ref19) {
      var dispatch = _ref18.dispatch,
          getters = _ref18.getters;
      var userVolumeId = _ref19.userVolumeId,
          path = _ref19.path,
          type = _ref19.type;
      return dispatch('loadJsonTree', type === 'uservolumes' ? { userVolumeObject: getters.getMyUserVolumeById(userVolumeId), path: path, type: type } : { userVolumeObject: getters.getMyDVUserVolumeById(userVolumeId), path: path, type: type });
    }
  }
});

/***/ }),

/***/ "5Uh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_focus__["mixin"]],
  data: function data() {
    return {
      userVolume: {},
      newVolumeName: '',
      newVolumeDescription: '',
      initialVolumeName: '',
      initialVolumeDescription: '',
      focused: false,
      open: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    invalidUVName: function invalidUVName() {
      return this.newVolumeName.includes('/');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  methods: {
    startDialog: function startDialog(volume) {
      this.userVolume = volume;
      var initialVolumeName = volume.name;
      var initialVolumeDescription = volume.description;
      this.newVolumeName = initialVolumeName;
      this.initialVolumeName = initialVolumeName;
      this.newVolumeDescription = initialVolumeDescription;
      this.initialVolumeDescription = initialVolumeDescription;
      this.focused = true;
      this.open = true;
    },
    editUserVolume: function editUserVolume() {
      var _this = this;

      if (!this.invalidUVName) {
        this.open = false;
        var config = { headers: { 'X-Auth-Token': this.token } };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.userVolume.apiEndpoint + 'api/volume/' + this.userVolume.rootVolumeObj.name + '/' + this.userVolume.owner + '/' + encodeURIComponent(this.initialVolumeName), { name: this.newVolumeName, description: this.newVolumeDescription }, config).then(function () {
          _this.$emit('userVolumeEdited');
        }, function (error) {
          alert('Error Message: ' + error.response.data.error);
        });
      }
    }
  }
});

/***/ }),

/***/ "5mnW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5qSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeAdmin_vue__ = __webpack_require__("tFW6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd5d11a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeAdmin_vue__ = __webpack_require__("edv+");
function injectStyle (ssrContext) {
  __webpack_require__("BaJ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fd5d11a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fd5d11a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5tvu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2__ = __webpack_require__("hv7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__ = __webpack_require__("+3jA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_select2_dist_css_select2_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_bootstrap_theme_dist_select2_bootstrap_css__ = __webpack_require__("LHL3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_bootstrap_theme_dist_select2_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_select2_bootstrap_theme_dist_select2_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_omit__ = __webpack_require__("Dc7M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_omit__);
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-select2',
  props: ['options', 'value', 'templateResult', 'placeholder', 'allowClear', 'matcher', 'searchMessage'],
  computed: {
    select2args: function select2args() {
      var _this = this;

      return {
        data: this.options,
        theme: 'bootstrap',
        templateResult: this.templateResult,
        placeholder: this.placeholder,
        escapeMarkup: function escapeMarkup(m) {
          return m;
        },
        minimumInputLength: 1,
        allowClear: this.allowClear,
        matcher: this.matcher,
        language: {
          inputTooShort: function inputTooShort() {
            return _this.searchMessage;
          }
        }
      };
    }
  },
  mounted: function mounted() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el)
    // init select2
    .select2(this.select2args).val(this.value).trigger('change')
    // emit event on change.
    .on('change', function (e) {
      return vm.$emit('input', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget).val());
    });
  },

  watch: {
    value: function value(_value) {
      // update value
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).val(_value).trigger('change');
    },
    select2args: function select2args(_select2args, oldargs) {
      // skip fields where new methods are generated in the computed select2args's
      var ignoredFields = ['language', 'templateResult', 'escapeMarkup'];
      if (__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_omit___default()(_select2args, ignoredFields), __WEBPACK_IMPORTED_MODULE_5_lodash_omit___default()(oldargs, ignoredFields))) {
        return;
      }
      // update options
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).empty().select2(_select2args).val(this.value).trigger('change');
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).off().select2('destroy');
  }
});

/***/ }),

/***/ "6/B9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"resourcesTab"}},[_c('div',{staticClass:"container-fluid wrap"},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"grantPrivilegesDialog"}},[_c('grant-privileges-dialog')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"resourcestab"}},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 ",attrs:{"id":"resourcesDiv"}},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading panel-heading-style"},[_c('span',{staticClass:"panel-title"},[_vm._v("Grantable Resources")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"resourcesRefreshLink","title":"Refresh"}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('p',[_vm._v("In this pre-production release, this page provides a listing of the resources you are able to grant to other users (for example, to allow them to write to a user volume, or make containers with your Docker images).")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table-bordered hover order-column compact sciserver-datatable",attrs:{"id":"resourcesTable"}},[_c('tbody',{attrs:{"id":"resourcesTableBody"}})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6D+U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Iyg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['currentUserVolume', 'path'],
  methods: {
    changeUV: function changeUV(id) {
      this.$emit('changeUV', id);
    },
    showFiles: function showFiles(index) {
      this.$emit('showFiles', index);
    },
    resetPath: function resetPath() {
      this.$emit('resetPath');
    }
  }
});

/***/ }),

/***/ "6XPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");

var RECENT_NOTEBOOKS_INDEX = '.sciserver/recent-notebooks.json';
var MAX_RECENT = 20;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RecentNotebookList',
    props: ['disabled', // parent can toggle this to only update list when visible
    'shownum', 'tight'],
    data: function data() {
        return {
            recentNotebooks: [],
            refreshTimer: null
        };
    },
    created: function created() {
        var _this = this;

        this.refreshTimer = setInterval(function () {
            _this.refreshList();
        }, 60000);
        if (this.myPersistentVol) {
            this.refreshList();
        }
    },

    watch: {
        myPersistentVol: function myPersistentVol() {
            this.refreshList();
        },
        disabled: function disabled() {
            this.refreshList();
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        indexUrl: function indexUrl() {
            return this.myPersistentVol.apiEndpoint + 'api/file/' + this.myPersistentVol.urlSegment + ('/' + RECENT_NOTEBOOKS_INDEX + '?TaskName=Notebook.Index&quiet=true');
        },
        recentNotebooksProcessed: function recentNotebooksProcessed() {
            var _this2 = this;

            return _.filter(this.recentNotebooks, function (n) {
                return n.name;
            }).map(function (n) {
                var path = n.pathIdentifiers;
                var volume = _this2.volumeInfo(path);
                var owner = _.get(volume, 'owner', '');
                var ownerInfo = _this2.$store.state.userProfile.username === owner ? '' : owner + '/';
                var volName = '' + ownerInfo + _.get(volume, 'name');
                var dir = _.split(path.path, '/').slice(0, -1).join('/');
                var filesLink = '/files/' + path.volType + '/' + path.volId + '/' + dir;
                var nbLink = '/notebook/' + path.volType + '/' + path.volId + '/' + path.path;
                var imageName = _.get(n.imageInfo, 'name');
                return {
                    name: n.name,
                    path: path,
                    imageInfo: n.imageInfo,
                    timeIndicator: _this2.formatTimeIndicator(n.time),
                    volume: volume,
                    volName: volName,
                    dir: dir,
                    filesLink: filesLink,
                    nbLink: nbLink,
                    imageName: imageName
                };
            }).slice(0, this.shownum == null ? MAX_RECENT : this.shownum);
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['myPersistentVol', 'myUserVolumeObjects', 'myDataVolumeObjects'])),
    methods: {
        refreshList: function refreshList() {
            var _this3 = this;

            if (!this.disabled) {
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.indexUrl, conf).then(function (response) {
                    _this3.recentNotebooks = _.reverse(response.data);
                }).catch(function () {});
            }
        },
        addToList: function addToList(id, path, name, imageInfo) {
            if (!name || !id) {
                return;
            }
            this.modifyList(id, path, name, imageInfo, null);
        },
        removeFromList: function removeFromList(path) {
            this.modifyList(null, path, null, null, null);
        },
        modifyList: function modifyList(id, path, name, imageInfo) {
            var _this4 = this;

            var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
            var pathIdentifiers = _.pick(path, ['volType', 'volId', 'path']);
            var indexEntry = { id: id, name: name, pathIdentifiers: pathIdentifiers, imageInfo: imageInfo, time: Date.now() };
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.indexUrl, conf).then(function (response) {
                var index = Array.isArray(response.data) ? response.data : [];
                // previous entries identifying same notebook are either the same ID, or same path
                _.remove(index, { id: id });
                _.remove(index, { pathIdentifiers: path });
                if (name && id) {
                    index.push(indexEntry);
                }
                _this4.publishIndex(_.takeRight(index, MAX_RECENT));
            }).catch(function (error) {
                // probably don't have the file, though this returns 500 in such a case...
                if (_.get(error, 'response.data.error', '').endsWith('File does not exist.') && name) {
                    var index = [indexEntry];
                    _this4.publishIndex(index);
                }
            });
        },
        publishIndex: function publishIndex(index) {
            var _this5 = this;

            var conf = { headers: { 'X-Auth-Token': this.$store.state.token,
                    'Content-Type': 'application/octet-stream' } };
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(this.indexUrl, index, conf).then(function () {
                _this5.recentNotebooks = _.reverse(index);
            });
        },
        volumeInfo: function volumeInfo(path) {
            return _.find(path.volType === 'uservolumes' ? this.myUserVolumeObjects : this.myDataVolumeObjects, { id: parseInt(path.volId, 10) });
        },
        formatTimeIndicator: function formatTimeIndicator(time) {
            if (Date.now() - time < 60 * 1000) {
                return 'a few seconds ago';
            } else if (Date.now() - time < 600 * 1000) {
                return 'a few minutes ago';
            } else if (Date.now() - time < 3600 * 1000) {
                return 'less than 1 hour ago';
            } else if (Date.now() - time < 86400 * 1000) {
                return 'less than 1 day ago';
            } else if (Date.now() - time < 7 * 86400 * 1000) {
                return 'a few days ago';
            } else if (Date.now() - time < 30 * 86400 * 1000) {
                return 'within the last month';
            }
            return 'more than a month ago';
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.refreshTimer);
    }
});

/***/ }),

/***/ "7BI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeVolume_vue__ = __webpack_require__("lbJ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e346b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeVolume_vue__ = __webpack_require__("kAB7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeVolume_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e346b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeVolume_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7EyP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skyserver.8eb01b0.png";

/***/ }),

/***/ "7vgu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DomainStep',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"], __WEBPACK_IMPORTED_MODULE_2_vue_focus__["mixin"]],
  data: function data() {
    return {
      name: '',
      description: '',
      maxMemory: 0,
      focused: false
    };
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
    },
    description: {},
    maxMemory: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      numeric: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["numeric"]
    },
    form: ['name', 'description', 'maxMemory']
  },
  methods: {
    validate: function validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    }
  }
});

/***/ }),

/***/ "8/6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComputeFrame__ = __webpack_require__("XODw");
//
//
//
//
//
//



var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ComputeFrameTest',
    components: {
        computeFrame: __WEBPACK_IMPORTED_MODULE_0__ComputeFrame__["a" /* default */]
    },
    data: function data() {
        return {
            imageInfoDefault: {
                domain: 6,
                name: 'SciServer Essentials 3.0',
                userVolumes: [],
                dataVolumes: []
            },
            forceNew: false
        };
    },
    created: function created() {
        this.$store.dispatch('loadUserComputeDomains');
        this.forceNew = _.get(this.$route.query, 'fn', false);
        this.$router.replace({ query: _.omit(this.$route.query, 'fn') });
    },

    computed: {
        imageInfo: function imageInfo() {
            if (_.get(this.$route.query, 'ij')) {
                try {
                    return JSON.parse(atob(this.$route.query.ij));
                } catch (e) {
                    console.error('could not parse image info json');
                }
            }
            var img = {};
            img.domain = parseInt(_.get(this.$route.query, 'd', this.imageInfoDefault.domain), 10);
            img.name = _.get(this.$route.query, 'n', this.imageInfoDefault.name);
            if (_.get(this.$route.query, 'uv')) {
                img.userVolumes = _.map(this.$route.query.uv.split(','), function (x) {
                    return parseInt(x, 10);
                });
            } else {
                img.userVolumes = this.imageInfoDefault.userVolumes;
            }
            if (_.get(this.$route.query, 'dv')) {
                img.dataVolumes = _.map(this.$route.query.dv.split(','), function (x) {
                    return parseInt(x, 10);
                });
            } else {
                img.dataVolumes = this.imageInfoDefault.dataVolumes;
            }
            console.log('final resolved image info:', img);
            return img;
        },
        path: function path() {
            return _.get(this.$route.query, 'p', '');
        }
    }
});

/***/ }),

/***/ "8Zdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manageLinkedAccount',
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    signOutLink: function signOutLink() {
      var href = this.$router.resolve({ route: this.$route }).href;
      var callback = '' + window.location.origin + href;
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/logout?callbackUrl=' + callback;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['linkedAccounts'])),
  created: function created() {
    this.getLinkedAccounts();
  },

  methods: {
    getLinkedAccounts: function getLinkedAccounts() {
      this.$store.dispatch('loadLinkedAccounts');
    },
    unlinkAccount: function unlinkAccount(accountID, accountName) {
      var _this = this;

      var config = { headers: { 'X-Auth-Token': this.$store.state.token, 'Content-Type': 'application/json', Accept: '*/*' } };
      var url = "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'api/accounts/' + accountID;
      if (confirm('Are you sure you want to unlink ' + accountName + '?')) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url, config).then(function () {
          _this.getLinkedAccounts();
        });
      }
    }
  }
});

/***/ }),

/***/ "8a/o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareDataVolumeDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    dvResources: function dvResources() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(this.getGrantableResources('DATAVOLUME').sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (di) {
        return di.fileService.name;
      }).thenBy('name')), 'fileService.name');
    },
    isValid: function isValid() {
      return this.selectedResources && this.checkedPrivilege;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getGrantableResources'])), // computed
  data: function data() {
    return {
      selectedResources: undefined,
      checkedPrivilege: undefined,
      focused: false,
      open: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startDialog: function startDialog() {
      this.loadResources();
      this.selectedResources = undefined;
      this.checkedPrivilege = undefined;
      this.focused = true;
      this.open = true;
    },
    linkResources: function linkResources() {
      this.$emit('linkDVResources', this.selectedResources, this.checkedPrivilege);
      this.open = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadResources']))
}); // default

/***/ }),

/***/ "8p1D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('p',[_vm._v("This page doesn't appear to exist in SciServer. Please "),_c('a',{attrs:{"title":"report bug or suggest feedback","href":"http://www.sciserver.org/support/bug-report-and-suggestion-form/"}},[_vm._v("contact us")]),_vm._v(" to let us know how this happened.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "94Ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeApp_vue__ = __webpack_require__("8/6o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4565cad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeApp_vue__ = __webpack_require__("APis");
function injectStyle (ssrContext) {
  __webpack_require__("RaCr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4565cad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "94sV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applicationConfiguration__ = __webpack_require__("uYv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__titleMixin__ = __webpack_require__("nD3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RecentNotebookList__ = __webpack_require__("Nj2m");
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'NotebookDash',
    components: {
        RecentNotebookList: __WEBPACK_IMPORTED_MODULE_2__RecentNotebookList__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__titleMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__applicationConfiguration__["a" /* default */]],
    data: function data() {
        return {
            title: 'Notebooks'
        };
    }
});

/***/ }),

/***/ "9JyY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilesTab_vue__ = __webpack_require__("Lk58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c047a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilesTab_vue__ = __webpack_require__("oKTs");
function injectStyle (ssrContext) {
  __webpack_require__("1BhJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilesTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10c047a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilesTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Qic":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcesTab_vue__ = __webpack_require__("48sQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b8bb52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcesTab_vue__ = __webpack_require__("6/B9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcesTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3b8bb52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcesTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9uGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Editor"}},[_c('div',{attrs:{"id":"editWrapper"}},[_c('div',{attrs:{"id":"editorControls"}},[_c('div',{staticClass:"editorControl",staticStyle:{"background-color":"#337ab7","color":"white","height":"24px","text-align":"middle","padding-left":"8px","padding-top":"2px"},attrs:{"id":"filename"}},[_c('span',{staticStyle:{"margin":"auto","font-weight":"bold"}},[_vm._v(_vm._s(_vm.filename))]),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove",staticStyle:{"float":"right","cursor":"pointer","margin-right":"10px","margin-top":"2px"},on:{"click":_vm.close}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticStyle:{"background-color":"#ffffff","color":"#000000","height":"24px","padding":"2px"}},[(_vm.editMode)?_c('button',{staticClass:"btn btn-secondary btn-xs",on:{"click":_vm.setViewMode}},[_vm._v(" view ")]):_c('button',{staticClass:"btn btn-primary btn-xs"},[_vm._v(" viewing ")]),_vm._v(" "),(_vm.writeable)?_c('span',[(_vm.editMode)?_c('button',{staticClass:"btn btn-primary btn-xs"},[_vm._v(" editing ")]):_c('button',{staticClass:"btn btn-secondary btn-xs",on:{"click":_vm.setEditMode}},[_vm._v(" edit ")]),_vm._v(" "),(_vm.hasRenderFunction)?_c('span',[(_vm.dualView)?_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":_vm.setDualMode}},[_vm._v(" dual ")]):_c('button',{staticClass:"btn btn-secondary btn-xs",on:{"click":_vm.setDualMode}},[_vm._v(" dual ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.editMode)?_c('span',[(_vm.autoSave)?_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":_vm.toggleAutoSave}},[_vm._v(" autosave ")]):_c('button',{staticClass:"btn btn-secondary btn-xs",on:{"click":_vm.toggleAutoSave}},[_vm._v(" autosave ")]),_vm._v(" "),(_vm.inSave || !_vm.dirty)?_c('button',{staticClass:"btn btn-secondary btn-xs"},[_vm._v(" save ")]):_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":_vm.save}},[_vm._v(" save ")]),_vm._v(" "),_c('span',{staticStyle:{"color":"#666666"}},[(_vm.inSave)?_c('span',[_c('em',[_vm._v(" saving... ")])]):_c('span',[_vm._v(" last save: "+_vm._s(_vm.lastSaveTimeStamp)+" ")])])]):_vm._e()])]),_vm._v(" "),(_vm.shouldInline)?_c('div',{staticClass:"content",staticStyle:{"top":"24px"}},[_c('iframe',{staticClass:"contentFrame",attrs:{"src":(_vm.filepath + "?inline=true")}})]):(_vm.finalError)?_c('div',{staticClass:"content contentMessage"},[_vm._v("\n      There was an unrecoverable error in loading or viewing this file: "),_c('br'),_vm._v("\n      "+_vm._s(_vm.finalError)+" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.close}},[_vm._v(" Close ")])]):(_vm.promptLoad)?_c('div',{staticClass:"content contentMessage"},[(_vm.largeFile)?_c('span',[_vm._v(" You are trying to load a large file, you may experience long load times and difficulty in editing. "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.unkownType)?_c('span',[_vm._v("  There is no built in rendering for this file type and it does not appear to be text.  "),_c('br')]):_vm._e(),_vm._v("\n      Would you still like to load? "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.acceptedLoad = true}}},[_vm._v(" OK ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.downloadAndClose}},[_vm._v(" Download ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":_vm.close}},[_vm._v(" Close ")])]):(_vm.validatedPath)?_c('div',{staticClass:"content",staticStyle:{"display":"flex"},on:{"mousemove":_vm.doresize,"mouseup":_vm.stopresize,"keydown":function($event){if(!('button' in $event)&&$event.keyCode!==83){ return null; }if(!$event.ctrlKey){ return null; }$event.preventDefault();return _vm.save($event)}}},[(_vm.loading && !_vm.loaded)?_c('div',{staticClass:"content contentMessage"},[_vm._v("\n        Loading... "),_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]):_vm._e(),_vm._v(" "),(_vm.showEditor)?_c('codemirror',{ref:"editor",staticStyle:{"top":"8px","flex":"1","min-width":"50%"},attrs:{"options":_vm.cmOptions},on:{"ready":_vm.cmReady,"input":_vm.contentUpdate},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRender && _vm.showEditor),expression:"showRender && showEditor"}],staticStyle:{"flex":"1","min-width":"5px","max-width":"5px","margin":"3px","background-color":"silver","cursor":"col-resize"},on:{"mousedown":_vm.startresize}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRender),expression:"showRender"}],ref:"renderbox",staticClass:"markdown-render",staticStyle:{"padding":"10px","flex":"1","overflow":"auto","position":"relative"},attrs:{"id":"renderbox","status":_vm.rendering}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9zyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Support Links","size":"sm","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('a',{staticStyle:{"text-decoration":"underline","font-size":"14px"},attrs:{"href":"http://www.sciserver.org/support/help/","title":"Go to User Guide","rel":"noopener","target":"_blank"}},[_vm._v("User guides")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"underline","font-size":"14px"},attrs:{"href":"http://www.sciserver.org/support/documentation/","title":"Go to API Documentation","rel":"noopener","target":"_blank"}},[_vm._v("API documentation")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"underline","font-size":"14px"},attrs:{"href":"mailto:sciserver-helpdesk@jhu.edu","title":"Email to help desk"}},[_vm._v("Help desk")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticStyle:{"text-decoration":"underline","font-size":"14px"},attrs:{"href":"http://www.sciserver.org/support/bug-report-and-suggestion-form/","title":"Report Bug","rel":"noopener","target":"_blank"}},[_vm._v("Bug report form")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-action":"auto-focus"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Close")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A+g3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A597":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserver_compute_jobs.c8a2c86.png";

/***/ }),

/***/ "APis":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","width":"100%","height":"100%","top":"0px","left":"0px"}},[_c('compute-frame',{attrs:{"imageInfo":_vm.imageInfo,"path":_vm.path,"noReuse":_vm.forceNew}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AvMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//





var $ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collaboration'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    ownerUserName: function ownerUserName() {
      return this.getUserById(__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(this.collaboration.members, { role: 'OWNER' }).id).username;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getUserById'])),
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$on('acceptClicked', function () {
      _this.acceptChange();
    });
    __WEBPACK_IMPORTED_MODULE_3__main__["EventBus"].$on('declineClicked', function () {
      _this.declineChange();
    });
  },

  methods: {
    acceptChange: function acceptChange() {
      $('#acceptButton').prop('disabled', true);
      $('#declineButton').prop('disabled', true);
      $('#acceptButton').html('Accepting ...');
    },
    declineChange: function declineChange() {
      $('#acceptButton').prop('disabled', true);
      $('#declineButton').prop('disabled', true);
      $('#declineButton').html('Declining ...');
    }
  }
});

/***/ }),

/***/ "AzAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'LoadingStatus',
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['loadingAction', 'loadingStatusIcon']))
});

/***/ }),

/***/ "BQry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d56b9d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("8p1D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d56b9d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BSWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageLinkedAccount_vue__ = __webpack_require__("8Zdh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda0af34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manageLinkedAccount_vue__ = __webpack_require__("ucpX");
function injectStyle (ssrContext) {
  __webpack_require__("6D+U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cda0af34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manageLinkedAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cda0af34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manageLinkedAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BaJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BjVa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Brm7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C+pg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RootVolumes_vue__ = __webpack_require__("Df1i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c1dd6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RootVolumes_vue__ = __webpack_require__("LsGW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RootVolumes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72c1dd6b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RootVolumes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CR0T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CcZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenameMoveDialog_vue__ = __webpack_require__("Wxpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3101ace8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenameMoveDialog_vue__ = __webpack_require__("OLHM");
function injectStyle (ssrContext) {
  __webpack_require__("1DNd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3101ace8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenameMoveDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3101ace8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenameMoveDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ClkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeImage_vue__ = __webpack_require__("w0C8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8a1b4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeImage_vue__ = __webpack_require__("asFW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8a1b4d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D/ym":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABhWlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mSotUHOwgIpKhOlkQFREnqWIRLJS2QqsOJjd9QZOGJMXFUXAtOPhYrDq4OOvq4CoIgg8QNzcnRRcp8dyk0CLGA4f78d/zH849FxAaFaaaXeOAqllGKh4Ts7lVMfAKH4KUsxiWmKkn0osZeMbXPVVS3EV5L++6P6NXyZsM8InEc0w3LOIN4ulNS+e8TxxmJUkhPiceM2hA4keuyy6/cS46LPCeYSOTmicOE4vFDpY7mJUMlXiKOKKoGvUXsi4rnLc4q5Uaa83JXxjKaytprlMOIY4lJJCECBk1lFGBhSidGikmUnQf8/APOv4kuWRylcHIsYAqVEiOH/wPfu/WLExOuJ1CMaD7xbY/RoDALtCs2/b3sW03TwD/M3Cltf3VBjDzSXq9rUWOgL5t4OK6rcl7wOUOMPCkS4bkSH5KoVAA3s/om3JA/y3Qs+burXWP0wcgQ7tavgEODoHRIvVe93h3sHNv/9a09vcDgUFyrZPZIkwAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQflAQgCHgpFmSNhAAAAGXRFWHRDb21tZW50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAARpJREFUaN7t2SESgkAYhuFPx0gj4QUs2LbYbFIsnAATBS+A2W0WtZD0BGRsNIsmLQSqFEhaTFitMu46Mt92hv/d2X0IdPI8r9GC1anruhUhXbRkMYQhilbv80cy7D0f2+vjy6MYsIMIe2+gR62LnGAWV4r21YS7OyAcajhat6JSeEAqFDdedob8R8jzXqI8S0yFgBACYrpCpmuqbPX2XolzWeL+bBiShg4cP0bx660uYviOgzBtGDKWCZLIhfXrEMtFlCSQ4y9/Rw5zgcVR3dyj5QmbCS871aJaVItqUS2qRbWoFtWiWlSLalEtqkW1qBbVolpUiyE6Q/qWqXAcE1ZfU8gwXCOwDQURBuxg3ehHaCO1eEcYwpD/XC9hYOykjRxpCQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "DA7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_union__ = __webpack_require__("SJ4O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clipboard_copy__ = __webpack_require__("XinO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clipboard_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_clipboard_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notebook_utils__ = __webpack_require__("qyQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__titleMixin__ = __webpack_require__("nD3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notebook_ComputeDomainChooser__ = __webpack_require__("a/MN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notebook_RenameMoveDialog__ = __webpack_require__("CcZR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__notebook_Terminal__ = __webpack_require__("aZKy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__notebook_RecentNotebookList__ = __webpack_require__("Nj2m");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var _ = __webpack_require__("M4fF");

var TITLE_PREFIX = 'SciServer Notebooks';
var NOTEBOOK_INIT_TIMEOUT = 30; // number of poll intervals (not seconds)
var NOTEBOOK_RELOAD_TRIES = 3;
var NOTEBOOK_POLL_INTERVAL = 3000; // milliseconds between poll actions
var BEACON_INTERVAL = 60000; // 1 minute
var INACTIVE_TIMEOUT = 3600000; // 1 hour
var RECENT_EDIT = INACTIVE_TIMEOUT;
var loadstate = {
    NONE: 0,
    LOADING: 1,
    LOADED: 2
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'NotebookTab',
    components: {
        ComputeDomainChooser: __WEBPACK_IMPORTED_MODULE_8__notebook_ComputeDomainChooser__["a" /* default */],
        RenameMoveDialog: __WEBPACK_IMPORTED_MODULE_9__notebook_RenameMoveDialog__["a" /* default */],
        Terminal: __WEBPACK_IMPORTED_MODULE_10__notebook_Terminal__["a" /* default */],
        RecentNotebookList: __WEBPACK_IMPORTED_MODULE_11__notebook_RecentNotebookList__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_7__titleMixin__["a" /* default */]],
    mounted: function mounted() {},

    data: function data() {
        return {
            pageTitle: TITLE_PREFIX,
            connected: false,
            notebookState: loadstate.NONE,
            persistentVol: null,
            scratchVol: null,
            showTerminal: false,
            imageInfo: null,
            readOnlyMode: false,
            writable: true,
            lastEditTime: 0,
            pendingMetadataSave: false,
            notebookContents: null,
            computeId: null,
            jupyter: null,
            poller: null,
            notebookReloadTries: NOTEBOOK_RELOAD_TRIES,
            notebookInitTimeout: NOTEBOOK_INIT_TIMEOUT,
            error: null,
            warning: null,
            loadMessage: 'loading...',
            lastActivity: Date.now(),
            lastBeacon: Date.now()
        };
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('computeCookie', this.$store.state.token, { secure: true });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('computeToken', this.$store.state.token, { secure: true });
        this.$store.dispatch('loadUserComputeDomains');
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        user: function user() {
            return this.$store.state.userProfile.username;
        },
        sourceVolume: function sourceVolume() {
            var volid = parseInt(this.$route.params.volId, 10);
            if (this.$route.params.volType === 'datavolumes') {
                return this.myDataVolumeObjects.filter(function (vol) {
                    return vol.id === volid;
                }).pop();
            }
            return this.myUserVolumeObjects.filter(function (vol) {
                return vol.id === volid;
            }).pop();
        },
        notebookPath: function notebookPath() {
            var _this = this;

            if (!this.$route.params.path) {
                this.$router.replace('/notebook');
                return null;
            }
            if (this.sourceVolume && !this.notebookContents) {
                var url = this.sourceVolume.apiEndpoint + 'api/file';
                if (this.$route.params.volType === 'datavolumes') {
                    url = url + '/' + this.sourceVolume.name;
                } else {
                    url = url + '/' + this.sourceVolume.urlSegment;
                }
                if (this.$route.params.path === null) {
                    console.warning('short circuited null notebook');return null;
                }
                url = url + '/' + this.$route.params.path + '.ipynb?TaskName=Dashboard.Notebook.ReadNotebook';
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, conf).then(function (response) {
                    _this.notebookContents = response.data;
                }).catch(function () {
                    _this.$refs.recentNotebookList.removeFromList(_this.$route.params);
                    _this.$router.replace('/notebook?nf=1');
                });
            }
            if (this.$route.query.copy) {
                if (this.notebookContents) {
                    var nbname = '.sciserver/new-notebook-' + Date.now();
                    var _url = this.myPersistentVol.apiEndpoint + 'api/file/' + this.myScratchVol.urlSegment + nbname + '.ipynb?TaskName=Dashboard.Notebook.CopyNotebook';
                    var _conf = { headers: { 'X-Auth-Token': this.$store.state.token,
                            'Content-Type': 'application/octet-stream' } };
                    if (this.$route.query.empty) {
                        this.notebookContents.cells = [];
                    }
                    _.set(this.notebookContents, 'metadata.sciserver.copySource', this.$route.params);
                    // unset notebook ID so we can assign a new one via shared logic
                    _.set(this.notebookContents, 'metadata.sciserver.notebookId', undefined);
                    _.set(this.notebookContents, 'metadata.sciserver.notebookId', this.notebookId);
                    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(_url, this.notebookContents, _conf).then(function () {
                        _this.$router.replace('/notebook/uservolumes/' + _this.myScratchVol.id + '/' + nbname);
                    });
                }
            } else if (this.sourceVolume) {
                if (this.sourceVolume.type === 'datavolumes') {
                    return this.sourceVolume.name + '/' + this.$route.params.path + '.ipynb';
                }
                return '' + this.sourceVolume.urlSegment + this.$route.params.path + '.ipynb';
            }
            return null;
        },
        computeBootstrapped: function computeBootstrapped() {
            var _this2 = this;

            if (this.notebookContents && !this.imageInfo && this.notebookPath) {
                this.imageInfo = _.get(this.notebookContents, 'metadata.sciserver.imageInfo');
                if (!this.imageInfo) {
                    this.setError('Error: notebook has no image information, please modify compute environment');
                    setTimeout(this.$refs.imageChooser.startDialog, 750);
                    return false;
                }
            }
            if (this.imageInfo && this.computeDataVolumes) {
                this.pendingMetadataSave = true;
                // we have obtained all we need, and systems go. add to notbook index
                this.$refs.recentNotebookList.addToList(this.notebookId, this.$route.params, this.notebookName, this.imageInfo);
                var cachedContainer = _.get(this.imageInfo, 'cachedContainer.' + this.user);
                if (cachedContainer) {
                    // really need to check if container is still valid here.
                    this.computeId = cachedContainer;
                    return true;
                }
                this.loadMessage = 'creating your container...';
                var url = "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/domains/' + this.imageInfo.domain + '/containers';
                var conf = { headers: {
                        'X-Auth-Token': this.$store.state.token,
                        'Content-Type': 'application/json',
                        'X-Description': 'NOTEBOOK' } };
                // persistent and scratch added each time. Flag to prevent adding if they were
                // removed by user?
                this.imageInfo.userVolumes = __WEBPACK_IMPORTED_MODULE_4_array_union___default()(this.imageInfo.userVolumes, [this.myPersistentVol.id, this.myScratchVol.id, this.sourceVolume.id]);
                var data = {
                    dockerImageName: this.imageInfo.name,
                    volumeContainers: this.computeDataVolumes,
                    userVolumes: this.imageInfo.userVolumes.map(function (i) {
                        return { userVolumeId: i };
                    }) };
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data, conf).then(function (response) {
                    _this2.computeId = parseInt(response.data, 10);
                    _.set(_this2.imageInfo, 'cachedContainer.' + _this2.user, _this2.computeId);
                });
                return true;
            }
            return false;
        },
        computeNotebookUrl: function computeNotebookUrl() {
            if (this.computeBootstrapped && this.computeId) {
                this.resetLoadStatus();
                return "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/go?id=' + this.computeId + '&path=/notebooks/' + this.notebookPath;
            }
            return null;
        },
        ready: function ready() {
            return this.notebookState === loadstate.LOADED && !this.error;
        },
        notebookId: function notebookId() {
            return _.get(this.notebookContents, 'metadata.sciserver.notebookId', btoa(this.user + Date.now().toString()));
        },
        notebookName: function notebookName() {
            if (this.notebookPath) {
                var name = this.notebookPath.split('/').pop().replace('.ipynb', '');
                this.pageTitle = TITLE_PREFIX + ' - ' + name;
                return name;
            }
            return null;
        },
        isTempFile: function isTempFile() {
            if (!this.notebookName) {
                return false;
            }
            if (this.sourceVolume === this.myScratchVol) {
                return true;
            }
            return this.notebookName.startsWith('new-notebook-');
        },
        notebookDir: function notebookDir() {
            if (this.notebookPath) {
                return this.notebookPath.split('/').slice(0, -1).join('/');
            }
            return null;
        },
        computeDomain: function computeDomain() {
            return this.imageInfo ? this.getUserComputeDomainById(this.imageInfo.domain) : null;
        },
        computeDomainName: function computeDomainName() {
            return this.computeDomain ? this.computeDomain.name : null;
        },
        computeImageName: function computeImageName() {
            return this.imageInfo ? this.imageInfo.name : null;
        },
        computeUserVolumes: function computeUserVolumes() {
            var _this3 = this;

            if (this.computeDomain) {
                return this.computeDomain.userVolumes.filter(function (i) {
                    return _this3.imageInfo.userVolumes.includes(i.id);
                });
            }
            return null;
        },
        computeDataVolumes: function computeDataVolumes() {
            var _this4 = this;

            if (this.computeDomain) {
                return this.computeDomain.volumes.filter(function (i) {
                    return _this4.imageInfo.dataVolumes.includes(i.publisherDID);
                });
            }
            return null;
        },
        mountedVolumes: function mountedVolumes() {
            var _this5 = this;

            if (this.imageInfo) {
                return this.myUserVolumeObjects.filter(function (i) {
                    return _this5.imageInfo.userVolumes.includes(i.id);
                });
            }
            return [];
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isAdmin', 'myUserVolumeObjects', 'myDataVolumeObjects', 'getUserVolumeById', 'getDataVolumeById', 'myPersistentVol', 'myScratchVol', 'getUserComputeDomainById'])),
    methods: {
        setError: function setError(msg) {
            this.loadMessage = null;
            this.error = msg;
        },
        resetLoadTimers: function resetLoadTimers() {
            this.loadMessage = 'opening notebook session...';
            this.error = null;
            this.notebookInitTimeout = NOTEBOOK_INIT_TIMEOUT;
            this.notebookReloadTries = NOTEBOOK_RELOAD_TRIES;
        },
        resetLoadStatus: function resetLoadStatus() {
            var _this6 = this;

            this.resetLoadTimers();
            this.notebookState = loadstate.NONE;
            clearInterval(this.poller);
            this.poller = setInterval(function () {
                return _this6.polling();
            }, NOTEBOOK_POLL_INTERVAL);
        },
        polling: function polling() {
            var _this7 = this;

            if (this.notebookState !== loadstate.LOADED && this.notebookInitTimeout > 0) {
                this.notebookInitTimeout -= 1;
                if (this.notebookInitTimeout < 25) {
                    this.loadMessage = 'still working on loading your notebook...';
                }
                if (this.notebookInitTimeout < 15) {
                    this.loadMessage = '...hmmm, this is taking a bit long, but still trying...';
                }
            } else if (this.notebookState !== loadstate.LOADED) {
                this.notebookState = loadstate.NONE;
                this.setError('We\'re sorry, there seems to have been a problem loading your notebook');
            }
            if (this.notebookState === loadstate.LOADING && this.$refs.notebookFrame.contentDocument.readyState === 'complete') {
                try {
                    // a hack, until we can get state by API
                    var errdd = this.$refs.notebookFrame.contentDocument.getElementsByTagName('dd');
                    if (errdd && errdd.length === 3 && errdd[1].innerText === 'Container not found') {
                        _.set(this.imageInfo, 'cachedContainer.' + this.user, null);
                        this.computeId = null;
                        return;
                    }
                    __WEBPACK_IMPORTED_MODULE_6__notebook_utils__["a" /* default */].jupyterClassicVisualModifications(this.$refs.notebookFrame);
                    this.jupyter = this.$refs.notebookFrame.contentWindow.Jupyter;
                    if (!this.jupyter.notebook._fully_loaded) {
                        console.log('Notebook frame loaded, but notebook not fully loaded!');
                        throw new Error('Notebook not fully loaded');
                    }
                    console.log('Notebook is fully loaded and ready!');
                    // The underlying writablilty of the file on filesystem. This is presumably
                    // immutable, so we keep separate from the readOnlyMode setting (and gate by it)
                    this.writable = this.jupyter.notebook.writable;
                    console.log('writable flag from jupyter: ', this.jupyter.notebook.writable);
                    if (this.writable) {
                        // If recently edited by another user, automatically start in RO
                        var lastEditUser = _.get(this.notebookContents, 'metadata.sciserver.lastEdit.user');
                        var lastEditTime = _.get(this.notebookContents, 'metadata.sciserver.lastEdit.time');
                        if (lastEditUser !== this.user && Date.now() - lastEditTime < RECENT_EDIT) {
                            this.readOnlyMode = true;
                            this.$notify({
                                group: 'top_center_notify',
                                type: 'warn',
                                text: 'Notebook was edited by user <b>' + lastEditUser + '</b> within the last hour. Opening readonly - toggle if you are sure you want to write.',
                                duration: 8000
                            });
                        }
                    } else {
                        this.$notify({
                            group: 'top_center_notify',
                            type: 'warn',
                            text: 'No write permission on notebook, opening read-only. Not edits will be saved!',
                            duration: 5000
                        });
                        this.readOnlyMode = true;
                    }
                    this.notebookState = loadstate.LOADED;
                    this.resetLoadTimers();
                    this.addActivityTimers();
                    this.$refs.notebookFrame.contentWindow.onbeforeunload = function () {
                        _this7.notebookState = loadstate.NONE;
                    };
                } catch (err) {
                    console.log('notebook loading error: ', err);
                    if (this.notebookReloadTries > 0) {
                        this.notebookReloadTries -= 1;
                        this.$refs.notebookFrame.src = this.computeNotebookUrl;
                    }
                }
            }
            // large notebooks may complete the html/js load before
            // they are mutable. Wait for loaded condition to write
            // updated image info.
            if (this.pendingMetadataSave && this.notebookState === loadstate.LOADED) {
                console.log('notebook fully loaded:', this.jupyter.notebook._fully_loaded);
                if (this.jupyter.notebook._fully_loaded) {
                    _.set(this.jupyter.notebook, 'metadata.sciserver.imageInfo', this.imageInfo);
                    _.set(this.jupyter.notebook, 'metadata.sciserver.notebookId', this.notebookId);
                    this.jupyter.notebook.dirty = !this.readOnlyMode;
                    this.pendingMetadataSave = false;
                }
            }
            // Main long poll. Keep container going by pinging compute
            // if activity detected and timeout session when inactive
            // for configured amount of time.
            //
            // The ping should automatically cause a redirect to login
            // when token expires, but should also be checking for
            // connectivity and put warning up when disconnected
            var beaconTime = Date.now() - this.lastBeacon;
            var inactiveTime = Date.now() - this.lastActivity;
            if (this.notebookState === loadstate.LOADED && beaconTime > BEACON_INTERVAL && inactiveTime < BEACON_INTERVAL) {
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/container/' + this.computeId + '/ping');
                this.lastBeacon = Date.now();
            }
            if (inactiveTime > INACTIVE_TIMEOUT) {
                clearInterval(this.poller);
                this.setError('session paused due to inactivity, press any key to continue');
                this.$refs.notebookApp.addEventListener('keydown', this.reload);
                this.$refs.notebookApp.addEventListener('mouseup', this.reload);
            } else if (inactiveTime > INACTIVE_TIMEOUT * 0.85) {
                this.warning = 'are you there? Your session will timeout due to inactivity soon';
            } else {
                this.warning = null;
            }
            // save the notebook if it gets dirty (meaning edited and not reflected on disk) and
            // hasn't been saved recently
            if (this.notebookState === loadstate.LOADED) {
                this.jupyter.notebook.writable = !this.readOnlyMode;
                if (this.jupyter.notebook.dirty) {
                    if (Date.now() - this.lastEditTime > 15000) {
                        this.lastEditTime = Date.now();
                        _.set(this.jupyter.notebook.metadata, 'sciserver.lastEdit', { user: this.user, time: this.lastEditTime });
                        this.jupyter.notebook.save_notebook();
                    }
                }
            }
        },
        reload: function reload() {
            this.$router.go();
        },
        notebookLoad: function notebookLoad() {
            this.resetActivity();
            this.notebookState = loadstate.LOADING;
        },
        resetActivity: function resetActivity() {
            this.lastActivity = Date.now();
        },
        addActivityTimers: function addActivityTimers() {
            this.$refs.notebookApp.addEventListener('mousemove', this.resetActivity);
            this.$refs.notebookApp.addEventListener('keydown', this.resetActivity);
            this.$refs.notebookFrame.contentWindow.addEventListener('mousemove', this.resetActivity);
            this.$refs.notebookFrame.contentWindow.addEventListener('keydown', this.resetActivity);
        },
        toClipboard: function toClipboard(data) {
            __WEBPACK_IMPORTED_MODULE_5_clipboard_copy___default()(data);
            this.$notify({ group: 'top_center_notify', text: 'copied to clipboard', duration: 1000 });
            return false;
        },
        toggleReadMode: function toggleReadMode() {
            if (this.readOnlyMode) {
                this.readOnlyMode = !confirm('Any changes made during read-only mode will be written out. Are you sure?');
            } else {
                this.readOnlyMode = true;
            }
        },
        getLink: function getLink() {
            this.toClipboard(window.location.origin + window.location.pathname);
            return false;
        },
        computeDVtoFSId: function computeDVtoFSId(datavol) {
            return _.get(_.find(this.myDataVolumeObjects, { displayName: datavol.name }), 'id');
        },
        openImageChooser: function openImageChooser() {
            this.$refs.imageChooser.startDialog();
        },
        imageInfoModified: function imageInfoModified(newInfo) {
            this.error = null;
            var cachedContainer = newInfo.cachedContainer;
            newInfo.cachedContainer = _.get(this.imageInfo, 'cachedContainer');
            _.set(this.imageInfo, 'cachedContainer.' + this.user, cachedContainer);
            this.imageInfo = newInfo;
        },
        openMoveDialog: function openMoveDialog() {
            if (this.notebookState !== loadstate.LOADED) {
                this.$notify({ group: 'top_center_notify',
                    text: 'Please wait until fully loaded to rename or move',
                    type: 'warning',
                    duration: 1000 });
            } else {
                this.$refs.moveDialog.startDialog();
            }
        },
        moveNotebook: function moveNotebook(location) {
            var _this8 = this;

            var fsPath = '' + location.volume.urlSegment + location.path + '.ipynb';
            // this is not pretty, but jupyter only allows relative renames within notebook
            var currentNParts = this.notebookPath.split('/').slice(0, -1).length;
            var renamePath = '' + '../'.repeat(currentNParts) + fsPath;
            var url = '/notebook/uservolumes/' + location.volume.id + '/' + location.path;
            this.notebookState = loadstate.NONE;
            this.loadMessage = 'renaming notebook, please hold tight...';
            this.jupyter.notebook.save_notebook().then(function () {
                _this8.jupyter.notebook.rename(renamePath).then(function () {
                    _this8.jupyter.notebook.notebook_path = fsPath;
                    _this8.jupyter.notebook.session.rename_notebook(fsPath);
                    _this8.$router.replace(url);
                }).catch(function () {
                    _this8.$notify({ group: 'top_center_notify',
                        type: 'error',
                        text: 'error renaming notebook!' });
                    _this8.notebookLoad();
                });
            }).catch(function () {
                _this8.$notify({ group: 'top_center_notify',
                    type: 'error',
                    text: 'could not save notebook prior to move!' });
                _this8.notebookLoad();
            });
        }
    }
});

/***/ }),

/***/ "DG3W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShareDockerImages',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    dockerResources: function dockerResources() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(this.getGrantableResources('DOCKERIMAGE').sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (di) {
        return di.dockerComputeDomain.name;
      }).thenBy('name')), 'dockerComputeDomain.name');
    },
    isValid: function isValid() {
      return this.selectedResources && this.checkedPrivilege;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getGrantableResources'])), // computed
  created: function created() {},

  data: function data() {
    return {
      selectedResources: undefined,
      checkedPrivilege: undefined,
      open: false,
      focused: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startDialog: function startDialog() {
      this.loadResources();
      this.selectedResources = undefined;
      this.checkedPrivilege = undefined;
      this.focused = true;
      this.open = true;
    },
    linkResources: function linkResources() {
      this.$emit('linkDIResources', this.selectedResources, this.checkedPrivilege);
      this.open = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadResources']))
}); // default

/***/ }),

/***/ "DNP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcesList_vue__ = __webpack_require__("uGIV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49472800_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcesList_vue__ = __webpack_require__("a6aK");
function injectStyle (ssrContext) {
  __webpack_require__("w0ot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-49472800"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourcesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49472800_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourcesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DT6N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DZMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUsageDialog_vue__ = __webpack_require__("g8X+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d58e27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUsageDialog_vue__ = __webpack_require__("cQEK");
function injectStyle (ssrContext) {
  __webpack_require__("VflN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33d58e27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUsageDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d58e27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUsageDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Df1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['currentRootVolumes', 'selectedVolumeType'],
  methods: {
    changeVolumesType: function changeVolumesType(item) {
      this.$emit('changeVolumesType', item);
    }
  }
});

/***/ }),

/***/ "Dghi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addMembersButton_vue__ = __webpack_require__("0PzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae92a8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addMembersButton_vue__ = __webpack_require__("G1Vt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addMembersButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae92a8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addMembersButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DnSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__files_utils__ = __webpack_require__("RswP");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  data: function data() {
    return {
      newFolderName: '',
      open: false,
      focused: false
    };
  },
  props: ['userVolume', 'path'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    invalidUVName: function invalidUVName() {
      return this.newFolderName.includes('/');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  methods: {
    startDialog: function startDialog() {
      this.newFolderName = '';
      this.focused = true;
      this.open = true;
    },
    createSubFolder: function createSubFolder() {
      var _this = this;

      this.open = false;
      var config = { headers: { 'X-Auth-Token': this.token } };
      var url = __WEBPACK_IMPORTED_MODULE_5__files_utils__["default"].joinURLWithFileName(this.userVolume, 'api/folder/', this.path, this.newFolderName);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, '', config).then(function () {
        _this.$emit('newSubFolderCreated');
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].notify({
          group: 'top_center_notify',
          text: 'Successfully created new folder',
          duration: 1000,
          type: 'success'
        });
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].notify({
          group: 'top_center_notify',
          text: '' + error.response.data.error,
          duration: 1000,
          type: 'warn'
        });
      });
      this.newFolderName = '';
      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "E3JQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading panel-headings-with-buttons"},[(!_vm.isEditting || !_vm.canEditName)?_c('span',{staticClass:"panel-title collaboration-name"},[_vm._v(_vm._s(_vm.collaboration.name))]):_c('span',{staticClass:"panel-title collaboration-name",staticStyle:{"color":"black"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newName),expression:"newName"}],attrs:{"placeholder":"Name"},domProps:{"value":(_vm.newName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-sm"},[(_vm.isEditable && !_vm.isEditting)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","aria-label":"Edit Collaboration"},on:{"click":_vm.startEditting}},[_c('span',{staticClass:"glyphicon glyphicon-pencil",attrs:{"aria-hidden":"true"}})]):_vm._e()])]),_vm._v(" "),(_vm.collaboration.description || _vm.isEditting)?_c('div',{staticClass:"panel-body"},[(!_vm.isEditting)?[_vm._v("\n      "+_vm._s(_vm.collaboration.description)+"\n      "),(_vm.collaboration.term)?_c('span',[_c('b',[_vm._v("Term: ")]),_vm._v(_vm._s(_vm.collaboration.term))]):_vm._e(),_vm._v(" "),(_vm.collaboration.year)?_c('span',[_c('b',[_vm._v("Year: ")]),_vm._v(_vm._s(_vm.collaboration.year))]):_vm._e()]:[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newDescription),expression:"newDescription"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],style:(_vm.editCollaborationDescriptionStyle),attrs:{"rows":"5","autocapitalize":"sentences","spellcheck":"true","placeholder":"Optional Description"},domProps:{"value":(_vm.newDescription)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.newDescription=$event.target.value}}}),_vm._v(" "),_c('btn',{staticClass:"pull-right",attrs:{"type":"default"},on:{"click":function($event){_vm.isEditting = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('btn',{staticClass:"pull-right",attrs:{"type":"success"},on:{"click":_vm.save}},[_vm._v("Save")])]],2):_vm._e(),_vm._v(" "),_c('pop-up-dialog',{ref:"alertPopUp"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E9NE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Create Compute Domain","size":"lg","footer":false,"transition-duration":0},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form-wizard',{attrs:{"color":"#3498db","shape":"tab","title":"","subtitle":"","finishButtonText":"Create Domain"},on:{"on-complete":_vm.finishDomain}},[_c('tab-content',{attrs:{"title":"New Domain","before-change":function (){ return _vm.validateStep('step1'); }}},[_c('domain-step',{ref:"step1",on:{"on-validate":_vm.mergePartialModels}})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Nodes","before-change":function (){ return _vm.validateStep('nodesStep'); }}},[_c('nodes-step',{ref:"nodesStep",on:{"on-validate":_vm.mergePartialModels}})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Images","before-change":function (){ return _vm.validateStep('imagesStep'); }}},[_c('images-step',{ref:"imagesStep",on:{"on-validate":_vm.mergePartialModels}})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Data Volumes","before-change":function (){ return _vm.validateStep('volumesStep'); }}},[_c('volumes-step',{ref:"volumesStep",on:{"on-validate":_vm.mergePartialModels}})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"User Volumes","before-change":function (){ return _vm.validateStep('userVolumesStep'); }}},[_c('user-volumes-step',{ref:"userVolumesStep",on:{"on-validate":_vm.mergePartialModels}})],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Summary"}},[(!_vm.savingDomain)?[_vm._v("\n      Once this wizard is finished, the \""+_vm._s(_vm.finalModel.name)+"\" domain will be created as follows:\n      "),_c('ul',{staticClass:"summary-list"},[(_vm.finalModel.description)?_c('li',[_vm._v("Description: "+_vm._s(_vm.finalModel.description))]):_c('li',[_vm._v("No Description")]),_vm._v(" "),(parseInt(_vm.finalModel.maxMemory, 10))?_c('li',[_vm._v("RAM Limit Per Container: "+_vm._s(_vm._f("humanReadableLimit")(_vm.finalModel.maxMemory)))]):_c('li',[_vm._v("No RAM Limit")]),_vm._v(" "),(_vm.finalModel.nodes)?_c('li',[_vm._v(_vm._s(_vm.finalModel.nodes.length)+" "+_vm._s(_vm._f("pluralize")(_vm.finalModel.nodes.length,'node')))]):_vm._e(),_vm._v(" "),(_vm.finalModel.images)?_c('li',[_vm._v(_vm._s(_vm.finalModel.images.length)+" "+_vm._s(_vm._f("pluralize")(_vm.finalModel.images.length,'image')))]):_vm._e(),_vm._v(" "),(_vm.finalModel.volumes)?_c('li',[_vm._v(_vm._s(_vm.finalModel.volumes.length)+" data "+_vm._s(_vm._f("pluralize")(_vm.finalModel.volumes.length,'volume')))]):_vm._e(),_vm._v(" "),(_vm.finalModel.rootVolumesOnCD)?_c('li',[_vm._v("linked with "+_vm._s(_vm.finalModel.rootVolumesOnCD.length)+" root "+_vm._s(_vm._f("pluralize")(_vm.finalModel.rootVolumesOnCD.length,'volume')))]):_vm._e()])]:_c('domain-saver',{ref:"domainSaver",attrs:{"final-model":_vm.finalModel}})],2)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ea37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ExJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = redirectionToLoginPortal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__remove_token_from_url__ = __webpack_require__("/8ks");


function redirectionToLoginPortal() {
  // Remove ?token to avoid having multiple ?token= query parameters
  Object(__WEBPACK_IMPORTED_MODULE_0__remove_token_from_url__["a" /* default */])();
  var callbackURL = encodeURIComponent(window.location.href);
  window.location.href = "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/login?callbackUrl=' + callbackURL;
}

/***/ }),

/***/ "F7q8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImageConfigurer',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    if (this.initialData) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.initialData);
    }
    return {
      name: '',
      description: '',
      dockerRef: '',
      containerManagerClass: 'org.sciserver.compute.core.container.DefaultExecutableManager'
    };
  },

  computed: {
    submitButtonMessage: function submitButtonMessage() {
      if (this.isEditing) {
        return 'Save Changes';
      }
      return 'Add Image';
    }
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    description: {},
    dockerRef: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    containerManagerClass: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    form: ['name', 'description', 'dockerRef', 'containerManagerClass']
  },
  methods: {
    attemptSave: function attemptSave() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      if (isValid) {
        this.$emit('on-save', this.$data);
      }
    }
  }
});

/***/ }),

/***/ "FbNc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserver-notebook-loading.e14a883.gif";

/***/ }),

/***/ "Fhiy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sharedComponents_alertDialog__ = __webpack_require__("pqqY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['collaboration'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_focus__["mixin"]],
  components: {
    popUpDialog: __WEBPACK_IMPORTED_MODULE_1__sharedComponents_alertDialog__["a" /* default */]
  },
  data: function data() {
    return {
      isEditting: false,
      newDescription: '',
      newName: '',
      focused: false
    };
  },
  computed: {
    isEditable: function isEditable() {
      return this.canEditName || this.canEditDescription;
    },
    isDeletable: function isDeletable() {
      return this.collaboration._links.delete;
    },
    isLeavable: function isLeavable() {
      return this.collaboration._links.leave;
    },
    canEditName: function canEditName() {
      return this.collaboration._links.editName;
    },
    canEditDescription: function canEditDescription() {
      return this.collaboration._links.editDescription;
    },
    canShareResource: function canShareResource() {
      return this.collaboration._links.shareResource;
    },
    isWorkspace: function isWorkspace() {
      return this.collaboration.type === 'WORKSPACE';
    },

    editCollaborationDescriptionStyle: function editCollaborationDescriptionStyle() {
      return {
        width: '100%'
      };
    }
  },
  methods: {
    startEditting: function startEditting() {
      this.newDescription = this.collaboration.description;
      this.newName = this.collaboration.name;
      this.focused = true;
      this.isEditting = true;
    },
    save: function save() {
      var _this = this;

      this.isEditting = false;
      var updatedInfo = {};
      if (this.canEditName) updatedInfo.name = this.newName;
      if (this.canEditDescription) updatedInfo.description = this.newDescription;
      if (this.collaboration.type === 'COURSEWARE') {
        updatedInfo.courseNumber = this.collaboration.courseNumber;
        updatedInfo.term = this.collaboration.term;
        updatedInfo.year = this.collaboration.year;
        this.$http.post(this.collaboration._links.editDescription.href, updatedInfo).then(function () {
          _this.$store.dispatch('loadCollaborations');
        }).catch(function (e) {
          // TODO: Real error handling
          _this.$refs.alertPopUp.showAlert(e, 'Error message');
        });
      } else {
        this.$http.patch(this.collaboration._links.editDescription.href, updatedInfo).then(function () {
          _this.$store.dispatch('loadCollaborations');
        }).catch(function (e) {
          // TODO: Real error handling
          _this.$refs.alertPopUp.showAlert(e, 'Error message');
        });
      }
    }
  },
  watch: {
    collaboration: function collaboration(newCollaboration, oldCollaboration) {
      if (newCollaboration._links.self.href !== oldCollaboration._links.self.href) {
        this.isEditting = false;
      }
    }
  }
});

/***/ }),

/***/ "FkwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEditDialog_vue__ = __webpack_require__("Jx6T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21aad65d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEditDialog_vue__ = __webpack_require__("tk7n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupEditDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21aad65d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupEditDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs7G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/scidrive.d123c27.png";

/***/ }),

/***/ "FxQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotebookTab_vue__ = __webpack_require__("DA7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6877c206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotebookTab_vue__ = __webpack_require__("yBuX");
function injectStyle (ssrContext) {
  __webpack_require__("lv8+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotebookTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6877c206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotebookTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G1Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addMembers"}},[_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":_vm.addMembersToGroup}},[_c('span',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('users-modal',{ref:"inviteUsersModal",attrs:{"workspace":_vm.workspace,"gMembers":_vm.members},on:{"submitAddUsersRequest":_vm.requestAdd}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GHD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeNodes',
  props: ['nodeIds'],
  computed: {
    nodeNames: function nodeNames() {
      var _this = this;

      return this.nodeIds.map(function (x) {
        return _this.$store.state.compute.computeNodes[x].name;
      }).join(', ');
    }
  }
});

/***/ }),

/***/ "GQi5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__redirectionToLoginPortal__ = __webpack_require__("ExJh");


var alreadyClosing = false;

function handleError(statusCode, requestURL, jsonResponse, errorThrown, textStatus) {
  if (alreadyClosing) return;
  if (statusCode === 401) {
    alert('You have logged out or your session has expired. Please login again.');
    alreadyClosing = true;
    Object(__WEBPACK_IMPORTED_MODULE_0__redirectionToLoginPortal__["a" /* default */])();
  } else {
    var err = jsonResponse ? jsonResponse.error : errorThrown;
    var stat = textStatus ? ': Status: ' + textStatus : '';
    console.error('Error when connecting to URL [' + requestURL + '] : ' + err + ' ' + stat);
  }
}

/***/ }),

/***/ "Gaas":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GbMj":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAABhWlDQ1BJQ0MgcHJvZmlsZQAAKJF9kTtIw1AUhv+mSotUHOwgIpKhOlkQFREnqWIRLJS2QqsOJjd9QZOGJMXFUXAtOPhYrDq4OOvq4CoIgg8QNzcnRRcp8dyk0CLGA4f78d/zH849FxAaFaaaXeOAqllGKh4Ts7lVMfAKH4KUsxiWmKkn0osZeMbXPVVS3EV5L++6P6NXyZsM8InEc0w3LOIN4ulNS+e8TxxmJUkhPiceM2hA4keuyy6/cS46LPCeYSOTmicOE4vFDpY7mJUMlXiKOKKoGvUXsi4rnLc4q5Uaa83JXxjKaytprlMOIY4lJJCECBk1lFGBhSidGikmUnQf8/APOv4kuWRylcHIsYAqVEiOH/wPfu/WLExOuJ1CMaD7xbY/RoDALtCs2/b3sW03TwD/M3Cltf3VBjDzSXq9rUWOgL5t4OK6rcl7wOUOMPCkS4bkSH5KoVAA3s/om3JA/y3Qs+burXWP0wcgQ7tavgEODoHRIvVe93h3sHNv/9a09vcDgUFyrZPZIkwAAAAGYktHRAD/AP8A/6C9p5MAAAAJcEhZcwAALiMAAC4jAXilP3YAAAAHdElNRQflAQgCCiXA5sltAAAAGXRFWHRDb21tZW50AENyZWF0ZWQgd2l0aCBHSU1QV4EOFwAAAPRJREFUaN7tl68OglAYxQ/OzcILaKJRro3iE5gsNGfRoslE0puZyWTSAo1G1iegGCkENpK8gMV0zRR1zCl/zmlfu799Z/t+V0vTVKEB0ZRSjQDpoCEhCEEI0hKQbnG8YG1JRJV/9gju9YAxq/Xz6BC2C+/swbUF9M+r9Xp93837GvenR/iOCQAYbn0YvQlmQV6/jRjCLMymMOpZrSxOCnMSZ2WqFUFaFuQfQfJghfljA2c5wO20xy7My4BUIXfEocQibNFB5H+EIHQtuhZdi65F16Jr0bXoWnQtuhZdi65F16Jr0bXoWnQt3hGCEIQgBCFITfMEeq2PDbSN2FsAAAAASUVORK5CYII="

/***/ }),

/***/ "Ggrg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GvmV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GzRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _this = this;

//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'JqueryCalendar',
  computed: {},
  props: ['from', 'to'],
  data: function data() {
    return {
      dateFrom: _this.from,
      dateTo: _this.to
    };
  },
  watch: {},
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=dateStart]').datetimepicker({
      onChangeDateTime: function onChangeDateTime(dp, $input) {
        _this2.$emit('changedFrom', $input.val());
        _this2.dateFrom = $input.val();
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=dateEnd]').datetimepicker({
      onChangeDateTime: function onChangeDateTime(dp, $input) {
        _this2.$emit('changedTo', $input.val());
        _this2.dateTo = $input.val();
      }
    });
  },

  methods: {
    clearAll: function clearAll() {
      this.$emit('changedFrom', '');
      this.dateFrom = '';
      this.$emit('changedTo', '');
      this.dateTo = '';
    }
  }
});

/***/ }),

/***/ "HNft":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootVolumes__ = __webpack_require__("C+pg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbForFile__ = __webpack_require__("uVBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sharedComponents_alertDialog__ = __webpack_require__("pqqY");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var $ = __webpack_require__("7t+N");
var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");
var fileUtils = __webpack_require__("RswP").default;
var mathUtils = __webpack_require__("jIKD").default;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'copyFiles',
  data: function data() {
    return {
      path: '',
      owner: '',
      rootName: '',
      rootVName: '',
      shared: false,
      url: '',
      loading: false,
      parentURL: '',
      selected: [],
      open: false,
      selectedVolumeType: 'uservolumes',
      selectedUVId: ''
    };
  },
  components: {
    RootVolumeTemplate: __WEBPACK_IMPORTED_MODULE_7__RootVolumes__["a" /* default */],
    BreadCrumb: __WEBPACK_IMPORTED_MODULE_8__BreadcrumbForFile__["a" /* default */],
    popUpDialog: __WEBPACK_IMPORTED_MODULE_9__sharedComponents_alertDialog__["a" /* default */]
  },
  created: function created() {
    this.getVolumes();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isShowingFiles: function isShowingFiles() {
      return this.currentUserVolume;
    },
    currentRootVolumes: function currentRootVolumes() {
      var rv = [];
      if (this.myRootVolumeObjects) {
        rv.push({ name: 'User Volumes', type: 'uservolumes', id: 1 });
      }
      if (this.myDataVolumeObjects) {
        rv.push({ name: 'Data Volumes', type: 'datavolumes', id: 2 });
      }
      return rv;
    },
    currentListOfUV: function currentListOfUV() {
      if (this.selectedVolumeType === 'uservolumes') {
        return fileUtils.getCurrentUVList(this.myUserVolumeObjects);
      } else if (this.selectedVolumeType === 'datavolumes') {
        return fileUtils.getCurrentDVList(this.myDataVolumeObjects);
      }
      return undefined;
    },
    currentUserVolume: function currentUserVolume() {
      var id = this.selectedUVId;
      if (id === undefined || this.myUserVolumeObjects.length === 0) {
        return undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.currentListOfUV, { id: parseInt(id, 10) });
    },
    listToDisplay: function listToDisplay() {
      if (this.currentUserVolume) {
        return this.currentFiles;
      }
      return this.currentListOfUV;
    },
    sortedVolumes: function sortedVolumes() {
      var sortAll = _.orderBy(this.listToDisplay, ['type', 'name']);
      return sortAll;
    },
    username: function username() {
      return this.userProfile.username;
    },
    currentFiles: function currentFiles() {
      var _this = this;

      if (!this.currentUserVolume) return [];
      var jsonTree = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.$store.state.files.jsonTreeCache, [this.currentUserVolume.id, this.path]);
      return __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(jsonTree, 'root.folders', []), function (folder) {
        return {
          name: folder.name,
          type: 'dir',
          owner: _this.currentUserVolume.owner,
          size: folder.size ? mathUtils.bytesToSize(folder.size) : '',
          modified: folder.lastModified === null ? '' : moment(folder.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }), __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(jsonTree, 'root.files', []), function (file) {
        return {
          name: file.name,
          type: 'file',
          size: file.size === null ? '' : mathUtils.bytesToSize(file.size),
          modified: file.lastModified === null ? '' : moment(file.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }));
    },
    columnFields: function columnFields() {
      if (this.selectedVolumeType === 'uservolumes') {
        return ['Volume', 'Root Volume', 'Owner'];
      } else if (this.selectedVolumeType === 'datavolumes') {
        return ['Data Sets', 'Folders', ''];
      }
      return undefined;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'myRootVolumeObjects', 'myDataVolumeObjects'])),
  watch: {
    currentUserVolume: function currentUserVolume(uv) {
      if (uv) {
        this.getFiles();
      }
    },
    path: function path() {
      if (this.currentUserVolume) {
        this.getFiles();
      }
    }
  },
  // All the methods you want the view to have access to, basically an object of functions
  methods: {
    getVolumes: function getVolumes() {
      this.$store.dispatch('loadAllUserVolumes');
    },
    getFiles: function getFiles() {
      this.$store.dispatch('loadJsonTreeById', { userVolumeId: this.currentUserVolume.id, path: this.path, type: this.currentUserVolume.type });
    },
    changeUV: function changeUV(id) {
      this.path = '';
      this.selectedUVId = id;
    },
    goToFiles: function goToFiles(name) {
      this.path += '/' + name;
    },
    showFiles: function showFiles(index) {
      var allPath = this.path.split('/');
      var len = allPath.length - 1;
      allPath.splice(index + 1, len);
      var strPath = allPath.join('/');
      this.path = '' + strPath;
    },
    copy: function copy(selectedFile, url) {
      this.parentURL = url;
      this.resetPath();
      this.selected = selectedFile;
      this.open = true;
    },
    paste: function paste() {
      var _this2 = this;

      this.$store.commit('loadingStatus', ['Copying', 'True']);
      $('#spinner2').show();
      if (Array.isArray(this.selected)) {
        $.each(this.selected, function (index0, text0) {
          _this2.confirmPaste(text0.name);
        });
      } else {
        this.confirmPaste(this.selected.name);
      }
    },
    confirmPaste: function confirmPaste(selectedName) {
      var _this3 = this;

      var filepath = this.currentUserVolume.type + '/' + this.currentUserVolume.name + this.path;
      var actionUrl = this.currentUserVolume.type + '/' + this.$route.params.userVolumeId + this.path;
      var actionObject = {
        actionName: 'Copying',
        actionFileName: selectedName,
        actionLocation: filepath,
        actionStatus: 'True'
      };
      this.$store.commit('updateMessage', actionObject);
      var selected = this.checkIfFileFolderExists(selectedName);
      var encodedSelectedName = encodeURIComponent(selectedName);
      var config = { headers: { 'X-Auth-Token': this.$store.state.token } };
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(this.parentURL + '/' + encodedSelectedName + '?replaceExisting=false&doCopy=true', { destinationPath: this.path + '/' + selected,
        destinationRootVolume: this.currentUserVolume.type === 'uservolumes' ? this.currentUserVolume.rootVolumeObj.name : null,
        destinationUserVolume: this.currentUserVolume.type === 'uservolumes' ? decodeURIComponent(this.currentUserVolume.name) : null,
        destinationDataVolume: this.currentUserVolume.type === 'uservolumes' ? null : decodeURIComponent(this.currentUserVolume.name),
        destinationOwnerName: this.currentUserVolume.type === 'uservolumes' ? this.currentUserVolume.owner : null,
        destinationFileService: null }, config).then(function () {
        _this3.getFiles();
        _this3.$emit('copiedSuccess');
        that.$store.commit('loadingStatus', '');
        actionObject = {
          actionName: 'Copying',
          actionFileName: selectedName,
          actionLocation: '' + filepath,
          actionStatus: 'False'
        };
        that.$store.commit('updateMessage', actionObject);
        $('#spinner2').hide();
      }, function (error) {
        actionObject = {
          actionName: 'Copying',
          actionFileName: selectedName,
          actionLocation: '' + filepath,
          actionStatus: 'False',
          actionRequired: 'True',
          actionurl: '' + actionUrl,
          actionMessage: error.response.data.error
        };
        that.$store.commit('updateMessage', actionObject);
        $('#spinner2').hide();
      });
    },
    close: function close() {
      this.$emit('close');
    },
    checkIfFileFolderExists: function checkIfFileFolderExists(fileFolderName) {
      var found = this.listToDisplay.find(function (uv) {
        return uv.name === fileFolderName;
      });
      var newName = fileFolderName;
      var index = 1;
      while (found) {
        newName = fileFolderName + ' (' + index + ')';
        index += 1;
        found = this.ifFileExists(newName);
      }
      return newName;
    },
    ifFileExists: function ifFileExists(newName) {
      var found = this.listToDisplay.find(function (uv) {
        return uv.name === newName;
      });
      return found;
    },
    changeVolumesType: function changeVolumesType(type) {
      this.selectedVolumeType = fileUtils.changeVolumesType(type);
      this.resetPath();
    },
    resetPath: function resetPath() {
      this.selectedUVId = undefined;
      this.path = '';
    }
  }
});

/***/ }),

/***/ "HnMz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IIeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("StcR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e3abb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("ZXz2");
function injectStyle (ssrContext) {
  __webpack_require__("5mnW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35e3abb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e3abb0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IOKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VolumeConfigurer__ = __webpack_require__("xtG+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VolumesStep',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    VolumeConfigurer: __WEBPACK_IMPORTED_MODULE_1__VolumeConfigurer__["a" /* default */]
  },
  data: function data() {
    return {
      volumes: [],
      isEditing: false,
      currentlyEditingIndex: undefined
    };
  },
  validations: {
    volumes: {},
    form: ['volumes']
  },
  methods: {
    validate: function validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
    saveVolume: function saveVolume(newVolume) {
      if (this.currentlyEditingIndex === undefined) {
        this.volumes.push(newVolume);
      } else {
        this.volumes[this.currentlyEditingIndex] = newVolume;
        this.currentlyEditingIndex = undefined;
      }
      this.isEditing = false;
    },
    startEditing: function startEditing(index) {
      this.currentlyEditingIndex = index;
      this.isEditing = true;
    },
    cancelEdit: function cancelEdit() {
      this.isEditing = false;
      this.currentlyEditingIndex = undefined;
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modules */
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr__ = __webpack_require__("vNPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_extend__ = __webpack_require__("/+tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_deep_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_deep_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__ = __webpack_require__("KgVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_notification__ = __webpack_require__("CLX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__files__ = __webpack_require__("5KjM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__jobs__ = __webpack_require__("WZ7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__courses__ = __webpack_require__("YhQx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__compute__ = __webpack_require__("bfo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scienceDomains__ = __webpack_require__("PpVR");






/* node-deep-extend is used to recurisvely
 merge object properties, but override arrays.
 For example, when merging group information, we
 want to keep the latest member list, not a union
 of old and new members. */

















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_notification___default.a);

/* All API calls that are throttled will
wait at least this many milliseconds between calls */
var API_THROTTLE_TIME = 2000;

var modules = {
  files: __WEBPACK_IMPORTED_MODULE_15__files__["a" /* default */],
  jobs: __WEBPACK_IMPORTED_MODULE_16__jobs__["a" /* default */],
  compute: __WEBPACK_IMPORTED_MODULE_18__compute__["a" /* default */],
  course: __WEBPACK_IMPORTED_MODULE_17__courses__["a" /* default */],
  science: __WEBPACK_IMPORTED_MODULE_19__scienceDomains__["a" /* default */]
};

var initialState = {
  userProfile: {},
  token: undefined,
  myCollaborations: [],
  publicGroups: [],
  publicUsers: [],
  collaborations: {},
  collaborationLinks: [],
  configLinks: [],
  userActivities: [],
  groups: {},
  users: {},
  resources: [],
  /* either NOTLOADED, LOADING, LOADED, or RELOADING */
  userActivitiesStatus: 'NOTLOADED',
  collaborationLoadingStatus: 'NOTLOADED',
  configLoadingStatus: 'NOTLOADED',
  resourceLoadingStatus: 'NOTLOADED',
  groupLinkStack: '',
  linkedAccounts: [],
  actionName: '', // Name of the action
  actionFileName: '', // Name of the file for the action
  actionStatus: false, // Status for the action on the file
  actionArray: [],
  responseArray: [], // actions that require response like failed upload
  numOfNotifications: 0,
  loadingAction: '',
  loadingStatusIcon: false,
  sortingStatus: '+name',
  loadScienceDomains: false,
  totalScienceDomains: 0,
  joinedScienceDomains: 0,
  collaborationResponse: {}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  modules: modules,
  state: initialState,
  getters: {
    lastGroupRoute: function lastGroupRoute(state) {
      return state.groupLinkStack;
    },

    isAdmin: function isAdmin(state, getters) {
      return getters.getGroupIds.find(function (g) {
        return __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(getters.getCollaborationById(g), 'name') === 'admin';
      }) !== undefined;
    },
    userIdForUserName: function userIdForUserName(state) {
      return function (name) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(state.users, { username: name }).id;
      };
    },
    getGroupById: function getGroupById(state) {
      return function (id) {
        return state.groups[id];
      };
    },
    getUserById: function getUserById(state) {
      return function (id) {
        return state.users[id];
      };
    },
    getCollaborationById: function getCollaborationById(state) {
      return function (id) {
        return state.collaborations[id];
      };
    },
    getGroupIds: function getGroupIds(state, getters) {
      return state.myCollaborations.filter(function (id) {
        return __WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(getters.getCollaborationById(id), 'type') === 'GROUP';
      });
    },
    getMembershipIn: function getMembershipIn(state, getters) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(getters.getCollaborationById(id), 'members'), { id: state.userProfile.id });
      };
    },
    getRoleIn: function getRoleIn(state, getters) {
      return function (collaborationId) {
        return getters.getMembershipIn(collaborationId).role;
      };
    },
    getStatusIn: function getStatusIn(state, getters) {
      return function (collaborationId) {
        return getters.getMembershipIn(collaborationId).status;
      };
    },
    getGrantableResources: function getGrantableResources(state) {
      return function (resourceType) {
        return __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(state.resources, function (r) {
          return r.type === resourceType && __WEBPACK_IMPORTED_MODULE_8_lodash_findIndex___default()(r.allowedActions, { category: 'G' }) >= 0;
        });
      };
    },
    getResourceDetails: function getResourceDetails(state) {
      return function (type, entityId) {
        return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(state.resources, { type: type, entityId: entityId });
      };
    },
    getNumOfNotifications: function getNumOfNotifications(state) {
      return state.numOfNotifications;
    },
    getActionArray: function getActionArray(state) {
      return state.actionArray;
    },
    getResponseArray: function getResponseArray(state) {
      return state.responseArray;
    },
    getScienceDomainLoadStatus: function getScienceDomainLoadStatus(state) {
      return state.loadScienceDomains;
    },
    getTotalScienceDomains: function getTotalScienceDomains(state) {
      return state.totalScienceDomains;
    },
    getJoinedScienceDomains: function getJoinedScienceDomains(state) {
      return state.joinedScienceDomains;
    }
  },
  mutations: {
    setTotalScienceDomains: function setTotalScienceDomains(state, newState) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'totalScienceDomains', newState);
    },
    setJoinedScienceDomains: function setJoinedScienceDomains(state, newState) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'joinedScienceDomains', newState);
    },
    loadScienceDomainStatus: function loadScienceDomainStatus(state, newState) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'loadScienceDomains', newState);
    },
    setSortingStatus: function setSortingStatus(state, newState) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'sortingStatus', newState);
    },
    loadingStatus: function loadingStatus(state, _ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          message = _ref2[0],
          stateOfMessage = _ref2[1];

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'loadingAction', message);
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'loadingStatusIcon', stateOfMessage);
    },
    updateMessage: function updateMessage(state, actionObject) {
      // actionStatus : To know if to display that object
      // actionRequired: To determine if that object requires action
      if (actionObject.actionRequired === 'True') {
        state.responseArray.push(actionObject);
      }
      if (actionObject.actionStatus === 'False') {
        for (var j = 0; j < state.actionArray.length; j += 1) {
          if (state.actionArray[j].actionFileName === actionObject.actionFileName) {
            state.actionArray.splice(j, 1);
          }
        }
      } else {
        state.actionArray.push(actionObject);
      }
      if (state.responseArray) {
        state.numOfNotifications = state.actionArray.length + state.responseArray.length;
      } else {
        state.numOfNotifications = state.actionArray.length;
      }
    },
    updateResponseArray: function updateResponseArray(state, actionName) {
      for (var j = 0; j < state.responseArray.length; j += 1) {
        if (state.responseArray[j].actionFileName === actionName) {
          state.responseArray.splice(j, 1);
          state.numOfNotifications = state.actionArray.length + state.responseArray.length;
        }
      }
    },
    removeAllNotifications: function removeAllNotifications(state) {
      state.responseArray = [];
      if (state.actionArray) {
        state.numOfNotifications = state.actionArray.length;
      }
    },
    callAlert: function callAlert() {
      console.log('Alert');
    },
    setUserProfile: function setUserProfile(state, newProfile) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'userProfile', newProfile);
    },
    setToken: function setToken(state, newToken) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.headers.common['X-Auth-Token'] = newToken;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state, 'token', newToken);
    },
    setPublicGroups: function setPublicGroups(state, groups) {
      state.publicGroups = groups;
    },
    setPublicUsers: function setPublicUsers(state, users) {
      state.publicUsers = users;
    },
    updateGroups: function updateGroups(state, groups) {
      state.groups = __WEBPACK_IMPORTED_MODULE_5_deep_extend___default()({}, state.groups, groups);
    },
    setCollaborations: function setCollaborations(state, collaborations) {
      state.collaborations = collaborations;
    },
    setCollaborationIds: function setCollaborationIds(state, collaborationIds) {
      state.myCollaborations = collaborationIds;
    },
    setCollaborationLinks: function setCollaborationLinks(state, collaborationLinks) {
      state.collaborationLinks = collaborationLinks;
    },
    setConfigUrls: function setConfigUrls(state, configUrls) {
      state.configLinks = configUrls;
    },
    setUserActivities: function setUserActivities(state, userActivities) {
      state.userActivities = userActivities;
    },
    setResources: function setResources(state, resources) {
      state.resources = resources;
    },
    startUpdatingUserInCollaboration: function startUpdatingUserInCollaboration(state, _ref3) {
      var collaborationId = _ref3.collaborationId,
          user = _ref3.user,
          newStatus = _ref3.newStatus,
          newRole = _ref3.newRole;

      if (newStatus !== 'WITHDRAWN' && newStatus !== 'DECLINED') {
        if (!__WEBPACK_IMPORTED_MODULE_10_lodash_some___default()(state.collaborations[collaborationId].members, { id: user.id })) {
          state.collaborations[collaborationId].members.push({
            id: user.id,
            role: newRole,
            status: newStatus
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(state.collaborations[collaborationId].members, { id: user.id }).role = newRole;
          __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(state.collaborations[collaborationId].members, { id: user.id }).status = newStatus;
        }
      }

      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(state.collaborations[collaborationId].members, { id: user.id }), 'updating', true);
    },
    updateUsers: function updateUsers(state, users) {
      state.users = __WEBPACK_IMPORTED_MODULE_5_deep_extend___default()({}, state.users, users);
    },
    updateResources: function updateResources(state, resources) {
      state.resources = __WEBPACK_IMPORTED_MODULE_5_deep_extend___default()({}, state.resources, resources);
    },
    startLoadingConfig: function startLoadingConfig(state) {
      switch (state.configLoadingStatus) {
        case 'NOTLOADING':
          state.configLoadingStatus = 'LOADING';
          break;
        case 'LOADED':
          state.configLoadingStatus = 'RELOADING';
          break;
        default:
          break;
      }
    },
    finishLoadingConfig: function finishLoadingConfig(state) {
      state.configLoadingStatus = 'LOADED';
    },
    startLoadingUserActivities: function startLoadingUserActivities(state) {
      switch (state.userActivitiesStatus) {
        case 'NOTLOADING':
          state.userActivitiesStatus = 'LOADING';
          break;
        case 'LOADED':
          state.userActivitiesStatus = 'RELOADING';
          break;
        default:
          break;
      }
    },
    finishLoadingUserActivities: function finishLoadingUserActivities(state) {
      state.userActivitiesStatus = 'LOADED';
    },
    startLoadingResources: function startLoadingResources(state) {
      switch (state.resourceLoadingStatus) {
        case 'NOTLOADING':
          state.resourceLoadingStatus = 'LOADING';
          break;
        case 'LOADED':
          state.resourceLoadingStatus = 'RELOADING';
          break;
        default:
          break;
      }
    },
    finishLoadingResources: function finishLoadingResources(state) {
      state.resourceLoadingStatus = 'LOADED';
    },
    startLoadingCollaborations: function startLoadingCollaborations(state) {
      switch (state.collaborationLoadingStatus) {
        case 'NOTLOADING':
          state.collaborationLoadingStatus = 'LOADING';
          break;
        case 'LOADED':
          state.collaborationLoadingStatus = 'RELOADING';
          break;
        default:
          break;
      }
    },
    updateCollaborationLinks: function updateCollaborationLinks(state, response) {
      var racmUrlFormat = new URL('' + "https://sciserver.sdcc.bnl.gov/sciserver/racm/");
      var creategroupUrlFormat = new URL(response._links.createGroup.href);
      // Check if create group URL is different
      if (racmUrlFormat.host !== creategroupUrlFormat.host) {
        var collaborationList = response._embedded.collaborationList;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (var eachCollab in collaborationList) {
          var tempLinks = collaborationList[eachCollab]._links;
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (var linkDescription in tempLinks) {
            var tempURLformat = new URL(tempLinks[linkDescription].href);
            var tempURL = tempLinks[linkDescription].href.replace(tempURLformat.host, racmUrlFormat.host);
            tempLinks[linkDescription].href = tempURL;
          }
        }
        var _links = response._links;
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (var eachLink in _links) {
          var _tempURLformat = new URL(_links[eachLink].href);
          var _tempURL = _links[eachLink].href.replace(_tempURLformat.host, racmUrlFormat.host);
          _links[eachLink].href = _tempURL;
        }
      }
      state.collaborationResponse = response;
    },
    finishLoadingCollaborations: function finishLoadingCollaborations(state) {
      state.collaborationLoadingStatus = 'LOADED';
    },
    updateGroupLinkStack: function updateGroupLinkStack(state, lastBrowsed) {
      state.groupLinkStack = lastBrowsed;
    },
    setLinkedAccounts: function setLinkedAccounts(state, linkedAccounts) {
      state.linkedAccounts = linkedAccounts;
    }
  },
  actions: {
    loadConfig: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref4) {
      var commit = _ref4.commit;

      commit('startLoadingConfig');
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/config').then(function (response) {
        commit('setConfigUrls', response.body);
        commit('finishLoadingConfig');
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    loadResources: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref5) {
      var commit = _ref5.commit;

      commit('startLoadingResources');
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/rest/resources/v2').then(function (response) {
        commit('setResources', response.body);
        commit('finishLoadingResources');
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    loadUserActivities: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref6) {
      var commit = _ref6.commit;

      commit('startLoadingUserActivities');
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/logging-api" + '/api/messages/applications?type=authentication&doShowInUserHistory=true&top=10').then(function (response) {
        commit('setUserActivities', response.body);
        commit('finishLoadingUserActivities');
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    loadCollaborations: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref7) {
      var commit = _ref7.commit;

      commit('startLoadingCollaborations');
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/collaborations', { headers: { Accept: '*' } }).then(function (response) {
        commit('updateCollaborationLinks', response.body);
        response.body = initialState.collaborationResponse;
        commit('updateUsers', __WEBPACK_IMPORTED_MODULE_11_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(response.body, '_embedded.userList'), 'id'));
        commit('setCollaborations', __WEBPACK_IMPORTED_MODULE_11_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(response.body, '_embedded.collaborationList'), function (c) {
          return '' + c._links.self.href;
        }));
        commit('setCollaborationIds', __WEBPACK_IMPORTED_MODULE_12_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_get___default()(response.body, '_embedded.collaborationList'), '_links.self.href'));
        commit('setCollaborationLinks', response.body._links);
        commit('finishLoadingCollaborations');
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    loadPublicGroupsAndUsers: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref8) {
      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/users/public').then(function (response) {
        var user = new __WEBPACK_IMPORTED_MODULE_4_normalizr__["schema"].Entity('users');
        var group = new __WEBPACK_IMPORTED_MODULE_4_normalizr__["schema"].Entity('groups', {
          owner: user
        });
        var normalizedData = Object(__WEBPACK_IMPORTED_MODULE_4_normalizr__["normalize"])(response.body, {
          groups: [group],
          users: [user]
        });
        /* API sets these properties to blank for all objects: */
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(normalizedData.entities.groups).forEach(function (g) {
          delete g.memberGroups;
          delete g.memberUsers;
        });
        commit('updateUsers', normalizedData.entities.users);
        commit('updateGroups', normalizedData.entities.groups);
        commit('setPublicGroups', normalizedData.result.groups);
        commit('setPublicUsers', normalizedData.result.users);
      });
    }, API_THROTTLE_TIME, { trailing: false }),

    changeCollaborationMembership: function changeCollaborationMembership(_ref9, _ref10) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;
      var collaborationId = _ref10.collaborationId,
          editMemberListEndpoint = _ref10.editMemberListEndpoint,
          user = _ref10.user,
          newRole = _ref10.newRole,
          newStatus = _ref10.newStatus;

      for (var i = 0; i < user.length; i += 1) {
        commit('startUpdatingUserInCollaboration', { collaborationId: collaborationId, user: user[i], newStatus: newStatus, newRole: newRole });
      }
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get(editMemberListEndpoint).then(function (response) {
        var groupInfo = response.body;
        for (var _i = 0; _i < user.length; _i += 1) {
          if (__WEBPACK_IMPORTED_MODULE_10_lodash_some___default()(groupInfo.memberUsers, { userid: user[_i].id })) {
            var membership = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(groupInfo.memberUsers, {
              userid: user[_i].id
            });
            if (newRole !== undefined) {
              membership.role = newRole;
            }
            if (newStatus !== undefined) {
              membership.status = newStatus;
            }
          } else {
            groupInfo.memberUsers.push({
              user: {
                username: user[_i].username
              },
              status: newStatus,
              role: newRole
            });
          }
        }
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.post("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups', groupInfo);
      }).then(function () {
        return dispatch('loadCollaborations');
      });
    },
    loadLastGroupPath: function loadLastGroupPath(_ref11, path) {
      var commit = _ref11.commit;

      commit('updateGroupLinkStack', path);
    },

    loadLinkedAccounts: __WEBPACK_IMPORTED_MODULE_9_lodash_throttle___default()(function (_ref12) {
      var commit = _ref12.commit;
      return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'api/accounts').then(function (response) {
        commit('setLinkedAccounts', response.data);
      });
    }, API_THROTTLE_TIME, { trailing: false })
  }
}));

/***/ }),

/***/ "IgVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Share Databases"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Databases")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedResources),expression:"selectedResources"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedResources=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dbResources),function(domainResources){return _c('optgroup',{key:domainResources[0].rdbComputeDomain.name,attrs:{"label":domainResources[0].rdbComputeDomain.name}},_vm._l((domainResources),function(item){return _c('option',{key:item.entityId,domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)}),0)])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-4 control-label"},[_vm._v("Allow this group to:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"QUERY"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"QUERY")},on:{"change":function($event){_vm.checkedPrivilege="QUERY"}}}),_vm._v("\n          Query\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"QUERY,UPDATE"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"QUERY,UPDATE")},on:{"change":function($event){_vm.checkedPrivilege="QUERY,UPDATE"}}}),_vm._v("\n          Query and Edit\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"QUERY,UPDATE,GRANT"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"QUERY,UPDATE,GRANT")},on:{"change":function($event){_vm.checkedPrivilege="QUERY,UPDATE,GRANT"}}}),_vm._v("\n          Query, Edit and Share this Database\n        ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid},on:{"click":_vm.linkResources}},[_vm._v("Share")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JOgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Move Folder/File","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Volumes")])]),_vm._v(" "),_c('root-volume-template',{attrs:{"currentRootVolumes":_vm.currentRootVolumes,"selectedVolumeType":_vm.selectedVolumeType},on:{"changeVolumesType":_vm.changeVolumesType}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('bread-crumb',{attrs:{"currentUserVolume":_vm.currentUserVolume,"path":_vm.path},on:{"changeUV":_vm.changeUV,"showFiles":_vm.showFiles,"resetPath":_vm.resetPath}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin fa-3x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticStyle:{"text-align":"center"},attrs:{"id":"spinner"}},[_vm._v("Moving ... "),_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"table table-condensed table-striped table-responsive",attrs:{"id":"moveFilesTable"}},[_c('thead',[_c('tr',[(_vm.isShowingFiles)?[_c('th',{staticClass:"sorted ascending",attrs:{"scope":"col"}},[_vm._v("Name")])]:_vm._l((_vm.columnFields),function(column){return _c('th',{key:column},[_vm._v("\n                      "+_vm._s(column)+"\n                    ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedVolumes),function(volume){return (volume.write || _vm.isShowingFiles)?_c('tr',{key:volume.name},[_c('td',[((volume.type === 'uservolumes' || volume.type === 'datavolumes'))?_c('div',{staticClass:"userVolume"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.changeUV(volume.id)}}},[(volume.owner!==_vm.username)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && !volume.sharedUsers.length)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#008ae6"}})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && volume.sharedUsers.length)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#008ae6"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v("\n                          "+_vm._s(decodeURIComponent(volume.displayName ? volume.displayName : volume.name))+"\n                        ")])]):_vm._e(),_vm._v(" "),(volume.type === 'dir')?_c('div',{staticClass:"volume"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.goToFiles(volume.name)}}},[_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#008ae6"}})]),_vm._v(_vm._s(volume.name))])]):_vm._e(),_vm._v(" "),(volume.type === 'file')?_c('div',{staticClass:"file"},[_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-file-o fa-2x"})]),_vm._v(_vm._s(decodeURIComponent(volume.name))+"\n                      ")]):_vm._e()]),_vm._v(" "),(_vm.isShowingFiles)?[_c('td',[_vm._v(" "+_vm._s(volume.modified))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(volume.size))])]:_vm._e(),_vm._v(" "),(volume.type === 'uservolumes')?[_c('td',[_vm._v(_vm._s(volume.rootVolumeObj.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(volume.owner))])]:_vm._e(),_vm._v(" "),(volume.type === 'datavolumes')?[_c('td',[_vm._v(_vm._s(volume.name))]),_vm._v(" "),_c('td')]:_vm._e()],2):_vm._e()}),0)])],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.sendToMove()}}},[_vm._v("Move")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-action":"auto-focus"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('pop-up-dialog',{ref:"alertPopUp"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jhex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel pane-default"},[_c('div',{staticClass:"panel-body"},[_c('p',[_vm._v("You have been invited to join this group created by "+_vm._s(_vm.ownerUserName)+".")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"id":"acceptButton"},on:{"click":function($event){_vm.$emit('acceptInvitation', _vm.collaboration)}}},[_vm._v("Accept Invitation")]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"id":"declineButton"},on:{"click":function($event){_vm.$emit('declineInvitation', _vm.collaboration)}}},[_vm._v("Decline Invitation")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JtHP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDataVolumeDialog_vue__ = __webpack_require__("8a/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cf9f992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDataVolumeDialog_vue__ = __webpack_require__("VFSP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDataVolumeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cf9f992_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDataVolumeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jx6T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__create_dialog__ = __webpack_require__("l47g");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GroupEditDialog',
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_2__create_dialog__["a" /* default */])('#groupEditDialog', null);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isAdmin']))
});

/***/ }),

/***/ "KOqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePassword_vue__ = __webpack_require__("wfbM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5c21246_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePassword_vue__ = __webpack_require__("wn4D");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5c21246_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LHL3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LS1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ComputeFrame',
    props: ['imageInfo', 'customLoader', 'noReuse', 'path', 'sessionTimeout'],
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('computeCookie', this.$store.state.token, { secure: true });
        __WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('computeToken', this.$store.state.token, { secure: true });
        this.timeout = this.sessionTimeout || this.timeout;
    },

    data: function data() {
        return {
            loaded: false,
            loadMessage: 'loading...',
            containerId: null,
            imageErrors: [],
            lastActive: 0,
            inactive: false,
            needsprobe: false,
            timeout: 3600000,
            timer: null
        };
    },
    watch: {
        imageInfo: function imageInfo() {
            this.loaded = false;
            this.containerId = null;
        },
        resolvedImageInfo: function resolvedImageInfo() {
            var _this = this;

            if (this.resolvedImageInfo) {
                if (this.noReuse) {
                    this.startContainer();
                } else {
                    this.loadMessage = 'getting sessions...';
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/containers').then(function (response) {
                        _this.findOrStartContainer(response.data);
                    }).catch(function (error) {
                        console.error('error getting list of running containers ' + error);
                        _this.startContainer();
                    });
                }
            }
        },
        loaded: function loaded() {
            if (this.loaded) {
                this.$refs.computeApp.addEventListener('mousemove', this.resetActivity);
                this.$refs.computeApp.addEventListener('keydown', this.resetActivity);
                this.$refs.computeFrame.contentWindow.addEventListener('mousemove', this.resetActivity);
                this.$refs.computeFrame.contentWindow.addEventListener('keydown', this.resetActivity);
                this.lastActive = Date.now();
                setTimeout(this.pingCompute, 60000);
            }
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        resolvedImageInfo: function resolvedImageInfo() {
            if (!this.$store.state.compute.userComputeDomainsLoaded) {
                return null;
            }
            if (!(this.myPersistentVol && this.myScratchVol)) {
                console.log('no persistent or scratch vol');
                return null;
            }
            this.imageErrors = [];
            var domain = this.getUserComputeDomainById(this.imageInfo.domain);
            if (!domain) {
                this.imageErrors.push('no such domain ' + this.imageInfo.domain);
                return false;
            }
            var defaultUv = [this.myPersistentVol.id, this.myScratchVol.id];
            var domainUv = domain.userVolumes.map(function (v) {
                return v.id;
            });
            var domainDv = domain.volumes.map(function (v) {
                return parseInt(v.publisherDID, 10);
            });
            var missingUv = _.difference(this.imageInfo.userVolumes, domainUv);
            var missingDv = _.difference(this.imageInfo.dataVolumes, domainDv);
            var domainImages = domain.images.map(function (v) {
                return v.name;
            });
            if (missingUv.length !== 0) {
                this.imageErrors.push('no access to uservolumes: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(missingUv));
            }
            if (missingDv.length !== 0) {
                this.imageErrors.push('no access to datavolumes: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(missingDv));
            }
            if (!domainImages.includes(this.imageInfo.name)) {
                this.imageErrors.push('no access to image ' + this.imageInfo.name);
            }
            if (this.imageErrors.length !== 0) {
                return false;
            }
            return {
                domain: this.imageInfo.domain,
                dockerImageName: this.imageInfo.name,
                // data volumes (volumeContainers) are done in this way to preserve the writability flag, which comes
                // from the racm domain data
                volumeContainers: _.intersectionBy(domain.volumes, _.map(this.imageInfo.dataVolumes, function (i) {
                    return { publisherDID: String(i) };
                }), 'publisherDID'),
                userVolumes: _.union(defaultUv, _.get(this.imageInfo, 'userVolumes', [])).map(function (i) {
                    return { userVolumeId: i };
                })
            };
        },
        computeContainerUrl: function computeContainerUrl() {
            if (this.containerId) {
                var path = this.path ? '&path=' + this.path : '';
                return "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/go?id=' + this.containerId + '&' + path;
            }
            return '';
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'myDataVolumeObjects', 'getUserVolumeById', 'getDataVolumeById', 'myPersistentVol', 'myScratchVol', 'getUserComputeDomainById'])),
    methods: {
        findOrStartContainer: function findOrStartContainer(containerList) {
            var _this2 = this;

            var matched = containerList.filter(function (c) {
                return _.get(c, 'domainId') === _this2.resolvedImageInfo.domain && _.get(c, 'json.dockerImageName') === _this2.resolvedImageInfo.dockerImageName && _.difference(_this2.resolvedImageInfo.userVolumes.map(function (i) {
                    return i.userVolumeId;
                }), _.get(c, 'json.userVolumes', []).map(function (i) {
                    return i.userVolumeId;
                })).length === 0 && _.difference(_this2.resolvedImageInfo.volumeContainers.map(function (i) {
                    return i.publisherDID;
                }), _.get(c, 'json.volumeContainers', []).map(function (i) {
                    return i.publisherDID;
                })).length === 0;
            });
            console.log('found matching containers:', 'imageInfo:', this.resolvedImageInfo, 'matched:', matched);
            if (matched.length === 0) {
                this.startContainer();
            } else {
                this.loadMessage = 'loading application...';
                this.containerId = _.sample(matched).id;
            }
        },
        startContainer: function startContainer() {
            var _this3 = this;

            this.loadMessage = 'starting compute session...';
            var createUrl = "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/domains/' + this.resolvedImageInfo.domain + '/containers';
            var conf = { headers: {
                    'Content-Type': 'application/json', 'X-Description': 'NOTEBOOK', 'X-auth-token': this.$store.state.token
                } };
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(createUrl, this.resolvedImageInfo, conf).then(function (response) {
                _this3.loadMessage = 'starting application...';
                _this3.containerId = parseInt(response.data, 10);
            }).catch(function (error) {
                _this3.imageErrors.push('error creating container ' + error.data);
            });
        },
        frameLoadCallback: function frameLoadCallback() {
            if (!this.containerId) {
                return;
            }
            this.loadMessage = 'loading application...';
            var framedoc = this.$refs.computeFrame.contentDocument;
            // a bit hacky, but a number of things could mean we won't immediately get sent to the final url, and thus
            // we need to retry. Most likely compute has not completed container setup. We try to identify various
            // conditions here
            var preloadCond = framedoc.title === '503 Service Temporarily Unavailable' || framedoc.title === 'SciServer User Dashboard' || _.includes(_.get(framedoc.getElementsByTagName('dd'), 1, '').innerText, '503 Service Unavailable') && framedoc.title === 'Error';
            if (!preloadCond) {
                if (this.customLoader) {
                    this.customLoader(this);
                } else {
                    this.loaded = true;
                }
            } else {
                console.log('compute container not ready or error loading, retrying...');
                setTimeout(this.retryContainerUrl, 2000);
            }
        },
        retryContainerUrl: function retryContainerUrl() {
            console.log('retrying loading container url');
            this.$refs.computeFrame.src = this.computeContainerUrl;
        },
        resetActivity: function resetActivity() {
            this.needsprobe = false;
            this.lastActive = Date.now();
        },
        pingCompute: function pingCompute() {
            if (this._isDestroyed) {
                return;
            }
            var idle = Date.now() - this.lastActive;
            console.log('polling activity, idle time is now ' + idle);
            if (idle < 70000) {
                console.log('pinging compute container');
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/container/' + this.containerId + '/ping').catch(function (error) {
                    return console.error('failed to ping compute: ' + error);
                });
            } else if (idle < this.timeout) {
                console.log('no recent activity, marking as needing probe');
                this.needsprobe = true;
            } else if (idle >= this.timeout) {
                // stop the cycle, no recovery from here
                this.inactive = true;
                return;
            }
            this.timer = setTimeout(this.pingCompute, 60000);
        },
        reload: function reload() {
            this.$router.go();
        },
        beforeDestroy: function beforeDestroy() {
            console.log('component being destroyed, clearing timeout');
            clearTimeout(this.timer);
        }
    }
});

/***/ }),

/***/ "Lk58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_has__ = __webpack_require__("umy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__files_tab_moveFiles__ = __webpack_require__("jof2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__files_tab_copyFile__ = __webpack_require__("mjvC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__files_tab_CreateVolumeDialog__ = __webpack_require__("P4UP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__files_tab_CreateFolderDialog__ = __webpack_require__("qh8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__files_tab_EditVolumeDialog__ = __webpack_require__("Xp25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__files_tab_RenameFileDialog__ = __webpack_require__("qQLk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__files_tab_ShareUserVolumeDialog__ = __webpack_require__("Y+Xs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__files_tab_FileUsageDialog__ = __webpack_require__("DZMi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__files_utils__ = __webpack_require__("RswP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__files_tab_RootVolumes__ = __webpack_require__("C+pg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__files_tab_DeleteFileDialog__ = __webpack_require__("r8lU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__sharedComponents_alertDialog__ = __webpack_require__("pqqY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__sharedComponents_listGroup__ = __webpack_require__("MoEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__files_tab_LoadingStatus__ = __webpack_require__("+W60");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import orderBy from 'natural-orderby';

















var marked = __webpack_require__("EFqf");
var dompurify = __webpack_require__("OvQW");

var mathUtils = __webpack_require__("jIKD").default;
var fileUtils = __webpack_require__("RswP").default;

var $ = __webpack_require__("7t+N");
var moment = __webpack_require__("PJh5");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FilesTab',
  components: {
    moveFiles: __WEBPACK_IMPORTED_MODULE_15__files_tab_moveFiles__["a" /* default */],
    copyFile: __WEBPACK_IMPORTED_MODULE_16__files_tab_copyFile__["a" /* default */],
    CreateVolumeDialog: __WEBPACK_IMPORTED_MODULE_17__files_tab_CreateVolumeDialog__["a" /* default */],
    CreateFolderDialog: __WEBPACK_IMPORTED_MODULE_18__files_tab_CreateFolderDialog__["a" /* default */],
    EditVolumeDialog: __WEBPACK_IMPORTED_MODULE_19__files_tab_EditVolumeDialog__["a" /* default */],
    RenameFileDialog: __WEBPACK_IMPORTED_MODULE_20__files_tab_RenameFileDialog__["a" /* default */],
    ShareUserVolumeDialog: __WEBPACK_IMPORTED_MODULE_21__files_tab_ShareUserVolumeDialog__["a" /* default */],
    FileUsageDialog: __WEBPACK_IMPORTED_MODULE_22__files_tab_FileUsageDialog__["a" /* default */],
    DeleteFileDialog: __WEBPACK_IMPORTED_MODULE_25__files_tab_DeleteFileDialog__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default.a,
    LoadingStatus: __WEBPACK_IMPORTED_MODULE_28__files_tab_LoadingStatus__["a" /* default */],
    RootVolumeTemplate: __WEBPACK_IMPORTED_MODULE_24__files_tab_RootVolumes__["a" /* default */],
    popUpDialog: __WEBPACK_IMPORTED_MODULE_26__sharedComponents_alertDialog__["a" /* default */],
    listGroup: __WEBPACK_IMPORTED_MODULE_27__sharedComponents_listGroup__["a" /* default */]
  },
  mounted: function mounted() {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.lastRoute !== '' && vm.lastRoute !== '/files' && to.path === '/files') {
        next('' + vm.lastRoute);
      } else if (vm.lastRoute !== '' && to.path !== '/files') {
        next(to.path);
      } else if (vm.lastRoute === '' && to.path !== '/files') {
        next(to.path);
      } else {
        next('/files/' + vm.selectedVolumeType);
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('loadLastPath', from.path);
    next();
  },

  data: function data() {
    return {
      filelist: false,
      searchTerm: '',
      selectedItem: [],
      isSelectedAll: false,
      fileManagement: "https://www.sciserver.org/support/how-to-use-sciserver/#filemanagement",
      file_uploading: false,
      dropzoneOptions: {
        url: 'url',
        thumbnailWidth: 150,
        uploadMultiple: false,
        method: 'put',
        maxFiles: 100,
        parallelUploads: 20,
        timeout: 1800000
      },
      display_spinner: false,
      sortedObject: '',
      increaseIcon: {
        content: '\f0dc',
        color: 'red'
      },
      titleChanged: false,
      currentList: [],
      isReversed: false,
      currentSelectedHeader: 'name',
      isCurrentIncreasing: true,
      readmeData: '',
      readmePath: ''
    };
  },
  created: function created() {
    this.getVolumes();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    volumeIcon: function volumeIcon() {
      if (this.currentSelectedHeader === 'name') {
        if (this.isCurrentIncreasing) {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    rootVolumeIcon: function rootVolumeIcon() {
      if (this.currentSelectedHeader === 'rootVolumeName') {
        if (this.isCurrentIncreasing) {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    ownerIcon: function ownerIcon() {
      if (this.currentSelectedHeader === 'owner') {
        if (this.isCurrentIncreasing) {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    dataSetsIcon: function dataSetsIcon() {
      if (this.currentSelectedHeader === 'displayName') {
        if (this.isCurrentIncreasing) {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    foldersIcon: function foldersIcon() {
      if (this.currentSelectedHeader === 'name') {
        if (this.isCurrentIncreasing) {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    nameIcon: function nameIcon() {
      var temp = this.$store.state.sortingStatus;
      if (temp.substring(1) === 'name') {
        if (temp.charAt(0) === '+') {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    modifiedIcon: function modifiedIcon() {
      var temp = this.$store.state.sortingStatus;
      if (temp.substring(1) === 'modified') {
        if (temp.charAt(0) === '+') {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    sizeIcon: function sizeIcon() {
      var temp = this.$store.state.sortingStatus;
      if (temp.substring(1) === 'rsize') {
        if (temp.charAt(0) === '+') {
          return 'sorted ascending';
        }
        return 'sorted descending';
      }
      return 'sorted normal';
    },
    isShowingFiles: function isShowingFiles() {
      return this.currentUserVolume;
    },
    sortedVolumes: function sortedVolumes() {
      var currentRouterParam = this.$route.params.userVolumeId;
      if (currentRouterParam) {
        return this.fileSorting;
      }
      return this.volumesSorting;
    },
    volumesSorting: function volumesSorting() {
      var routerParam = this.$route.params.rootVolume;
      if (this.currentSelectedHeader.length === 0 && routerParam === 'uservolumes') {
        return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()('name', { ignoreCase: true }));
      }
      if (this.currentSelectedHeader.length === 0 && routerParam === 'dataVolumes') {
        return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()('displayName', { ignoreCase: true }));
      }
      if (this.currentSelectedHeader !== null) {
        if (this.isCurrentIncreasing) {
          return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()(this.currentSelectedHeader, { ignoreCase: true }));
        }
        return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()(this.currentSelectedHeader, { ignoreCase: true })).reverse();
      }
      return this.searchedActivities;
    },
    fileSorting: function fileSorting() {
      var temp = this.$store.state.sortingStatus;
      if (temp.charAt(0) === '+') {
        return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()('type').thenBy(temp.substring(1), { ignoreCase: true }));
      }
      if (temp.charAt(0) === '-') {
        return this.searchedActivities.sort(__WEBPACK_IMPORTED_MODULE_13_thenby___default()('type').thenBy(temp.substring(1), { ignoreCase: true })).reverse();
      }
      return this.searchedActivities;
    },
    username: function username() {
      return this.userProfile.username;
    },
    searchedActivities: function searchedActivities() {
      var _this = this;

      this.loadReadme(this.listToDisplay);
      if (this.isShowingFiles) {
        return this.listToDisplay.filter(function (volume) {
          return volume.name.toLowerCase().match(_this.searchTerm.toLowerCase()) || volume.size.toLowerCase().match(_this.searchTerm.toLowerCase()) || volume.modified.toLowerCase().match(_this.searchTerm.toLowerCase());
        });
      }
      if (this.selectedVolumeType === 'uservolumes') {
        return this.listToDisplay.filter(function (volume) {
          return (volume.displayName ? volume.displayName.toLowerCase().match(_this.searchTerm.toLowerCase()) : volume.name.toLowerCase().match(_this.searchTerm.toLowerCase())) || (volume.rootVolumeObj ? volume.rootVolumeObj.name.toLowerCase().match(_this.searchTerm.toLowerCase()) : volume.name.toLowerCase().match(_this.searchTerm.toLowerCase())) || volume.owner.toLowerCase().match(_this.searchTerm.toLowerCase());
        });
      }
      return this.listToDisplay.filter(function (volume) {
        return volume.displayName.toLowerCase().match(_this.searchTerm.toLowerCase()) || volume.name.toLowerCase().match(_this.searchTerm.toLowerCase());
      });
    },
    resetSearch: function resetSearch() {
      this.searchTerm = '';
    },
    availableActions: function availableActions() {
      var actions = '';
      if (this.selectedItem.length && this.isShowingFiles) {
        if (__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['type', 'dir']) && this.writeAccess) {
          actions = 'copy,move,delete';
        } else if (__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['type', 'dir']) && !this.writeAccess) {
          actions = 'copy';
        } else if (!__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['type', 'dir']) && this.writeAccess) {
          actions = 'download,copy,move,delete';
        } else {
          actions = 'download,copy';
        }
      }
      return actions;
    },
    getEachAction: function getEachAction() {
      var eachAction = [];
      if (this.availableActions !== '') {
        eachAction = this.availableActions.split(',');
      }
      return eachAction;
    },
    deleteAction: function deleteAction() {
      return this.getEachAction.includes('delete');
    },
    copyAction: function copyAction() {
      return this.getEachAction.includes('copy');
    },
    downloadAction: function downloadAction() {
      return this.getEachAction.includes('download');
    },
    moveAction: function moveAction() {
      return this.getEachAction.includes('move');
    },
    writeAccess: function writeAccess() {
      return this.currentUserVolume && __WEBPACK_IMPORTED_MODULE_8_lodash_includes___default()(this.currentUserVolume.allowedActions, 'write');
    },
    deleteUVAction: function deleteUVAction() {
      if (__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['delete', false])) {
        return false;
      }
      return true;
    },
    grantUVAction: function grantUVAction() {
      if (__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['grant', false])) {
        return false;
      }
      return true;
    },
    editUVAction: function editUVAction() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.selectedItem, ['write', false]) || this.selectedItem.find(function (u) {
        return u.owner !== _this2.username;
      })) {
        return false;
      }
      return true;
    },
    refreshFilesSpinner: function refreshFilesSpinner() {
      return {
        'fa-spin': this.loading === true
      };
    },
    selectedVolumeType: function selectedVolumeType() {
      var id = this.$route.params.rootVolume;
      if (id === undefined) {
        return 'uservolumes';
      }
      return id;
    },
    currentUserVolume: function currentUserVolume() {
      var id = this.$route.params.userVolumeId;
      if (id === undefined || this.myUserVolumeObjects.length === 0) {
        return undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.currentListOfUV, { id: parseInt(id, 10) });
    },
    currentListOfUV: function currentListOfUV() {
      if (this.$route.params.rootVolume === 'uservolumes') {
        return fileUtils.getCurrentUVList(this.myUserVolumeObjects);
      } else if (this.$route.params.rootVolume === 'datavolumes') {
        return fileUtils.getCurrentDVList(this.myDataVolumeObjects);
      }
      return undefined;
    },
    currentRootVolumes: function currentRootVolumes() {
      var rv = [];
      if (this.myRootVolumeObjects.length > 0) {
        rv.push({ name: 'User Volumes', type: 'uservolumes', id: 1 });
      }
      if (this.myDataVolumeObjects.length > 0) {
        rv.push({ name: 'Data Volumes', type: 'datavolumes', id: 2 });
      }
      return rv;
    },
    currentFiles: function currentFiles() {
      var _this3 = this;

      if (!this.currentUserVolume) return [];
      var jsonTree = __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(this.$store.state.files.jsonTreeCache, [this.currentUserVolume.id, this.path]);
      return __WEBPACK_IMPORTED_MODULE_9_lodash_concat___default()(__WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(jsonTree, 'root.folders', []), function (folder) {
        return {
          name: folder.name,
          type: 'dir',
          owner: _this3.currentUserVolume.owner,
          size: folder.size ? mathUtils.bytesToSize(folder.size) : '',
          modified: folder.lastModified === null ? '' : moment(folder.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }), __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(jsonTree, 'root.files', []), function (file) {
        return {
          name: file.name,
          type: 'file',
          size: file.size === null ? '' : mathUtils.bytesToSize(file.size),
          rsize: file.size,
          modified: file.lastModified === null ? '' : moment(file.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }));
    },
    listToDisplay: function listToDisplay() {
      if (this.currentUserVolume) {
        return this.currentFiles;
      }
      return this.getNonExcludedVolumes();
    },
    loading: function loading() {
      if (this.currentUserVolume) {
        return !__WEBPACK_IMPORTED_MODULE_12_lodash_has___default()(this.$store.state.files.jsonTreeCache, [this.currentUserVolume.id, this.path]);
      }
      return this.myUserVolumeObjects.length === 0;
    },
    path: function path() {
      if (this.$route.params.path === undefined) return '';
      return '/' + this.$route.params.path;
    },
    config: function config() {
      return { headers: { 'X-Auth-Token': this.$store.state.token } };
    },
    downloadFilePath: function downloadFilePath() {
      var url = fileUtils.joinURLWithPath(this.currentUserVolume, 'api/file/', this.path);
      return url;
    },
    notebookBasePath: function notebookBasePath() {
      var volpath = this.path === '/' ? '' : this.path;
      return '/notebook/' + this.selectedVolumeType + '/' + this.currentUserVolume.id + volpath;
    },
    columnFields: function columnFields() {
      if (this.selectedVolumeType === 'uservolumes') {
        return ['Volume', 'Root Volume', 'Owner', ' ', ' '];
      } else if (this.selectedVolumeType === 'datavolumes') {
        return ['Data Sets', 'Folders', ' ', ' ', ' '];
      }
      return undefined;
    },
    isNotebookFirstAlphaGroupMember: function isNotebookFirstAlphaGroupMember() {
      var _this4 = this;

      return this.getGroupIds.find(function (g) {
        return __WEBPACK_IMPORTED_MODULE_10_lodash_get___default()(_this4.getCollaborationById(g), 'name') === '__SciserverNotebookFirstDemo__';
      }) !== undefined;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["d" /* mapState */])(['userProfile', 'token', 'loadingUI', 'sortingStatus', 'loadingAction', 'loadingStatusIcon']), Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'lastRoute', 'myRootVolumeObjects', 'myDataVolumeObjects', 'getGroupIds', 'getCollaborationById'])),
  watch: {
    $route: function $route(to, from) {
      if (!to.params.rootVolume) {
        this.$router.push(from.fullPath);
      }
    },
    currentUserVolume: function currentUserVolume(uv) {
      if (uv) {
        this.getFiles();
      }
    },
    currentListOfUV: function currentListOfUV() {
      if (this.selectedItem) {
        this.selectedItem = [];
      }
      if (this.isSelectedAll) {
        this.selectedAll();
      }
    },
    currentFiles: function currentFiles() {
      if (this.selectedItem) {
        this.selectedItem = [];
      }
      if (this.isSelectedAll) {
        this.selectedAll();
      }
      if (this.searchTerm !== '') {
        this.searchTerm = '';
      }
    }
  },
  // All the methods you want the view to have access to, basically an object of functions
  methods: {
    getNonExcludedVolumes: function getNonExcludedVolumes() {
      var excludedResources = this.$store.state.files.serviceOwnedResources;
      return this.currentListOfUV.filter(function (e) {
        return !excludedResources.includes(e.resourceUUID);
      });
    },
    getHeaderName: function getHeaderName(value) {
      var headermap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
      headermap.set('Data Sets', 'displayName');
      headermap.set('Volume', 'name');
      headermap.set('Folders', 'name');
      headermap.set('Owner', 'owner');
      headermap.set('Root Volume', 'rootVolumeName');
      this.currentSelectedHeader = headermap.get(value);
      this.isCurrentIncreasing = !this.isCurrentIncreasing;
      this.titleChanged = !this.titleChanged;
    },
    sortingMethod: function sortingMethod(value) {
      var storeValue = this.$store.state.sortingStatus;
      if (storeValue.substring(1) === value) {
        if (storeValue.charAt(0) === '+') {
          this.$store.commit('setSortingStatus', '-' + value);
        } else {
          this.$store.commit('setSortingStatus', '+' + value);
        }
      } else {
        this.$store.commit('setSortingStatus', '+' + value);
      }
    },
    loadReadme: function loadReadme(currentList) {
      var _this5 = this;

      var currentPath = this.$route.path;
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(currentList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var temp = _step.value;

          if (temp.name === 'README.md') {
            var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(this.currentUserVolume, 'api/file/', this.path, 'README.md');
            var config = { headers: { 'X-Auth-Token': this.$store.state.token }, validateStatus: function validateStatus(status) {
                return status >= 0;
              } };
            if (currentPath !== this.readmePath) {
              __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '?TaskName=Dashboard.Files.Readme', config).then(function (response) {
                _this5.readmePath = currentPath;
                if (response.status === 200) {
                  _this5.readmeData = '[<a href="#filesTable">Skip to file list</a>]<br>';
                  _this5.readmeData += dompurify.sanitize(marked(response.data));
                } else {
                  _this5.readmeData = '';
                }
              });
            }
            return null;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.readmeData = '';
      this.readmePath = '';
      return null;
    },
    aftercalled: function aftercalled() {
      this.getFiles();
    },
    getVolumes: function getVolumes() {
      this.$store.dispatch('loadAllUserVolumes');
      this.$store.dispatch('loadScienceDomains', this.userProfile);
    },
    getFiles: function getFiles() {
      this.$store.dispatch('loadJsonTreeById', { userVolumeId: this.currentUserVolume.id, path: this.path, type: this.currentUserVolume.type });
    },
    refreshFileService: function refreshFileService() {
      if (this.currentUserVolume) {
        this.getFiles();
      } else {
        this.getVolumes();
      }
    },
    downloadSingleFile: function downloadSingleFile(file) {
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(this.currentUserVolume, 'api/file/', this.path, file.name);
      __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].downloadFile(url, file.name);
    },
    editFile: function editFile(file) {
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(this.currentUserVolume, 'api/file/', this.path, file.name);
      this.$router.push('/editor?f=' + url);
    },
    downloadMultipleFiles: function downloadMultipleFiles(files, index) {
      var _this6 = this;

      if (index >= 0) {
        var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(this.currentUserVolume, 'api/file/', this.path, files[index].name);
        fileUtils.downloadFile(url, files[index].name);
        setTimeout(function () {
          _this6.downloadMultipleFiles(files, index - 1);
        }, 5000);
      }
    },
    changeSelectedVolumesType: function changeSelectedVolumesType(type) {
      this.selectedVolumeType = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].changeVolumesType(type);
      this.$router.push({ path: '/files' });
    },
    changeVolumesTypeFromParent: function changeVolumesTypeFromParent(type) {
      this.$emit('changeVolumesType', type);
    },
    dropzoneChangeUrl: function dropzoneChangeUrl(file) {
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(this.currentUserVolume, 'api/file/', this.path, file.name);
      this.$refs.vueDropzone.setOption('headers', { 'X-Auth-Token': this.token });
      this.$refs.vueDropzone.setOption('url', url);
    },
    comeback: function comeback(file, message, xhr) {
      console.log(xhr);
      console.log(message);
      var errorMessage = null;
      if (message !== null) {
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].notify({
          group: 'top_center_notify',
          text: 'File upload failed.',
          duration: 1000,
          type: 'error',
          ignoreDuplicates: true
        });
      }
      if (message.status === 'error') {
        errorMessage = message.error;
      } else {
        errorMessage = message + ' For large file upload, use the upload button.';
      }
      var actionObject = {
        actionName: 'Uploading',
        actionFileName: file.name,
        actionStatus: 'False',
        actionRequired: 'True',
        actionMessage: errorMessage
      };
      this.$store.commit('updateMessage', actionObject);
    },
    dropzoneSendRequest: function dropzoneSendRequest(file, xhr) {
      var actionObject = {
        actionName: 'Uploading',
        actionFileName: file.name,
        actionStatus: 'True',
        actionRequired: 'False'
      };
      this.$store.commit('updateMessage', actionObject);
      this.$store.commit('loadingStatus', ['Uploading', true]);
      var _send = xhr.send;
      xhr.send = function send() {
        _send.call(xhr, file);
      };
    },
    fileUploadComplete: function fileUploadComplete(file) {
      this.getFiles();
      var actionObject = {
        actionName: 'Uploading',
        actionFileName: file.name,
        actionStatus: 'False',
        actionRequired: 'False'
      };
      this.$store.commit('loadingStatus', '');
      this.$store.commit('updateMessage', actionObject);
      this.$refs.vueDropzone.removeFile(file);
    },
    fileUploadClicked: function fileUploadClicked() {
      $('#uploadedFile')[0].value = null;
    },
    uploadFile: function uploadFile() {
      var _this7 = this;

      var filepath = this.currentUserVolume.type + '/' + this.currentUserVolume.name + this.path;
      var actionUrl = this.currentUserVolume.type + '/' + this.$route.params.userVolumeId + this.path;
      var actionObject = {
        actionName: 'Uploading',
        actionFileName: null,
        actionLocation: null,
        actionStatus: 'True',
        actionRequired: null,
        actionurl: null
      };
      var files = $('#uploadedFile')[0].files;
      var config = {
        headers: {
          'X-Auth-Token': this.$store.state.token,
          'Content-Type': 'application/octet-stream'
        }
      };
      var that = this;
      if (files.length > 0) {
        for (var i = 0; i < files.length; i += 1) {
          var file = $('#uploadedFile')[0].files[i];
          if (file) {
            actionObject = {
              actionName: 'Uploading',
              actionFileName: file.name,
              actionLocation: '' + filepath,
              actionStatus: 'True',
              actionRequired: null,
              actionurl: '' + actionUrl
            };
            that.$store.commit('updateMessage', actionObject);
          }
        }
      }
      if (files.length > 0) {
        var _loop = function _loop(_i) {
          var file = $('#uploadedFile')[0].files[_i];
          if (file) {
            _this7.$store.commit('loadingStatus', ['Uploading', true]);
            var errorMessage = '';
            var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithFileName(that.currentUserVolume, 'api/file/', that.path, file.name);
            // eslint-disable-next-line chai-friendly/no-unused-expressions,no-loop-func
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, file, config).then(function () {
              try {
                that.getFiles();
                // eslint-disable-next-line no-empty
              } catch (e) {}
            })
            // eslint-disable-next-line no-loop-func
            .catch(function (error) {
              try {
                errorMessage = error.response.data.error;
              } catch (e) {
                errorMessage = 'Please make sure if the file already exists.';
              }
            })
            // eslint-disable-next-line no-loop-func
            .finally(function () {
              _this7.$forceUpdate();
              _this7.$store.commit('loadingStatus', ['Uploading', false]);
              if (errorMessage.length === 0) {
                _this7.storeNotificationUpdate(file.name, filepath, 'False', 'False', url, '');
              } else if (errorMessage === 'true') {
                _this7.storeNotificationUpdate(file.name, filepath, 'False', 'True', url, errorMessage);
              } else {
                _this7.storeNotificationUpdate(file.name, filepath, 'False', 'True', url, errorMessage);
              }
            });
          }
        };

        for (var _i = 0; _i < files.length; _i += 1) {
          _loop(_i);
        }
      }
    },
    storeNotificationUpdate: function storeNotificationUpdate(fileName, filePath, actionStatus, actionrequired, actionUrl, actionmessage) {
      var actionObject = {
        actionName: 'Uploading',
        actionFileName: fileName,
        actionLocation: filePath,
        actionStatus: 'False',
        actionRequired: actionrequired,
        actionurl: actionUrl,
        actionMessage: actionmessage
      };
      if (actionmessage.length === 0) {
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].notify({
          group: 'top_center_notify',
          text: 'File upload successful',
          duration: 1000,
          type: 'success',
          ignoreDuplicates: true
        });
      }
      this.$store.commit('updateMessage', actionObject);
    },
    childMove: function childMove(selected) {
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithPath(this.currentUserVolume, 'api/data/', this.path);
      this.$refs.moveButton.move(selected, url);
    },
    childCopy: function childCopy(files) {
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinURLWithPath(this.currentUserVolume, 'api/data/', this.path);
      this.$refs.copyButton.copy(files, url);
    },
    sendTodelete: function sendTodelete(files) {
      var _this8 = this;

      if (confirm('Are you sure you want to delete ' + files.length + ' items?')) {
        $.each(files, function (index0, text0) {
          _this8.deleteFiles(text0.name);
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].notify({
            group: 'top_center_notify',
            text: 'Delete Successful!',
            duration: 1000,
            type: 'error',
            ignoreDuplicates: true
          });
        });
      }
    },
    deleteFiles: function deleteFiles(fileName) {
      var _this9 = this;

      $('#filelist').show();
      if (!this.listToDisplay) {
        $('#filelist').show();
      }
      var url = fileUtils.joinURLWithFileName(this.currentUserVolume, 'api/data/', this.path, fileName);
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, this.config).then(function () {
        _this9.getFiles();
      }, function (error) {
        _this9.$refs.alertPopUp.showAlert(error.response.data.error, 'Error Message');
      });
    },
    deleteFile: function deleteFile(fileName) {
      $('#filelist').show();
      if (!this.listToDisplay) {
        $('#filelist').show();
      }
      if (confirm('Are you sure you want to delete ' + fileName)) {
        this.deleteFiles(fileName);
      }
    },
    sendTodeleteUserVolume: function sendTodeleteUserVolume(volumes) {
      if (!this.listToDisplay) {
        $('#filelist').show();
      }
      if (confirm('Are you sure you want to delete ' + volumes.length + ' items?')) {
        this.deleteUserVolumes(volumes, volumes.length - 1);
      }
    },
    findVolumeById: function findVolumeById(id) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.currentListOfUV, { id: id });
    },
    deleteUserVolumes: function deleteUserVolumes(volumes, index) {
      var _this10 = this;

      if (index >= 0) {
        var userVolume = this.findVolumeById(volumes[index].id);
        var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinBaseURL(userVolume, 'api/volume/');
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, this.config).then(function () {
          _this10.deleteUserVolumes(volumes, index - 1);
          _this10.getVolumes();
        });
      }
    },
    deleteUserVolume: function deleteUserVolume(userVolumeId) {
      var userVolume = this.findVolumeById(userVolumeId);
      var url = __WEBPACK_IMPORTED_MODULE_23__files_utils__["default"].joinBaseURL(userVolume, 'api/volume/');
      this.$refs.deleteFileDialog.startDialog(userVolume.name, url);
    },
    sendToeditVolume: function sendToeditVolume(volumes) {
      var _this11 = this;

      $.each(volumes, function (index0, text0) {
        _this11.editVolume(text0);
      });
    },
    sendToshareVolume: function sendToshareVolume(volumes) {
      var _this12 = this;

      $.each(volumes, function (index0, text0) {
        _this12.shareVolume(text0);
      });
    },
    sendToUnshareVolume: function sendToUnshareVolume(volumes) {
      var _this13 = this;

      $.each(volumes, function (index0, text0) {
        _this13.unshareVolume(text0);
      });
    },
    createNewVolume: function createNewVolume() {
      $('#spinner').show();
      this.$refs.createVolumeDialog.startDialog();
      // $('#spinner').hide();
    },
    createNewSubFolder: function createNewSubFolder() {
      this.$refs.createFolderDialog.startDialog();
    },
    editVolume: function editVolume(volume) {
      this.$refs.editVolumeDialog.startDialog(volume);
    },
    shareVolume: function shareVolume(volume) {
      this.$refs.shareUserVolumeDialog.startDialog(volume);
    },
    renameFileOrFolder: function renameFileOrFolder(name) {
      this.$refs.renameFileDialog.startDialog(name);
    },
    viewQuotas: function viewQuotas() {
      this.$refs.fileUsageDialog.startDialog();
    },
    selectedAll: function selectedAll() {
      this.isSelectedAll = !this.isSelectedAll;
      this.selectedItem = [];
      if (this.isSelectedAll) {
        // Check all
        this.selectedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.listToDisplay);
      }
    },
    select: function select() {
      this.isSelectedAll = false;
    }
  }
});

/***/ }),

/***/ "LsGW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"list-group",attrs:{"name":"group-list","tag":"div"}},_vm._l((_vm.currentRootVolumes),function(item){return _c('button',{key:item.name,staticClass:"list-group-item",class:{active: item.type === _vm.selectedVolumeType},attrs:{"type":"button"},on:{"click":function($event){_vm.changeVolumesType(item.type)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LvGO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"400px"}},[_c('h5',{staticClass:"card-title",staticStyle:{"text-align":"left","padding":"10px"}},[_vm._v("Notifications")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"}),_vm._v(" "),_c('ul',[(_vm.numOfNotifications === 0)?_c('li',[_vm._m(0)]):_vm._e(),_vm._v(" "),_vm._l((_vm.getActionArray),function(item){return _c('li',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('span',{staticClass:"fa fa-cloud-upload"}),_vm._v(" "+_vm._s(item.actionName)+" "+_vm._s(item.actionFileName)+" to "+_vm._s(item.actionLocation)+" "+_vm._s(item.actionurl)+"\n      ")])])}),_vm._v(" "),_vm._l((_vm.actionRequiredItems),function(item){return _c('li',{staticClass:"list-group-item list-group-item-action list-group-item-danger"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.removeAction(item.actionFileName)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v("\n      Failed "+_vm._s(item.actionName)+"\n      "),_c('router-link',{attrs:{"to":("/files/" + (item.actionurl))}},[_vm._v(" "+_vm._s(item.actionFileName)+"\n      ")])],1)})],2),_vm._v(" "),_c('h5',{staticStyle:{"text-align":"center","padding":"10px"}},[_c('a',{on:{"click":function($event){_vm.removeAction(_vm.item.actionFileName)}}},[_vm._v("Clear All")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-dismissable",attrs:{"role":"alert"}},[_c('span',{staticClass:"fa fa-check-circle-o"}),_vm._v(" No new notifications\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M35A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title'],
  data: function data() {
    return {
      open: false,
      info: {},
      groupInfo: {}
    };
  },
  methods: {
    startDialog: function startDialog(info, groupInfo) {
      this.info = info;
      this.groupInfo = groupInfo;
      this.open = true;
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb769fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ySHw");
function injectStyle (ssrContext) {
  __webpack_require__("xavP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eb769fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb769fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MWBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MoEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listGroup_vue__ = __webpack_require__("SnlR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f124d34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listGroup_vue__ = __webpack_require__("kWjw");
function injectStyle (ssrContext) {
  __webpack_require__("iDB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f124d34c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f124d34c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MwGA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('h1',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('p',[_vm._t("default",[(_vm.action)?_c('button',{staticClass:"btn btn-success btn-sm",class:_vm.buttonClasses,attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N+sN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N5D7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__token_provider__ = __webpack_require__("Rwq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





/* harmony default export */ __webpack_exports__["a"] = (function () {
  var tokens = Object(__WEBPACK_IMPORTED_MODULE_1__token_provider__["a" /* default */])();
  if (tokens.length === 0) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('No authentication found');

  var successCallback = function successCallback(response) {
    var token = response.config.extraInfo.token;
    __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('portalCookie', token, { secure: true });
    return {
      userProfile: response.data,
      token: token
    };
  };

  var chainedAttempts = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/user', {
    headers: { 'X-Auth-Token': tokens[0] },
    extraInfo: { token: tokens[0] }
  });

  tokens.slice(1).forEach(function (token) {
    chainedAttempts = chainedAttempts.catch(function () {
      return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/user', {
        headers: { 'X-Auth-Token': token },
        extraInfo: { token: token }
      });
    });
  });

  return chainedAttempts.then(successCallback);
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uiv__ = __webpack_require__("tEJ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__error_handler__ = __webpack_require__("GQi5");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











// eslint-disable-next-line import/prefer-default-export
var EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

__webpack_require__("A+g3");

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_uiv__);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(undefined, function (err) {
  // Ignore axios errors if requesting user profile
  // We do this to avoid giving a visible error when testing
  // tokens on the first load
  if (err.request.responseURL === "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/user') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  }
  Object(__WEBPACK_IMPORTED_MODULE_11__error_handler__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(err, 'response.status'), __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(err, 'request.responseURL'), err.data, err, __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(err, 'response.statusText'));
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.interceptors.push(function () {
  return function (response) {
    if (response.status < 299) return;
    var jsonResponse = null;
    try {
      jsonResponse = JSON.parse(response.body);
    } catch (ignored) {
      // ignore if the body is not valid json
    }
    Object(__WEBPACK_IMPORTED_MODULE_11__error_handler__["a" /* default */])(response.status, response.url, jsonResponse, undefined, response.statusText);
  };
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */] }
});

/***/ }),

/***/ "NMcc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSaver_vue__ = __webpack_require__("XueU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64421852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSaver_vue__ = __webpack_require__("drEV");
function injectStyle (ssrContext) {
  __webpack_require__("Brm7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64421852"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainSaver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64421852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainSaver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nj2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentNotebookList_vue__ = __webpack_require__("6XPa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388b485e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentNotebookList_vue__ = __webpack_require__("rYgK");
function injectStyle (ssrContext) {
  __webpack_require__("CR0T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-388b485e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecentNotebookList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388b485e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecentNotebookList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nw6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"text-align: center",staticStyle:{"margin":"auto","width":"50%","padding-left":"20%","padding-right":"20%"}},[_vm._v(" loadingAction ..."),_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OAwq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDatabaseContexts_vue__ = __webpack_require__("o474");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8ec4e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDatabaseContexts_vue__ = __webpack_require__("IgVR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDatabaseContexts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8ec4e7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDatabaseContexts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OKdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var $ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newWorkspaceModal',
  data: function data() {
    return {
      checkedUsers: [],
      usersRow: [],
      open: false
    };
  },
  props: ['workspace', 'gMembers'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    allUsers: function allUsers() {
      return this.publicUsers.map(this.getUserById).map(function (u) {
        return [u.username, u.id, 'USER'];
      });
    },
    workspaceId: function workspaceId() {
      return this.workspace._links.self.href;
    },
    workspaceEditMember: function workspaceEditMember() {
      return this.workspace._links.editMemberList.href;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['userProfile', 'publicUsers', 'publicGroups', 'users', 'groups', 'token', 'collaborations']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getUserById', 'getGroupById', 'isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeCollaborationMembership'])),
  watch: {
    allUsers: function allUsers() {
      if ($.fn.dataTable.isDataTable('#usersTable')) {
        var table = $('#usersTable').DataTable();
        table.clear();
        table.rows.add(this.allUsers).draw(false);
      } else {
        $('#usersTable').DataTable({
          data: this.allUsers,
          processing: true,
          bFilter: true,
          stateSave: false,
          select: true,
          paging: true
        });
      }
    },
    open: function open() {
      if (!this.open) {
        __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit('closeAddMembers');
      }
    }
  },
  methods: {
    startDialog: function startDialog() {
      this.updateUsersTable();
      this.open = true;
    },
    addUsers: function addUsers(newStatus, newRole) {
      var user = '';
      var users = [];
      var data = $('#usersTable').DataTable().rows({
        selected: true
      }).data();
      for (var i = 0; i < data.length; i += 1) {
        user = data[i][1];
        users.push(this.users[user]);
      }
      this.submitAddUsersRequest(users, newRole, newStatus);
    },
    submitAddUsersRequest: function submitAddUsersRequest(user, newRole, newStatus) {
      this.$emit('submitAddUsersRequest', user, newRole, newStatus);
    },
    updateUsersTable: function updateUsersTable() {
      if ($.fn.dataTable.isDataTable('#usersTable')) {
        $('#usersTable').DataTable().clear().destroy();
      }
      $('#usersTable').DataTable({
        data: this.allUsers,
        processing: true,
        bFilter: true,
        stateSave: false,
        select: true,
        paging: true
      });
    }
  }
});

/***/ }),

/***/ "OLHM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"rename and/or move file","size":"lg","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('a',{attrs:{"href":"#","title":"select destination volume"},on:{"click":function($event){_vm.destVolume = null; _vm.destPath = ''}}},[_c('span',{staticClass:"glyphicon glyphicon-folder-close"})]),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"go to base path of volume"},on:{"click":function($event){_vm.destPath = ''}}},[_vm._v(_vm._s(_vm.volumePath))]),_vm._v(" "),_vm._l((_vm.cookieTrail),function(crumb){return _c('span',[_c('a',{attrs:{"href":"#","title":"go to path"},on:{"click":function($event){_vm.destPath = crumb.path}}},[_vm._v(_vm._s(crumb.name))]),_vm._v(" / ")])}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.destFilename),expression:"destFilename"}],staticClass:"form-control",staticStyle:{"display":"inline","width":"auto","min-width":"300px"},attrs:{"type":"text"},domProps:{"value":(_vm.destFilename)},on:{"input":function($event){if($event.target.composing){ return; }_vm.destFilename=$event.target.value}}}),_vm._v(" "),_c('a',{attrs:{"href":"#","title":"go back one path component"},on:{"click":_vm.backDir}},[_c('span',{staticClass:"glyphicon glyphicon-menu-left"})]),_vm._v(" "),_c('div',{staticClass:"dialog"},[(!_vm.destVolume)?_c('div',[_vm._v("\n      Select user volume:\n      "),_vm._l((_vm.validVolumes.sort()),function(vol){return _c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.destVolume = vol}}},[_vm._v(_vm._s(vol.name))])})],2):_vm._e(),_vm._v(" "),(_vm.destVolume)?_c('div',[_vm._v("\n      Subdirs:\n      "),_c('div',{staticClass:"newdir"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newDir),expression:"newDir"}],staticClass:"form-control",staticStyle:{"width":"120px"},domProps:{"value":(_vm.newDir)},on:{"submit":_vm.mkDir,"input":function($event){if($event.target.composing){ return; }_vm.newDir=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"create directory at path"},on:{"click":_vm.mkDir}},[_vm._v(" + ")])]),_vm._v(" "),_vm._l((_vm.directories.sort()),function(dir){return _c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.destPath = "" + _vm.destPath + dir + "/"}}},[_vm._v(" "+_vm._s(dir)+" ")])})],2):_vm._e(),_vm._v(" "),(_vm.destVolume)?_c('div',{staticStyle:{"margin-top":"6px"}},[_vm._v("\n      Files in path:\n      "),_vm._l((_vm.files.sort()),function(file){return _c('span',{staticStyle:{"font-style":"italic","margin-right":"16px","color":"#cccccc"}},[_vm._v(" "+_vm._s(file)+" ")])})],2):_vm._e()]),_vm._v(" "),(!_vm.valid)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n     "+_vm._s(_vm.invalidity)+"\n   ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v(" Cancel ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.startDialog}},[_vm._v(" Reset ")]),_vm._v(" "),(_vm.valid && _vm.changed)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.apply}},[_vm._v(" Apply")]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OvMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Share Compute Images"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Compute Images")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedResources),expression:"selectedResources"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedResources=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dockerResources),function(domainResources){return _c('optgroup',{key:domainResources[0].dockerComputeDomain.name,attrs:{"label":domainResources[0].dockerComputeDomain.name}},_vm._l((domainResources),function(item){return _c('option',{key:item.entityId,domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)}),0)])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-4 control-label"},[_vm._v("Allow this group to:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"createContainer"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"createContainer")},on:{"change":function($event){_vm.checkedPrivilege="createContainer"}}}),_vm._v("\n          Create Containers\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"createContainer,grant"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"createContainer,grant")},on:{"change":function($event){_vm.checkedPrivilege="createContainer,grant"}}}),_vm._v("\n          Create Containers and Share this Image\n        ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid},on:{"click":_vm.linkResources}},[_vm._v("Share")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P4UP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateVolumeDialog_vue__ = __webpack_require__("XeZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c38d79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateVolumeDialog_vue__ = __webpack_require__("Ugwr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateVolumeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38c38d79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateVolumeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PS+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PpVR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_thenby__);






/* All API calls that are throttled will
   wait at least this many milliseconds between calls */
var API_THROTTLE_TIME = 2000;

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        scienceDomains: [],
        scienceDomainsId: {}
    },
    mutations: {
        setScienceDomainsId: function setScienceDomainsId(state, id) {
            state.scienceDomainsId = id;
        },
        setScienceDomains: function setScienceDomains(state, domains) {
            state.scienceDomains = domains;
        }
    },
    actions: {
        loadScienceDomains: __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function (_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                userProfile = _ref.userProfile;
            return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/publicgroups').then(function (response) {
                var checkScienceDomains = response.body.length;
                if (checkScienceDomains === 0) {
                    commit('loadScienceDomainStatus', false);
                } else {
                    commit('loadScienceDomainStatus', true);
                }
                var globalGroupsBody = response.body;
                var myGlobalGroups = [];
                var userRole = void 0;
                var ownerId = void 0;
                var numOfJoinedDomains = 0;
                for (var i = 0; i < globalGroupsBody.length; i += 1) {
                    var members = [];
                    var formattedResources = globalGroupsBody[i].resources.map(function (r) {
                        return {
                            entityId: r.id,
                            resourceId: r.id,
                            name: r.name,
                            resourceType: r.resourceTypeName,
                            actions: r.actions,
                            resourceContext: {
                                contextClassName: r.contextClassName,
                                description: r.resourceContextUUID,
                                name: r.resourceTypeName
                            }
                        };
                    });
                    var _links = {};
                    for (var j = 0; j < globalGroupsBody[i].admins.length; j += 1) {
                        members.push({
                            status: globalGroupsBody[i].admins[j].role,
                            id: globalGroupsBody[i].admins[j].id,
                            role: globalGroupsBody[i].admins[j].role
                        });
                        if (globalGroupsBody[i].admins[j].role === 'OWNER') {
                            ownerId = globalGroupsBody[i].admins[j].id;
                        }
                    }
                    if (userProfile && userProfile.id && ownerId === state.userProfile.id) {
                        userRole = 'OWNER';
                        _links = {
                            delete: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            editDescription: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            editMemberList: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            editName: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            forceAddMember: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            self: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            shareResource: {
                                href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id + '/sharedResources?actions={actions}&resourceType={resourceType}&entityId={entityId}',
                                templated: true
                            }
                        };
                    } else if (userProfile && userProfile.id && globalGroupsBody[i].userRole === 'ADMIN' && globalGroupsBody[i].userStatus === 'ACCEPTED') {
                        userRole = 'ADMIN';
                        _links = {
                            editDescription: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            editMemberList: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            editName: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            forceAddMember: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            self: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id },
                            shareResource: {
                                href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id + '/sharedResources?actions={actions}&resourceType={resourceType}&entityId={entityId}',
                                templated: true
                            }
                        };
                    } else if (globalGroupsBody[i].userRole === 'MEMBER' && globalGroupsBody[i].userStatus === 'ACCEPTED') {
                        userRole = 'MEMBER';
                        _links = {
                            leave: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/leave?groupId=' + globalGroupsBody[i].id },
                            self: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/ugm/rest/groups/' + globalGroupsBody[i].id }
                        };
                    } else {
                        userRole = 'OTHER';
                        _links = {
                            join: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + 'ugm/rest/groups/join?groupId=' + globalGroupsBody[i].id },
                            self: { href: "https://sciserver.sdcc.bnl.gov/sciserver/racm/" + 'ugm/rest/groups/join?groupId=' + globalGroupsBody[i].id }
                        };
                    }
                    if (_links.leave) {
                        numOfJoinedDomains += 1;
                    }
                    var description = globalGroupsBody[i].description.trim();
                    var titleIndex = description.match(/\[TITLE\]: # \(([^)]*)\)/);
                    if (titleIndex) {
                        globalGroupsBody[i].groupName = titleIndex[1];
                    }
                    myGlobalGroups.push({
                        groupId: globalGroupsBody[i].id,
                        members: members,
                        userRole: userRole,
                        _links: _links,
                        description: description,
                        type: 'PUBLIC GROUP',
                        name: globalGroupsBody[i].groupName,
                        resources: formattedResources
                    });
                }
                myGlobalGroups.sort(__WEBPACK_IMPORTED_MODULE_4_thenby___default()('name'));
                commit('setJoinedScienceDomains', numOfJoinedDomains);
                commit('setTotalScienceDomains', globalGroupsBody.length);
                commit('setScienceDomains', __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(myGlobalGroups, function (c) {
                    return '' + c.groupId;
                }));
                commit('setScienceDomainsId', __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(myGlobalGroups, function (r) {
                    return r.groupId.toString();
                }));
            });
        }, API_THROTTLE_TIME, { trailing: false })
    }
});

/***/ }),

/***/ "Q1Kn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isEditing)?_c('p',[_vm._v("\n    Data Volumes are currently created by creating a docker container with one or more folders mounted.\n    This docker container never has to run, and can be as simple as one using the "),_c('code',[_vm._v("hello")]),_vm._v(" image.\n    This docker volume container must be created on all nodes.\n  ")]):_vm._e(),_vm._v(" "),(!_vm.isEditing && _vm.volumes)?_c('ul',{staticClass:"list-group"},_vm._l((_vm.volumes),function(volume,index){return _c('li',{key:volume.name,staticClass:"list-group-item clearfix"},[_vm._v("\n\n      "+_vm._s(volume.name)+"\n      "),_c('div',{staticClass:"btn-group pull-right",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Remove")])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing()}}},[_vm._v("\n\n    Add New Data Volume\n  ")]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('volume-configurer',{attrs:{"initial-data":_vm.volumes[_vm.currentlyEditingIndex],"is-editing":_vm.currentlyEditingIndex !== undefined},on:{"on-save":_vm.saveVolume,"cancel":_vm.cancelEdit}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QEcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form clearfix"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.name.$error }},[_c('label',[_vm._v("Node Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Node Name"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},function($event){_vm.$v.name.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.name.$error && !_vm.$v.name.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.dockerApiUrl.$error }},[_c('label',[_vm._v("Docker API Server")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.dockerApiUrl),expression:"dockerApiUrl",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://10.10.10.10:2376/"},domProps:{"value":(_vm.dockerApiUrl)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.dockerApiUrl=$event.target.value.trim()},function($event){_vm.$v.dockerApiUrl.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.dockerApiUrl.$error && !_vm.$v.dockerApiUrl.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Docker API Server is required and must be a valid url (e.g., "),_c('code',[_vm._v("https://10.10.10.10:2376/")]),_vm._v(")\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.proxyApiUrl.$error }},[_c('label',[_vm._v("Proxy API Server")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.proxyApiUrl),expression:"proxyApiUrl",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://10.10.10.10:8001/"},domProps:{"value":(_vm.proxyApiUrl)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.proxyApiUrl=$event.target.value.trim()},function($event){_vm.$v.proxyApiUrl.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.proxyApiUrl.$error && !_vm.$v.proxyApiUrl.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Proxy API Server is required and must be a valid url (e.g., "),_c('code',[_vm._v("https://10.10.10.10:8001/")]),_vm._v(")\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.proxyBaseUrl.$error }},[_c('label',[_vm._v("Base URL for Proxy Server")]),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Address by which the node will be accessible to users")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.proxyBaseUrl),expression:"proxyBaseUrl",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"https://domain.example.com/this-node/"},domProps:{"value":(_vm.proxyBaseUrl)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.proxyBaseUrl=$event.target.value.trim()},function($event){_vm.$v.proxyBaseUrl.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.proxyBaseUrl.$error && !_vm.$v.proxyBaseUrl.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Proxy Base URL is required and must be a valid url (e.g., "),_c('code',[_vm._v("https://domain.example.com/this-node/")]),_vm._v(")\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.clientKey.$error }},[_c('label',[_vm._v("Client Key File Name")]),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Name of the private key used by clients to authenticate to the Docker and proxy APIs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.clientKey),expression:"clientKey",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"name-of-node-key.pem"},domProps:{"value":(_vm.clientKey)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.clientKey=$event.target.value.trim()},function($event){_vm.$v.clientKey.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.clientKey.$error && !_vm.$v.clientKey.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Client key name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.clientCert.$error }},[_c('label',[_vm._v("Client Certificate File Name")]),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("Name of the signed certificate used by clients to authenticate to the Docker and proxy APIs")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.clientCert),expression:"clientCert",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"name-of-node-cert.pem"},domProps:{"value":(_vm.clientCert)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.clientCert=$event.target.value.trim()},function($event){_vm.$v.clientCert.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.clientCert.$error && !_vm.$v.clientCert.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Client certificate name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit","disabled":_vm.$v.form.$error},on:{"click":_vm.attemptSave}},[_vm._v(_vm._s(_vm.submitButtonMessage))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QJBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VolumeConfigurer',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    if (this.initialData) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.initialData);
    }
    return {
      name: '',
      description: '',
      dockerRef: ''
    };
  },

  computed: {
    submitButtonMessage: function submitButtonMessage() {
      if (this.isEditing) {
        return 'Save Changes';
      }
      return 'Add Data Volume';
    }
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    description: {},
    dockerRef: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    form: ['name', 'description', 'dockerRef']
  },
  methods: {
    attemptSave: function attemptSave() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      if (isValid) {
        this.$emit('on-save', this.$data);
      }
    }
  }
});

/***/ }),

/***/ "Qvo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileDialog_vue__ = __webpack_require__("upny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50359a5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileDialog_vue__ = __webpack_require__("drtI");
function injectStyle (ssrContext) {
  __webpack_require__("ieWe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50359a5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50359a5e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profileDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R4OF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewGroupButton_vue__ = __webpack_require__("zMFO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97ced4ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewGroupButton_vue__ = __webpack_require__("hfDn");
function injectStyle (ssrContext) {
  __webpack_require__("BjVa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97ced4ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewGroupButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97ced4ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewGroupButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RJhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JqueryCalendar_vue__ = __webpack_require__("GzRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fabb346_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JqueryCalendar_vue__ = __webpack_require__("1SNh");
function injectStyle (ssrContext) {
  __webpack_require__("laQ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JqueryCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fabb346_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JqueryCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "RaCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rd+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nodeIds)?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Compute Nodes")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._v("\n    "+_vm._s(_vm.nodeNames)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RswP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_includes__);



function makePathComponent(userVolumeObject, path) {
  var url = '';
  if (userVolumeObject.type === 'uservolumes') {
    url = userVolumeObject.rootVolumeObj.name + '/' + userVolumeObject.owner + '/' + encodeURIComponent(userVolumeObject.name);
  } else {
    url = '' + encodeURIComponent(userVolumeObject.name);
  }
  if (path) {
    url = '' + url + path;
  }
  return url;
}

function joinBaseURL(userVolumeObject, urlPart) {
  return '' + userVolumeObject.apiEndpoint + urlPart + makePathComponent(userVolumeObject, null) + '/';
}

function joinURLWithPath(userVolumeObject, urlPart, path) {
  var url = joinBaseURL(userVolumeObject, urlPart);
  if (path !== '') {
    var splitString = path.split('/').filter(function (part) {
      return part.length > 0;
    }).map(encodeURIComponent).join('/');
    var fullPath = '' + url + splitString;
    return fullPath;
  }
  return url;
}
function joinURLWithFileName(userVolumeObject, urlPart, path, fileName) {
  var url = joinURLWithPath(userVolumeObject, urlPart, path);
  if (path !== '') {
    var _fullPath = url + '/' + encodeURIComponent(fileName);
    return _fullPath;
  }
  var fullPath = '' + url + encodeURIComponent(fileName);
  return fullPath;
}
/* currentListOfUserVolumes and currentFiles maps these objects to
    * objects with fields for display purposes. */
function getCurrentUVList(myUserVolumeObjects) {
  return myUserVolumeObjects.map(function (val) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      size: '',
      modified: '',
      sharedVolumes: val.rootVolumeObj.containsSharedVolumes,
      grant: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'grant'),
      delete: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'delete'),
      read: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'read'),
      write: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'write'),
      sharedUsers: val.sharedWith,
      url: val.fileserviceObj.apiEndpoint
    }, val);
  });
}
function getCurrentDVList(myDataVolumeObjects) {
  return myDataVolumeObjects.map(function (val) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      size: '',
      modified: '',
      grant: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'grant'),
      delete: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'delete'),
      read: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'read'),
      write: __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(val.allowedActions, 'write'),
      sharedUsers: val.sharedWith
    }, val);
  });
}
function changeVolumesType(type) {
  var selectedVolumeType = '';
  if (type === 'uservolumes') {
    selectedVolumeType = 'uservolumes';
  } else {
    selectedVolumeType = 'datavolumes';
  }
  return selectedVolumeType;
}
function createDownloadFileLink(url, fileName) {
  var link = document.createElement('a');
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.download = fileName;
  link.href = url;
  return link;
}
function clickLink(link) {
  link.click();
}
function removeChildFromDocBody(link) {
  document.body.removeChild(link);
}
function downloadFile(url, fileName) {
  var link = createDownloadFileLink(url, fileName);
  clickLink(link);
  removeChildFromDocBody(link);
}
/* harmony default export */ __webpack_exports__["default"] = ({ joinBaseURL: joinBaseURL,
  joinURLWithPath: joinURLWithPath,
  joinURLWithFileName: joinURLWithFileName,
  getCurrentUVList: getCurrentUVList,
  getCurrentDVList: getCurrentDVList,
  changeVolumesType: changeVolumesType,
  downloadFile: downloadFile,
  createDownloadFileLink: createDownloadFileLink,
  clickLink: clickLink,
  removeChildFromDocBody: removeChildFromDocBody,
  makePathComponent: makePathComponent
});

/***/ }),

/***/ "Rwq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/** @module token-provider */



/**
 * @return {Array}
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var possibleTokens = [];
  var parsed = __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(location.search);
  if (parsed.token) {
    possibleTokens.push(parsed.token);
  }
  if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('portalCookie')) {
    possibleTokens.push(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('portalCookie'));
  }

  return possibleTokens;
});

/***/ }),

/***/ "SJMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerDomainInCompute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return registerNodeInCompute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return registerSlotsForNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerImageInCompute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerImageInRACM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return registerVolumeInCompute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return registerDomainInRACM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return saveEntityToAdminGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return saveAllToAdminGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_range__);






var registerDomainInCompute = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(token, model) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requestBody = {
              name: model.name,
              description: model.description,
              max_memory: parseInt(model.maxMemory, 10)
            };
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/domain', requestBody, {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 3:
            response = _context.sent;
            return _context.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function registerDomainInCompute(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var registerNodeInCompute = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(token, model, node) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            requestBody = {
              name: node.name,
              description: node.name,
              docker_api_url: node.dockerApiUrl,
              docker_api_client_cert: node.clientCert,
              docker_api_client_key: node.clientKey,
              proxy_api_url: node.proxyApiUrl,
              proxy_api_client_cert: node.clientCert,
              proxy_api_client_key: node.clientKey,
              proxy_base_url: node.proxyBaseUrl,
              domain_id: parseInt(model.domain_id, 10)
            };
            _context2.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/node', requestBody, {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function registerNodeInCompute(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var registerSlotsForNode = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(token, nodeId) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            requestBody = {
              node_id: nodeId,
              // Skipping port 10010 since it is used for CRI
              port_numbers: __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(10000, 10010).concat(__WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(10011, 10101))
            };
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/slots', requestBody, {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 3:
            response = _context3.sent;
            return _context3.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function registerSlotsForNode(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var registerImageInCompute = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(token, model, image) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            requestBody = {
              name: image.name,
              description: image.description,
              docker_ref: image.dockerRef,
              container_manager_class: image.containerManagerClass,
              domain_id: parseInt(model.domain_id, 10)
            };
            _context4.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/image', requestBody, {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 3:
            response = _context4.sent;
            return _context4.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function registerImageInCompute(_x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();

var registerImageInRACM = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(token, domainId, image) {
    var existingDomainsResponse, modifiedDomain, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/dockercomputedomains', {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 2:
            existingDomainsResponse = _context5.sent;
            modifiedDomain = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(existingDomainsResponse.data, { id: parseInt(domainId, 10) });

            modifiedDomain.images.push({
              name: image.name,
              description: image.description,
              publisherDID: image.id.toString()
            });
            _context5.next = 7;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/computedomains/docker', modifiedDomain, {
              headers: {
                'X-Auth-Token': token
              },
              params: {
                admins: 'admin'
              }
            });

          case 7:
            response = _context5.sent;
            return _context5.abrupt('return', response.data);

          case 9:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function registerImageInRACM(_x11, _x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}();

var registerVolumeInCompute = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(token, model, volume) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            requestBody = {
              name: volume.name,
              description: volume.description,
              docker_ref: volume.dockerRef,
              domain_id: parseInt(model.domain_id, 10)
            };
            _context6.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/volume', requestBody, {
              headers: {
                'X-Auth-Token': token
              }
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function registerVolumeInCompute(_x14, _x15, _x16) {
    return _ref6.apply(this, arguments);
  };
}();

var registerDomainInRACM = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(token, model) {
    var requestBody, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            requestBody = {
              name: model.name,
              description: model.description,
              publisherDID: model.domain_id.toString(),
              apiEndpoint: "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/api/domains/' + model.domain_id,
              images: model.images.map(function (image) {
                return {
                  name: image.name,
                  description: image.description,
                  publisherDID: image.id.toString()
                };
              }),
              volumes: model.volumes.map(function (volume) {
                return {
                  name: volume.name,
                  description: volume.description,
                  publisherDID: volume.id.toString()
                };
              }),
              rootVolumes: model.rootVolumesOnCD.map(function (rootVolume) {
                return {
                  displayName: rootVolume.name,
                  pathOnCD: model.rootVolumePathOnCDs[rootVolume.id],
                  rootVolumeId: rootVolume.id
                };
              })
            };
            _context7.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/computedomains/docker', requestBody, {
              headers: {
                'X-Auth-Token': token
              },
              params: {
                admins: 'admin'
              }
            });

          case 3:
            response = _context7.sent;
            return _context7.abrupt('return', response.data);

          case 5:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function registerDomainInRACM(_x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();

var saveEntityToAdminGroup = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(adminGroup, token, resourceType, actions, entityId) {
    var url, path;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            url = adminGroup._links.shareResource.href.split('?');
            path = url[0];
            _context8.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(path, {}, {
              headers: {
                'X-Auth-Token': token
              },
              params: {
                resourceType: resourceType,
                actions: actions,
                entityId: entityId
              }
            });

          case 4:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function saveEntityToAdminGroup(_x19, _x20, _x21, _x22, _x23) {
    return _ref8.apply(this, arguments);
  };
}();

var saveAllToAdminGroup = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(adminGroup, token, racmObject) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return racmObject.images.map(function () {
              var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(image) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return saveEntityToAdminGroup(adminGroup, token, 'DOCKERIMAGE', 'grant', image.id);

                      case 2:
                      case 'end':
                        return _context9.stop();
                    }
                  }
                }, _callee9, _this);
              }));

              return function (_x27) {
                return _ref10.apply(this, arguments);
              };
            }());

          case 2:
            _context11.next = 4;
            return racmObject.volumes.map(function () {
              var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(volume) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return saveEntityToAdminGroup(adminGroup, token, 'VOLUMECONTAINER', 'grant', volume.id);

                      case 2:
                      case 'end':
                        return _context10.stop();
                    }
                  }
                }, _callee10, _this);
              }));

              return function (_x28) {
                return _ref11.apply(this, arguments);
              };
            }());

          case 4:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function saveAllToAdminGroup(_x24, _x25, _x26) {
    return _ref9.apply(this, arguments);
  };
}();

/***/ }),

/***/ "SOcW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeRootVolumes_vue__ = __webpack_require__("a1wk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143ef6aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeRootVolumes_vue__ = __webpack_require__("znjg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeRootVolumes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_143ef6aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeRootVolumes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SPy3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AlertPopUp',
  computed: {},
  data: function data() {
    return {
      open: false,
      message: '',
      title: ''
    };
  },
  watch: {},
  mounted: function mounted() {},

  methods: {
    showAlert: function showAlert(message, title) {
      this.message = message;
      this.title = title;
      this.open = true;
    }
  }
});

/***/ }),

/***/ "SXnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__files_utils__ = __webpack_require__("RswP");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_focus__["mixin"]],
  data: function data() {
    return {
      newName: '',
      initialName: '',
      open: false,
      focused: false
    };
  },
  props: ['path', 'userVolume'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    invalidFolderName: function invalidFolderName() {
      return this.newName.includes('/');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  methods: {
    startDialog: function startDialog(initialName) {
      this.newName = initialName;
      this.initialName = initialName;
      this.focused = true;
      this.open = true;
    },
    confirmRename: function confirmRename() {
      var _this = this;

      if (!this.invalidFolderName) {
        this.open = false;
        var url = __WEBPACK_IMPORTED_MODULE_4__files_utils__["default"].joinURLWithFileName(this.userVolume, 'api/data/', this.path, this.initialName);
        var config = { headers: { 'X-Auth-Token': this.token } };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
          destinationPath: this.path + '/' + this.newName,
          destinationRootVolume: this.userVolume.type === 'uservolumes' ? this.userVolume.rootVolumeObj.name : null,
          destinationOwnerName: this.userVolume.type === 'uservolumes' ? this.userVolume.owner : null,
          destinationUserVolume: this.userVolume.type === 'uservolumes' ? this.userVolume.name : null,
          destinationDataVolume: this.userVolume.type === 'uservolumes' ? null : this.userVolume.name,
          destinationFileService: null
        }, config).then(function () {
          _this.$emit('fileRenamed');
        }, function (error) {
          alert('Error Message: ' + error.response.data.error);
        });
      }
    }
  }
});

/***/ }),

/***/ "SnlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listGroup',
  props: ['items', 'onClick', 'title', 'headingType', 'selectedId']
});

/***/ }),

/***/ "StcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_drawer__ = __webpack_require__("MqxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';


// eslint-disable-next-line import/first


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotificationsTab',
  data: function data() {
    return {
      open: false
    };
  },
  components: {
    Drawer: __WEBPACK_IMPORTED_MODULE_1_vue_simple_drawer___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['loadingUI', 'statusUpdate', 'numOfNotifications']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getActionArray', 'getResponseArray', 'getNumOfNotifications']), {
    actionRequiredItems: function actionRequiredItems() {
      return this.getResponseArray;
    }
  }),
  methods: {
    toggle: function toggle() {
      this.open = !this.open;
    },
    removeAction: function removeAction(actionName) {
      this.$store.commit('updateResponseArray', actionName);
    },
    removeAll: function removeAll() {
      this.$store.commit('removeAllNotifications');
    }
  }
});

/***/ }),

/***/ "TF2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function getKeys(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
}
function runningJobs(obj) {
  var keys = getKeys(obj);
  var jobs = 0;
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    if (key < 32) {
      jobs += obj[keys[i]];
    }
  }
  return jobs;
}
function completedJobs(obj) {
  var keys = getKeys(obj);
  var jobs = 0;
  for (var i = 0; i < keys.length; i += 1) {
    var key = keys[i];
    if (key >= 32) {
      jobs += obj[keys[i]];
    }
  }
  return jobs;
}
/* harmony default export */ __webpack_exports__["a"] = ({ runningJobs: runningJobs, completedJobs: completedJobs, getKeys: getKeys });

/***/ }),

/***/ "TabH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserver_compute.c8a2c86.png";

/***/ }),

/***/ "Two5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'changePassword',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    signOutLink: function signOutLink() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/logout?callbackUrl=' + window.location.href;
    },
    pass1EqualPass2: function pass1EqualPass2() {
      return this.password1 === this.password2;
    },
    blankPassField: function blankPassField() {
      return this.password1 === '' || this.password2 === '';
    },
    resetPassword: function resetPassword() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/change-password';
    },
    validPassword: function validPassword() {
      var re = new RegExp('.{8,}');
      return re.test(this.password1);
    },
    forgotPasswordURL: function forgotPasswordURL() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'reset-password';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  data: function data() {
    return {
      password1: '',
      password2: '',
      showPass: false,
      changePassLink: "https://www.sciserver.org/support/how-to-use-sciserver/#change",
      open: false,
      focused: false
    };
  },
  methods: {
    startDialog: function startDialog() {
      this.password1 = '';
      this.password2 = '';
      this.showPass = false;
      this.focused = true;
      this.open = true;
    },
    changePassword: function changePassword() {
      var config = { headers: { 'X-Auth-Token': this.$store.state.token, 'Content-Type': 'application/json', Accept: '*/*' } };
      var url = "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'api/password';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, { password: this.password2 }, config).then(this.redirect, this.error);
    },
    redirect: function redirect() {
      this.clearAll();
      alert('Your password has been updated successfully. You will be redirected to log in page.');
      window.location.replace(this.signOutLink);
    },
    clearAll: function clearAll() {
      this.password1 = '';
      this.password2 = '';
      this.open = false;
    },
    showHidePass: function showHidePass() {
      var x = document.getElementById('changePass1');
      var y = document.getElementById('changePass2');
      if (x.type === 'password') {
        x.type = 'text';
      } else {
        x.type = 'password';
      }
      if (y.type === 'password') {
        y.type = 'text';
      } else {
        y.type = 'password';
      }
    }
  }
});

/***/ }),

/***/ "UH1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodesStep_vue__ = __webpack_require__("gLyJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d06fd830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodesStep_vue__ = __webpack_require__("Y7qq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodesStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d06fd830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodesStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ugwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Files Service\n       "),_c('a',{staticClass:"contextualHints",attrs:{"rel":"noopener","target":"_blank","href":_vm.createUV,"title":"Help Creating User Volume"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Help Creating User Volume")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("User Volume Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVolumeName),expression:"newVolumeName"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"User Volume Name"},domProps:{"value":(_vm.newVolumeName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createUserVolume($event)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.newVolumeName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":"Description"},domProps:{"value":(_vm.description)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createUserVolume($event)},"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Root Volume: ")]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("Select a Root Volume to choose where this user volume is mounted. Different root volumes may have different data storage options.")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRootV),expression:"selectedRootV"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedRootV=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":""},domProps:{"value":{}}},[_vm._v("Select a Root Volume")]),_vm._v(" "),_vm._l((_vm.sortedRootVolumes),function(rootV){return _c('option',{key:rootV.id,domProps:{"value":rootV}},[_vm._v("\n              "+_vm._s(rootV.name)+" - "+_vm._s(rootV.description)+"\n            ")])})],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidUVName),expression:"invalidUVName"}]},[_vm._v("User volume name cannot contain /.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid || _vm.invalidUVName},on:{"click":_vm.createUserVolume}},[_vm._v(" Create User Volume")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uvt9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserver_icon_groups.7ee05a4.png";

/***/ }),

/***/ "UwFo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V75J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scienceTab"}},[_c('div',{staticClass:"container-fluid wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('list-group',{attrs:{"title":"Science Domains","headingType":"primary"}},_vm._l((_vm.sortedCollaborationIds),function(collaborationId){return _c('router-link',{key:collaborationId,staticClass:"list-group-item",class:{active: _vm.shownCollaborationId === collaborationId},attrs:{"to":("/science/" + (_vm.currentListOfGroups[collaborationId].groupId)),"type":"button","role":"tab"},nativeOn:{"click":function($event){_vm.selectedCollaborationId = collaborationId}}},[_c('span',{staticStyle:{"font-size":"2rem"}},[_vm._v(_vm._s(_vm.currentListOfGroups[collaborationId].name))]),_vm._v(" "),(!_vm.currentListOfGroups[collaborationId]._links.join)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"#5cb85c","font-size":"2em"},attrs:{"id":"checkbox","aria-hidden":"true"}}):_vm._e()])}),1),_vm._v(" "),_c('notifications',{attrs:{"position":"top left","width":"300","group":"foo2"}}),_vm._v(" "),(_vm.alertStatus)?_c('div',{staticClass:"alert alert-success",attrs:{"id":"success-alert"}},[_vm._v("\n          "+_vm._s(_vm.alertMessage)+" "),_c('strong',[_vm._v(" "+_vm._s(_vm.currentDomain)+" ")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[(_vm.shownCollaborationObject)?_c('div',{staticClass:"main-screen"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel panel-heading "},[_vm._v("\n                    "+_vm._s(_vm.shownCollaborationObject.name)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"panel panel-body"},[_c('div',{staticClass:"col-md-2"},[_c('table',[_c('tr',[_c('td',[(_vm.shownCollaborationObjectLogo)?_c('img',{staticClass:"img-responsive science-image",attrs:{"src":_vm.shownCollaborationObjectLogo}}):_c('img',{staticClass:"img-responsive science-image",attrs:{"src":__webpack_require__("zCUr")}}),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"10%","text-align":"center"}},[(_vm.joinStatus)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.joinPublicCollaboration}},[_vm._v(" Join ")]):_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.leaveCollaboration}},[_vm._v(" Leave ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"markdown-render"},[_c('vue-markdown',{attrs:{"source":_vm.markedDescription,"breaks":false,"html":true}})],1)])])]),_vm._v(" "),_vm._l((_vm.getTitles),function(value){return (value !== 'FileService.UserVolume' && value !== 'privilege' && value !== 'VolumeContainer')?_c('div',[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel panel-heading"},[(value === 'Casjobs.DatabaseContext')?_c('span',{staticClass:"panel-title"},[_vm._v(" Casjobs Database ")]):_vm._e(),_vm._v(" "),(value === 'DockerImage')?_c('span',{staticClass:"panel-title"},[_vm._v(" Compute Image ")]):_vm._e(),_vm._v(" "),(value === 'FileService.DataVolume')?_c('span',{staticClass:"panel-title"},[_vm._v(" Data Set ")]):_vm._e(),_vm._v(" "),(value === 'DatabaseContext')?_c('span',{staticClass:"panel-title"},[_vm._v(" Database Context ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body resource-container"},_vm._l((_vm.shownCollaborationObject.resources),function(resourceObject){return (value === resourceObject.resourceType && value !== 'privilege')?_c('div',{staticClass:"col-md-2"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('i',{class:_vm.getImage(value),staticStyle:{"color":"#666666"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(resourceObject.name)+" ")])]),_vm._v(" "),_c('br')]):_vm._e()}),0)])]):_vm._e()})],2):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VFSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Share Data Volume"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Data Volume")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedResources),expression:"selectedResources"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedResources=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.dvResources),function(domainResources){return _c('optgroup',{key:domainResources[0].fileService.name,attrs:{"label":domainResources[0].fileService.name}},_vm._l((domainResources),function(item){return _c('option',{key:item.entityId,domProps:{"value":item}},[_vm._v("\n              "+_vm._s(item.name)+"\n            ")])}),0)}),0)])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-4 control-label"},[_vm._v("Allow this group to:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read")},on:{"change":function($event){_vm.checkedPrivilege="read"}}}),_vm._v("\n            Read\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write")},on:{"change":function($event){_vm.checkedPrivilege="read,write"}}}),_vm._v("\n            Read/Write\n          ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write,grant"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write,grant")},on:{"change":function($event){_vm.checkedPrivilege="read,write,grant"}}}),_vm._v("\n            Read/Write and Share this Data Volume\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"text-muted center-block"},[_vm._v("**Share volume containers associated with the data volumes through resources page.")]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid},on:{"click":_vm.linkResources}},[_vm._v("Share")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VG/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeRootVolume_vue__ = __webpack_require__("3k/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_033cffe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeRootVolume_vue__ = __webpack_require__("ketF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeRootVolume_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_033cffe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeRootVolume_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VPLt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupsTab_vue__ = __webpack_require__("mB/h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a09ef696_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupsTab_vue__ = __webpack_require__("qhHi");
function injectStyle (ssrContext) {
  __webpack_require__("oBS8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a09ef696"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupsTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a09ef696_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupsTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VflN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vr67":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form clearfix"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.name.$error }},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Data Volume Name"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},function($event){_vm.$v.name.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.name.$error && !_vm.$v.name.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.description.$error }},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.description),expression:"description",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.description)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.description=$event.target.value.trim()},function($event){_vm.$v.description.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.dockerRef.$error }},[_c('label',[_vm._v("Docker Volume Container Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.dockerRef),expression:"dockerRef",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"volume_myvolume"},domProps:{"value":(_vm.dockerRef)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.dockerRef=$event.target.value.trim()},function($event){_vm.$v.dockerRef.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.dockerRef.$error && !_vm.$v.dockerRef.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      A name of a container containing the mounts for this data volume must be specified\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit","disabled":_vm.$v.form.$error},on:{"click":_vm.attemptSave}},[_vm._v(_vm._s(_vm.submitButtonMessage))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WCQg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserver_logo_icon_blue.e304c50.png";

/***/ }),

/***/ "WMna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RootVolumes__ = __webpack_require__("C+pg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbForFile__ = __webpack_require__("uVBl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sharedComponents_alertDialog__ = __webpack_require__("pqqY");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var $ = __webpack_require__("7t+N");
var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");
var fileUtils = __webpack_require__("RswP").default;
var mathUtils = __webpack_require__("jIKD").default;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'moveFiles',
  data: function data() {
    return {
      path: '',
      shared: false,
      url: '',
      loading: false,
      parentURL: '',
      selected: [],
      open: false,
      selectedVolumeType: 'uservolumes',
      selectedUVId: ''
    };
  },
  components: {
    RootVolumeTemplate: __WEBPACK_IMPORTED_MODULE_7__RootVolumes__["a" /* default */],
    BreadCrumb: __WEBPACK_IMPORTED_MODULE_8__BreadcrumbForFile__["a" /* default */],
    popUpDialog: __WEBPACK_IMPORTED_MODULE_9__sharedComponents_alertDialog__["a" /* default */]
  },
  created: function created() {
    this.getVolumes();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isShowingFiles: function isShowingFiles() {
      return this.currentUserVolume;
    },
    currentRootVolumes: function currentRootVolumes() {
      var rv = [];
      if (this.myRootVolumeObjects) {
        rv.push({ name: 'User Volumes', type: 'uservolumes', id: 1 });
      }
      if (this.myDataVolumeObjects) {
        rv.push({ name: 'Data Volumes', type: 'datavolumes', id: 2 });
      }
      return rv;
    },
    currentListOfUV: function currentListOfUV() {
      if (this.selectedVolumeType === 'uservolumes') {
        return fileUtils.getCurrentUVList(this.myUserVolumeObjects);
      } else if (this.selectedVolumeType === 'datavolumes') {
        return fileUtils.getCurrentDVList(this.myDataVolumeObjects);
      }
      return undefined;
    },
    currentUserVolume: function currentUserVolume() {
      var id = this.selectedUVId;
      if (id === undefined || this.myUserVolumeObjects.length === 0) {
        return undefined;
      }
      return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(this.currentListOfUV, { id: parseInt(id, 10) });
    },
    listToDisplay: function listToDisplay() {
      if (this.currentUserVolume) {
        return this.currentFiles;
      }
      return this.currentListOfUV;
    },
    sortedVolumes: function sortedVolumes() {
      var sortAll = _.orderBy(this.listToDisplay, ['type', 'name']);
      return sortAll;
    },
    username: function username() {
      return this.userProfile.username;
    },
    currentFiles: function currentFiles() {
      var _this = this;

      if (!this.currentUserVolume) return [];
      var jsonTree = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.$store.state.files.jsonTreeCache, [this.currentUserVolume.id, this.path]);
      return __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(jsonTree, 'root.folders', []), function (folder) {
        return {
          name: folder.name,
          type: 'dir',
          owner: _this.currentUserVolume.owner,
          size: folder.size ? mathUtils.bytesToSize(folder.size) : '',
          modified: folder.lastModified === null ? '' : moment(folder.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }), __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(jsonTree, 'root.files', []), function (file) {
        return {
          name: file.name,
          type: 'file',
          size: file.size === null ? '' : mathUtils.bytesToSize(file.size),
          modified: file.lastModified === null ? '' : moment(file.lastModified).format('YYYY-MM-DD HH:mm:ss')
        };
      }));
    },
    columnFields: function columnFields() {
      if (this.selectedVolumeType === 'uservolumes') {
        return ['Volume', 'Root Volume', 'Owner'];
      } else if (this.selectedVolumeType === 'datavolumes') {
        return ['Data Sets', 'Folders', ''];
      }
      return undefined;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'myRootVolumeObjects', 'myDataVolumeObjects'])),
  watch: {
    currentUserVolume: function currentUserVolume(uv) {
      if (uv) {
        this.getFiles();
      }
    },
    path: function path() {
      if (this.currentUserVolume) {
        this.getFiles();
      }
    }
  },
  // All the methods you want the view to have access to, basically an object of functions
  methods: {
    getVolumes: function getVolumes() {
      this.$store.dispatch('loadAllUserVolumes');
    },
    getFiles: function getFiles() {
      this.$store.dispatch('loadJsonTreeById', { userVolumeId: this.currentUserVolume.id, path: this.path, type: this.currentUserVolume.type });
    },
    changeUV: function changeUV(id) {
      this.path = '';
      this.selectedUVId = id;
    },
    goToFiles: function goToFiles(name) {
      this.path += '/' + name;
    },
    showFiles: function showFiles(index) {
      var allPath = this.path.split('/');
      var len = allPath.length - 1;
      allPath.splice(index + 1, len);
      var strPath = allPath.join('/');
      this.path = '' + strPath;
    },
    move: function move(selectedFile, url) {
      this.parentURL = url;
      this.resetPath();
      this.selected = selectedFile;
      this.open = true;
    },
    sendToMove: function sendToMove() {
      var _this2 = this;

      $('#spinner').show();
      this.$store.commit('loadingStatus', ['Moving', 'True']);
      if (Array.isArray(this.selected)) {
        $.each(this.selected, function (index0, text0) {
          _this2.confirmMove(text0.name);
          console.log('inside $');
        });
      } else {
        this.confirmMove(this.selected.name);
      }
    },
    confirmMove: function confirmMove(selected) {
      var _this3 = this;

      var filepath = this.currentUserVolume.type + '/' + this.currentUserVolume.name + this.path;
      var actionUrl = this.currentUserVolume.type + '/' + this.$route.params.userVolumeId + this.path;
      var actionObject = {
        actionName: 'Moving',
        actionFileName: selected,
        actionLocation: '' + filepath,
        actionStatus: 'True'
      };
      this.$store.commit('updateMessage', actionObject);
      var config = { headers: { 'X-Auth-Token': this.$store.state.token } };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(this.parentURL + '/' + encodeURIComponent(selected) + '?replaceExisting=false&doCopy=false', {
        destinationPath: this.path + '/' + selected,
        destinationRootVolume: this.currentUserVolume.type === 'uservolumes' ? this.currentUserVolume.rootVolumeObj.name : null,
        destinationUserVolume: this.currentUserVolume.type === 'uservolumes' ? decodeURIComponent(this.currentUserVolume.name) : null,
        destinationDataVolume: this.currentUserVolume.type === 'uservolumes' ? null : decodeURIComponent(this.currentUserVolume.name),
        destinationOwnerName: this.currentUserVolume.type === 'uservolumes' ? this.currentUserVolume.owner : null,
        destinationFileService: null }, config).then(function () {
        _this3.getFiles();
        _this3.$emit('movedSuccess');
        $('#spinner').hide();
        actionObject = {
          actionName: 'Moving',
          actionFileName: selected,
          actionLocation: '' + filepath,
          actionStatus: 'False'
        };
        _this3.$store.commit('updateMessage', actionObject);
        _this3.$store.commit('loadingStatus', '');
      }, function (error) {
        console.log(error.response.data);
        actionObject = {
          actionName: 'Moving',
          actionFileName: selected,
          actionLocation: '' + filepath,
          actionStatus: 'False',
          actionRequired: 'True',
          actionurl: '' + actionUrl,
          actionMessage: error.response.data.error
        };
        _this3.$store.commit('updateMessage', actionObject);
        _this3.$store.commit('loadingStatus', '');
        $('#spinner').hide();
      });
      // $('#spinner').hide();
    },
    close: function close() {
      this.$emit('close');
    },
    changeVolumesType: function changeVolumesType(type) {
      this.selectedVolumeType = fileUtils.changeVolumesType(type);
      this.resetPath();
    },
    resetPath: function resetPath() {
      this.selectedUVId = undefined;
      this.path = '';
    }
  }
});

/***/ }),

/***/ "WZ7T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);



/* All API calls that are throttled will
wait at least this many milliseconds between calls */
var API_THROTTLE_TIME = 2000;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    jobs: []
  },
  mutations: {
    setJobs: function setJobs(state, jobsList) {
      state.jobs = jobsList;
    }
  },
  actions: {
    loadJobs: __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function (_ref) {
      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/jobsstats?since=24').then(function (response) {
        commit('setJobs', response.data);
      });
    }, API_THROTTLE_TIME, { trailing: false })
  }
});

/***/ }),

/***/ "Wxpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'RenameMoveDialog',
    mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_focus__["mixin"]],
    props: ['currentVolume', 'currentPath', 'validVolumes', 'autoExtension'],
    data: function data() {
        return {
            open: false,
            focused: false,
            destFilename: '',
            destPath: '',
            destVolume: null,
            pathContents: null,
            invalidity: '',
            newDir: ''
        };
    },
    watch: {
        basePath: function basePath() {
            this.pathContents = null;
            this.getDirs();
        }
    },
    computed: {
        volumePath: function volumePath() {
            if (this.destVolume) {
                console.log(this.destVolume);
                return this.destVolume.urlSegment;
            }
            return '';
        },
        basePath: function basePath() {
            return '' + this.volumePath + this.destPath;
        },
        directories: function directories() {
            if (!this.pathContents) {
                return [];
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.pathContents.root.folders, function (i) {
                return i.name;
            });
        },
        files: function files() {
            if (!this.pathContents) {
                return [];
            }
            return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(this.pathContents.root.files, function (i) {
                return i.name;
            });
        },
        cookieTrail: function cookieTrail() {
            var x = '';
            return this.destPath.split('/').slice(0, -1).map(function (i) {
                x = '' + x + i + '/';return { name: i, path: x };
            });
        },
        valid: function valid() {
            this.invalidity = '';
            if (!this.changed) {
                return true;
            }
            if (this.destVolume == null) {
                this.invalidity = 'please select a destination volume';
            }
            if (this.destFilename.includes('/')) {
                this.invalidity += 'Filename cannot contain "/"! ';
            }
            if (this.files.includes(this.destFilename + this.autoExtension)) {
                this.invalidity += 'File already exists! ';
            }
            return this.invalidity === '';
        },
        changed: function changed() {
            if (this.destPath + this.destFilename === this.currentPath && this.destVolume === this.currentVolume) {
                return false;
            }
            return true;
        }
    },
    methods: {
        startDialog: function startDialog() {
            this.focused = true;
            this.open = true;
            this.destFilename = this.currentPath.split('/').pop();
            this.destPath = this.currentPath.split('/').slice(0, -1).join('/');
            if (this.destPath !== '') {
                this.destPath += '/';
            }
            this.destVolume = this.currentVolume;
        },
        getDirs: function getDirs() {
            var _this = this;

            if (this.destVolume) {
                var url = this.destVolume.apiEndpoint + '/api/jsontree/' + this.basePath + '?level=2';
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, conf).then(function (response) {
                    _this.pathContents = response.data;
                });
            }
        },
        backDir: function backDir() {
            if (this.destPath === '') {
                this.destVolume = null;
            }
            this.destPath = this.destPath.split('/').slice(0, -2).join('/');
            if (this.destPath !== '') {
                this.destPath = this.destPath + '/';
            }
        },
        mkDir: function mkDir() {
            var _this2 = this;

            if (this.newDir) {
                var url = this.destVolume.apiEndpoint + '/api/folder/' + this.basePath + this.newDir;
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url, null, conf).then(function () {
                    _this2.destPath = '' + _this2.destPath + _this2.newDir + '/';
                    _this2.newDir = '';
                    _this2.getDirs();
                }).catch(function (error) {
                    var msg = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(error, 'response.data.error') || 'Unknown error creating directory!';
                    _this2.$notify({ group: 'top_center_notify', type: 'error', text: msg });
                });
            }
        },
        apply: function apply() {
            this.$emit('renamed', { volume: this.destVolume, path: this.destPath + this.destFilename });
            this.open = false;
            this.focused = false;
        }
    }
});

/***/ }),

/***/ "XODw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeFrame_vue__ = __webpack_require__("LS1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ab3a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeFrame_vue__ = __webpack_require__("Y3hP");
function injectStyle (ssrContext) {
  __webpack_require__("wKU1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67ab3a81"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ab3a81_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XeZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FilesTab__ = __webpack_require__("9JyY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sharedComponents_alertDialog__ = __webpack_require__("pqqY");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  components: {
    FilesTab: __WEBPACK_IMPORTED_MODULE_5__FilesTab__["a" /* default */],
    popUpDialog: __WEBPACK_IMPORTED_MODULE_6__sharedComponents_alertDialog__["a" /* default */]
  },
  data: function data() {
    return {
      newVolumeName: '',
      description: '',
      open: false,
      selectedRootV: {},
      createUV: "https://www.sciserver.org/support/how-to-use-sciserver/#createvolume",
      focused: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    // workspace root volumes does not have create permission
    hasCreatePerm: function hasCreatePerm() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(this.myRootVolumeObjects.allowedActions, 'write');
    },
    isValid: function isValid() {
      return this.newVolumeName && this.selectedRootV.name;
    },
    invalidUVName: function invalidUVName() {
      return this.newVolumeName.includes('/');
    },
    sortedRootVolumes: function sortedRootVolumes() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default()(this.myRootVolumeObjects.filter(function (x) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(x.allowedActions, 'create');
      }), 'name');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['myFileSystemObjects', 'myRootVolumeObjects']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  methods: {
    startDialog: function startDialog() {
      this.newVolumeName = '';
      this.selectedRootV = {};
      this.description = '';
      this.focused = true;
      this.open = true;
    },
    createUserVolume: function createUserVolume() {
      if (!this.invalidUVName) {
        this.open = false;
        var newOwner = this.userProfile.username;
        var config = { headers: { 'X-Auth-Token': this.token } };
        var encodedUVName = encodeURIComponent(this.newVolumeName);
        var URL = this.selectedRootV.fileserviceObj.apiEndpoint + 'api/volume/' + this.selectedRootV.name + '/' + newOwner + '/' + encodedUVName;
        this.$store.dispatch('createUV', { description: this.description, path: URL, config: config });
      }
    }
  }
});

/***/ }),

/***/ "XfQq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Create Folder"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Folder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newFolderName),expression:"newFolderName"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"New Folder Name"},domProps:{"value":(_vm.newFolderName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.createSubFolder($event)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.newFolderName=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidUVName),expression:"invalidUVName"}]},[_vm._v("Folder name cannot contain /.")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.invalidUVName},on:{"click":function($event){_vm.createSubFolder()}}},[_vm._v("Create Folder")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xp25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVolumeDialog_vue__ = __webpack_require__("5Uh/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5668f2a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVolumeDialog_vue__ = __webpack_require__("teTW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditVolumeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5668f2a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditVolumeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XueU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_zipWith__ = __webpack_require__("5Je9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_zipWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_zipWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__ = __webpack_require__("SJMa");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DomainSaver',
  props: ['finalModel'],
  data: function data() {
    return {
      registeredDomainInCompute: false,
      registeredNodesInCompute: false,
      registeredSlotsInCompute: false,
      registeredImagesInCompute: false,
      registeredVolumesInCompute: false,
      registeredInRACM: false,
      sharedAllWithAdminGroup: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    totalProgress: function totalProgress() {
      var tasksCompleted = +this.registeredDomainInCompute + +this.registeredNodesInCompute + +this.registeredSlotsInCompute + +this.registeredImagesInCompute + +this.registeredVolumesInCompute + +this.registeredInRACM + +this.sharedAllWithAdminGroup;
      return Math.round(100 * (tasksCompleted / 7));
    },
    totalProgressStyle: function totalProgressStyle() {
      return {
        minWidth: '2em',
        width: this.totalProgress + '%'
      };
    },
    adminGroup: function adminGroup() {
      var _this = this;

      if (!this.myCollaborations) return undefined;
      return this.myCollaborations.map(function (x) {
        return _this.collaborations[x];
      }).find(function (x) {
        return x.name === 'admin' && x.type === 'GROUP';
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['token', 'collaborations', 'myCollaborations'])),
  methods: {
    saveDomain: function saveDomain() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, runningModel, addIds, domainIds, allNodes, allImages, allVolumes, racmObj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this2;
                runningModel = vm.finalModel;

                addIds = function addIds(list, ids) {
                  return __WEBPACK_IMPORTED_MODULE_5_lodash_zipWith___default()(list, ids, function (object, id) {
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
                      id: id
                    }, object);
                  });
                };

                _context.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["a" /* registerDomainInCompute */])(vm.token, runningModel);

              case 5:
                domainIds = _context.sent;


                vm.registeredDomainInCompute = true;
                runningModel = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({ domain_id: domainIds }, runningModel);
                allNodes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(runningModel.nodes.map(function (nodeObj) {
                  return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["e" /* registerNodeInCompute */])(vm.token, runningModel, nodeObj);
                })).then(function (nodeIds) {
                  vm.registeredNodesInCompute = true;
                  runningModel = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, runningModel, { nodes: addIds(runningModel.nodes, nodeIds) });
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(nodeIds.map(function (nodeId) {
                    return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["f" /* registerSlotsForNode */])(vm.token, nodeId);
                  }));
                });
                allImages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(runningModel.images.map(function (imageObj) {
                  return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["c" /* registerImageInCompute */])(vm.token, runningModel, imageObj);
                })).then(function (imageIds) {
                  vm.registeredImagesInCompute = true;
                  runningModel = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, runningModel, { images: addIds(runningModel.images, imageIds) });
                });
                allVolumes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(runningModel.volumes.map(function (volumeObj) {
                  return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["g" /* registerVolumeInCompute */])(vm.token, runningModel, volumeObj);
                })).then(function (volumeIds) {
                  vm.registeredVolumesInCompute = true;
                  runningModel = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, runningModel, { volumes: addIds(runningModel.volumes, volumeIds) });
                });
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([allNodes, allImages, allVolumes]);

              case 13:
                _context.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["b" /* registerDomainInRACM */])(vm.token, runningModel);

              case 15:
                racmObj = _context.sent;

                vm.registeredInRACM = true;

                _context.next = 19;
                return Object(__WEBPACK_IMPORTED_MODULE_6__components_admin_compute_new_domain_wizard_domain_register__["h" /* saveAllToAdminGroup */])(vm.adminGroup, vm.token, racmObj);

              case 19:
                vm.sharedAllWithAdminGroup = true;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "Y+Xs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareUserVolumeDialog_vue__ = __webpack_require__("tU44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4307a033_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareUserVolumeDialog_vue__ = __webpack_require__("+W2J");
function injectStyle (ssrContext) {
  __webpack_require__("k0Xc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4307a033"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShareUserVolumeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4307a033_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShareUserVolumeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y3hP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"computeApp",staticClass:"container"},[_c('iframe',{ref:"computeFrame",staticClass:"expanded",attrs:{"src":_vm.computeContainerUrl},on:{"load":_vm.frameLoadCallback}}),_vm._v(" "),(!_vm.loaded)?_c('div',{staticClass:"loading expanded curtain"},[(_vm.imageErrors.length > 0)?_c('div',[_c('span',{staticClass:"glyphicon glyphicon-warning-sign",staticStyle:{"font-size":"60px","margin":"auto","color":"#337ab7","padding-bottom":"14px"}}),_vm._v(" "),_vm._l((_vm.imageErrors),function(err){return _c('div',[_vm._v("\n        "+_vm._s(err)+"\n      ")])})],2):_c('div',[_c('span',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"70px"}}),_vm._v(" "),_c('p',{staticStyle:{"padding-top":"15px","font-style":"italic"}},[_vm._v(" "+_vm._s(_vm.loadMessage)+" ")])])]):_vm._e(),_vm._v(" "),(_vm.needsprobe)?_c('div',{staticClass:"transparent expanded curtain"}):_vm._e(),_vm._v(" "),(_vm.inactive)?_c('div',{staticClass:"cloaked expanded curtain"},[_c('div',{staticStyle:{"background-color":"#ffffffde","padding":"60px","border-radius":"20px","font-weight":"bold","max-width":"40%","margin":"auto"}},[_c('p',{staticStyle:{"margin-bottom":"16px"}},[_vm._v(" Your session has been paused due to inactivity ")]),_vm._v(" "),_c('span',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.reload()}}},[_vm._v(" reload ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y7qq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isEditing)?_c('p',[_vm._v("\n    Nodes (a.k.a DockerVMs) are configured through using the "),_c('code',[_vm._v("scripts/node-setup.sh")]),_vm._v(" in the\n    "),_c('a',{attrs:{"href":"https://github.com/sciserver/sciserver-compute-java/"}},[_vm._v("sciserver-compute-java")]),_vm._v("\n    repository. This script generates private and signing keys in "),_c('code',[_vm._v("/etc/certs")]),_vm._v(" that are needed\n    for allowing Compute to communicate with the nodes.\n  ")]):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('p',[_vm._v("\n    Containers are created such that the proxy may communicate to them on any ports\n    between 10000 and 10100, not including port 10010. Be sure no other processes are using these ports.\n  ")]):_vm._e(),_vm._v(" "),(!_vm.isEditing && _vm.nodes)?_c('ul',{staticClass:"list-group"},_vm._l((_vm.nodes),function(node,index){return _c('li',{key:node.name,staticClass:"list-group-item clearfix"},[_vm._v("\n\n      "+_vm._s(node.name)+"\n      "),_c('div',{staticClass:"btn-group pull-right",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Remove")])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing()}}},[_vm._v("\n\n    Add New Node\n  ")]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('node-configurer',{attrs:{"initial-data":_vm.nodes[_vm.currentlyEditingIndex],"is-editing":_vm.currentlyEditingIndex !== undefined},on:{"on-save":_vm.saveNode,"cancel":_vm.cancelEdit}}):_vm._e(),_vm._v(" "),(_vm.$v.form.$error)?_c('p',{staticClass:"text-danger"},[_vm._v("\n      One or more nodes must be configured\n    ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sharedComponents_NotFound__ = __webpack_require__("BQry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_profile_getter__ = __webpack_require__("N5D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GroupsTab__ = __webpack_require__("VPLt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SciserverTab__ = __webpack_require__("zBdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UserActivityTab__ = __webpack_require__("l4iD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ResourcesTab__ = __webpack_require__("9Qic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FilesTab__ = __webpack_require__("9JyY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_ComputeAdmin__ = __webpack_require__("5qSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ScienceTab__ = __webpack_require__("fqdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_NotebookTab__ = __webpack_require__("FxQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_notebook_NotebookDash__ = __webpack_require__("atA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Editor__ = __webpack_require__("aek+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_compute_ComputeApp__ = __webpack_require__("94Ju");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__redirectionToLoginPortal__ = __webpack_require__("ExJh");

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base:  false ? '/' : "/sciserver/dashboard/",
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_5__components_SciserverTab__["a" /* default */],
    alias: ['/dashboard']
  }, {
    path: '/groups/:groupId?',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_4__components_GroupsTab__["a" /* default */]
  }, {
    path: '/resource',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ResourcesTab__["a" /* default */]
  }, {
    path: '/files/:rootVolume?/:userVolumeId?/:path*',
    name: 'Files Tab',
    component: __WEBPACK_IMPORTED_MODULE_8__components_FilesTab__["a" /* default */]
  }, {
    path: '/activity_log',
    component: __WEBPACK_IMPORTED_MODULE_6__components_UserActivityTab__["a" /* default */]
  }, {
    path: '/admin/compute',
    component: __WEBPACK_IMPORTED_MODULE_9__components_admin_ComputeAdmin__["a" /* default */]
  }, {
    path: '/notebook/:volType/:volId/:path+',
    component: __WEBPACK_IMPORTED_MODULE_11__components_NotebookTab__["a" /* default */]
  }, {
    path: '/notebook',
    component: __WEBPACK_IMPORTED_MODULE_12__components_notebook_NotebookDash__["a" /* default */]
  }, {
    path: '/editor',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Editor__["a" /* default */]
  }, {
    path: '/science/:scienceId?',
    component: __WEBPACK_IMPORTED_MODULE_10__components_ScienceTab__["a" /* default */]
  }, {
    path: '/apps',
    component: __WEBPACK_IMPORTED_MODULE_14__components_compute_ComputeApp__["a" /* default */]
  }, {
    path: '*',
    name: 'fallback',
    component: __WEBPACK_IMPORTED_MODULE_2__components_sharedComponents_NotFound__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  if (
  // don't authenticate if logged in
  to.name === 'fallback' ||
  // or already logged in
  router.app.$store.state.token) {
    next();
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_3__user_profile_getter__["a" /* default */])().then(function (_ref) {
    var userProfile = _ref.userProfile,
        token = _ref.token;

    router.app.$store.commit('setUserProfile', userProfile);
    router.app.$store.commit('setToken', token);
    router.app.$store.dispatch('loadConfig');
    router.app.$store.dispatch('loadPublicGroupsAndUsers');
    router.app.$store.dispatch('loadCollaborations');
    router.app.$store.dispatch('loadJobs');
    router.app.$store.dispatch('loadAllUserVolumes').then(function () {
      return router.app.$store.dispatch('loadAllQuotas');
    });
    next();
  }).catch(function () {
    Object(__WEBPACK_IMPORTED_MODULE_15__redirectionToLoginPortal__["a" /* default */])();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YfF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueSelect2_vue__ = __webpack_require__("5tvu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4672530_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSelect2_vue__ = __webpack_require__("3s5q");
function injectStyle (ssrContext) {
  __webpack_require__("Ggrg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VueSelect2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4672530_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VueSelect2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YhQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__("+X65");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* All API calls that are throttled will
wait at least this many milliseconds between calls */
var API_THROTTLE_TIME = 2000;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    userProfile: {},
    courses: {},
    selectedCourse: [],
    coursesLoadingStatus: 'NOTLOADED'
  },
  getters: {},
  mutations: {
    setCourses: function setCourses(state, courses) {
      state.courses = courses;
    },
    setCourseByID: function setCourseByID(state, course) {
      state.selectedCourse = course;
    },
    startLoadingCourses: function startLoadingCourses(state) {
      switch (state.coursesLoadingStatus) {
        case 'NOTLOADING':
          state.coursesLoadingStatus = 'LOADING';
          break;
        case 'LOADED':
          state.coursesLoadingStatus = 'RELOADING';
          break;
        default:
          break;
      }
    },
    finishLoadingCourses: function finishLoadingCourses(state) {
      state.coursesLoadingStatus = 'LOADED';
    }
  },
  actions: {
    // works
    loadCourses: __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function (_ref) {
      var commit = _ref.commit;

      commit('startLoadingCourses');
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/courses', { headers: { Accept: '*' } }).then(function (response) {
        commit('setCourses', response.body);
        commit('finishLoadingCourses');
      });
    }, API_THROTTLE_TIME, { trailing: false }),
    // works
    loadCourseByID: function loadCourseByID(_ref2, courseID) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.get("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/course/' + courseID, { headers: { Accept: '*' } }).then(function (response) {
        commit('setCourseByID', response.body);
      });
    },
    editCourse: function editCourse(_ref3, _ref4) {
      var dispatch = _ref3.dispatch;
      var courseID = _ref4.courseID,
          newGroupInfo = _ref4.newGroupInfo;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/course/' + courseID, newGroupInfo).then(function () {
        dispatch('loadCourses');
        dispatch('loadCourseByID');
      });
    },
    editMember: function editMember(_ref5, _ref6) {
      var dispatch = _ref5.dispatch;
      var courseID = _ref6.courseID,
          newMembersList = _ref6.newMembersList;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/courses/' + courseID, newMembersList).then(function () {
        dispatch('loadCourses');
      });
    },
    shareResources: function shareResources(_ref7, _ref8) {
      var dispatch = _ref7.dispatch;
      var courseID = _ref8.courseID,
          resourceType = _ref8.resourceType,
          permissions = _ref8.permissions,
          entityId = _ref8.entityId;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.put("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/courses/' + courseID + '/sharedResources?resourceType=' + resourceType + '&actions=' + permissions + '&entityId=' + entityId).then(function () {
        dispatch('loadCourses');
      });
    },

    // works
    createCourse: function createCourse(_ref9, _ref10) {
      var dispatch = _ref9.dispatch;
      var course = _ref10.course;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.post("https://sciserver.sdcc.bnl.gov/sciserver/courseware/courseware" + '/course', course).then(function () {
        dispatch('loadCourses');
      });
    }
  }
});

/***/ }),

/***/ "YvPX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.computeOnlyIds),function(volume){return _c('compute-volume',{key:("compute:" + volume),attrs:{"volume-id":("compute:" + volume)}})}),_vm._v(" "),_vm._l((_vm.volumeContainerIds),function(volume){return _c('compute-volume',{key:volume,attrs:{"volume-id":volume}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1YT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changeUserPassword_vue__ = __webpack_require__("Two5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70283e52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changeUserPassword_vue__ = __webpack_require__("bBDz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_changeUserPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70283e52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_changeUserPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZEcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notebook_utils__ = __webpack_require__("qyQn");
//
//
//
//
//
//
//





var MAX_COMPUTE_RETRIES = 20; // after which we probably wont get anything back
var COMPUTE_POLL_MS = 3000;
var TERMINAL_POLL_MS = 300;

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Terminal',
    props: ['computeId'],
    data: function data() {
        return {
            terminalId: null,
            baseUrl: null,
            poller: null,
            computePoller: null,
            ready: false,
            processing: false,
            computeRetries: MAX_COMPUTE_RETRIES
        };
    },
    created: function created() {
        var _this = this;

        this.computePoller = setInterval(function () {
            return _this.getComputeBaseUrl();
        }, COMPUTE_POLL_MS);
    },

    watch: {
        computeId: function computeId() {
            this.baseUrl = null;
            this.terminalId = null;
            this.computeRetries = MAX_COMPUTE_RETRIES;
        }
    },
    computed: {
        computeTerminalUrl: function computeTerminalUrl() {
            var _this2 = this;

            if (this.terminalId) {
                return "https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/go?id=' + this.computeId + '&path=/terminals/' + this.terminalId;
            }
            if (this.computeId && this.baseUrl) {
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token,
                        'X-XSRFToken': __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('_xsrf') } };
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('' + this.baseUrl, null, conf).then(function (response) {
                    _this2.terminalId = response.data.name;
                });
            }
            return null;
        }
    },
    methods: {
        // This call is for determining redirect URL compute assigns. In various stages of starting this can be
        // erroneously redirected to dashboard or come back with some intermediate error codes, so a single triggered
        // call would not suffice, we really need to poll and validate the redirected URL prior to use.
        getComputeBaseUrl: function getComputeBaseUrl() {
            var _this3 = this;

            if (this.computeId && !this.baseUrl && !this.processing && this.computeRetries > 0) {
                this.processing = true;
                this.computeRetries -= 1;
                var conf = { headers: { 'X-Auth-Token': this.$store.state.token } };
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/go?id=' + this.computeId + '&path=/api/terminals', conf).then(function (response) {
                    var reqUrl = response.request.responseURL;
                    if (Array.isArray(response.data) && reqUrl.includes('/api/terminals')) {
                        if (_this3.baseUrl !== reqUrl) {
                            _this3.baseUrl = reqUrl;
                        }
                    }
                }).catch(function (err) {
                    console.error('error querying terminals', err);
                }).finally(function () {
                    _this3.processing = false;
                });
            }
        },
        terminalLoad: function terminalLoad() {
            var _this4 = this;

            console.log('terminal load called');
            this.ready = false;
            clearInterval(this.poller);
            this.poller = setInterval(function () {
                return _this4.poll();
            }, TERMINAL_POLL_MS);
        },
        poll: function poll() {
            var term = this.$refs.terminalFrame.contentWindow.terminal;
            if (!term) {
                return;
            }
            // If we loose connection or the user terminates (e.g. C-D), setup to allocate another
            if (![term.socket.CONNECTING, term.socket.OPEN].includes(term.socket.readyState)) {
                this.terminalId = null;
                this.ready = false;
                return;
            }
            if (!this.ready) {
                try {
                    __WEBPACK_IMPORTED_MODULE_2__notebook_utils__["a" /* default */].jupyterClassicTerminalModifications(this.$refs.terminalFrame);
                    this.ready = true;
                } catch (err) {
                    console.error('failed terminal mods');
                }
            }
            // this is readjusted by jupyter at resizing, but we want to fill the space
            this.$refs.terminalFrame.contentDocument.getElementById('site').style.setProperty('height', '100%');
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.poller);
        clearInterval(this.computePoller);
    }
});

/***/ }),

/***/ "ZHV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"title":_vm.title},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.message))])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZXz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',{staticClass:"dropdown"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggle}},[_c('span',{staticClass:"fa fa-bell-o"}),_vm._v(" "),(_vm.numOfNotifications > 0)?_c('span',{staticClass:"num"},[_vm._v(" "+_vm._s(_vm.getNumOfNotifications))]):_vm._e()])])]),_vm._v(" "),_c('Drawer',{attrs:{"align":"right","closeable":false,"maskClosable":true},on:{"close":_vm.toggle,"click":_vm.toggle}},[(_vm.open)?_c('div',[_c('ul',[_c('li',[_c('span',{staticClass:"label"},[_vm._v("Notifications")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm pull-right",staticStyle:{"margin-top":"6px"},attrs:{"a":"","type":"button"},on:{"click":_vm.removeAll}},[_vm._v("Clear All")])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.numOfNotifications === 0)?_c('ul',[_c('li',[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('span',[_vm._v("No new notifications")])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getActionArray),function(item){return _c('ul',[_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('span',{staticClass:"fa fa-cloud-upload"}),_vm._v(" "+_vm._s(item.actionName)+" "+_vm._s(item.actionFileName)+" "),(item.actionurl)?_c('router-link',{attrs:{"to":("/files/" + (item.actionurl))}},[_vm._v(" to "+_vm._s(item.actionLocation))]):_vm._e()],1),_vm._v(" "),_c('br')])}),_vm._v(" "),_vm._l((_vm.actionRequiredItems),function(item){return _c('ul',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n          Failed "+_vm._s(item.actionName)),_c('router-link',{attrs:{"to":("/files/" + (item.actionurl))}},[_vm._v(" "+_vm._s(item.actionFileName))]),_vm._v("\n          . "+_vm._s(item.actionMessage)+"\n          "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){_vm.removeAction(item.actionFileName)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])],1),_vm._v(" "),_c('br')])})],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZcQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sharedComponents_JqueryCalendar__ = __webpack_require__("RJhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sharedComponents_alertDialog__ = __webpack_require__("pqqY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sharedComponents_emptyState__ = __webpack_require__("0XGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__applicationConfiguration__ = __webpack_require__("uYv6");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var $ = __webpack_require__("7t+N");
var moment = __webpack_require__("PJh5");
var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActivityLog',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__applicationConfiguration__["a" /* default */]],
  components: {
    jqueryCalendar: __WEBPACK_IMPORTED_MODULE_3__sharedComponents_JqueryCalendar__["a" /* default */],
    popUpDialog: __WEBPACK_IMPORTED_MODULE_4__sharedComponents_alertDialog__["a" /* default */],
    EmptyState: __WEBPACK_IMPORTED_MODULE_5__sharedComponents_emptyState__["a" /* default */]
  },
  data: function data() {
    return {
      files_URL: '/files',
      activityLog: "https://www.sciserver.org/support/how-to-use-sciserver/#recent",
      numberOfSciserverMessage: '',
      loading: false,
      sciserverMessage: [],
      checkedApplication: [],
      from: '',
      to: '',
      applications: [{ app: 'skyserver', name: 'SkyServer' }, { app: 'casjobs', name: 'CasJobs' }, { app: 'jobm', name: 'Jobs' }, { app: 'fileservice', name: 'FileService' }, { app: 'scidrive', name: 'SciDrive' }, { app: 'skyquery', name: 'SkyQuery' }, { app: 'compute', name: 'Compute' }, { app: 'authentication', name: 'LoginPortal' }, { app: 'User Profile', name: 'User Profile' }, { app: 'Groups', name: 'Groups' }, { app: 'Resource', name: 'Resource' }] };
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    refreshActivitiesSpinner: function refreshActivitiesSpinner() {
      return {
        'fa-spin': this.loading === true
      };
    },
    constructSciServerMessagesUrl: function constructSciServerMessagesUrl() {
      var newUrl = "https://sciserver.sdcc.bnl.gov/sciserver/logging-api" + '/api/messages/applications?type=' + this.checkedApplications + '&doShowInUserHistory=true';
      var pageLength = 100;
      if (this.from) {
        var startDate = new Date(this.from);
        var startMilliseconds = startDate.getTime();
        newUrl = newUrl + '&start=' + startMilliseconds;
      }
      if (this.to) {
        var endDate = new Date(this.to);
        var endMilliseconds = endDate.getTime();
        newUrl = newUrl + '&end=' + endMilliseconds;
      }
      if (this.numberOfSciserverMessage) {
        newUrl = newUrl + '&top=' + this.numberOfSciserverMessage;
      } else {
        newUrl = newUrl + '&top=' + pageLength;
      }
      return newUrl;
    },
    checkedApplications: function checkedApplications() {
      var apps = '';
      if (this.transformedApps.length > 0) {
        apps = this.transformedApps.toString();
      } else {
        apps = 'skyserver,casjobs,jobm,fileservice,scidrive,skyquery,compute,authentication,racm';
      }
      return apps;
    },
    transformedApps: function transformedApps() {
      var apps = [];
      $.each(this.checkedApplication, function (index0, text0) {
        if (text0 === 'User Profile' || text0 === 'Groups' || text0 === 'Resource') {
          if (!apps.includes('racm')) {
            apps.push('racm');
          }
        } else {
          apps.push(text0);
        }
      });
      return apps;
    },
    sortApps: function sortApps() {
      var _this = this;

      var sorted = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.applications).sort().reduce(function (acc, key) {
        acc[key] = _this.applications[key];
        return acc;
      }, {});
      return sorted;
    },
    sortedApps: function sortedApps() {
      return _.sortBy(this.applications, ['name']);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['token', 'publicGroups']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'getGroupById'])),
  created: function created() {
    this.loadMessages();
  },
  mounted: function mounted() {
    var _this2 = this;

    $('input[name=dateStart]').datetimepicker({
      onChangeDateTime: function onChangeDateTime(dp, $input) {
        _this2.from = $input.val();
      }
    });
    $('input[name=dateEnd]').datetimepicker({
      onChangeDateTime: function onChangeDateTime(dp, $input) {
        var startDate = document.getElementById('dateStart').value;
        var endDate = document.getElementById('dateEnd').value;
        if (Date.parse(startDate) >= Date.parse(endDate)) {
          _this2.$refs.alertPopUp.showAlert('End date should be greater than Start date', 'Error message');
          document.getElementById('dateEnd').value = '';
        }
        _this2.to = $input.val();
      }
    });
  },

  methods: {
    loadMessages: function loadMessages() {
      var _this3 = this;

      var that = this;
      that.loading = true;
      this.$http.get(this.constructSciServerMessagesUrl).then(function (response) {
        that.sciserverMessage = [];
        $.each(response.data, function (index0, text0) {
          var val = $.parseJSON(text0.content);
          var app = text0.application_type;
          var initialApp = text0.application_type;
          var message = '';
          var content = '';
          var verb = '';
          var predicate = '';
          var subject = '';
          var activity = '';
          var racm = '';
          if (val.Action != null) {
            message = val.Action;
          } else if (val.action != null) {
            message = val.action;
          }
          if (val && val.sentence && val.sentence.verb) {
            verb = val.sentence.verb;
          }
          if (val && val.sentence && val.sentence.subject) {
            subject = val.sentence.subject;
          }
          if (val && val.sentence && val.sentence.predicate) {
            predicate = val.sentence.predicate;
          }
          if (val && val.EntryPoint && app === 'skyserver') {
            message = val.EntryPoint.substring(24, val.EntryPoint.length);
          }
          if (val && val.SqlCmd && app === 'skyserver') {
            content = val.SqlCmd;
          }
          if (val && val.group && val.sentence && val.sentence.verb !== 'shared') {
            racm = 'Groups';
            initialApp = 'Groups';
          } else if (val && val.sentence && val.sentence.predicate === 'user profile') {
            racm = 'User Profile';
            initialApp = 'User Profile';
          } else if (val && val.sentence && val.resource) {
            racm = 'Resource';
            initialApp = 'Resource';
          } else if (val && val.group && val.sentence && val.sentence.verb === 'shared') {
            racm = 'Groups';
            initialApp = 'Groups';
            if (val.entityId && val.resourceType === 'USERVOLUME') {
              var uvName = that.findUserVolName(val.entityId);
              var groupName = that.findGroupName(val.group);
              if (uvName || groupName) {
                predicate = 'uservolume \'' + uvName + '\' with group \'' + groupName + '\'';
                message = subject + ' shared uservolume \'' + uvName + '\' with group \'' + groupName + '\'';
              }
            }
          }
          if (app === 'skyserver') {
            app = '<a href=' + _this3.skyserver_URL + '  title="Go to SkyServer" rel="noopener" \n            target="_blank" role="button" class="btn btn-default"><b>SkyServer</b></a>';
          } else if (app === 'casjobs') {
            app = '<a href=' + _this3.casJobs_URL + ' title="Go to CasJobs" rel="noopener" \n            target="_blank" role="button" class="btn btn-default"><b>CasJobs</b></a>';
          } else if (app === 'authentication') {
            app = '<b>LoginPortal</b>';
          } else if (app === 'racm') {
            app = '<b>' + racm + '</b>';
          } else if (app === 'jobm') {
            app = '<a href=' + _this3.computeJobs_URL + ' title="Go to Compute Jobs" rel="noopener"\n            target="_blank" role="button" class="btn btn-default"><b>Jobs</b></a>';
          } else if (app === 'fileservice') {
            app = '<b>FileService</b>';
          } else if (app === 'scidrive') {
            app = '<a href=' + _this3.scidrive_URL + ' title="Go to SciDrive" rel="noopener"\n            target="_blank" role="button" class="btn btn-default"><b>SciDrive</b></a>';
          } else if (app === 'skyquery') {
            app = '<a href=' + _this3.skyquery_URL + ' title="Go to SkyQuery" rel="noopener"\n            target="_blank" role="button" class="btn btn-default"><b>SkyQuery</b></a>';
          } else if (app === 'compute') {
            app = '<a href=' + _this3.compute_URL + ' title="Go to Compute" rel="noopener"\n            target="_blank" role="button" class="btn btn-default"><b>Compute</b></a>';
          } else {
            app = text0.application_type;
          }
          if (verb !== '' && predicate !== '') {
            activity = '<span title="' + message + '"><b>' + verb + '</b> ' + predicate + '</span>';
          } else if (content !== '') {
            activity = '<span title="' + content + '"> <b>' + message + '</b> : ' + content + '</span>';
          } else {
            activity = '<span title="' + message + '">' + message + '</span>';
          }
          if (that.checkedApplication.length < 1) {
            that.sciserverMessage.push({ 0: app, 1: activity, 2: moment(text0.time_string).format('DD MMM YYYY hh:mm:ss a') });
          } else if (that.checkedApplication.includes(racm)) {
            that.sciserverMessage.push({ 0: app, 1: activity, 2: moment(text0.time_string).format('DD MMM YYYY hh:mm:ss a') });
          } else if (that.transformedApps.includes(initialApp)) {
            that.sciserverMessage.push({ 0: app, 1: activity, 2: moment(text0.time_string).format('DD MMM YYYY hh:mm:ss a') });
          }
        });
        that.loading = false;
        if ($.fn.dataTable.isDataTable('#sciserverTable')) {
          // trying to refresh the table
          var table = $('#sciserverTable').DataTable();
          table.clear();
          table.rows.add(that.sciserverMessage).draw(false);
        } else {
          // instantiate it for the first time:
          $('#sciserverTable').DataTable({
            data: that.sciserverMessage,
            processing: true,
            bFilter: true, // text search
            stateSave: false,
            select: false,
            paging: true,
            responsive: true,
            columnDefs: [{ className: 'wrapword', targets: [1] }, { className: 'changeColumnWidth', targets: [2] }, { type: 'date', targets: [2] }],
            order: [[2, 'desc']],
            language: {
              loadingRecords: 'Loading...',
              processing: 'Processing...',
              sLengthMenu: 'Rows _MENU_  per page'
            }
          });
        }
      });
    },
    refreshActivity: function refreshActivity() {
      this.clearAll();
      this.loadMessages();
    },
    clearAll: function clearAll() {
      this.from = '';
      this.to = '';
      this.numberOfSciserverMessage = '';
      $('#applicationMenu').val('');
      this.checkedApplication = [];
    },
    findUserVolName: function findUserVolName(uvID) {
      var uv = [];
      var uvName = '';
      var that = this;
      if (that.myUserVolumeObjects) {
        uv = that.myUserVolumeObjects.find(function (m) {
          return m.id === uvID;
        });
        if (uv && uv.name) {
          uvName = uv.name;
        }
      }
      return uvName;
    },
    findGroupName: function findGroupName(grID) {
      var group = [];
      var groupName = '';
      if (this.publicGroups) {
        group = this.publicGroups.map(this.getGroupById).find(function (g) {
          return g.id === grID;
        });
        if (group && group.groupName) {
          groupName = group.groupName;
        }
      }
      return groupName;
    }
  }
});

/***/ }),

/***/ "Zcb4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sciserverlogo.ea67fbb.png";

/***/ }),

/***/ "Zoh1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/skyquery.4cc732e.png";

/***/ }),

/***/ "a/MN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeDomainChooser_vue__ = __webpack_require__("u+a3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6331cdcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeDomainChooser_vue__ = __webpack_require__("b7kb");
function injectStyle (ssrContext) {
  __webpack_require__("bB7X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6331cdcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeDomainChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6331cdcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeDomainChooser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a1wk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComputeRootVolume__ = __webpack_require__("VG/9");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeRootVolumes',
  components: {
    ComputeRootVolume: __WEBPACK_IMPORTED_MODULE_0__ComputeRootVolume__["a" /* default */]
  },
  props: ['rootVolumeOnComputeDomainIds']
});

/***/ }),

/***/ "a6aK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasGrantableResource('USERVOLUME') || _vm.sharedUserVolumes.length > 0)?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Shared "),(_vm.collabType === 'Group')?_c('span',[_vm._v("Files")]):_c('span',[_vm._v("Course Materials")])]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.shareResource,"title":"How to share files"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("How to share files")])]),_vm._v(" "),(_vm.hasGrantableResource('USERVOLUME') && this.collaboration.type !== 'PUBLIC GROUP')?_c('button',{staticClass:"btn btn-success btn-xs pull-right",on:{"click":_vm.openShareUserVolumeDialog}},[_c('span',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body resource-container"},[_vm._l((_vm.sharedUserVolumes),function(uv){return _c('div',{key:uv.resourceId,staticClass:"btn-group text-center resource-item"},[_c('div',{staticClass:"btn btn-default resource-name dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#008ae6"},attrs:{"aria-hidden":"true"}}),_c('br'),_vm._v(_vm._s(uv.name)+"\n            "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Menu")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":("/files/uservolumes/" + (uv.entityId)),"title":("Go to " + (uv.name))}},[_vm._v("Go To")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"View More Info"},on:{"click":function($event){_vm.openInfo('userVolumeInfoDialog', _vm.getResourceDetails('USERVOLUME', uv.entityId), uv)}}},[_vm._v("More Info")])]),_vm._v(" "),(_vm.isGrantableThroughAnyMeans('USERVOLUME', uv.entityId))?_c('li',{on:{"click":function($event){_vm.unshare([_vm.getResourceDetails('USERVOLUME', uv.entityId)])}}},[_c('a',{attrs:{"href":"#","title":"Remove Resource"}},[_vm._v("Remove")])]):_vm._e()])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sharedUserVolumes.length),expression:"!sharedUserVolumes.length"}],staticClass:"text-muted center-block"},[_vm._v("Share user volumes with this group to see them here.")])],2)]):_vm._e(),_vm._v(" "),_c('resource-info-dialog',{ref:"userVolumeInfoDialog",attrs:{"title":"User Volume Info"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(slotProps.info.name))]),_vm._v(" "),(slotProps.info.name)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Creator")]),_c('dd',[_vm._v(_vm._s(slotProps.info.owner))]),_vm._v(" "),_c('dt',[_vm._v("Description")]),_c('dd',[_vm._v(_vm._s(slotProps.info.description))]),_vm._v(" "),_c('dt',[_vm._v("Type of Volume")]),_c('dd',[_vm._v(_vm._s(slotProps.info.rootVolume.name))]),_vm._v(" "),_c('dt',[_vm._v("Hosted By")]),_c('dd',[_vm._v(_vm._s(slotProps.info.fileService.name))]),_vm._v(" "),_c('dt',[_vm._v("Actions Allowed")]),_vm._v(" "),_c('dd',[(slotProps.groupInfo.actions.includes('read'))?_c('div',[_vm._v("Read")]):_vm._e(),_vm._v(" "),(slotProps.groupInfo.actions.includes('write'))?_c('div',[_vm._v("Write")]):_vm._e(),_vm._v(" "),(slotProps.groupInfo.actions.includes('delete'))?_c('div',[_vm._v("Delete user volume")]):_vm._e(),_vm._v(" "),(slotProps.groupInfo.actions.includes('grant'))?_c('div',[_vm._v("Share user volume with others")]):_vm._e()])]):_vm._e()]}}])}),_vm._v(" "),(_vm.hasGrantableResource('DATAVOLUME') || _vm.sharedDataVolumes.length > 0)?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Shared Data Volume")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.shareResource,"title":"How to share Data Volume"}},[_c('span',{staticClass:"sr-only"},[_vm._v("How to share Data Volume")])]),_vm._v(" "),(_vm.hasGrantableResource('DATAVOLUME') && this.collaboration.type !== 'PUBLIC GROUP')?_c('button',{staticClass:"btn btn-success btn-xs pull-right",on:{"click":_vm.openShareDataVolumeDialog}},[_c('span',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body resource-container"},[_vm._l((_vm.sharedDataVolumes),function(dv){return _c('div',{key:dv.resourceId,staticClass:"btn-group text-center resource-item"},[_c('div',{staticClass:"resource-name btn btn-default dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-archive fa-2x",attrs:{"aria-hidden":"true"}}),_c('br'),_vm._v(_vm._s(dv.name)+"\n        "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Menu")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":("/files/datavolumes/" + (dv.entityId)),"title":("Go to " + (dv.name))}},[_vm._v("Go To")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"View More Info"},on:{"click":function($event){_vm.openInfo('dataVolumeContainerInfoDialog', _vm.getResourceDetails('DATAVOLUME', dv.entityId), _vm.allGroupInfos('DATAVOLUME', dv.name, 'dockerComputeDomain.name'))}}},[_vm._v("More Info")])]),_vm._v(" "),(_vm.isGrantableThroughAnyMeans('DATAVOLUME', dv.entityId))?_c('li',{on:{"click":function($event){_vm.unshare(_vm.allGroupInfos('DATAVOLUME', dv.name, 'dockerComputeDomain.name'))}}},[_c('a',{attrs:{"href":"#","title":"Remove Resource"}},[_vm._v("Remove")])]):_vm._e()])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sharedDataVolumes.length),expression:"!sharedDataVolumes.length"}],staticClass:"text-muted center-block"},[_vm._v("Share Data Volume with this group to see them here.")])],2)]):_vm._e(),_vm._v(" "),_c('resource-info-dialog',{ref:"dataVolumeContainerInfoDialog",attrs:{"title":"Data Volume Info"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(slotProps.info.name))]),_vm._v(" "),(slotProps.info.name)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_c('dd',[_vm._v(_vm._s(slotProps.info.description))]),_vm._v(" "),_c('dt',[_vm._v("Actions Allowed")]),_vm._v(" "),_c('dd',_vm._l((slotProps.groupInfo),function(resource){return _c('div',{key:resource.entityId},[(resource.actions.includes('read'))?_c('div',[_vm._v("Read")]):_vm._e(),_vm._v(" "),(resource.actions.includes('write'))?_c('div',[_vm._v("Write")]):_vm._e(),_vm._v(" "),(resource.actions.includes('delete'))?_c('div',[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(resource.actions.includes('grant'))?_c('div',[_vm._v("Share Data Volume with others")]):_vm._e()])}),0)]):_vm._e()]}}])}),_vm._v(" "),((_vm.hasGrantableResource('DOCKERIMAGE') || _vm.sharedImages.length > 0) && _vm.collabType === 'Group')?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Shared Compute Images")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.shareResource,"title":"How to share compute images"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("How to share compute images")])]),_vm._v(" "),(_vm.hasGrantableResource('DOCKERIMAGE') && this.collaboration.type !== 'PUBLIC GROUP')?_c('button',{staticClass:"btn btn-success btn-xs pull-right",on:{"click":_vm.openShareDockerImagesDialog}},[_c('span',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body resource-container"},[_vm._l((_vm.sharedImages),function(image){return _c('div',{key:image.resourceId,staticClass:"btn-group text-center resource-item"},[_c('div',{staticClass:"resource-name btn btn-default dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-th fa-2x",attrs:{"aria-hidden":"true"}}),_c('br'),_vm._v(_vm._s(image.name)+"\n            "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Menu")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","title":"View More Info"},on:{"click":function($event){_vm.openInfo('dockerImageInfoDialog', _vm.getResourceDetails('DOCKERIMAGE', image.entityId), _vm.allGroupInfos('DOCKERIMAGE', image.name, 'dockerComputeDomain.name'))}}},[_vm._v("More Info")])]),_vm._v(" "),(_vm.isGrantableThroughAnyMeans('DOCKERIMAGE', image.entityId))?_c('li',{on:{"click":function($event){_vm.unshare(_vm.allGroupInfos('DOCKERIMAGE', image.name, 'dockerComputeDomain.name'))}}},[_c('a',{attrs:{"href":"#","title":"Remove Resource"}},[_vm._v("Remove")])]):_vm._e()])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sharedImages.length),expression:"!sharedImages.length"}],staticClass:"text-muted center-block"},[_vm._v("Share compute images with this group to see them here.")])],2)]):_vm._e(),_vm._v(" "),_c('resource-info-dialog',{ref:"dockerImageInfoDialog",attrs:{"title":"Compute Image Info"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(slotProps.info.name))]),_vm._v(" "),(slotProps.info.name)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_c('dd',[_vm._v(_vm._s(slotProps.info.description))]),_vm._v(" "),_c('dt',[_vm._v("Actions Allowed")]),_vm._v(" "),_c('dd',_vm._l((slotProps.groupInfo),function(resource){return _c('div',{key:resource.entityId},[_c('div',[_c('b',[_vm._v("For "+_vm._s(_vm.getResourceDetails('DOCKERIMAGE', resource.entityId).dockerComputeDomain.name)+":")])]),_vm._v(" "),(resource.actions.includes('createContainer'))?_c('div',[_vm._v("Use image for new containers")]):_vm._e(),_vm._v(" "),(resource.actions.includes('grant'))?_c('div',[_vm._v("Share image with others")]):_vm._e()])}),0)]):_vm._e()]}}])}),_vm._v(" "),((_vm.hasGrantableResource('DATABASE') || _vm.sharedDatabases.length > 0) && _vm.collabType === 'Group')?_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Shared Databases")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.shareResource,"title":"How to share databases"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("How to share databases")])]),_vm._v(" "),(_vm.hasGrantableResource('DATABASE') && this.collaboration.type !== 'PUBLIC GROUP')?_c('button',{staticClass:"btn btn-success btn-xs pull-right",on:{"click":_vm.openShareDatabaseDialog}},[_c('span',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-body resource-container"},[_vm._l((_vm.sharedDatabases),function(database){return _c('div',{key:database.resourceId,staticClass:"btn-group text-center resource-item"},[_c('div',{staticClass:"resource-name btn btn-default dropdown-toggle",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-database fa-2x",attrs:{"aria-hidden":"true"}}),_c('br'),_vm._v(_vm._s(database.name)+"\n            "),_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Menu")])]),_vm._v(" "),(database.type === 'DATABASE')?_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","title":"View More Info"},on:{"click":function($event){_vm.openInfo('databaseInfoDialog', _vm.getResourceDetails('DATABASE', database.entityId), _vm.allGroupInfos('DATABASE', database.name, 'rdbComputeDomain.name'))}}},[_vm._v("More Info")])]),_vm._v(" "),(_vm.isGrantableThroughAnyMeans('DATABASE', database.entityId))?_c('li',{on:{"click":function($event){_vm.unshare(_vm.allGroupInfos('DATABASE', database.name, 'rdbComputeDomain.name'))}}},[_c('a',{attrs:{"href":"#","title":"Remove Resource"}},[_vm._v("Remove")])]):_vm._e()]):_vm._e(),_vm._v(" "),(database.resourceType === 'Casjobs.DatabaseContext')?_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","title":"View More Info"},on:{"click":function($event){_vm.openInfo('casJobsDatabaseInfoDialog', _vm.getResourceDetails('RESOURCE', database.entityId), _vm.allGroupInfos('RESOURCE', database.name, 'CasJobs'))}}},[_vm._v("More Info")])]),_vm._v(" "),(_vm.isGrantableThroughAnyMeans('RESOURCE', database.entityId))?_c('li',{on:{"click":function($event){_vm.unshare(_vm.allGroupInfos('RESOURCE', database.name, 'CasJobs'))}}},[_c('a',{attrs:{"href":"#","title":"Remove Resource"}},[_vm._v("Remove")])]):_vm._e()]):_vm._e()])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sharedDatabases.length),expression:"!sharedDatabases.length"}],staticClass:"text-muted center-block"},[_vm._v("Share database context with this group to see them here.")])],2)]):_vm._e(),_vm._v(" "),_c('resource-info-dialog',{ref:"databaseInfoDialog",attrs:{"title":"Database Info"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(slotProps.info.name))]),_vm._v(" "),(slotProps.info.name)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_c('dd',[_vm._v(_vm._s(slotProps.info.description))]),_vm._v(" "),_c('dt',[_vm._v("Actions Allowed")]),_vm._v(" "),_c('dd',_vm._l((slotProps.groupInfo),function(resource){return _c('div',{key:resource.entityId},[_c('div',[_c('b',[_vm._v("For "+_vm._s(_vm.getResourceDetails('DATABASE', resource.entityId).rdbComputeDomain.name)+":")])]),_vm._v(" "),(resource.actions.includes('QUERY'))?_c('div',[_vm._v("Query")]):_vm._e(),_vm._v(" "),(resource.actions.includes('UPDATE'))?_c('div',[_vm._v("Update")]):_vm._e(),_vm._v(" "),(resource.actions.includes('GRANT'))?_c('div',[_vm._v("Share database with others")]):_vm._e()])}),0)]):_vm._e()]}}])}),_vm._v(" "),_c('resource-info-dialog',{ref:"casJobsDatabaseInfoDialog",attrs:{"title":"Database Info"},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(slotProps.info.name))]),_vm._v(" "),(slotProps.info.name)?_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_c('dd',{staticClass:"resource-description"},[_vm._v(_vm._s(slotProps.info.description))]),_vm._v(" "),_c('dt',[_vm._v("Actions Allowed")]),_vm._v(" "),_c('dd',_vm._l((slotProps.groupInfo),function(resource){return _c('div',{key:resource.entityId},[(resource.actions.includes('submitQuery'))?_c('div',[_vm._v("Submit Query")]):_vm._e(),_vm._v(" "),(resource.actions.includes('viewSchema'))?_c('div',[_vm._v("View Schema")]):_vm._e(),_vm._v(" "),(resource.actions.includes('grant'))?_c('div',[_vm._v("Share database with others")]):_vm._e()])}),0)]):_vm._e()]}}])}),_vm._v(" "),_c('share-user-volume-dialog',{ref:"shareUserVolumeDialog",on:{"linkUVResources":_vm.addResources}}),_vm._v(" "),_c('share-volume-container',{ref:"shareVolumeContainerDialog",on:{"linkVCResources":_vm.addResources}}),_vm._v(" "),_c('share-docker-images',{ref:"shareDockerImagesDialog",on:{"linkDIResources":_vm.addResources}}),_vm._v(" "),_c('share-database-contexts',{ref:"shareDatabaseDialog",on:{"linkDBResources":_vm.addResources}}),_vm._v(" "),_c('share-data-volume',{ref:"shareDataVolumeDialog",on:{"linkDVResources":_vm.addResources}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a7Oi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceInfoDialog_vue__ = __webpack_require__("M35A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb65eb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceInfoDialog_vue__ = __webpack_require__("0gtn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceInfoDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb65eb40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceInfoDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aPBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form clearfix"},[_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.name.$error }},[_c('label',[_vm._v("Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Image Name"},domProps:{"value":(_vm.name)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},function($event){_vm.$v.name.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.name.$error && !_vm.$v.name.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      Name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.description.$error }},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.description),expression:"description",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.description)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.description=$event.target.value.trim()},function($event){_vm.$v.description.$touch()}],"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.dockerRef.$error }},[_c('label',[_vm._v("Docker Image Reference")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.dockerRef),expression:"dockerRef",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","placeholder":"my.docker.registry.io:port/image-name:version"},domProps:{"value":(_vm.dockerRef)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.dockerRef=$event.target.value.trim()},function($event){_vm.$v.dockerRef.$touch()}],"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),(_vm.$v.dockerRef.$error && !_vm.$v.dockerRef.required)?_c('span',{staticClass:"help-block"},[_vm._v("\n      A reference that Docker understands as an image name is required\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.$v.containerManagerClass.$error }},[_c('label',[_vm._v("Executable Manager")]),_vm._v(" "),_c('span',{staticClass:"help-block"},[_vm._v("\n      SciServer code to use to run images. This only needs to be changed for GPU-enabled images or those using the\n      MATLAB installation at JHU.\n    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.containerManagerClass),expression:"containerManagerClass"}],staticClass:"form-control",on:{"input":function($event){_vm.$v.containerManagerClass.$touch()},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.containerManagerClass=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"org.sciserver.compute.core.container.DefaultExecutableManager"}},[_vm._v("Default")]),_vm._v(" "),_c('option',{attrs:{"value":"org.sciserver.compute.core.container.DsAppsExecutableManager"}},[_vm._v("Load ds_apps (for MATLAB @ JHU)")]),_vm._v(" "),_c('option',{attrs:{"value":"org.sciserver.compute.core.container.GpuExecutableManager"}},[_vm._v("GPU")]),_vm._v(" "),_c('option',{attrs:{"value":"org.sciserver.compute.core.container.JetsonExecutableManager"}},[_vm._v("Jetson")]),_vm._v(" "),_c('option',{attrs:{"value":"org.sciserver.compute.core.container.NvidiaExecutableManager"}},[_vm._v("NVIDIA")]),_vm._v(" "),_c('option',{attrs:{"value":"org.sciserver.compute.core.container.KubernetesExecutableManager"}},[_vm._v("Kubernetes")])])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit","disabled":_vm.$v.form.$error},on:{"click":_vm.attemptSave}},[_vm._v(_vm._s(_vm.submitButtonMessage))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('cancel')}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aZKy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terminal_vue__ = __webpack_require__("ZEcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c3943_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terminal_vue__ = __webpack_require__("vW9R");
function injectStyle (ssrContext) {
  __webpack_require__("Gaas")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Terminal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c3943_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Terminal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aek+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__ = __webpack_require__("pIzI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_341745a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__ = __webpack_require__("9uGp");
function injectStyle (ssrContext) {
  __webpack_require__("18eA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_341745a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "asFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.foundImage)?_c('li',{staticClass:"list-group-item"},[(_vm.racmImage)?_c('span',{staticClass:"badge"},[_vm._v("RACM ID: "+_vm._s(_vm.racmImage.id))]):_c('span',{staticClass:"badge alert-danger"},[_vm._v("Not Registered in RACM")]),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v("Compute ID: "+_vm._s(_vm.computeImageId))]),_vm._v(" "),_c('h4',{staticClass:"list-group-item-heading"},[_vm._v(_vm._s(_vm.foundImage.name))]),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.foundImage.description))]),_vm._v(" "),(_vm.computeImage)?[_c('dt',[_vm._v("Docker Reference")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.computeImage.docker_ref))]),_vm._v(" "),_c('dt',[_vm._v("Executation Manager")]),_vm._v(" "),_c('dd',[_vm._v("\n        "+_vm._s(_vm._f("abbrivExecutationManager")(_vm.computeImage.container_manager_class))+"\n      ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"panel-body",class:_vm.classForConsistency},[(_vm.racmImage && _vm.computeImage)?[(_vm.consistentMetadata)?_c('span',[_vm._v("\n        ✅ Name and Description are consistent between RACM and Compute databases\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && _vm.computeImage.name !== _vm.racmImage.name)?_c('p',[_vm._v("\n        Another image name is registered in Compute: \""+_vm._s(_vm.computeImage.name)+"\"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && _vm.computeImage.description !== _vm.racmImage.description)?_c('p',[_vm._v("\n        A different image description is registered in Compute: \""+_vm._s(_vm.computeImage.description)+"\"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && !_vm.isGrantedToAdmin)?_c('p',[_vm._v("\n        The \"admin\" group does not have grant privileges on this image\n      ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.racmImage && !_vm.computeImage)?[_vm._v("\n      Not registered in Compute!\n    ")]:_vm._e(),_vm._v(" "),(!_vm.racmImage && _vm.computeImage)?[_vm._v("\n      Not registered in RACM!\n    ")]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "atA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotebookDash_vue__ = __webpack_require__("94sV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee2b05d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotebookDash_vue__ = __webpack_require__("dCHy");
function injectStyle (ssrContext) {
  __webpack_require__("Ea37")
  __webpack_require__("dHAj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ee2b05d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotebookDash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee2b05d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotebookDash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"compute environment settings","size":"lg","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-5"},[_c('b',[_vm._v("Domain:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.domain),expression:"domain"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.domain=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.resetForm()}]}},_vm._l((_vm.validDomains),function(dom){return _c('option',{attrs:{"title":dom.description},domProps:{"value":dom}},[_vm._v(" "+_vm._s(dom.name)+" ")])}),0),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.domainDescription)+" ")]),_vm._v(" "),_c('b',[_vm._v("Image:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.image),expression:"image"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.image=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.domainImages),function(img){return _c('option',{domProps:{"value":img}},[_vm._v(" "+_vm._s(img.name)+" ")])}),0),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.imageDescription)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-7",staticStyle:{"max-height":"300px","overflow-y":"auto"}},[_c('b',[_vm._v("User Volumes:")]),_vm._v(" "),_vm._l((_vm.domainUserVolumes),function(uservol){return _c('label',{staticStyle:{"margin":"4px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userVols),expression:"userVols"}],staticClass:"test-input",staticStyle:{"display":"none"},attrs:{"type":"checkbox"},domProps:{"value":uservol,"checked":Array.isArray(_vm.userVols)?_vm._i(_vm.userVols,uservol)>-1:(_vm.userVols)},on:{"change":function($event){var $$a=_vm.userVols,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=uservol,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.userVols=$$a.concat([$$v]))}else{$$i>-1&&(_vm.userVols=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.userVols=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"btn btn-default",attrs:{"title":("user volume in " + (uservol.rootVolumeName) + " owned by " + (uservol.owner) + ". " + (uservol.description))}},[_vm._v("\n          "+_vm._s(uservol.name)+"\n        ")])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b',[_vm._v("Data Volumes:")]),_vm._v(" "),_vm._l((_vm.domainDataVolumes),function(datavol){return _c('label',{staticStyle:{"margin":"4px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataVols),expression:"dataVols"}],staticClass:"test-input",staticStyle:{"display":"none"},attrs:{"type":"checkbox"},domProps:{"value":datavol,"checked":Array.isArray(_vm.dataVols)?_vm._i(_vm.dataVols,datavol)>-1:(_vm.dataVols)},on:{"change":function($event){var $$a=_vm.dataVols,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=datavol,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.dataVols=$$a.concat([$$v]))}else{$$i>-1&&(_vm.dataVols=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.dataVols=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"btn btn-default",attrs:{"title":("" + (datavol.description))}},[_vm._v("\n          "+_vm._s(datavol.name)+"\n        ")])])})],2)]),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Or, use pre-existing container (admin only - use sparingly! Note\n    that the container metadata and real container spec may differ if\n    used). ID: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.containerId),expression:"containerId"}],attrs:{"type":"input"},domProps:{"value":(_vm.containerId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.containerId=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.imageInfoModified)?_c('div',{staticClass:"alert alert-warning"},[_c('span',{staticClass:"glyphicon glyphicon-exclamation-sign"}),_vm._v("\n    Modifying image info requires switching to a new container in a\n    new process - cells will have to be rerun. Please ensure any data\n    written out has been saved to a mounted user volume or data volume\n    (including "),_c('b',[_vm._v("Temporary")]),_vm._v(". Only data stored directly on the container\n    file system will be lost)\n  ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v(" Cancel ")]),_vm._v(" "),(_vm.isApplyable)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.applyImageInfo}},[_vm._v(" Apply")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bB7X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bBDz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_vm._v("\n         New Password\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password1),expression:"password1"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"name":"changePass1","type":"password","id":"changePass1"},domProps:{"value":(_vm.password1)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.password1=$event.target.value}}}),_vm._v("\n          Confirm New Password\n          "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password2),expression:"password2"}],staticClass:"form-control",attrs:{"name":"changePass2","type":"password","id":"changePass2"},domProps:{"value":(_vm.password2)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changePassword($event)},"input":function($event){if($event.target.composing){ return; }_vm.password2=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showPass),expression:"showPass"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showPass)?_vm._i(_vm.showPass,null)>-1:(_vm.showPass)},on:{"click":_vm.showHidePass,"change":function($event){var $$a=_vm.showPass,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showPass=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showPass=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showPass=$$c}}}}),(_vm.showPass)?_c('span',[_vm._v("Hide")]):_vm._e(),_vm._v(" "),(!_vm.showPass)?_c('span',[_vm._v("Show")]):_vm._e(),_vm._v(" Password\n         "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pass1EqualPass2),expression:"!pass1EqualPass2"}]},[_vm._v("**Password must match")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.validPassword),expression:"!validPassword"}]},[_vm._v("Your password must be a minimum of 8 characters long.")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('a',{staticStyle:{"text-decoration":"underline","font-size":"14px"},attrs:{"href":("" + _vm.forgotPasswordURL),"title":"Reset Password","rel":"noopener","target":"_blank"}},[_vm._v("Forgot Password")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal","disabled":!_vm.pass1EqualPass2 || _vm.blankPassField || !_vm.validPassword},on:{"click":_vm.changePassword}},[_vm._v("Update Password")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bR8C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bSWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImageConfigurer__ = __webpack_require__("3h7b");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ImagesStep',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    ImageConfigurer: __WEBPACK_IMPORTED_MODULE_2__ImageConfigurer__["a" /* default */]
  },
  data: function data() {
    return {
      images: [],
      isEditing: false,
      currentlyEditingIndex: undefined
    };
  },
  validations: {
    images: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(1)
    },
    form: ['images']
  },
  methods: {
    validate: function validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
    saveImage: function saveImage(newImage) {
      if (this.currentlyEditingIndex === undefined) {
        this.images.push(newImage);
      } else {
        this.images[this.currentlyEditingIndex] = newImage;
        this.currentlyEditingIndex = undefined;
      }
      this.isEditing = false;
    },
    startEditing: function startEditing(index) {
      this.currentlyEditingIndex = index;
      this.isEditing = true;
    },
    cancelEdit: function cancelEdit() {
      this.isEditing = false;
      this.currentlyEditingIndex = undefined;
    }
  }
});

/***/ }),

/***/ "bfo+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr__ = __webpack_require__("vNPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);





/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    racmComputeDomains: {},
    computeComputeDomains: {},
    racmImages: {},
    computeImages: {},
    racmVolumeContainers: {},
    computeVolumeContainers: {},
    computeNodes: {},
    racmRootVolumesOnCD: {},
    userComputeDomains: {},
    userComputeDomainsLoaded: false
  },
  mutations: {
    setFromRACMComputeDomains: function setFromRACMComputeDomains(state, domains) {
      var image = new __WEBPACK_IMPORTED_MODULE_1_normalizr__["schema"].Entity('images');
      var volumeContainer = new __WEBPACK_IMPORTED_MODULE_1_normalizr__["schema"].Entity('volumeContainers');
      var rootVolumeOnCD = new __WEBPACK_IMPORTED_MODULE_1_normalizr__["schema"].Entity('rootvolumesOnCD');
      var domain = new __WEBPACK_IMPORTED_MODULE_1_normalizr__["schema"].Entity('domains', {
        images: [image],
        volumes: [volumeContainer],
        rootVolumes: [rootVolumeOnCD]
      });
      var normalizedData = Object(__WEBPACK_IMPORTED_MODULE_1_normalizr__["normalize"])(domains, [domain]);

      state.racmComputeDomains = normalizedData.entities.domains;
      state.racmImages = normalizedData.entities.images;
      state.racmVolumeContainers = normalizedData.entities.volumeContainers;
      state.racmRootVolumesOnCD = normalizedData.entities.rootvolumesOnCD;
    },
    setFromComputeDomains: function setFromComputeDomains(state, domains) {
      state.computeComputeDomains = __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(domains, 'id');
    },
    setComputeImages: function setComputeImages(state, images) {
      state.computeImages = __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(images, 'id');
    },
    setComputeVolumeContainers: function setComputeVolumeContainers(state, volumes) {
      state.computeVolumeContainers = __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(volumes, 'id');
    },
    setComputeNodes: function setComputeNodes(state, nodes) {
      state.computeNodes = __WEBPACK_IMPORTED_MODULE_2_lodash_keyBy___default()(nodes, 'id');
    },
    setFromUserComputeDomains: function setFromUserComputeDomains(state, domains) {
      state.userComputeDomains = domains;
      state.userComputeDomainsLoaded = true;
    }
  },
  actions: {
    loadUserComputeDomains: function loadUserComputeDomains(_ref) {
      var rootState = _ref.rootState,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/computedomains', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setFromUserComputeDomains', response.data);
      });
    },
    loadCompute: function loadCompute(_ref2) {
      var rootState = _ref2.rootState,
          commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/jobm/rest/dockercomputedomains', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setFromRACMComputeDomains', response.data);
      });
    },
    loadDomainsFromCompute: function loadDomainsFromCompute(_ref3) {
      var rootState = _ref3.rootState,
          commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/domain', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setFromComputeDomains', response.data);
      });
    },
    loadImagesFromCompute: function loadImagesFromCompute(_ref4) {
      var rootState = _ref4.rootState,
          commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/image', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setComputeImages', response.data);
      });
    },
    loadVolumesFromCompute: function loadVolumesFromCompute(_ref5) {
      var rootState = _ref5.rootState,
          commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/volume', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setComputeVolumeContainers', response.data);
      });
    },
    loadNodesFromCompute: function loadNodesFromCompute(_ref6) {
      var rootState = _ref6.rootState,
          commit = _ref6.commit;

      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://sciserver.sdcc.bnl.gov/sciserver/compute" + '/admin/node', {
        headers: {
          'X-Auth-Token': rootState.token
        }
      }).then(function (response) {
        commit('setComputeNodes', response.data);
      });
    }
  },
  getters: {
    getUserComputeDomainById: function getUserComputeDomainById(state) {
      return function (id) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(state.userComputeDomains, { publisherDID: id.toString() });
      };
    }
  }
});

/***/ }),

/***/ "brZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue';
var $ = __webpack_require__("7t+N");

// eslint-disable-next-line import/first


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SideNotifications',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['loadingUI', 'statusUpdate', 'numOfNotifications']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getActionArray', 'getResponseArray']), {
    actionRequiredItems: function actionRequiredItems() {
      return this.getResponseArray;
    }
  }),
  mounted: function mounted() {
    $().on('click', 'dropdown', function (e) {
      console.log('lol');
      e.stopPropagation();
    });
  },

  methods: {
    removeAction: function removeAction(actionName) {
      this.$store.commit('updateResponseArray', actionName);
    }
  }
});

/***/ }),

/***/ "cQEK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"View Quotas","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._l((_vm.sortedQuotas),function(quotaGroup){return _c('div',{key:quotaGroup[0].rootVolumeId,staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[(quotaGroup[0].rootVolume && quotaGroup[0].rootVolume.name )?[_vm._v("\n    "+_vm._s(quotaGroup[0].rootVolume.name)+"\n  ")]:_vm._e(),_vm._v("\n   on "+_vm._s(quotaGroup[0].fileservice.name)+" \n")],2),_vm._v(" "),_vm._l((quotaGroup),function(quota){return _c('div',{key:quota.rootVolumeId + quota.type + quota.username + quota.userVolumeId,staticClass:"list-group-item"},[(quota.username)?[_vm._v("\n        "+_vm._s(quota.username)+"'s user volumes:\n      ")]:[_vm._v("\n        "+_vm._s(_vm.get(_vm.getUserVolumeById(quota.userVolumeId), 'name'))+"\n      ")],_vm._v(" "),_c('div',{staticClass:"file-usage-full-box"},[_c('div',{staticClass:"file-usage-used-box",style:(_vm.styleForUsageBox(quota))})]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm._f("filesize")(quota.numberOfBytesUsed))+" used out of "+_vm._s(_vm._f("filesize")(quota.numberOfBytesQuota))+"\n    ")],2)})],2)}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('p',{staticClass:"text-muted"},[_vm._v("File usage information can take up to 30 minutes to first appear or update.")]),_vm._v(" "),_c('btn',{attrs:{"data-action":"auto-focus"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Close")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cVVO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nsf1.1a5bc18.gif";

/***/ }),

/***/ "cxNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var jQuery = __webpack_require__("7t+N");
var apiCall = __webpack_require__("pBBg").default;
var GrantAccess = __webpack_require__("3wMt").default;

var $ = jQuery;

/* harmony default export */ __webpack_exports__["default"] = (function (_config, _divid) {
  var that = this;
  this.config = _config;
  this.token = _config.token;
  this.user = _config.user;
  // initialize elements wrt rootdiv
  this.rootdiv = jQuery('#' + _divid);
  this.resourcesTable = this.rootdiv.find('#resourcesTable');
  // an object with {columns,rows,hrNames}
  this.resources = null;
  // data: contextClass,resourceContextUUID,resourceContextAPIEndpoint,
  //       resourceType,resourceName, resourcePubDID,resourceuuid,action,actionCategory
  // table: Context Class,RACM Link,Resource Type,Resource - Name,Resource - PubID,Action,[]
  function loadResources() {
    apiCall(that.config.getResourcesUrl, that.token, 'GET', '', function (json) {
      that.resources = json;
      var columnsFromRequest = that.resources.columns;
      var columnsHrFromRequest = that.resources.hrNames;
      var columnsToBeDeleted = ['resourceContextUUID', 'resourceuuid', 'action'];
      var columnIndexesToKeep = [];
      var columnsForDataTable = [];
      var resourceUUIDIndex = columnsFromRequest.indexOf('resourceuuid');
      var actionCategoryIndex = columnsFromRequest.indexOf('actionCategory');
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (var k in columnsFromRequest) {
        if (!columnsToBeDeleted.includes(columnsFromRequest[k])) {
          columnIndexesToKeep.push(k);
          if (columnsFromRequest[k] === 'actionCategory') {
            columnsForDataTable.push({ title: '' });
          } else {
            columnsForDataTable.push({ title: columnsHrFromRequest[k] });
          }
        }
      }
      $('#resourcesTable').DataTable({
        columns: columnsForDataTable
      });
      var rows = [];
      $.each(that.resources.rows, function (index, row) {
        var filteredRow = [];
        var resourceUUID = row[resourceUUIDIndex];
        if (row[actionCategoryIndex] === 'G') {
          row[actionCategoryIndex] = '<button onclick=\'Config.Resources.grant("' + resourceUUID + '")\'>Grant</button>';
          // eslint-disable-next-line guard-for-in,no-restricted-syntax
          for (var _k in row) {
            if (columnIndexesToKeep.includes(_k)) {
              filteredRow.push(row[_k]);
            }
          }
          rows.push(filteredRow);
        }
      });
      if ($.fn.dataTable.isDataTable('#resourcesTable')) {
        // trying to refresh the table
        $('#resourcesTable').DataTable().clear().destroy();
      }
      $('#resourcesTable').DataTable({
        data: rows,
        processing: true,
        bFilter: true,
        paging: true,
        select: {
          style: 'single'
        },
        language: {
          emptyTable: 'No resources to display'
        }
      });
    }, null);
  }
  that.grantAccess = new GrantAccess(_config, 'grantPrivileges', that);
  $('#resourcesRefreshLink').on('click', loadResources);
  this.grant = function (resourceUUID) {
    that.grantAccess.grant(resourceUUID);
  };
  // initialize
  loadResources();
});

/***/ }),

/***/ "dCHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"notebookDash",attrs:{"id":"NotebookDash"}},[_c('div',{staticClass:"full-overlay",staticStyle:{"min-width":"400px","padding-top":"60px"}},[_c('div',{staticStyle:{"width":"80%","max-width":"1000px","margin":"auto"}},[(_vm.$route.query.nf)?_c('div',{staticStyle:{"display":"block","padding-bottom":"12px"}},[_vm._v(" Could not find notebook! ")]):_vm._e(),_vm._v(" "),(_vm.oneclickNotebookPath)?_c('router-link',{attrs:{"to":("/notebook/" + _vm.oneclickNotebookPath + "?copy=true")}},[_c('button',{staticClass:"btn btn-primary"},[_vm._v(" Quick Notebook ")])]):_vm._e(),_vm._v(" "),_c('recent-notebook-list',{ref:"recentNotebookList",staticStyle:{"padding-top":"12px"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dHAj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dM+v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'supportDialog',
  computed: {},
  data: function data() {
    return {
      open: false
    };
  },
  methods: {
    startDialog: function startDialog() {
      this.open = true;
    }
  }
});

/***/ }),

/***/ "dSKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserVolumesStep_vue__ = __webpack_require__("ylhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29411944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserVolumesStep_vue__ = __webpack_require__("w3np");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserVolumesStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29411944_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserVolumesStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ddFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDockerImages_vue__ = __webpack_require__("DG3W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cffd14c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDockerImages_vue__ = __webpack_require__("OvMt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareDockerImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cffd14c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareDockerImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "de2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading panel-headings-with-buttons"},[_c('span',[_c('span',{staticClass:"panel-title"},[_vm._v("Members")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.inviteUserLink,"title":"How to invite"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("How to invite")])])]),_vm._v(" "),(_vm.canEditMemberList)?_c('users-list',{attrs:{"workspace":_vm.collaboration,"members":_vm.members},on:{"submitAddUsersRequest":_vm.changeMembership}}):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"list-group",style:({ 'padding-bottom': _vm.isEditting ? '60px' : 'inherit' })},[(_vm.canEditMemberList)?_c('li',[(_vm.invitedUserId)?_c('div',[_c('div',{staticClass:"invitation-support-box checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitedUserIsAdmin),expression:"invitedUserIsAdmin"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.invitedUserIsAdmin)?_vm._i(_vm.invitedUserIsAdmin,null)>-1:(_vm.invitedUserIsAdmin)},on:{"change":function($event){var $$a=_vm.invitedUserIsAdmin,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.invitedUserIsAdmin=$$a.concat([$$v]))}else{$$i>-1&&(_vm.invitedUserIsAdmin=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.invitedUserIsAdmin=$$c}}}}),_vm._v("\n                  Allow to edit group and invite others?\n                ")])]),_vm._v(" "),(_vm.isDeclinedUser(_vm.invitedUserId))?_c('p',{staticClass:"text-danger invitation-support-box"},[_vm._v("This user previously declined an invitation.")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('button',{staticClass:"btn btn-success",staticStyle:{"flex":"1"},on:{"click":function($event){_vm.inviteUser(false)}}},[_vm._v("Invite User")]),_vm._v(" "),(_vm.canForceAdd)?_c('button',{staticClass:"btn btn-warning",staticStyle:{"flex":"1"},on:{"click":function($event){_vm.inviteUser(true)}}},[_vm._v("Force Add")]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.members),function(member){return (['INVITED', 'ACCEPTED', 'OWNER'].includes(member.status))?_c('li',{key:member.user,staticClass:"list-group-item",class:{'member-updating': member.updating},attrs:{"title":_vm.titleTextForUser(_vm.users[member.id])}},[(!_vm.isEditting)?[(member.status === 'INVITED')?_c('span',{staticClass:"badge"},[_vm._v("INVITED")]):_c('span',{staticClass:"badge"},[_vm._v(_vm._s(member.role))]),_vm._v("\n            "+_vm._s(_vm.users[member.id].username)+"\n          ")]:[_vm._v("\n            "+_vm._s(_vm.displayNameWhenEditting(_vm.users[member.id]))+"\n            "),_c('br'),_vm._v(" "),(member.role !== 'OWNER')?_c('dropdown',{staticStyle:{"width":"100%"}},[_c('btn',{staticClass:"dropdown-toggle",staticStyle:{"width":"100%"},attrs:{"type":"default"}},[(member.role === 'ADMIN')?[_vm._v("Can Edit Group & Invite Others")]:[_vm._v("Member")],_vm._v("\n                 "),_c('span',{staticClass:"caret"})],2),_vm._v(" "),_c('template',{slot:"dropdown"},[(member.role === 'MEMBER')?_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.promoteToAdmin(member.id, 'ADMIN')}}},[_vm._v("Promote to Admin")])]):_vm._e(),_vm._v(" "),(member.role === 'ADMIN')?_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.switchToNonAdmin(member.id, 'MEMBER')}}},[_vm._v("Switch to non-Admin member")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":function($event){_vm.removeMember(member)}}},[(member.status === 'INVITED')?[_vm._v("Rescind Invitation")]:[_vm._v("Remove")]],2)])])],2):_vm._e()]],2):_vm._e()})],2),_vm._v(" "),(_vm.canEditMemberList && _vm.collaboration.members)?_c('div',{staticClass:"panel-footer text-right",staticStyle:{"padding":"0px"}},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.isEditting = !_vm.isEditting}}},[(!_vm.isEditting)?_c('small',{staticClass:"text-danger"},[_vm._v("Edit Member List")]):_vm._e(),_vm._v(" "),(_vm.isEditting)?_c('small',[_vm._v("Finish Editting Member List")]):_vm._e()])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dl6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__("3kHb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__("2+hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__math_utils__ = __webpack_require__("jIKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_domain_wizard_DomainStep__ = __webpack_require__("utPj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_domain_wizard_NodesStep__ = __webpack_require__("UH1d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__new_domain_wizard_ImagesStep__ = __webpack_require__("pIYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__new_domain_wizard_VolumesStep__ = __webpack_require__("4yJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__new_domain_wizard_UserVolumesStep__ = __webpack_require__("dSKA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__new_domain_wizard_DomainSaver__ = __webpack_require__("NMcc");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NewDomainWizard',
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__["TabContent"],
    DomainStep: __WEBPACK_IMPORTED_MODULE_5__new_domain_wizard_DomainStep__["a" /* default */],
    NodesStep: __WEBPACK_IMPORTED_MODULE_6__new_domain_wizard_NodesStep__["a" /* default */],
    ImagesStep: __WEBPACK_IMPORTED_MODULE_7__new_domain_wizard_ImagesStep__["a" /* default */],
    VolumesStep: __WEBPACK_IMPORTED_MODULE_8__new_domain_wizard_VolumesStep__["a" /* default */],
    UserVolumesStep: __WEBPACK_IMPORTED_MODULE_9__new_domain_wizard_UserVolumesStep__["a" /* default */],
    DomainSaver: __WEBPACK_IMPORTED_MODULE_10__new_domain_wizard_DomainSaver__["a" /* default */]
  },
  data: function data() {
    return {
      open: false,
      focused: false,
      loaded: false,
      savingDomain: false,

      finalModel: {}
    };
  },
  methods: {
    startDialog: function startDialog() {
      this.loaded = true;
      this.focused = true;
      this.open = true;
    },
    validateStep: function validateStep(name) {
      return this.$refs[name].validate();
    },
    mergePartialModels: function mergePartialModels(model, isValid) {
      if (isValid) {
        this.finalModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.finalModel, model);
      }
    },
    finishDomain: function finishDomain() {
      var vm = this;
      if (vm.savingDomain) return;
      vm.savingDomain = true;

      // Need to run this after domainSaver has a chance to be
      // mounted after changing savingDomain
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].nextTick(function () {
        return vm.$refs.domainSaver.saveDomain().then(function () {
          vm.$emit('on-save');
          vm.open = false;
          vm.savingDomain = false;
          vm.finalModel = {};
          vm.loaded = false;
        });
      });
    }
  },
  filters: {
    humanReadableLimit: function humanReadableLimit(value) {
      return __WEBPACK_IMPORTED_MODULE_4__math_utils__["default"].bytesToSize(value);
    }
  }
});

/***/ }),

/***/ "drEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Total Progress:")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped active",style:(_vm.totalProgressStyle),attrs:{"role":"progressbar","aria-valuenow":_vm.totalProgress,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n      "+_vm._s(_vm.totalProgress)+"%\n    ")])]),_vm._v(" "),_c('p',[_vm._v("Remaining Tasks:")]),_vm._v(" "),_c('ol',{staticClass:"remaining-list"},[(!_vm.registeredDomainInCompute)?_c('li',[_vm._v("Registering Domain in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredNodesInCompute)?_c('li',[_vm._v("Registering Nodes in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredSlotsInCompute)?_c('li',[_vm._v("Registering Slots for all Nodes in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredImagesInCompute)?_c('li',[_vm._v("Registering Images in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredVolumesInCompute)?_c('li',[_vm._v("Registering Volumes in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredInRACM)?_c('li',[_vm._v("Registering Domain in RACM…")]):_vm._e(),_vm._v(" "),(!_vm.sharedAllWithAdminGroup)?_c('li',[_vm._v("Granting Access to the admin group…")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "drtI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"My Account","size":"lg","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('listGroup',{attrs:{"title":"Account Settings","headingType":"default"}},[_c('a',{staticClass:"list-group-item",class:{ 'active' : _vm.isSelected(0) },attrs:{"href":"#"},on:{"click":function($event){_vm.selected = 0}}},[_vm._v("Profile")]),_vm._v(" "),_c('a',{staticClass:"list-group-item",class:{ 'active' : _vm.isSelected(1) },attrs:{"href":"#"},on:{"click":function($event){_vm.selected = 1}}},[_vm._v("Manage Linked Globus Account")]),_vm._v(" "),_c('a',{staticClass:"list-group-item",class:{ 'active' : _vm.isSelected(2) },attrs:{"href":"#"},on:{"click":function($event){_vm.selected = 2}}},[_vm._v("Change Password")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[(_vm.selected === 0)?_c('div',[_c('div',{staticClass:"Subhead mt-0 mb-0"},[_c('h3',{staticClass:"Subhead-heading",attrs:{"id":"public-profile-heading"}},[_vm._v("My Profile")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_vm._v("\n              User name:\n              "),_c('input',{staticClass:"form-control",attrs:{"name":"username","type":"text","id":"username","readonly":"readonly"},domProps:{"value":_vm.userProfile.username}}),_vm._v(" Contact email:\n              "),_c('input',{staticClass:"form-control",attrs:{"name":"email","type":"email","id":"email","readonly":"readonly"},domProps:{"value":_vm.userProfile.contactEmail}}),_vm._v(" Full name:\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fullName),expression:"fullName"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"name":"fullname","type":"text","id":"fullname","placeholder":_vm.initialFullName},domProps:{"value":(_vm.fullName)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.fullName=$event.target.value}}}),_vm._v(" Affiliation:\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.affiliation),expression:"affiliation"}],staticClass:"form-control",attrs:{"name":"affiliation","type":"text","id":"affiliation","placeholder":_vm.initialAffiliation},domProps:{"value":(_vm.affiliation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.affiliation=$event.target.value}}}),_vm._v(" "),(_vm.isAdmin)?[_vm._v("\n                Token:\n                "),_c('input',{staticClass:"form-control",attrs:{"name":"token","type":"text","readonly":"readonly"},domProps:{"value":_vm.token}})]:_vm._e()],2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"saveProfileButton"},on:{"click":_vm.saveProfile}},[_vm._v("Update profile")])]):_vm._e(),_vm._v(" "),(_vm.selected === 1)?_c('div',[_c('div',{staticClass:"Subhead mt-0 mb-0"},[_c('h3',{staticClass:"Subhead-heading",attrs:{"id":"public-profile-heading"}},[_vm._v("Manage Linked Globus Accounts")])]),_vm._v(" "),_c('manage-linked-accounts')],1):_vm._e(),_vm._v(" "),(_vm.selected === 2)?_c('div',[_c('div',{staticClass:"Subhead mt-0 mb-0"},[_c('h3',{staticClass:"Subhead-heading",attrs:{"id":"public-profile-heading"}},[_vm._v("Change Password")])]),_vm._v(" "),_c('change-user-password')],1):_vm._e()])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Close")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eXj4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareVolumeContainer_vue__ = __webpack_require__("1wrd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9abfb8d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareVolumeContainer_vue__ = __webpack_require__("k7sn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_shareVolumeContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9abfb8d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_shareVolumeContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "edv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('list-group',{attrs:{"title":"Compute Domains","headingType":"primary","items":_vm.racmDomains,"onClick":_vm.selectDomain,"selectedId":_vm.selectedId}},[_c('span',{attrs:{"slot":"headerContent"},slot:"headerContent"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","title":"Refresh"},on:{"click":_vm.loadAllInfo}},[_c('i',{staticClass:"fa fa-refresh",class:_vm.refreshSpinner,attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","title":"Create New Compute Domain"},on:{"click":_vm.newDomain}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[(_vm.shownId)?_c('compute-domain',{attrs:{"selected-id":_vm.shownId},on:{"on-save":_vm.loadAllInfo}}):_c('div',{staticClass:"jumbotron"},[_c('h1',[_vm._v("No Compute Domains Registered")]),_vm._v(" "),_c('p',[_vm._v("In order to use SciServer Compute, please "),_c('a',{on:{"click":_vm.newDomain}},[_vm._v("create")]),_vm._v("\n          one or more compute domains.")])])],1)]),_vm._v(" "),_c('new-domain-wizard',{ref:"newDomainWizard",on:{"on-save":_vm.loadAllInfo}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ehnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.computeOnlyIds),function(image){return _c('compute-image',{key:("compute:" + image),attrs:{"imageId":("compute:" + image)}})}),_vm._v(" "),_vm._l((_vm.imageIds),function(image){return _c('compute-image',{key:image,attrs:{"imageId":image}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ezwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Copy Folder/File","auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('span',{staticClass:"panel-title"},[_vm._v("Volumes")])]),_vm._v(" "),_c('root-volume-template',{attrs:{"currentRootVolumes":_vm.currentRootVolumes,"selectedVolumeType":_vm.selectedVolumeType},on:{"changeVolumesType":_vm.changeVolumesType}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('bread-crumb',{attrs:{"currentUserVolume":_vm.currentUserVolume,"path":_vm.path},on:{"changeUV":_vm.changeUV,"showFiles":_vm.showFiles,"resetPath":_vm.resetPath}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin fa-3x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticStyle:{"text-align":"center"},attrs:{"id":"spinner2"}},[_vm._v("Copying ... "),_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"table table-condensed table-striped table-responsive",attrs:{"id":"copyFilesTable"}},[_c('thead',[_c('tr',[(_vm.isShowingFiles)?[_c('th',{staticClass:"sorted ascending",attrs:{"scope":"col"}},[_vm._v("Name")])]:_vm._l((_vm.columnFields),function(column){return _c('th',{key:column},[_vm._v("\n                      "+_vm._s(column)+"\n                    ")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.sortedVolumes),function(volume){return (volume.write || _vm.isShowingFiles)?_c('tr',{key:volume.name},[_c('td',[((volume.type === 'uservolumes' || volume.type === 'datavolumes'))?_c('div',{staticClass:"userVolume"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.changeUV(volume.id)}}},[(volume.owner!==_vm.username)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && !volume.sharedUsers.length)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#008ae6"}})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && volume.sharedUsers.length)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#008ae6"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v("\n                          "+_vm._s(decodeURIComponent(volume.displayName ? volume.displayName : volume.name))+"\n                        ")])]):_vm._e(),_vm._v(" "),(volume.type === 'dir')?_c('div',{staticClass:"volume"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.goToFiles(volume.name)}}},[_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#008ae6"}})]),_vm._v(_vm._s(volume.name))])]):_vm._e(),_vm._v(" "),(volume.type === 'file')?_c('div',{staticClass:"file"},[_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-file-o fa-2x"})]),_vm._v(_vm._s(decodeURIComponent(volume.name))+"\n                      ")]):_vm._e()]),_vm._v(" "),(_vm.isShowingFiles)?[_c('td',[_vm._v(" "+_vm._s(volume.modified))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(volume.size))])]:_vm._e(),_vm._v(" "),(volume.type === 'uservolumes')?[_c('td',[_vm._v(_vm._s(volume.rootVolumeObj.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(volume.owner))])]:_vm._e(),_vm._v(" "),(volume.type === 'datavolumes')?[_c('td',[_vm._v(_vm._s(volume.name))]),_vm._v(" "),_c('td')]:_vm._e()],2):_vm._e()}),0)])],1)]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.paste()}}},[_vm._v("Paste")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-action":"auto-focus"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('pop-up-dialog',{ref:"alertPopUp"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fPVE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var apiCall = __webpack_require__("pBBg").default;
var $ = __webpack_require__("7t+N");
var Resources = __webpack_require__("cxNO").default;

/* harmony default export */ __webpack_exports__["default"] = (function (_user, _token) {
  var that = this;
  this.user = _user;
  this.username = _user.username;
  this.token = _token;

  function init(jsonEntities) {
    var entities = $.parseJSON(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonEntities));
    that.config.users = entities.users;
    that.config.groups = entities.groups;
    that.Resources = new Resources(that.config, 'resourcestab');
  }

  var loadConfig = function loadConfig(json) {
    that.config = $.parseJSON(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json));
    that.config.token = that.token;
    that.config.username = that.username;
    that.config.user = that.user;
    apiCall(that.config.getAllUsersUrl, that.token, 'GET', '', init, null, null);
  };

  apiCall("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + '/config', this.token, 'GET', '', loadConfig, null);
});

/***/ }),

/***/ "fqdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScienceTab_vue__ = __webpack_require__("tZc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77aa9680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScienceTab_vue__ = __webpack_require__("V75J");
function injectStyle (ssrContext) {
  __webpack_require__("MWBg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScienceTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77aa9680_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScienceTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g8X+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatMap__ = __webpack_require__("nfWN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_filesize__ = __webpack_require__("H52G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_filesize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_filesize__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      open: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    myFileserviceIdentifiers: function myFileserviceIdentifiers() {
      return this.$store.state.files.myFileserviceIdentifiers;
    },
    quotasForFileserviceIdentifier: function quotasForFileserviceIdentifier() {
      var _this = this;

      return function (identifier) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(_this.$store.state.files.quotasPerFileservice, identifier, []);
      };
    },
    sortedQuotas: function sortedQuotas() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_groupBy___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_flatMap___default()(this.myFileserviceIdentifiers.map(this.getFileserviceByIdentifier), function (fileservice) {
        return _this2.quotasForFileserviceIdentifier(fileservice.identifier).map(function (q) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            fileservice: fileservice,
            rootVolume: _this2.getRootVolumeById(q.rootVolumeId)
          }, q);
        });
      }), 'rootVolumeId'), function (listOfQuotas) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(listOfQuotas[0], 'fileservice.name');
      }).map(function (listOfQuotas) {
        return listOfQuotas.sort(__WEBPACK_IMPORTED_MODULE_6_thenby___default()('type').thenBy(function (quota) {
          return quota.username !== _this2.userProfile.username;
        }).thenBy('username').thenBy(function (quota) {
          return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(_this2.getUserVolumeById(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(quota, 'userVolumeId')), 'name');
        }));
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['userProfile']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getRootVolumeById', 'getFileserviceByIdentifier', 'getUserVolumeById'])),
  methods: {
    startDialog: function startDialog() {
      this.open = true;
    },

    styleForUsageBox: function styleForUsageBox(quota) {
      return {
        width: 100 * Math.min(1, quota.numberOfBytesUsed / quota.numberOfBytesQuota) + '%',
        background: quota.numberOfBytesUsed >= quota.numberOfBytesQuota ? 'red' : 'lime'
      };
    }
  },
  filters: {
    filesize: __WEBPACK_IMPORTED_MODULE_7_filesize___default.a
  }
});

/***/ }),

/***/ "gLyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NodeConfigurer__ = __webpack_require__("4jcw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NodesStep',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate__["validationMixin"]],
  components: {
    NodeConfigurer: __WEBPACK_IMPORTED_MODULE_2__NodeConfigurer__["a" /* default */]
  },
  data: function data() {
    return {
      nodes: [],
      isEditing: false,
      currentlyEditingIndex: undefined
    };
  },
  validations: {
    nodes: {
      required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
      minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(1)
    },
    form: ['nodes']
  },
  methods: {
    validate: function validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
    saveNode: function saveNode(newNode) {
      if (this.currentlyEditingIndex === undefined) {
        this.nodes.push(newNode);
      } else {
        this.nodes[this.currentlyEditingIndex] = newNode;
        this.currentlyEditingIndex = undefined;
      }
      this.isEditing = false;
    },
    startEditing: function startEditing(index) {
      this.currentlyEditingIndex = index;
      this.isEditing = true;
    },
    cancelEdit: function cancelEdit() {
      this.isEditing = false;
      this.currentlyEditingIndex = undefined;
    }
  }
});

/***/ }),

/***/ "gda6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jhulogo.28fcfec.png";

/***/ }),

/***/ "gpZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__create_dialog__ = __webpack_require__("l47g");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GrantPrivilegesDialog',
  mounted: function mounted() {
    Object(__WEBPACK_IMPORTED_MODULE_0__create_dialog__["a" /* default */])('#grantPrivilegesDialog', null);
  }
});

/***/ }),

/***/ "hfDn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-component"},[_c('button',{staticClass:"btn btn-success btn-sm",class:_vm.buttonClasses,attrs:{"type":"button","title":"Create New Group"},on:{"click":_vm.newGroup}},[_vm._t("default")],2),_vm._v(" "),_c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"New Group"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Group Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Group Name"},domProps:{"value":(_vm.name)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.saveNewGroup($event)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.description),expression:"description"}],staticClass:"form-control",attrs:{"rows":"3","placeholder":"Group Description"},domProps:{"value":(_vm.description)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.saveNewGroup($event)},"input":function($event){if($event.target.composing){ return; }_vm.description=$event.target.value}}})])]),_vm._v(" "),_c('template',{slot:"footer"},[_c('btn',{on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('btn',{attrs:{"type":"success","disabled":!_vm.isValid},on:{"click":_vm.saveNewGroup}},[_vm._v("Create")])],1),_vm._v(" "),_c('div',[_c('h5',[_vm._v("*If creating a group to share tables in CASJobs, note that the following naming conventions apply: ")]),_vm._v(" "),_c('ul',{staticClass:"bulletList"},[_c('li',[_vm._v("group name may only contain letters and numbers")]),_vm._v(" "),_c('li',[_vm._v("must start with a letter")])])])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hr5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationResponse_vue__ = __webpack_require__("AvMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b113e5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationResponse_vue__ = __webpack_require__("Jhex");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationResponse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b113e5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationResponse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hyEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__("q16o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sharedComponents_VueSelect2__ = __webpack_require__("YfF0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addMembersButton__ = __webpack_require__("Dghi");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueSelect2: __WEBPACK_IMPORTED_MODULE_5__sharedComponents_VueSelect2__["a" /* default */], usersList: __WEBPACK_IMPORTED_MODULE_6__addMembersButton__["a" /* default */] },
  data: function data() {
    return {
      invitedUserId: undefined,
      invitedUserIsAdmin: false,
      isEditting: false
    };
  },
  props: ['collaboration'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    inviteUserLink: function inviteUserLink() {
      return "https://www.sciserver.org/support/how-to-use-sciserver/#groupsinvite";
    },
    canEditMemberList: function canEditMemberList() {
      return this.collaboration._links.editMemberList;
    },
    members: function members() {
      var _this = this;

      if (this.collaboration.type === 'COURSEWARE') {
        return this.collaboration.members;
      }
      return this.collaboration.members.sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (member) {
        return member.status === 'INVITED';
      }).thenBy(function (member) {
        return { OWNER: 1, ADMIN: 2, MEMBER: 3 }[member.role];
      }).thenBy(function (a, b) {
        return _this.users[a.id].username.localeCompare(_this.users[b.id].username);
      }));
    },
    selectUserData: function selectUserData() {
      return this.publicUsers
      // .filter(id => !some(this.collaboration.members, { id, status: 'ACCEPTED' }))
      // .filter(id => !some(this.collaboration.members, { id, status: 'OWNER' }))
      .map(this.getUserById).sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (a, b) {
        return a.username.localeCompare(b.username);
      })).map(function (u) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          text: u.username
        }, u);
      });
    },
    canForceAdd: function canForceAdd() {
      return this.collaboration._links.forceAddMember;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['users', 'publicUsers', 'token']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getUserById'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    formatUserSelection: function formatUserSelection(user) {
      if (user.id === undefined) return user.text;
      var output = '';
      var fullname = user.fullname ? ' (' + user.fullname + ')' : '';
      output += '<p>' + user.username + fullname + '</p>';
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(user.affiliation)) {
        output += '<p class="small text-muted">' + user.affiliation + '</p>';
      }

      return output;
    },
    inviteUser: function inviteUser(force) {
      var user = [];
      user.push(this.users[this.invitedUserId]);
      this.changeMembership(user, this.invitedUserIsAdmin ? 'ADMIN' : 'MEMBER', force ? 'ACCEPTED' : 'INVITED');

      this.resetInvitation();
    },
    changeMembership: function changeMembership(user, newRole, newStatus) {
      this.changeCollaborationMembership({
        collaborationId: this.collaboration._links.self.href,
        editMemberListEndpoint: this.collaboration._links.editMemberList.href,
        user: user,
        newRole: newRole,
        newStatus: newStatus
      });
    },
    promoteToAdmin: function promoteToAdmin(memberID, role) {
      var user = [];
      user.push(this.users[memberID]);
      this.changeMembership(user, role);
    },
    switchToNonAdmin: function switchToNonAdmin(memberID, role) {
      var user = [];
      user.push(this.users[memberID]);
      this.changeMembership(user, role);
    },
    resetInvitation: function resetInvitation() {
      this.invitedUserId = undefined;
      this.invitedUserIsAdmin = false;
    },
    resetEditting: function resetEditting() {
      this.isEditting = false;
    },
    displayNameWhenEditting: function displayNameWhenEditting(user) {
      var fullnameAddition = user.fullname ? ' (' + user.fullname + ')' : '';
      return '' + user.username + fullnameAddition;
    },
    titleTextForUser: function titleTextForUser(user) {
      return [user.fullname, user.affiliation].join('\n');
    },
    isDeclinedUser: function isDeclinedUser(userId) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_some___default()(this.collaboration.members, { status: 'DECLINED', id: userId });
    },
    removeMember: function removeMember(member) {
      if (confirm('Are you sure you want to remove ' + this.displayNameWhenEditting(this.users[member.id]) + ' from this group?')) {
        var user = [];
        user.push(this.users[member.id]);
        this.changeMembership(user, member.role, 'WITHDRAWN');
      }
    },
    matchInvitedUser: function matchInvitedUser(params, data) {
      var term = params.term.toLowerCase().trim();

      if (term.trim() === '') {
        return data;
      }
      if (typeof data.text === 'undefined' || data.text === '') {
        return null;
      }
      if (data.username.toLowerCase().indexOf(term) > -1 || data.fullname && data.fullname.toLowerCase().indexOf(term) > -1 || data.affiliation && data.affiliation.toLowerCase().indexOf(term) > -1) {
        return data;
      }

      return null;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeCollaborationMembership'])),
  watch: {
    collaboration: function collaboration(newCollaboration, oldCollaboration) {
      if (newCollaboration.id !== oldCollaboration.id) {
        this.resetInvitation();
        this.resetEditting();
      }
    }
  }
});

/***/ }),

/***/ "i1NX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iDB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supportDialog_vue__ = __webpack_require__("dM+v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee3173d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supportDialog_vue__ = __webpack_require__("9zyT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_supportDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ee3173d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_supportDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iW9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isEditing)?_c('p',[_vm._v("\n    For performance, remember to run put the docker images on all the nodes.\n    For images from a registry, this is done with "),_c('kbd',[_vm._v("docker pull ...")]),_vm._v(".\n  ")]):_vm._e(),_vm._v(" "),(!_vm.isEditing && _vm.images)?_c('ul',{staticClass:"list-group"},_vm._l((_vm.images),function(image,index){return _c('li',{key:image.name,staticClass:"list-group-item clearfix"},[_vm._v("\n\n      "+_vm._s(image.name)+"\n      "),_c('div',{staticClass:"btn-group pull-right",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing(index)}}},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_vm._v("Remove")])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.startEditing()}}},[_vm._v("\n\n    Add New Image\n  ")]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('image-configurer',{attrs:{"initial-data":_vm.images[_vm.currentlyEditingIndex],"is-editing":_vm.currentlyEditingIndex !== undefined},on:{"on-save":_vm.saveImage,"cancel":_vm.cancelEdit}}):_vm._e(),_vm._v(" "),(_vm.$v.form.$error)?_c('p',{staticClass:"text-danger"},[_vm._v("\n      One or more images must be configured\n    ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibVK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/js/graphvizlib.wasm";

/***/ }),

/***/ "ieWe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jIKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// bytesToSize code source: https://gist.github.com/lanqy/5193417
function bytesToSize(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 B';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return bytes + ' ' + sizes[i];
  return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
}
/* harmony default export */ __webpack_exports__["default"] = ({ bytesToSize: bytesToSize });

/***/ }),

/***/ "joJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareUserVolumeDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    uvResources: function uvResources() {
      window.tempStuff = this.resources;
      return __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(this.getGrantableResources('USERVOLUME').sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (uv) {
        return uv.fileService.name;
      }).thenBy(function (uv) {
        return uv.rootVolume.name;
      }).thenBy('owner').thenBy('name')), 'rootVolume.name');
    },
    isValid: function isValid() {
      return this.selectedResources && this.checkedPrivilege;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getGrantableResources'])), // computed
  data: function data() {
    return {
      selectedResources: undefined,
      checkedPrivilege: undefined,
      open: false,
      focused: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startDialog: function startDialog() {
      this.loadResources();
      this.selectedResources = undefined;
      this.checkedPrivilege = undefined;
      this.focused = true;
      this.open = true;
    },
    linkResources: function linkResources() {
      this.$emit('linkUVResources', this.selectedResources, this.checkedPrivilege);
      this.open = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadResources']))
}); // default

/***/ }),

/***/ "jof2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moveFiles_vue__ = __webpack_require__("WMna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d722602c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moveFiles_vue__ = __webpack_require__("JOgx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_moveFiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d722602c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moveFiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k0Xc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k7sn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Share Data Volume"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Data Volume")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedResources),expression:"selectedResources"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedResources=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.vcResources),function(domainResources){return _c('optgroup',{key:domainResources[0].dockerComputeDomain.name,attrs:{"label":domainResources[0].dockerComputeDomain.name}},_vm._l((domainResources),function(item){return _c('option',{key:item.entityId,domProps:{"value":item}},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")])}),0)}),0)])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-4 control-label"},[_vm._v("Allow this group to:")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read")},on:{"change":function($event){_vm.checkedPrivilege="read"}}}),_vm._v("\n          Read\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write")},on:{"change":function($event){_vm.checkedPrivilege="read,write"}}}),_vm._v("\n          Read/Write\n        ")]),_vm._v(" "),_c('label',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedPrivilege),expression:"checkedPrivilege"}],attrs:{"type":"radio","name":"privilege","value":"read,write,grant"},domProps:{"checked":_vm._q(_vm.checkedPrivilege,"read,write,grant")},on:{"change":function($event){_vm.checkedPrivilege="read,write,grant"}}}),_vm._v("\n          Read/Write and Share this Data Volume\n        ")])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.isValid},on:{"click":_vm.linkResources}},[_vm._v("Share")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kAB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.foundVolume)?_c('li',{staticClass:"list-group-item"},[(_vm.racmVolume)?_c('span',{staticClass:"badge"},[_vm._v("RACM ID: "+_vm._s(_vm.racmVolume.id))]):_c('span',{staticClass:"badge alert-danger"},[_vm._v("Not Registered in RACM")]),_vm._v(" "),_c('span',{staticClass:"badge"},[_vm._v("Compute ID: "+_vm._s(_vm.computeVolumeId))]),_vm._v(" "),_c('h4',{staticClass:"list-group-item-heading"},[_vm._v(_vm._s(_vm.foundVolume.name))]),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Description")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.foundVolume.description))]),_vm._v(" "),(_vm.computeVolume)?[_c('dt',[_vm._v("Docker volume container")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.computeVolume.docker_ref))])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"panel-body",class:_vm.classForConsistency},[(_vm.racmVolume && _vm.computeVolume)?[(_vm.consistentMetadata)?_c('span',[_vm._v("\n        ✅ Name and Description are consistent between RACM and Compute databases\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && _vm.computeVolume.name !== _vm.racmVolume.name)?_c('p',[_vm._v("\n        A different name is registered in Compute: \""+_vm._s(_vm.computeVolume.name)+"\"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && _vm.computeVolume.description !== _vm.racmVolume.description)?_c('p',[_vm._v("\n        A different description is registered in Compute: \""+_vm._s(_vm.computeVolume.description)+"\"\n      ")]):_vm._e(),_vm._v(" "),(!_vm.consistentMetadata && !_vm.isGrantedToAdmin)?_c('p',[_vm._v("\n        The \"admin\" group does not have grant privileges on this volume\n      ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.racmVolume && !_vm.computeVolume)?[_vm._v("\n      Not registered in Compute!\n    ")]:_vm._e(),_vm._v(" "),(!_vm.racmVolume && _vm.computeVolume)?[_vm._v("\n      Not registered in RACM!\n    ")]:_vm._e()],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kTU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_admin_compute_new_domain_wizard_domain_register__ = __webpack_require__("SJMa");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DomainSaver',
  props: ['imageModel', 'computeDomainId', 'racmDomainId'],
  data: function data() {
    return {
      registeredInCompute: false,
      registeredInRACM: false,
      sharedWithAdminGroup: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    totalProgress: function totalProgress() {
      var tasksCompleted = +this.registeredInCompute + +this.registeredInRACM + +this.sharedWithAdminGroup;
      return Math.round(100 * (tasksCompleted / 3));
    },
    totalProgressStyle: function totalProgressStyle() {
      return {
        minWidth: '2em',
        width: this.totalProgress + '%'
      };
    },
    adminGroup: function adminGroup() {
      var _this = this;

      if (!this.myCollaborations) return undefined;
      return this.myCollaborations.map(function (x) {
        return _this.collaborations[x];
      }).find(function (x) {
        return x.name === 'admin' && x.type === 'GROUP';
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['token', 'collaborations', 'myCollaborations'])),
  methods: {
    saveImage: function saveImage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var vm, runningModel, imageId, domainObj;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this2;
                runningModel = vm.imageModel;
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_5__components_admin_compute_new_domain_wizard_domain_register__["c" /* registerImageInCompute */])(vm.token, { domain_id: vm.computeDomainId }, runningModel);

              case 4:
                imageId = _context.sent;

                vm.registeredInCompute = true;
                runningModel.id = imageId;

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__components_admin_compute_new_domain_wizard_domain_register__["d" /* registerImageInRACM */])(vm.token, vm.racmDomainId, runningModel);

              case 9:
                domainObj = _context.sent;

                vm.registeredInRACM = true;

                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_5__components_admin_compute_new_domain_wizard_domain_register__["i" /* saveEntityToAdminGroup */])(vm.adminGroup, vm.token, 'DOCKERIMAGE', 'grant', __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(domainObj.images, { publisherDID: imageId.toString() }).id);

              case 13:

                vm.sharedWithAdminGroup = true;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),

/***/ "kWjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"list"},[_c('h3',{class:("list-heading-" + _vm.headingType)},[_vm._v("\n       "+_vm._s(_vm.title)+"\n       "),_vm._t("headerContent")],2),_vm._v(" "),_vm._t("default",_vm._l((_vm.items),function(item){return _c('a',{key:item.id,staticClass:"list-group-item",class:{active: item.id === _vm.selectedId},attrs:{"href":"#","type":"button"},on:{"click":function($event){_vm.onClick(item.id)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}))],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ketF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.racmRootVolumeOnCD)?_c('li',{staticClass:"list-group-item"},[_c('h4',{staticClass:"list-group-item-heading"},[_vm._v(_vm._s(_vm.racmRootVolumeOnCD.displayName))]),_vm._v(" "),_c('dl',{staticClass:"dl-horizontal"},[_c('dt',[_vm._v("Path on Nodes")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.racmRootVolumeOnCD.pathOnCD))]),_vm._v(" "),(_vm.rootVolume && _vm.rootVolume.fileserviceObj)?[_c('dt',[_vm._v("Root Volume")]),_vm._v(" "),_c('dd',[_vm._v("\""+_vm._s(_vm.rootVolume.name)+"\" on the \""+_vm._s(_vm.rootVolume.fileserviceObj.name)+"\" file service")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"panel-body",class:_vm.classForConsistency},[(_vm.consistentMetadata)?_c('p',[_vm._v("\n      ✅ The display name is consistent with the root volume's name.\n    ")]):_c('p',[_vm._v("\n      Display name in Compute does not match the name of the root volume\n    ")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l47g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createdialog;
var jQuery = __webpack_require__("7t+N");
__webpack_require__("J5qV");

function createdialog(id, htmlTitle) {
  var dialog = jQuery(id).dialog({
    autoOpen: false,
    width: 'auto',
    modal: true,
    buttons: [{
      text: 'Close',
      click: function click() {
        jQuery(this).dialog('close');
      }
    }]
  });
  if (htmlTitle != null) {
    dialog.dialog('option', 'title', htmlTitle);
  }
  return dialog;
}

/***/ }),

/***/ "l4iD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActivityTab_vue__ = __webpack_require__("ZcQp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b095a08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActivityTab_vue__ = __webpack_require__("/qBL");
function injectStyle (ssrContext) {
  __webpack_require__("UwFo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActivityTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b095a08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActivityTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lFIZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog-xxl",attrs:{"auto-focus":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Available SciServer Users")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered responsive hover order-column compact sciserver-datatable",staticStyle:{"color":"black"},attrs:{"id":"usersTable"}},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th',{staticStyle:{"color":"black"}},[_vm._v("Name")])])]),_vm._v(" "),_c('tbody')])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 setFreeSpace"},[_c('div',{staticClass:"btn-group-vertical"},[_c('div',{staticClass:"dropdown",staticStyle:{"color":"black"}},[_c('button',{staticClass:"dropdown-toggle",attrs:{"title":"invite user","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                          Invite User\n                      ")]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","id":"inviteADMIN"},on:{"click":function($event){_vm.addUsers('INVITED', 'ADMIN')}}},[_vm._v("Admin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","id":"inviteMEMBER"},on:{"click":function($event){_vm.addUsers('INVITED', 'MEMBER')}}},[_vm._v("Member")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}]},[_c('div',{staticClass:"dropdown",staticStyle:{"color":"black"}},[_c('button',{staticClass:"dropdown-toggle",attrs:{"title":"Add User","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                              Add User\n                          ")]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","id":"addADMIN"},on:{"click":function($event){_vm.addUsers('ACCEPTED', 'ADMIN')}}},[_vm._v("Admin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","id":"addMEMBER"},on:{"click":function($event){_vm.addUsers('ACCEPTED', 'MEMBER')}}},[_vm._v("Member")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5",staticStyle:{"overflow-y":"auto"}},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Members")])]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"color":"black"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-hover sciserver-datatable",attrs:{"id":"userModalfilesTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Member Role")]),_vm._v(" "),_c('th',[_vm._v("Member Status")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.gMembers),function(member){return _c('tr',{key:member.id},[_c('td',[_vm._v(_vm._s(_vm.users[member.id].username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.role))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(member.status))])])}),0)])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lXIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['label', 'description', 'action']
});

/***/ }),

/***/ "laQ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lbJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trimStart__ = __webpack_require__("z6ge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_trimStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_trimStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeVolume',
  props: ['volumeId'],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    foundVolume: function foundVolume() {
      return this.racmVolume || this.computeVolume;
    },
    registeredInRACM: function registeredInRACM() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.volumeId);
    },
    volumeName: function volumeName() {
      if (this.racmVolume) return this.racmVolume.name;
      if (this.computeVolume) return this.computeVolume.name;
      return undefined;
    },
    computeVolumeId: function computeVolumeId() {
      if (this.racmVolume) {
        return parseInt(this.racmVolume.publisherDID, 10);
      } else if (this.volumeId) {
        return parseInt(__WEBPACK_IMPORTED_MODULE_2_lodash_trimStart___default()(this.volumeId, 'compute:'), 10);
      }
      return undefined;
    },
    racmVolume: function racmVolume() {
      if (!this.registeredInRACM) return undefined;
      return this.$store.state.compute.racmVolumeContainers[this.volumeId];
    },
    computeVolume: function computeVolume() {
      if (!this.volumeId) return undefined;
      return this.$store.state.compute.computeVolumeContainers[this.computeVolumeId];
    },
    classForConsistency: function classForConsistency() {
      return {
        'alert-danger': !(this.racmVolume && this.computeVolume),
        'alert-success': this.racmVolume && this.computeVolume && this.consistentMetadata,
        'alert-warning': this.racmVolume && this.computeVolume && !this.consistentMetadata
      };
    },
    consistentMetadata: function consistentMetadata() {
      if (this.computeVolume === undefined || this.racmVolume === undefined) return false;
      return this.computeVolume.name === this.racmVolume.name && this.computeVolume.description === this.racmVolume.description && this.isGrantedToAdmin;
    },
    isGrantedToAdmin: function isGrantedToAdmin() {
      var _this = this;

      if (!this.myCollaborations || !this.registeredInRACM) return undefined;
      var adminGroup = this.myCollaborations.map(function (x) {
        return _this.collaborations[x];
      }).find(function (x) {
        return x.name === 'admin' && x.type === 'GROUP';
      });
      if (!adminGroup) return undefined;
      var thisVolume = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(adminGroup.resources, { entityId: this.volumeId, type: 'VOLUMECONTAINER' });
      return thisVolume ? thisVolume.actions.includes('grant') : false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['collaborations', 'myCollaborations']))
});

/***/ }),

/***/ "lv8+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mB/h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__group_view_ResourcesList__ = __webpack_require__("DNP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__group_view_MembersList__ = __webpack_require__("3epO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__group_view_InvitationResponse__ = __webpack_require__("hr5T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__group_view_NewGroupButton__ = __webpack_require__("R4OF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__group_view_CollaborationInfo__ = __webpack_require__("4Mhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__group_view_GroupEditDialog__ = __webpack_require__("FkwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sharedComponents_emptyState__ = __webpack_require__("0XGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sharedComponents_listGroup__ = __webpack_require__("MoEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__main__ = __webpack_require__("NHnr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
The workspace page is
currently changed to group view.
Group view is a way to display
users group and the resources
shared with the user.
*/














var $ = __webpack_require__("7t+N");
var apiCall = __webpack_require__("pBBg").default;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'WorkspaceTab',
  components: {
    ResourcesList: __WEBPACK_IMPORTED_MODULE_6__group_view_ResourcesList__["a" /* default */],
    MembersList: __WEBPACK_IMPORTED_MODULE_7__group_view_MembersList__["a" /* default */],
    InvitationResponse: __WEBPACK_IMPORTED_MODULE_8__group_view_InvitationResponse__["a" /* default */],
    NewGroupButton: __WEBPACK_IMPORTED_MODULE_9__group_view_NewGroupButton__["a" /* default */],
    CollaborationInfo: __WEBPACK_IMPORTED_MODULE_10__group_view_CollaborationInfo__["a" /* default */],
    GroupEditDialog: __WEBPACK_IMPORTED_MODULE_11__group_view_GroupEditDialog__["a" /* default */],
    EmptyState: __WEBPACK_IMPORTED_MODULE_12__sharedComponents_emptyState__["a" /* default */],
    listGroup: __WEBPACK_IMPORTED_MODULE_13__sharedComponents_listGroup__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.loadResources();
    this.$store.dispatch('loadScienceDomains', this.userProfile);
    __WEBPACK_IMPORTED_MODULE_14__main__["EventBus"].$on('addMembers', function () {
      _this.nonStickyDiv();
    });
    __WEBPACK_IMPORTED_MODULE_14__main__["EventBus"].$on('closeAddMembers', function () {
      _this.stickyDiv();
    });
  },

  data: function data() {
    return {
      selectedCollaborationId: undefined,
      searchTerm: '',
      groupsList_border: '',
      createGroup: "https://www.sciserver.org/support/how-to-use-sciserver/#groupscreate",
      type: 'Group',
      displayInvite: true
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.lastGroupRoute && !vm.groupid) {
        next('groups/' + vm.lastGroupRoute);
      } else if (vm.groupid && !vm.lastGroupRoute) {
        if (vm.collaborations && vm.collaborations[vm.sortedCollaborationIds[0]] && vm.collaborations[vm.sortedCollaborationIds[0]].groupId) {
          next('groups/' + vm.collaborations[vm.sortedCollaborationIds[0]].groupId);
        }
      } else {
        next();
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    searchedGroups: function searchedGroups() {
      var _this2 = this;

      return this.sortedCollaborationIds.filter(function (id) {
        return _this2.collaborations[id].name.toLowerCase().match(_this2.searchTerm.toLowerCase());
      });
    },
    findCurrentGroupKey: function findCurrentGroupKey() {
      var _this3 = this;

      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.collaborations);
      return key.find(function (k) {
        return _this3.collaborations[k].groupId.toString() === _this3.groupid;
      });
    },
    shownCollaborationId: function shownCollaborationId() {
      if (this.findCurrentGroupKey) {
        return this.findCurrentGroupKey;
      }
      return this.sortedCollaborationIds[0];
    },
    groupid: function groupid() {
      return this.$route.params.groupId;
    },
    shownCollaborationObject: function shownCollaborationObject() {
      return this.collaborations[this.shownCollaborationId];
    },
    sortedCollaborationIds: function sortedCollaborationIds() {
      var _this4 = this;

      return this.myCollaborations
      /* Only show groups. */
      .filter(function (id) {
        return _this4.collaborations[id].type === 'GROUP';
      }).sort(__WEBPACK_IMPORTED_MODULE_5_thenby___default()(function (id) {
        return _this4.myStatus(id) !== 'INVITED';
      }).thenBy(function (a, b) {
        return _this4.collaborations[a].name.localeCompare(_this4.collaborations[b].name);
      }));
    },
    resourcesLoaded: function resourcesLoaded() {
      return this.collaborationLoadingStatus === 'LOADED' || this.collaborationLoadingStatus === 'RELOADING';
    },
    resourcesLoading: function resourcesLoading() {
      return this.collaborationLoadingStatus === 'LOADING' || this.collaborationLoadingStatus === 'RELOADING';
    },
    invitedToShownCollaboration: function invitedToShownCollaboration() {
      if (this.shownCollaborationObject._links.acceptInvitation) {
        this.displayInvite = true;
        return true;
      }
      return false;
    },
    shownResources: function shownResources() {
      if (!this.shownCollaborationObject) return [];
      return this.shownCollaborationObject.resources;
    },
    refreshGroupViewSpinner: function refreshGroupViewSpinner() {
      return {
        'fa-spin': this.resourcesLoading
      };
    },
    isDeletable: function isDeletable() {
      return this.shownCollaborationObject._links.delete;
    },
    isLeavable: function isLeavable() {
      return this.shownCollaborationObject._links.leave;
    },
    collaborationOwner: function collaborationOwner() {
      var _this5 = this;

      return this.shownCollaborationObject.members.find(function (k) {
        return k.id === _this5.userProfile.id;
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token', 'users', 'collaborationLoadingStatus', 'collaborations', 'myCollaborations', 'collaborationLoadingStatus', 'collaborationLinks']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['lastGroupRoute'])),
  watch: {
    groupid: function groupid() {
      this.$store.dispatch('loadLastGroupPath', this.groupid);
    }
  },
  methods: {
    loadResources: function loadResources() {
      this.$store.dispatch('loadCollaborations');
    },
    declineInvitation: function declineInvitation(collaboration) {
      var _this6 = this;

      if (confirm('Are you sure you want to decline membership?') === false) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_14__main__["EventBus"].$emit('declineClicked');
      apiCall(collaboration._links.declineInvitation.href, this.token, 'POST', '', function () {
        _this6.$store.dispatch('loadCollaborations').then(function () {
          __WEBPACK_IMPORTED_MODULE_3_vue__["default"].notify({
            group: 'top_center_notify',
            text: collaboration.name + ' declined!',
            duration: 1000,
            type: 'warn',
            ignoreDuplicates: true
          });
          _this6.displayInvite = false;
          _this6.unSelectDeletedGroup();
        });
      }, null);
    },
    acceptInvitation: function acceptInvitation(collaboration) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_14__main__["EventBus"].$emit('acceptClicked');
      apiCall(collaboration._links.acceptInvitation.href, this.token, 'POST', '', function () {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].notify({
          group: 'top_center_notify',
          text: collaboration.name + ' joined!',
          duration: 1000,
          type: 'success',
          ignoreDuplicates: true
        });
        _this7.displayInvite = false;
        _this7.loadResources();
      }, null);
    },
    leaveCollaboration: function leaveCollaboration() {
      var _this8 = this;

      if (confirm('Are you sure you want to leave the group \'' + this.shownCollaborationObject.name + '\'?')) {
        apiCall(this.shownCollaborationObject._links.leave.href, this.token, 'POST', '', function () {
          _this8.$store.dispatch('loadCollaborations').then(function () {
            _this8.unSelectDeletedGroup();
          });
          _this8.selectedCollaborationId = undefined;
        }, null);
      }
    },
    deleteCollaboration: function deleteCollaboration() {
      var _this9 = this;

      if (!confirm('Do you really want to delete the group \'' + this.shownCollaborationObject.name + '\' ?')) {
        return;
      }
      apiCall(this.shownCollaborationObject._links.delete.href, this.token, 'DELETE', '', function () {
        _this9.$store.dispatch('loadCollaborations').then(function () {
          _this9.unSelectDeletedGroup();
        });
        _this9.selectedCollaborationId = undefined;
      }, null);
    },
    unSelectDeletedGroup: function unSelectDeletedGroup() {
      if (!this.groupid) {
        this.$router.replace('groups/' + this.shownCollaborationObject.groupId);
      } else {
        this.$router.replace('' + this.shownCollaborationObject.groupId);
      }
    },
    myStatus: function myStatus(collaborationId) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(this.collaborations[collaborationId].members, { id: this.userProfile.id }).status;
    },
    addResources: function addResources(resource, privilege, collaboration) {
      var url = collaboration._links.shareResource.href.split('?');
      var path = url[0];
      apiCall(path + '?resourceType=' + resource.type + '&actions=' + privilege + '&entityId=' + resource.entityId, this.token, 'PUT', '', this.loadResources, null);
    },
    deleteResources: function deleteResources(resources) {
      var _this10 = this;

      var url = this.shownCollaborationObject._links.shareResource.href.split('?');
      var path = url[0];
      if (confirm('Are you sure you want to remove ' + resources[0].name + '?') === false) {
        return;
      }
      resources.forEach(function (resource) {
        apiCall(path + '?resourceType=' + resource.type + '&actions=&entityId=' + resource.entityId, _this10.token, 'PUT', '', _this10.loadResources, null);
      });
    },
    selectNewGroup: function selectNewGroup(newGroupName) {
      $('.col-sm-3').css('position', 'sticky');
      var id = this.findCurrentGroupKeyByName(newGroupName);
      var groupObj = this.findCurrentGroupObj(id);
      if (groupObj && groupObj.groupId) {
        if (!this.groupid) {
          this.$router.replace('groups/' + groupObj.groupId);
        } else {
          this.$router.replace('' + groupObj.groupId);
        }
      }
    },
    nonStickyDiv: function nonStickyDiv() {
      $('.col-sm-3').css('position', '');
      $('.col-sm-3').css('top', '0px');
    },
    stickyDiv: function stickyDiv() {
      $('.col-sm-3').css('position', 'sticky');
      $('.col-sm-3').css('top', '8px');
    },
    findCurrentGroupKeyByName: function findCurrentGroupKeyByName(groupName) {
      var _this11 = this;

      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.collaborations);
      var foundGroup = key.find(function (k) {
        return _this11.collaborations[k].name === groupName;
      });
      return foundGroup;
    },
    findCurrentGroupObj: function findCurrentGroupObj(groupId) {
      return this.collaborations[groupId];
    }
  }
});

/***/ }),

/***/ "mfia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Rename"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("New Name:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newName),expression:"newName"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.initialName},domProps:{"value":(_vm.newName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.confirmRename($event)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.newName=$event.target.value}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidFolderName),expression:"invalidFolderName"}]},[_vm._v("User volume name cannot contain /.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.invalidFolderName},on:{"click":_vm.confirmRename}},[_vm._v("Rename")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mh0T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GrantPrivilegesDialog_vue__ = __webpack_require__("gpZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb7326a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GrantPrivilegesDialog_vue__ = __webpack_require__("rT7W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GrantPrivilegesDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb7326a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GrantPrivilegesDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mjvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copyFile_vue__ = __webpack_require__("HNft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b609a2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copyFile_vue__ = __webpack_require__("ezwX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copyFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b609a2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copyFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nD3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'titleMixin',
    data: function data() {
        return {
            // in case later components do not set or use mixin, save for restoring
            originalPageTitle: null
        };
    },
    created: function created() {
        this.originalPageTitle = document.title;
        if (this.pageTitle) {
            document.title = this.pageTitle;
        }
    },

    watch: {
        pageTitle: function pageTitle() {
            document.title = this.pageTitle;
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.title = this.originalPageTitle;
    }
});

/***/ }),

/***/ "o474":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby__ = __webpack_require__("gUob");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_thenby___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_thenby__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__ = __webpack_require__("swUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shareDatabaseContexts',
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    dbResources: function dbResources() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_groupBy___default()(this.getGrantableResources('DATABASE').sort(__WEBPACK_IMPORTED_MODULE_2_thenby___default()(function (db) {
        return db.rdbComputeDomain.name;
      }).thenBy('name')), 'rdbComputeDomain.name');
    },
    isValid: function isValid() {
      return this.selectedResources && this.checkedPrivilege;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getGrantableResources'])), // computed
  data: function data() {
    return {
      selectedResources: undefined,
      checkedPrivilege: undefined,
      open: false,
      focused: false
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    startDialog: function startDialog() {
      this.loadResources();
      this.selectedResources = undefined;
      this.checkedPrivilege = undefined;
      this.focused = true;
      this.open = true;
    },
    linkResources: function linkResources() {
      this.$emit('linkDBResources', this.selectedResources, this.checkedPrivilege);
      this.open = false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['loadResources']))
}); // default

/***/ }),

/***/ "oBS8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oKTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"FilesTab"}},[_c('div',{staticClass:"container-fluid wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('list-group',{attrs:{"title":"Volumes","headingType":"primary"}},_vm._l((_vm.currentRootVolumes),function(item){return _c('router-link',{key:item.name,staticClass:"list-group-item",class:{active: item.type === _vm.selectedVolumeType},attrs:{"to":("/files/" + (item.type)),"type":"button"}},[_vm._v("\n                "+_vm._s(item.name)+"\n            ")])}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading panel-heading-style"},[_c('span',{staticClass:"panel-title"},[_vm._v("Files Service")]),_vm._v(" "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.fileManagement,"title":"More Info on Files"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("More Info on Files")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Refresh"},on:{"click":function($event){_vm.isShowingFiles ? _vm.getFiles() : _vm.getVolumes()}}},[_c('i',{staticClass:"fa fa-refresh",class:_vm.refreshFilesSpinner})]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control main-search",attrs:{"type":"text","name":"search","placeholder":"Filter..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})]),_vm._v(" "),(!_vm.isShowingFiles && _vm.listToDisplay && _vm.listToDisplay.length > 0 && _vm.selectedVolumeType !== 'datavolumes')?_c('btn',{staticClass:"float-right",attrs:{"type":"primary"},on:{"click":_vm.createNewVolume}},[_vm._v("Create User Volume")]):_vm._e(),_vm._v(" "),(_vm.selectedVolumeType !== 'datavolumes')?_c('btn',{attrs:{"type":"primary"},on:{"click":_vm.viewQuotas}},[_vm._v("View Quotas")]):_vm._e(),_vm._v(" "),(_vm.loadingStatusIcon)?_c('span',{staticStyle:{"margin":"auto","width":"50%","padding-left":"20%","padding-right":"20%"}},[_vm._v(" "+_vm._s(_vm.loadingAction)+" ..."),_c('i',{staticClass:"fa fa-spinner fa-spin fa-2x"})]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{class:[_vm.isShowingFiles && _vm.writeAccess ? 'col-sm-8' : 'col-sm-12']},[_c('div',{staticClass:"pull-right",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Button Group"}},[(_vm.isShowingFiles && _vm.writeAccess)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"for":"uploadedFile","type":"button"}},[_vm._v("Upload")]):_vm._e(),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","name":"datafile","id":"uploadedFile","multiple":""},on:{"click":_vm.fileUploadClicked,"change":function($event){_vm.uploadFile()}}}),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button"},on:{"click":_vm.createNewSubFolder}},[_vm._v("New Folder")]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":("/files/" + _vm.selectedVolumeType),"title":"Main User Volume Directory"}},[_c('i',{staticClass:"fa fa-home fa-2x"})])],1),_vm._v(" "),(_vm.currentUserVolume && _vm.currentUserVolume.type === 'uservolumes')?[(_vm.currentUserVolume.rootVolumeObj.name)?_c('li',[_vm._v(_vm._s(_vm.currentUserVolume.rootVolumeObj.name))]):_vm._e(),_vm._v(" "),(_vm.currentUserVolume.owner)?_c('li',[_vm._v(_vm._s(_vm.currentUserVolume.owner))]):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":("/files/" + _vm.selectedVolumeType + "/" + (_vm.currentUserVolume.id)),"title":("" + (_vm.currentUserVolume.name))}},[_vm._v(_vm._s(_vm.currentUserVolume.name))])],1)]:_vm._e(),_vm._v(" "),(_vm.currentUserVolume && _vm.currentUserVolume.type === 'datavolumes')?[_c('li',[_c('router-link',{attrs:{"to":("/files/" + _vm.selectedVolumeType + "/" + (_vm.currentUserVolume.id)),"title":("" + (_vm.currentUserVolume.name))}},[_vm._v(_vm._s(_vm.currentUserVolume.name))])],1)]:_vm._e(),_vm._v(" "),(_vm.path)?_vm._l((_vm.path.split('/').filter(function (x) { return x; })),function(pathSegment,index){return _c('li',{key:index},[_c('router-link',{attrs:{"title":("" + pathSegment),"to":("/files/" + _vm.selectedVolumeType + "/" + (_vm.currentUserVolume.id) + "/" + (encodeURIComponent(_vm.path.split('/').filter(function (x) { return x; }).slice(0, index + 1).join('/'))))}},[_vm._v("\n                          "+_vm._s(pathSegment)+"\n                        ")])],1)}):_vm._e()],2),_vm._v(" "),(_vm.isShowingFiles && _vm.selectedItem.length)?_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Button Group"}},[(_vm.downloadAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.downloadMultipleFiles(_vm.selectedItem, _vm.selectedItem.length - 1)}}},[_vm._v("Download")]):_vm._e(),_vm._v(" "),(_vm.copyAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.childCopy(_vm.selectedItem)}}},[_vm._v("Copy")]):_vm._e(),_vm._v(" "),(_vm.moveAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.childMove(_vm.selectedItem)}}},[_vm._v("Move")]):_vm._e(),_vm._v(" "),(_vm.deleteAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.sendTodelete(_vm.selectedItem)}}},[_vm._v("Delete")]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isShowingFiles && _vm.selectedItem.length)?_c('div',{staticClass:"btn-group",attrs:{"role":"group","aria-label":"Button Group"}},[(_vm.deleteUVAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"Delete User Volume"},on:{"click":function($event){_vm.sendTodeleteUserVolume(_vm.selectedItem)}}},[_c('span',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v("Delete\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.isShowingFiles && _vm.selectedItem.length === 1 && _vm.grantUVAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"share user volume with other users or groups"},on:{"click":function($event){_vm.sendToshareVolume(_vm.selectedItem)}}},[_c('span',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" Sharing\n                    ")]):_vm._e(),_vm._v(" "),(!_vm.isShowingFiles && _vm.selectedItem.length === 1 && _vm.editUVAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"Edit User Volume"},on:{"click":function($event){_vm.sendToeditVolume(_vm.selectedItem)}}},[_c('span',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v("Edit\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fa fa-spinner fa-spin fa-5x"}),_vm._v(" "),(!_vm.isShowingFiles)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.listToDisplay && _vm.listToDisplay.length <= 0),expression:"!loading && listToDisplay && listToDisplay.length <= 0"}]},[_c('h4',[_c('b',[_vm._v("Create")]),_vm._v(" your first userVolume "),_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":_vm.createNewVolume}},[_vm._v("Get Started")])])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.listToDisplay && _vm.listToDisplay.length <= 0),expression:"!loading && listToDisplay && listToDisplay.length <= 0"}]},[_c('div',{staticStyle:{"margin":"auto","text-align":"center","color":"grey"},attrs:{"id":"filelist"}},[_vm._v("File list empty.")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listToDisplay && _vm.listToDisplay.length),expression:"listToDisplay && listToDisplay.length"}],staticClass:"markdown-render",attrs:{"id":"readme-container"},domProps:{"innerHTML":_vm._s(_vm.readmeData)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.listToDisplay && _vm.listToDisplay.length),expression:"!loading && listToDisplay && listToDisplay.length"}],staticClass:"table table-hover sciserver-datatable sortable",attrs:{"id":"filesTable"}},[_c('thead',[_c('tr',[(_vm.isShowingFiles)?[_c('th',{staticClass:"no-sort"},[_c('div',{staticClass:"pretty p-default p-curve p-thick p-smooth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSelectedAll),expression:"isSelectedAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSelectedAll)?_vm._i(_vm.isSelectedAll,null)>-1:(_vm.isSelectedAll)},on:{"click":_vm.selectedAll,"change":function($event){var $$a=_vm.isSelectedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSelectedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSelectedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSelectedAll=$$c}}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('th',{class:_vm.nameIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.sortingMethod('name')}}},[_vm._v("Name")]),_vm._v(" "),_c('th',{class:_vm.modifiedIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.sortingMethod('modified')}}},[_vm._v("Last Modified")]),_vm._v(" "),_c('th',{class:_vm.sizeIcon,attrs:{"data-sort":"int"},on:{"click":function($event){_vm.sortingMethod('rsize')}}},[_vm._v("Size")]),_vm._v(" "),_c('th',{staticClass:"no-sort"}),_vm._v(" "),_c('th',{staticClass:"no-sort"})]:[_c('th',{staticClass:"no-sort"},[_c('div',{staticClass:"pretty p-default p-curve p-thick p-smooth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isSelectedAll),expression:"isSelectedAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isSelectedAll)?_vm._i(_vm.isSelectedAll,null)>-1:(_vm.isSelectedAll)},on:{"click":_vm.selectedAll,"change":function($event){var $$a=_vm.isSelectedAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isSelectedAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isSelectedAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isSelectedAll=$$c}}}}),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),(_vm.selectedVolumeType === 'uservolumes')?[_c('th',{class:_vm.volumeIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.getHeaderName('Volume')}}},[_vm._v("Volume")]),_vm._v(" "),_c('th',{class:_vm.rootVolumeIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.getHeaderName('Root Volume')}}},[_vm._v("Root Volume")]),_vm._v(" "),_c('th',{class:_vm.ownerIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.getHeaderName('Owner')}}},[_vm._v("Owner")]),_vm._v(" "),_c('th',{attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.sortingMethod('name')}}}),_vm._v(" "),_c('th',{attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.sortingMethod('name')}}})]:[_c('th',{class:_vm.dataSetsIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.getHeaderName('Data Sets')}}},[_vm._v("Data Sets")]),_vm._v(" "),_c('th',{class:_vm.foldersIcon,attrs:{"data-sort":"string-ins"},on:{"click":function($event){_vm.getHeaderName('Folders')}}},[_vm._v("Folders")]),_vm._v(" "),_c('th',{attrs:{"data-sort":"string-ins"}}),_vm._v(" "),_c('th',{attrs:{"data-sort":"string-ins"}}),_vm._v(" "),_c('th',{attrs:{"data-sort":"string-ins"}})]]],2)]),_vm._v(" "),(_vm.listToDisplay)?_c('tbody',_vm._l((_vm.sortedVolumes),function(volume){return _c('tr',{key:volume.id},[(volume.type === 'uservolumes' || volume.type === 'datavolumes')?_c('td',[_c('div',{staticClass:"pretty p-default p-curve p-thick p-smooth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem),expression:"selectedItem"}],attrs:{"type":"checkbox"},domProps:{"value":volume,"checked":Array.isArray(_vm.selectedItem)?_vm._i(_vm.selectedItem,volume)>-1:(_vm.selectedItem)},on:{"click":_vm.select,"change":function($event){var $$a=_vm.selectedItem,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=volume,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedItem=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedItem=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedItem=$$c}}}}),_vm._v(" "),_vm._m(2,true)])]):_vm._e(),_vm._v(" "),(volume.type === 'dir' || volume.type === 'file')?_c('td',[_c('div',{staticClass:"pretty p-default p-curve p-thick p-smooth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem),expression:"selectedItem"}],attrs:{"type":"checkbox"},domProps:{"value":volume,"checked":Array.isArray(_vm.selectedItem)?_vm._i(_vm.selectedItem,volume)>-1:(_vm.selectedItem)},on:{"click":_vm.select,"change":function($event){var $$a=_vm.selectedItem,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=volume,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedItem=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedItem=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedItem=$$c}}}}),_vm._v(" "),_vm._m(3,true)])]):_vm._e(),_vm._v(" "),_c('td',[(volume.type === 'uservolumes')?_c('div',{staticClass:"userVolume"},[_c('router-link',{attrs:{"to":volume.id.toString(),"title":("" + (volume.name)),"append":""}},[(volume.owner!==_vm.username)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#000000"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && !volume.sharedWith.length)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#337AB7"}})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && volume.sharedWith.length)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#337AB7"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v("\n                                    "+_vm._s(volume.displayName ? volume.displayName : volume.name)+"\n                                ")])],1):_vm._e(),_vm._v(" "),(volume.type === 'datavolumes')?_c('div',{staticClass:"datavolumes"},[_c('router-link',{attrs:{"to":volume.id.toString(),"title":("" + (volume.name)),"append":""}},[(volume.owner!==_vm.username)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#000000"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && !volume.sharedWith.length)?_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#337AB7"}})]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username && volume.sharedWith.length)?_c('span',{staticClass:"fa-stack fa-lg",staticStyle:{"color":"#337AB7"}},[_c('i',{staticClass:"fa fa-folder-o fa-stack-2x"}),_c('i',{staticClass:"fa fa-users fa-stack-1x"})]):_vm._e(),_vm._v("\n                                    "+_vm._s(volume.displayName ? volume.displayName : volume.name)+"\n                                ")])],1):_vm._e(),_vm._v(" "),(volume.type === 'dir')?_c('div',{staticClass:"volume"},[_c('router-link',{attrs:{"to":encodeURIComponent(volume.name),"title":("" + (volume.name)),"append":""}},[_c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-folder fa-2x",staticStyle:{"color":"#337AB7"}})]),_vm._v("\n                                 "+_vm._s(volume.name)+"\n                                ")])],1):_vm._e(),_vm._v(" "),(volume.type === 'file')?_c('div',{staticClass:"file",on:{"dblclick":function($event){_vm.editFile(volume)}}},[_vm._m(4,true),_vm._v(_vm._s(volume.name)+"\n                              ")]):_vm._e()]),_vm._v(" "),(_vm.isShowingFiles)?[_c('td',[_vm._v(_vm._s(volume.modified))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(volume.size))])]:_vm._e(),_vm._v(" "),(volume.type === 'uservolumes')?[(volume.rootVolumeObj)?_c('td',{attrs:{"data-sort-value":volume.rootVolumeObj.name}},[_vm._v(_vm._s(volume.rootVolumeObj.name))]):_vm._e(),_vm._v(" "),(volume.owner)?_c('td',{attrs:{"data-sort-value":volume.owner}},[_vm._v(_vm._s(volume.owner))]):_vm._e()]:_vm._e(),_vm._v(" "),(volume.type === 'datavolumes')?[_c('td',[_vm._v(_vm._s(volume.name))]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),_c('td',[(!_vm.isShowingFiles && (volume.grant || volume.delete || (volume.owner===_vm.username && volume.type==='uservolumes')))?_c('div',{staticClass:"dropdown"},[_vm._m(5,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"fileMenuDropDown"}},[(volume.grant)?_c('li',[_c('a',{attrs:{"href":"#","title":"Share User Volume"},on:{"click":function($event){_vm.shareVolume(volume)}}},[_vm._v("Sharing")])]):_vm._e(),_vm._v(" "),(volume.delete)?_c('li',[_c('a',{attrs:{"href":"#","title":"Delete User Volume"},on:{"click":function($event){_vm.deleteUserVolume(volume.id)}}},[_vm._v("Delete")])]):_vm._e(),_vm._v(" "),(volume.owner===_vm.username)?_c('li',[_c('a',{attrs:{"href":"#","title":"Edit User Volume"},on:{"click":function($event){_vm.editVolume(volume)}}},[_vm._v("Edit")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles)?_c('div',{staticClass:"dropdown"},[_vm._m(6,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"aria-labelledby":"fileMenuDropDown"}},[(volume.type==='file' && _vm.isShowingFiles)?_c('li',[_c('router-link',{attrs:{"to":("/editor/?f=" + _vm.downloadFilePath + "/" + (encodeURIComponent(volume.name)))}},[_vm._v("View/Edit")])],1):_vm._e(),_vm._v(" "),(volume.type==='file' && _vm.isShowingFiles)?_c('li',[_c('a',{attrs:{"href":_vm.downloadFilePath + '/' + encodeURIComponent(volume.name),"title":"Download"}},[_vm._v("Download")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles)?_c('li',[_c('a',{attrs:{"href":"#","title":"Copy file/folder"},on:{"click":function($event){$event.preventDefault();_vm.childCopy(volume)}}},[_vm._v("Copy")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('li',[_c('a',{attrs:{"href":"#","title":"Rename file/folder"},on:{"click":function($event){_vm.renameFileOrFolder(volume.name)}}},[_vm._v("Rename")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('li',[_c('a',{attrs:{"href":"#","title":"Move file/folder"},on:{"click":function($event){$event.preventDefault();_vm.childMove(volume)}}},[_vm._v("Move")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('li',[_c('a',{attrs:{"href":"#","title":"Delete file/folder"},on:{"click":function($event){_vm.deleteFile(volume.name)}}},[_vm._v("Delete")])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('td',[_c('div',[(volume.name.endsWith('.ipynb') && _vm.isNotebookFirstAlphaGroupMember)?_c('router-link',{attrs:{"to":(_vm.notebookBasePath + "/" + (volume.name.replace('.ipynb', '')))}},[_c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"}},[_c('span',{staticClass:"fa fa-notebook-o",attrs:{"aria-hidden":"true"}}),_vm._v("Open Notebook")])]):_vm._e(),_vm._v(" "),(volume.type==='file')?_c('a',{attrs:{"href":_vm.downloadFilePath + '/' + encodeURIComponent(volume.name),"title":"Download"}},[_vm._m(7,true)]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles)?_c('a',{attrs:{"href":"#","title":"Copy file/folder"}},[_c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.childCopy(volume)}}},[_c('span',{staticClass:"fa fa-files-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Copy")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('a',{attrs:{"href":"#","title":"Rename file/folder"}},[_c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"},on:{"click":function($event){_vm.renameFileOrFolder(volume.name)}}},[_c('span',{staticClass:"fa fa-pencil-square-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Rename")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('a',{attrs:{"href":"#","title":"Move file/folder"}},[_c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.childMove(volume)}}},[_c('span',{staticClass:"fa fa-share-square-o",attrs:{"aria-hidden":"true"}}),_vm._v(" Move")])]):_vm._e(),_vm._v(" "),(_vm.isShowingFiles && _vm.writeAccess)?_c('a',{attrs:{"href":"#","title":"Delete file/folder"},on:{"click":function($event){_vm.deleteFile(volume.name)}}},[_vm._m(8,true)]):_vm._e(),_vm._v(" "),(volume.grant)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"share user volume with other users or groups"},on:{"click":function($event){_vm.shareVolume(volume)}}},[_c('span',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" Sharing")]):_vm._e(),_vm._v(" "),(volume.delete)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"Delete User Volume"},on:{"click":function($event){_vm.deleteUserVolume(volume.id)}}},[_c('span',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Delete")]):_vm._e(),_vm._v(" "),(!_vm.isShowingFiles && volume.owner===_vm.username && _vm.editUVAction)?_c('label',{staticClass:"btn btn-default btn-sm",attrs:{"title":"Edit User Volume"},on:{"click":function($event){_vm.editVolume(volume)}}},[_c('span',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" Edit")]):_vm._e()],1)])],2)}),0):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowingFiles && _vm.writeAccess),expression:"isShowingFiles && writeAccess"}],staticClass:"col-sm-4"},[_c('vue-dropzone',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowingFiles && _vm.writeAccess),expression:"isShowingFiles && writeAccess"}],ref:"vueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-error":_vm.comeback,"vdropzone-processing":_vm.dropzoneChangeUrl,"vdropzone-sending":_vm.dropzoneSendRequest,"vdropzone-complete":_vm.fileUploadComplete}})],1)])])])])]),_vm._v(" "),_c('move-files',{ref:"moveButton",on:{"movedSuccess":_vm.getFiles,"changeVolumesType":_vm.changeVolumesTypeFromParent,"showFiles":function($event){this.$emit('showFiles', _vm.index)},"changeUV":function($event){this.$emit('changeUV', _vm.id)},"resetPath":function($event){this.$emit('resetPath')}}}),_vm._v(" "),_c('copy-file',{ref:"copyButton",on:{"copiedSuccess":_vm.getFiles,"changeVolumesType":_vm.changeVolumesTypeFromParent,"showFiles":function($event){this.$emit('showFiles', _vm.index)},"changeUV":function($event){this.$emit('changeUV', _vm.id)},"resetPath":function($event){this.$emit('resetPath')}}}),_vm._v(" "),_c('share-user-volume-dialog',{ref:"shareUserVolumeDialog",on:{"sharedVolume":_vm.getVolumes}}),_vm._v(" "),_c('create-folder-dialog',{ref:"createFolderDialog",attrs:{"userVolume":_vm.currentUserVolume,"path":_vm.path},on:{"newSubFolderCreated":_vm.aftercalled}}),_vm._v(" "),_c('create-volume-dialog',{ref:"createVolumeDialog",on:{"newVolumeCreated":_vm.getVolumes}}),_vm._v(" "),_c('edit-volume-dialog',{ref:"editVolumeDialog",on:{"userVolumeEdited":_vm.getVolumes}}),_vm._v(" "),_c('rename-file-dialog',{ref:"renameFileDialog",attrs:{"userVolume":_vm.currentUserVolume,"path":_vm.path},on:{"fileRenamed":_vm.getFiles}}),_vm._v(" "),_c('file-usage-dialog',{ref:"fileUsageDialog"}),_vm._v(" "),_c('delete-file-dialog',{ref:"deleteFileDialog",on:{"itemDeleted":_vm.refreshFileService}}),_vm._v(" "),_c('pop-up-dialog',{ref:"alertPopUp"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state p-primary"},[_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state p-primary"},[_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state p-primary"},[_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"state p-primary"},[_c('label')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa-stack fa-lg"},[_c('i',{staticClass:"fa fa-file-o fa-2x"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-xs dropdown-toggle",attrs:{"type":"button","id":"fileMenuDropDown","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_c('i',{staticClass:"fa fa-ellipsis-h",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-xs dropdown-toggle",attrs:{"type":"button","id":"fileMenuDropDown","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_c('i',{staticClass:"fa fa-ellipsis-h",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"}},[_c('span',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}}),_vm._v(" Download")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-default btn-xs",attrs:{"type":"button"}},[_c('span',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Delete")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oia1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pBBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = apiCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_handler__ = __webpack_require__("GQi5");



var $ = __webpack_require__("7t+N");

function apiCall(url, authToken, method, senddata, successcallback, ignored) {
  var headers = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  var allHeaders = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Auth-Token': authToken
  }, headers);

  $.ajax({
    url: url,
    dataType: 'json',
    data: senddata,
    headers: allHeaders,
    type: method,
    success: successcallback,
    error: function error(XMLHttpRequest, textStatus, errorThrown) {
      Object(__WEBPACK_IMPORTED_MODULE_1__error_handler__["a" /* default */])(XMLHttpRequest.status, url, XMLHttpRequest.responseJSON, errorThrown, textStatus);
    }
  });
}

/***/ }),

/***/ "pIYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesStep_vue__ = __webpack_require__("bSWO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525dcab5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesStep_vue__ = __webpack_require__("iW9F");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_525dcab5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pIzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_codemirror__ = __webpack_require__("E5Az");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_codemirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_codemirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_lib_codemirror_css__ = __webpack_require__("4/hK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_codemirror_lib_codemirror_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_codemirror_lib_codemirror_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_mode_python_python__ = __webpack_require__("tWbI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_codemirror_mode_python_python___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_codemirror_mode_python_python__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_mode_markdown_markdown__ = __webpack_require__("f6fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_codemirror_mode_markdown_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_codemirror_mode_markdown_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_mode_clike_clike__ = __webpack_require__("6S2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_codemirror_mode_clike_clike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_codemirror_mode_clike_clike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_shell_shell__ = __webpack_require__("PG9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_codemirror_mode_shell_shell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_codemirror_mode_shell_shell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_mode_javascript_javascript__ = __webpack_require__("5IAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_codemirror_mode_javascript_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_codemirror_mode_javascript_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_codemirror_mode_stex_stex__ = __webpack_require__("1cvq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_codemirror_mode_stex_stex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_codemirror_mode_stex_stex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_mode_sql_sql__ = __webpack_require__("JGZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_codemirror_mode_sql_sql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_codemirror_mode_sql_sql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror_mode_yaml_yaml__ = __webpack_require__("uqUb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_codemirror_mode_yaml_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_codemirror_mode_yaml_yaml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_codemirror_mode_xml_xml__ = __webpack_require__("ezqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_codemirror_mode_xml_xml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_codemirror_mode_xml_xml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_mode_r_r__ = __webpack_require__("9BoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_codemirror_mode_r_r___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_codemirror_mode_r_r__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror_mode_go_go__ = __webpack_require__("CQVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_codemirror_mode_go_go___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_codemirror_mode_go_go__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__ = __webpack_require__("2moA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__files_utils__ = __webpack_require__("RswP");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















var _ = __webpack_require__("M4fF");

var AUTO_SAVE_INTERVAL = 15000;
var AUTO_SAVE_CHARS = 40;
var WARN_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Editor',
    components: {
        codemirror: __WEBPACK_IMPORTED_MODULE_2_vue_codemirror__["codemirror"]
    },
    mounted: function mounted() {},

    data: function data() {
        return {
            filepath: null,
            filename: null,
            fileVolume: null,
            initialFileSize: null,
            fileContentType: null,
            acceptedLoad: false,
            code: '',
            cmOptions: {
                tabSize: 4,
                mode: 'text/plain',
                lineNumbers: true,
                line: true,
                readOnly: true,
                viewportMargin: 10,
                lineWrapping: true
            },
            autoSave: false,
            lastSaveSize: 0,
            lastSaveTime: Date.now(),
            lastEditTime: Date.now(),
            inSave: false,
            updateCounter: 0,
            saveCounter: 0,
            loading: false,
            loaded: false,
            finalError: null,
            mode: 'view'
        };
    },
    created: function created() {
        this.filename = this.$route.query.f.split('/').pop();
        if (this.filename === '') {
            this.finalError = 'no filename given!';
        }
        this.filepath = encodeURI(this.$route.query.f);
        window.addEventListener('beforeunload', this.unloadPrompt);
    },

    watch: {
        mode: function mode() {
            this.cmOptions.readOnly = this.mode === 'view';
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        validatedPath: function validatedPath() {
            var _this = this;

            // there seems to be no way with the current implementation of these store objects
            // to know if we have no objects or if they are not yet loaded...
            if (this.myDataVolumeObjects.length < 1 && this.myUserVolumeObjects.length < 1) {
                return null;
            }
            if (!this.fileVolume) {
                var volume = this.myUserVolumeObjects.filter(function (vol) {
                    return _this.filepath.includes(encodeURI(vol.apiEndpoint + 'api/file/' + vol.rootVolumeName + '/' + vol.owner + '/' + vol.name + '/'));
                });
                if (volume.length === 0) {
                    volume = this.myDataVolumeObjects.filter(function (vol) {
                        return _this.filepath.includes(encodeURI(vol.apiEndpoint + 'api/file/' + vol.name + '/'));
                    });
                }
                if (volume.length === 0) {
                    this.finalError = 'unrecognized volume, cannot view file!';
                    return false;
                }
                this.fileVolume = volume[0];
                console.log('found volume for file', this.fileVolume);
            }
            if (this.initialFileSize === null) {
                this.initialFileSize = -1;
                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.head('' + this.filepath, { headers: { 'X-Auth-Token': this.$store.state.token } }).then(function (response) {
                    _this.initialFileSize = _.get(response.headers, 'content-length', 0);
                    _this.fileContentType = _.get(response.headers, 'content-type', '');
                }).catch(function () {
                    console.error('could not detect filesize, continuing anyway');
                    _this.initialFileSize = 0;
                    _this.fileContentType = '';
                });
                return null;
            } else if (this.initialFileSize < 0 || this.promptLoad) {
                return null;
            }
            this.cmOptions.mode = __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__["a" /* default */].filenameToModeMimeType(this.filename);
            if (!this.cmOptions.mode) {
                if (_.startsWith(this.fileContentType, 'text/') || this.acceptedLoad) {
                    this.cmOptions.mode = 'text/plain';
                } else {
                    return null;
                }
            }
            if (this.loading) {
                return true;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.filepath + '?TaskName=Dashboard.viewfile', { headers: { 'X-Auth-Token': this.$store.state.token } }).then(function (response) {
                _this.code = typeof response.data === 'string' ? response.data : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data);
                _this.lastSaveSize = _this.code.length;
                _this.loaded = true;
            }).catch(function (error) {
                if (error.response.data.error.includes('File does not exist')) {
                    _this.code = '';
                    _this.loaded = true;
                    _this.cmOptions.readOnly = false;
                } else {
                    _this.finalError = error.response.data.error;
                }
            });
            setInterval(function () {
                return _this.periodicSave();
            }, AUTO_SAVE_INTERVAL);
            return true;
        },
        unkownType: function unkownType() {
            if (this.fileContentType === null) {
                return false;
            }
            return !this.fileContentType.startsWith('text/') && __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__["a" /* default */].filenameToModeMimeType(this.filename) === null;
        },
        largeFile: function largeFile() {
            return this.initialFileSize > WARN_FILE_SIZE;
        },
        promptLoad: function promptLoad() {
            return (this.largeFile || this.unkownType) && !this.acceptedLoad;
        },
        writeable: function writeable() {
            return _.get(this.fileVolume, 'allowedActions', []).includes('write');
        },
        editMode: function editMode() {
            return this.mode !== 'view';
        },
        dualView: function dualView() {
            return this.mode === 'dual';
        },
        shouldInline: function shouldInline() {
            return __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__["a" /* default */].shouldInline(this.filename);
        },
        showEditor: function showEditor() {
            return this.validatedPath && this.loaded && (this.editMode || !this.hasRenderFunction);
        },
        showRender: function showRender() {
            if (!this.hasRenderFunction) {
                return false;
            }
            return this.dualView || !this.showEditor;
        },
        hasRenderFunction: function hasRenderFunction() {
            return __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__["a" /* default */].getRenderFunction(this.filename);
        },
        rendering: function rendering() {
            if (!(this.loaded && this.$refs.renderbox)) {
                return null;
            }
            if (!this.showRender) {
                return null;
            }
            var renderfunc = __WEBPACK_IMPORTED_MODULE_17__view_edit_utils__["a" /* default */].getRenderFunction(this.filename);
            if (typeof renderfunc !== 'function') {
                return null;
            }
            return renderfunc(this.$refs.renderbox, this.code);
        },
        lastSaveTimeStamp: function lastSaveTimeStamp() {
            return new Date(this.lastSaveTime).toString();
        },
        dirty: function dirty() {
            return this.updateCounter > this.saveCounter;
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['myUserVolumeObjects', 'myDataVolumeObjects'])),
    methods: {
        startresize: function startresize() {
            this.inresize = true;
            this.lastresize = Date.now();
            return false;
        },
        doresize: function doresize(e) {
            if (this.inresize && Date.now() - this.lastresize > 100) {
                this.$refs.editor.$el.style.minWidth = e.clientX + 'px';
                this.$refs.editor.$el.style.maxWidth = e.clientX + 'px';
                return false;
            }
            return false;
        },
        stopresize: function stopresize() {
            this.inresize = false;
            return false;
        },
        cmReady: function cmReady(cm) {
            cm.doc.clearHistory();
            cm.refresh();
        },
        contentUpdate: function contentUpdate() {
            // probably a better method is to get the last edit time of file, or at least size
            if (Date.now() - this.lastEditTime > 3600000) {
                if (!confirm('last edit made more than 1 hour ago, continue?')) {
                    this.$router.go();
                }
            }
            this.updateCounter += 1;
            this.lastEditTime = Date.now();
            if (Math.abs(this.code.length - this.lastSaveSize) > AUTO_SAVE_CHARS && this.autoSave) {
                this.save();
            }
        },
        periodicSave: function periodicSave() {
            if (this.updateCounter > this.saveCounter && this.autoSave) {
                this.save();
            }
        },
        save: function save() {
            var _this2 = this;

            if (this.cmOptions.readOnly || this.inSave || !this.loaded || !this.dirty) {
                return;
            }
            var _updateCounter = this.updateCounter;
            var _codeLength = this.code.length;
            if (Date.now() - this.lastSaveTime > 3600000) {
                if (!confirm('last save more than 1 hour ago, continue?')) {
                    return;
                }
            }
            this.inSave = true;
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(this.filepath + '?quiet=true&TaskName=Dashboard.editfile', this.code, { headers: { 'X-Auth-Token': this.$store.state.token,
                    'Content-Type': 'application/octet-stream' } }).then(function () {
                console.log('saved...');
                _this2.saveCounter = _updateCounter;
                _this2.lastSaveSize = _codeLength;
                _this2.lastSaveTime = Date.now();
            }).catch(function (error) {
                if (error.response.data.error.includes('permissions')) {
                    _this2.cmOptions.readOnly = true;
                }
                _this2.$notify({
                    group: 'top_center_notify',
                    type: 'error',
                    text: 'Error saving file!'
                });
            }).finally(function () {
                _this2.inSave = false;
            });
        },
        setViewMode: function setViewMode() {
            this.mode = 'view';
        },
        setEditMode: function setEditMode() {
            this.mode = 'edit';
        },
        setDualMode: function setDualMode() {
            this.mode = this.mode === 'dual' ? 'edit' : 'dual';
        },
        toggleReadOnly: function toggleReadOnly() {
            this.cmOptions.readOnly = !this.cmOptions.readOnly;
        },
        toggleAutoSave: function toggleAutoSave() {
            this.autoSave = !this.autoSave;
        },
        downloadAndClose: function downloadAndClose() {
            __WEBPACK_IMPORTED_MODULE_18__files_utils__["default"].downloadFile(this.filepath, this.filename);
            // give a small pause to allow the file download to start in this context before moving on
            setTimeout(this.close, 750);
        },
        unloadPrompt: function unloadPrompt(e) {
            if (this.dirty) {
                e.preventDefault();
                e.returnValue = '';
            } else {
                delete e.returnValue;
            }
        },
        close: function close() {
            // Temporary solution. When this component is configured for inclusion in other layouts, this should
            // probably emit an event, which can be handled by the outer component
            this.$router.push('/files');
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (this.dirty && !window.confirm('There are unsaved changes. Do you still wish to exit?')) {
            next(false);
        } else {
            next();
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('beforeunload', this.unloadPrompt);
    }
});

/***/ }),

/***/ "piDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeDomain_vue__ = __webpack_require__("vji+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a61834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeDomain_vue__ = __webpack_require__("1Dxr");
function injectStyle (ssrContext) {
  __webpack_require__("HnMz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53a61834"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeDomain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53a61834_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeDomain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pqqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertDialog_vue__ = __webpack_require__("SPy3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb0c8d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alertDialog_vue__ = __webpack_require__("ZHV1");
function injectStyle (ssrContext) {
  __webpack_require__("DT6N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_acb0c8d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alertDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qQLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenameFileDialog_vue__ = __webpack_require__("SXnJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743f2a8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenameFileDialog_vue__ = __webpack_require__("mfia");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RenameFileDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_743f2a8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RenameFileDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qh8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFolderDialog_vue__ = __webpack_require__("DnSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e55385a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFolderDialog_vue__ = __webpack_require__("XfQq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateFolderDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e55385a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateFolderDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qhHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"workspace-tab"}},[_c('div',{staticClass:"container-fluid wrap"},[(_vm.resourcesLoaded && _vm.shownCollaborationObject)?_c('div',{staticClass:"row",staticStyle:{"display":"flex","align-items":"flex-start"}},[_c('div',{staticClass:"col-sm-3",staticStyle:{"position":"sticky","top":"8px"}},[_c('list-group',{staticStyle:{"border-color":"#337ab7"},attrs:{"title":"Groups","headingType":"primary"}},[_c('span',{attrs:{"slot":"headerContent"},slot:"headerContent"},[_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.createGroup,"title":"More Info on Groups"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("More Info on Groups")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","title":"Refresh"},on:{"click":_vm.loadResources}},[_c('i',{staticClass:"fa fa-refresh",class:_vm.refreshGroupViewSpinner,attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('span',{staticClass:"pull-right",on:{"click":_vm.nonStickyDiv}},[_c('new-group-button',{on:{"selectNewGroup":_vm.selectNewGroup,"closedModal":_vm.stickyDiv}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}})])],1)]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],staticClass:"form-control main-search",attrs:{"type":"text","name":"search","placeholder":"Filter..."},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}}),_vm._v(" "),_c('div',{attrs:{"id":"list_group_div"}},[_c('transition-group',{attrs:{"name":"group-list"}},_vm._l((_vm.searchedGroups),function(collaborationId){return _c('router-link',{key:collaborationId,staticClass:"list-group-item",class:{active: _vm.shownCollaborationId === collaborationId},attrs:{"to":("/groups/" + (_vm.collaborations[collaborationId].groupId)),"type":"button","role":"tab"},nativeOn:{"click":function($event){_vm.selectedCollaborationId = collaborationId}}},[_vm._v("\n            "+_vm._s(_vm.collaborations[collaborationId].name)+"\n            "),(_vm.myStatus(collaborationId) === 'INVITED')?_c('span',{staticClass:"glyphicon glyphicon-exclamation-sign"}):_vm._e(),_vm._v(" "),(_vm.collaborations[collaborationId]._links.leave && _vm.shownCollaborationId === collaborationId)?_c('button',{staticClass:"btn btn-link pull-right",attrs:{"type":"button"},on:{"click":_vm.leaveCollaboration}},[_c('small',{staticClass:"text-danger"},[_vm._v("Leave "+_vm._s(_vm.shownCollaborationObject.type.toLowerCase()))])]):_vm._e(),_vm._v(" "),(_vm.collaborations[collaborationId]._links.delete && _vm.shownCollaborationId === collaborationId)?_c('button',{staticClass:"btn btn-link pull-right",attrs:{"type":"button"},on:{"click":_vm.deleteCollaboration}},[_c('small',{staticClass:"text-danger"},[_vm._v("Delete "+_vm._s(_vm.shownCollaborationObject.type.toLowerCase()))])]):_vm._e()])}),1)],1)])],1),_vm._v(" "),_c('div',{class:[_vm.invitedToShownCollaboration ? 'col-sm-9' : 'col-sm-6']},[_c('collaboration-info',{attrs:{"collaboration":_vm.shownCollaborationObject}}),_vm._v(" "),(!_vm.invitedToShownCollaboration)?_c('resources-list',{attrs:{"selectedResources":_vm.shownResources,"collaboration":_vm.shownCollaborationObject,"collabType":_vm.type,"collabOwner":_vm.collaborationOwner},on:{"shareResources":_vm.addResources,"unshareResource":_vm.deleteResources}}):_vm._e(),_vm._v(" "),(_vm.invitedToShownCollaboration  && _vm.displayInvite)?_c('invitation-response',{attrs:{"collaboration":_vm.shownCollaborationObject},on:{"acceptInvitation":_vm.acceptInvitation,"declineInvitation":_vm.declineInvitation}}):_vm._e()],1),_vm._v(" "),(!_vm.invitedToShownCollaboration)?_c('div',{staticClass:"col-sm-3",staticStyle:{"position":"sticky","top":"8px"}},[_c('members-list',{attrs:{"collaboration":_vm.shownCollaborationObject}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.shownCollaborationId)?_c('empty-state',{attrs:{"label":"Collaborate with colleagues","description":"Groups allow you to share files and other resources within a collaboration."}},[_c('new-group-button',{attrs:{"button-classes":['btn-lg']}},[_vm._v("Create New Group")])],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"groupEditDialog"}},[_c('group-edit-dialog')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qyQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function removeElementIfExists(el) {
    if (el) {
        el.remove();
    }
}

function jupyterClassicVisualModifications(frame) {
    var framedoc = frame.contentDocument;

    removeElementIfExists(framedoc.getElementById('filelink'));
    removeElementIfExists(framedoc.getElementById('header-container'));
    removeElementIfExists(framedoc.getElementById('cmd_palette'));
    removeElementIfExists(framedoc.getElementById('toggle_header'));
    framedoc.getElementById('notebook-container').style.setProperty('width', '98%');
    framedoc.getElementById('menubar-container').style.setProperty('margin-left', '15px');
    framedoc.getElementById('notebook_panel').style.setProperty('background-color', '#f5faff');
    framedoc.getElementById('site').style.setProperty('background-color', '#f5faff');
    // The dynamic adjustent by jupyter on startup causes a shortened window
    var docHeight = framedoc.children[0].clientHeight;
    var headerHeight = framedoc.getElementById('header').clientHeight;
    framedoc.getElementById('site').style.setProperty('height', docHeight - headerHeight + 'px');
    framedoc.getElementsByTagName('body')[0].style.setProperty('background-color', '#f5faff');

    return true;
}

function jupyterClassicTerminalModifications(frame) {
    frame.contentDocument.getElementById('header').style.setProperty('display', 'none');
    frame.contentDocument.getElementById('terminado-container').style.setProperty('width', '100%');
    frame.contentDocument.getElementsByTagName('body')[0].style.setProperty('background-color', 'transparent');
    frame.contentDocument.querySelector('.xterm').style.setProperty('height', '100%');
    frame.contentDocument.querySelector('.terminado-container-container').style.setProperty('padding-top', '0px');

    frame.contentWindow.terminal.term.setOption('theme', { foreground: 'black', background: 'white', cursor: 'black' });

    return true;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    jupyterClassicVisualModifications: jupyterClassicVisualModifications,
    jupyterClassicTerminalModifications: jupyterClassicTerminalModifications
});

/***/ }),

/***/ "r0il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeImages_vue__ = __webpack_require__("tOhe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edab0e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeImages_vue__ = __webpack_require__("ehnu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edab0e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeImages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r8lU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteFileDialog_vue__ = __webpack_require__("vEkq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0946c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteFileDialog_vue__ = __webpack_require__("wW7X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteFileDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0946c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteFileDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rKSB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rT7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container theme-showcase",attrs:{"id":"grantPrivileges","role":"main"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('table',[_c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v("Resource Name")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',{attrs:{"id":"grant_resourceName"}})]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v("Resource Id (in Context)")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',{attrs:{"id":"grant_resourceid"}})]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v("Context Class")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',{attrs:{"id":"grant_contextclass"}})]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v("Resource Type")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',{attrs:{"id":"grant_resourcetype"}})]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"center"}},[_vm._v("Resource Context UUID")]),_vm._v(" "),_c('td',[_vm._v(":")]),_vm._v(" "),_c('td',{attrs:{"id":"grant_contextuuid"}})])])])])]),_vm._v(" "),_c('table',[_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Users and Groups")]),_vm._v(" "),_c('table',{staticClass:"table-bordered",attrs:{"id":"usersAndGroupsTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Type (U|G)")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Description (G)")])])]),_vm._v(" "),_c('tbody')])]),_c('td',[_vm._v("  ")]),_c('td',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Actions")]),_vm._v(" "),_c('table',{staticClass:"table-bordered",attrs:{"id":"resourceActions"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Name")])])]),_vm._v(" "),_c('tbody')])]),_c('td',[_vm._v("  ")]),_c('td',[_c('div',{staticClass:"btn-group-vertical"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"addPrivilegeButton"}},[_vm._v("Add")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"removePrivilegeButton"}},[_vm._v("Remove")])])]),_c('td',[_vm._v("  ")]),_c('td',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Privileges")]),_vm._v(" "),_c('table',{staticClass:"table-bordered",attrs:{"id":"assignedPrivileges"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("SciS-Entity")]),_vm._v(" "),_c('th',[_vm._v("SciS-Type")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),_c('tbody')])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("  ")]),_c('td',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Roles")]),_vm._v(" "),_c('table',{staticClass:"table-bordered",attrs:{"id":"resourceRoles"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Name")])])]),_vm._v(" "),_c('tbody')])]),_c('td',[_vm._v("  ")]),_c('td',[_c('div',{staticClass:"btn-group-vertical"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"addRoleButton"}},[_vm._v("Add")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"removeRoleButton"}},[_vm._v("Remove")])])]),_c('td',[_vm._v("  ")]),_c('td',[_c('h3',{attrs:{"align":"center"}},[_vm._v("Assigned Roles")]),_vm._v(" "),_c('table',{staticClass:"table-bordered",attrs:{"id":"assignedRoles"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("SciS-Entity")]),_vm._v(" "),_c('th',[_vm._v("SciS-Type")]),_vm._v(" "),_c('th',[_vm._v("Role")])])]),_vm._v(" "),_c('tbody')])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rYgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.recentNotebooksProcessed.length > 0)?_c('span',[_vm._v(" Recently opened notebooks:\n  "),(_vm.shownum)?_c('span',[_vm._v("("),_c('router-link',{attrs:{"title":"view more recent notebooks","to":"/notebook"}},[_vm._v("see all")]),_vm._v(")")],1):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.recentNotebooksProcessed),function(notebook){return _c('div',{staticClass:"panel panel-default",class:{'tight': _vm.tight},staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"panel-body"},[_c('span',{staticStyle:{"font-weight":"bolder"}},[_c('router-link',{attrs:{"title":"open notebook","to":notebook.nbLink}},[_vm._v("\n          "+_vm._s(notebook.name)+"\n        ")])],1),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"20px"}},[_vm._v(" (in\n        "),_c('router-link',{attrs:{"title":"open containing path","to":notebook.filesLink}},[_c('b',[_vm._v(_vm._s(notebook.volName))]),_vm._v("/"+_vm._s(notebook.dir)+"\n        ")]),_vm._v("\n        )\n      ")],1),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"20px"}},[_vm._v(" "+_vm._s(notebook.imageName)+" ")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('span',[_vm._v(" last opened "+_vm._s(notebook.timeIndicator)+" ")]),_vm._v(" |\n        "),_c('router-link',{attrs:{"title":"open notebook","to":notebook.nbLink}},[_c('span',{staticClass:"glyphicon glyphicon-edit"})]),_vm._v(" "),_c('router-link',{attrs:{"title":"copy notebook","to":((notebook.nbLink) + "?copy=true")}},[_c('span',{staticClass:"glyphicon glyphicon-copy"})]),_vm._v(" "),_c('router-link',{attrs:{"title":"new notebook same config","to":((notebook.nbLink) + "?copy=true&empty=true")}},[_c('span',{staticClass:"glyphicon glyphicon-export"})])],1)])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tFW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_head__ = __webpack_require__("DxBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keys__ = __webpack_require__("ktak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_values__ = __webpack_require__("L8MQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComputeDomain__ = __webpack_require__("piDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__compute_NewDomainWizard__ = __webpack_require__("z+KZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sharedComponents_listGroup__ = __webpack_require__("MoEu");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeAdmin',
  components: {
    ComputeDomain: __WEBPACK_IMPORTED_MODULE_6__ComputeDomain__["a" /* default */],
    NewDomainWizard: __WEBPACK_IMPORTED_MODULE_7__compute_NewDomainWizard__["a" /* default */],
    listGroup: __WEBPACK_IMPORTED_MODULE_8__sharedComponents_listGroup__["a" /* default */]
  },
  data: function data() {
    return {
      selectedId: undefined,
      isLoading: false
    };
  },
  computed: {
    shownId: function shownId() {
      if (this.selectedId) return this.selectedId;
      if (this.racmDomains.length) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_head___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_keys___default()(this.$store.state.compute.racmComputeDomains));
      }
      return undefined;
    },
    racmDomains: function racmDomains() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_values___default()(this.$store.state.compute.racmComputeDomains);
    },
    refreshSpinner: function refreshSpinner() {
      return {
        'fa-spin': this.isLoading
      };
    }
  },
  methods: {
    selectDomain: function selectDomain(id) {
      this.selectedId = id;
    },
    newDomain: function newDomain() {
      this.$refs.newDomainWizard.startDialog();
    },
    loadAllInfo: function loadAllInfo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([_this.$store.dispatch('loadCompute'), _this.$store.dispatch('loadDomainsFromCompute'), _this.$store.dispatch('loadImagesFromCompute'), _this.$store.dispatch('loadVolumesFromCompute'), _this.$store.dispatch('loadNodesFromCompute'), _this.$store.dispatch('loadCollaborations')]);

              case 3:
                _this.isLoading = false;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.loadAllInfo();
  }
});

/***/ }),

/***/ "tOhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComputeImage__ = __webpack_require__("ClkD");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeImages',
  components: {
    ComputeImage: __WEBPACK_IMPORTED_MODULE_0__ComputeImage__["a" /* default */]
  },
  props: ['imageIds', 'computeOnlyIds']
});

/***/ }),

/***/ "tU44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_xor__ = __webpack_require__("h3km");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_xor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_xor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__files_utils__ = __webpack_require__("RswP");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var $ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userVolume: {},
      open: false,
      sharedUsers: [],
      // https://stackoverflow.com/a/38872723/239003
      id: 'shareUserVolume' + Math.random().toString(36).substr(2, 10),
      shareUV: "https://www.sciserver.org/support/how-to-use-sciserver/#sharevolume"
    };
  },
  mounted: function mounted() {
    // The use of DataTables here means we can't make the
    // click listeners that are managed by vue
    window[this.id] = this;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sharedUsersRow: function sharedUsersRow() {
      var _this = this;

      return this.sharedUsers.map(function (sharedUser) {
        var isReadable = __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(sharedUser.allowedActions, 'read');
        var isWritable = __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(sharedUser.allowedActions, 'write');
        var isGrantable = __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(sharedUser.allowedActions, 'grant');
        var isDeletable = __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(sharedUser.allowedActions, 'delete');
        var role = '\n          <label class="checkbox-inline"><input type="checkbox" onchange="' + _this.id + '.toggleAction(' + sharedUser.id + ', \'' + sharedUser.type + '\', \'read\')" ' + (isReadable ? 'checked' : '') + '>Read</label>\n          <label class="checkbox-inline"><input type="checkbox" onchange="' + _this.id + '.toggleAction(' + sharedUser.id + ', \'' + sharedUser.type + '\', \'write\')" ' + (isWritable ? 'checked' : '') + '>Write</label>\n          <label class="checkbox-inline"><input type="checkbox" onchange="' + _this.id + '.toggleAction(' + sharedUser.id + ', \'' + sharedUser.type + '\', \'grant\')" ' + (isGrantable ? 'checked' : '') + '>Grant</label>\n          <label class="checkbox-inline"><input type="checkbox" onchange="' + _this.id + '.toggleAction(' + sharedUser.id + ', \'' + sharedUser.type + '\', \'delete\')" ' + (isDeletable ? 'checked' : '') + '>Delete</label>';
        return [sharedUser.name, sharedUser.id, sharedUser.type, role];
      });
    },
    groupsAndUsers: function groupsAndUsers() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default()(this.publicUsers.map(this.getUserById).map(function (u) {
        return [u.username, u.id, 'USER'];
      }), this.publicGroups.map(this.getGroupById).map(function (g) {
        return [g.groupName, g.id, 'GROUP'];
      }));
    },
    userVolumeName: function userVolumeName() {
      return ' Share ' + this.userVolume.name;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'publicUsers', 'publicGroups', 'users', 'groups', 'token']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getUserById', 'getGroupById'])),
  watch: {
    sharedUsersRow: function sharedUsersRow(newSharedUsersRow) {
      if ($.fn.dataTable.isDataTable('#membersTable-shareFile')) {
        var table = $('#membersTable-shareFile').DataTable();
        table.clear();
        table.rows.add(newSharedUsersRow).draw(false);
      } else {
        $('#membersTable-shareFile').DataTable({
          data: newSharedUsersRow,
          processing: true,
          bFilter: true,
          paging: true,
          select: true,
          language: {
            emptyTable: 'No Members To Display'
          }
        });
      }
    },
    groupsAndUsers: function groupsAndUsers() {
      if ($.fn.dataTable.isDataTable('#usersTable-shareFile')) {
        $('#usersTable-shareFile').DataTable().clear().destroy();
      }
      $('#usersTable-shareFile').DataTable({
        data: this.groupsAndUsers,
        processing: true,
        bFilter: true,
        stateSave: false,
        select: {
          style: 'single'
        },
        paging: true
      });
    }
  },
  methods: {
    startDialog: function startDialog(userVolume) {
      this.userVolume = userVolume;
      this.sharedUsers = this.userVolume.sharedUsers;
      this.updateGroupsAndUsersTable();
      this.open = true;
    },
    saveShared: function saveShared() {
      var _this2 = this;

      this.open = false;
      var config = { headers: { 'X-Auth-Token': this.token } };
      var url = __WEBPACK_IMPORTED_MODULE_7__files_utils__["default"].joinBaseURL(this.userVolume, 'api/share/');
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(url, this.sharedUsers, config).then(function () {
        _this2.$emit('sharedVolume');
      }, function (error) {
        alert('Error while sharing; ' + error.response.data.error);
      });
    },
    addMembers: function addMembers() {
      var data = $('#usersTable-shareFile').DataTable().rows({
        selected: true
      }).data().toArray();
      this.sharedUsers = __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default()(this.sharedUsers, data.map(function (entity) {
        return {
          name: entity[0],
          id: entity[1],
          type: entity[2],
          allowedActions: ['read']
        };
      }));
    },
    removeMembers: function removeMembers() {
      var removed = $('#membersTable-shareFile').DataTable().rows({
        selected: true
      }).data().toArray();
      $('#membersTable-shareFile').DataTable().rows('.selected').remove().draw();
      var data = $('#membersTable-shareFile').DataTable().rows().data().toArray();
      var allUsers = this.sharedUsers.filter(function (m) {
        return data.find(function (m2) {
          return m.id === m2[1];
        });
      });
      var removedUser = removed.map(function (entity) {
        return {
          name: entity[0],
          id: entity[1],
          type: entity[2],
          allowedActions: []
        };
      });
      this.sharedUsers = __WEBPACK_IMPORTED_MODULE_4_lodash_concat___default()(allUsers, removedUser);
    },
    toggleAction: function toggleAction(id, type, action) {
      var sharedUser = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(this.sharedUsers, { id: id, type: type });
      sharedUser.allowedActions = __WEBPACK_IMPORTED_MODULE_5_lodash_xor___default()(sharedUser.allowedActions, [action]);
    },
    updateGroupsAndUsersTable: function updateGroupsAndUsersTable() {
      if ($.fn.dataTable.isDataTable('#usersTable-shareFile')) {
        $('#usersTable-shareFile').DataTable().clear().destroy();
      }
      $('#usersTable-shareFile').DataTable({
        data: this.groupsAndUsers,
        processing: true,
        bFilter: true,
        stateSave: false,
        select: {
          style: 'single'
        },
        paging: true
      });
    }
  }
});

/***/ }),

/***/ "tYzz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/idies-logo-big3.3c1dd44.png";

/***/ }),

/***/ "tZc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sharedComponents_listGroup__ = __webpack_require__("MoEu");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var apiCall = __webpack_require__("pBBg").default;
var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        listGroup: __WEBPACK_IMPORTED_MODULE_5__sharedComponents_listGroup__["a" /* default */],
        VueMarkdown: __WEBPACK_IMPORTED_MODULE_3_vue_markdown___default.a
    },
    created: function created() {
        this.$store.dispatch('loadScienceDomains', this.userProfile);
    },

    data: function data() {
        return {
            selectedCollaborationId: undefined,
            collabObjects: [],
            alertStatus: false,
            alertMessage: '',
            currentDomain: '',
            names: [],
            maps2: [],
            resourceTypes: [],
            resourceNames: [],
            map: [],
            status: 'Join',
            isJoin: '',
            shownCollaborationObjectLogo: ''
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        getTitles: function getTitles() {
            return _.uniq(_.map(this.shownCollaborationObject.resources, function (x) {
                return x.resourceType;
            }));
        },
        markedDescription: function markedDescription() {
            var currentId = this.$route.params.scienceId || this.sortedCollaborationIds[0];
            var description = this.currentListOfGroups[currentId].description;
            this.setMarkedInformation(currentId, description);
            return description;
        },
        scienceGroups: function scienceGroups() {
            return this.$store.state.science.scienceDomains;
        },
        sortedCollaborationIds: function sortedCollaborationIds() {
            return this.$store.state.science.scienceDomainsId;
        },
        currentListOfGroups: function currentListOfGroups() {
            if (this.$store.state.science.scienceDomains) {
                return this.$store.state.science.scienceDomains;
            }
            return undefined;
        },
        findCurrentGroupKey: function findCurrentGroupKey() {
            var _this = this;

            var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.currentListOfGroups);
            return key.find(function (k) {
                return _this.currentListOfGroups[k].groupId.toString() === _this.groupid;
            });
        },
        groupid: function groupid() {
            return this.$route.params.scienceId;
        },
        shownCollaborationId: function shownCollaborationId() {
            if (this.findCurrentGroupKey) {
                return this.findCurrentGroupKey;
            }
            return this.sortedCollaborationIds[0];
        },
        shownCollaborationObject: function shownCollaborationObject() {
            return this.currentListOfGroups[this.shownCollaborationId];
        },
        joinStatus: function joinStatus() {
            return this.currentListOfGroups[this.shownCollaborationId]._links.join;
        },
        selectedScienceDomainDescriptionObj: function selectedScienceDomainDescriptionObj() {
            var obj = '';
            try {
                obj = JSON.parse(this.shownCollaborationObject.description);
            } catch (e) {
                // console.log(e);
            }
            if (obj && (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
                return obj;
            }
            obj = this.shownCollaborationObject.description;
            return obj;
        },
        selectedImageLogo: function selectedImageLogo() {
            return this.selectedScienceDomainDescriptionObj.logo;
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapState */])(['userProfile', 'token'])),
    methods: {
        setMarkedInformation: function setMarkedInformation(currentId, description) {
            var titleInfo = description.match(/\[TITLE\]: # \(([^)]*)\)/);
            if (titleInfo) {
                this.currentListOfGroups[currentId].name = titleInfo[1];
            }
            var logoInfo = description.match(/\[LOGO-URL\]: # \(([^)]*)\)/);
            if (logoInfo) {
                this.shownCollaborationObjectLogo = logoInfo[1];
            }
        },
        getImage: function getImage(value) {
            if (value === 'Casjobs.DatabaseContext') {
                return 'fa fa-database fa-2x';
            } else if (value === 'DockerImage') {
                return 'fa fa-th fa-2x';
            } else if (value === 'VolumeContainer') {
                return 'fa fa-archive fa-2x';
            } else if (value === 'FileService.DataVolume') {
                return 'fa fa-archive fa-2x';
            } else if (value === 'DatabaseContext') {
                return 'fa fa-database fa-2x';
            }
            return 'fa fa-archive fa-2x';
        },
        leaveCollaboration: function leaveCollaboration() {
            var _this2 = this;

            if (confirm('Would you like to leave \'' + this.shownCollaborationObject.name + '\'?')) {
                apiCall(this.shownCollaborationObject._links.leave.href, this.token, 'POST', '', function () {
                    _this2.$store.dispatch('loadScienceDomains', _this2.userProfile);
                }, null);
            }
        },
        joinPublicCollaboration: function joinPublicCollaboration() {
            var _this3 = this;

            if (confirm('Would you like to join \'' + this.shownCollaborationObject.name + '\'?')) {
                apiCall("https://sciserver.sdcc.bnl.gov/sciserver/racm/" + 'ugm/rest/groups/join?groupId=' + this.shownCollaborationObject.groupId, this.token, 'POST', '', function () {
                    _this3.$store.dispatch('loadScienceDomains', _this3.userProfile);
                }, null);
            }
        }
    }
});

/***/ }),

/***/ "td1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Total Progress:")]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped active",style:(_vm.totalProgressStyle),attrs:{"role":"progressbar","aria-valuenow":_vm.totalProgress,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm._v("\n      "+_vm._s(_vm.totalProgress)+"%\n    ")])]),_vm._v(" "),_c('p',[_vm._v("Remaining Tasks:")]),_vm._v(" "),_c('ol',{staticClass:"remaining-list"},[(!_vm.registeredInCompute)?_c('li',[_vm._v("Registering Image in Compute…")]):_vm._e(),_vm._v(" "),(!_vm.registeredInRACM)?_c('li',[_vm._v("Registering Image in RACM…")]):_vm._e(),_vm._v(" "),(!_vm.sharedWithAdminGroup)?_c('li',[_vm._v("Granting Access to the admin Group…")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Edit User Volume"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("User Volume Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVolumeName),expression:"newVolumeName"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.initialVolumeName},domProps:{"value":(_vm.newVolumeName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editUserVolume($event)},"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.newVolumeName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.newVolumeDescription),expression:"newVolumeDescription"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":_vm.initialVolumeDescription},domProps:{"value":(_vm.newVolumeDescription)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editUserVolume($event)},"input":function($event){if($event.target.composing){ return; }_vm.newVolumeDescription=$event.target.value}}})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.invalidUVName),expression:"invalidUVName"}]},[_vm._v("User volume name cannot contain /.")])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.invalidUVName},on:{"click":function($event){_vm.editUserVolume()}}},[_vm._v("Save Changes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tk7n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container theme-showcase",attrs:{"role":"main"}},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-1"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group-vertical"},[_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}]},[_vm._m(3),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])]),_vm._v(" "),_vm._m(4)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"inputGroupName"}},[_vm._v("Group Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"name":"name","type":"text","id":"groupname"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"inputGroupName"}},[_vm._v("Description")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{staticClass:"form-control",attrs:{"name":"description","type":"text","id":"groupdescription"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Available SciServer Users")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered responsive hover order-column compact sciserver-datatable"},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Email")])])]),_vm._v(" "),_c('tbody')])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"dropdown-toggle",attrs:{"title":"invite user","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                            Invite User\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","id":"inviteADMIN"}},[_vm._v("Admin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","id":"inviteMEMBER"}},[_vm._v("Member")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"dropdown-toggle",attrs:{"title":"Add User","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                                Add User\n                            ")]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","id":"addADMIN"}},[_vm._v("Admin")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","id":"addMEMBER"}},[_vm._v("Member")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"panel panel-primary"},[_c('div',{staticClass:"panel-heading"},[_c('h5',{staticClass:"panel-title"},[_vm._v("Group Members")])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticStyle:{"overflow-x":"auto"}},[_c('table',{staticClass:"table-bordered responsive hover order-column compact sciserver-datatable"},[_c('thead',{staticClass:"thead-default"},[_c('tr',[_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("email")]),_vm._v(" "),_c('th',[_vm._v("Member Role")]),_vm._v(" "),_c('th',[_vm._v("Member Status")])])]),_vm._v(" "),_c('tbody')])])]),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"id":"removeGroupMembersButton","title":"Remove Member"}},[_vm._v("Remove Member")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u+a3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ComputeDomainChooser',
    mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_focus__["mixin"]],
    props: ['currentImageInfo'],
    data: function data() {
        return {
            open: false,
            focused: false,
            domains: null,
            domain: null,
            image: null,
            userVols: [],
            dataVols: [],
            containerId: null,
            change: false
        };
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        validDomains: function validDomains() {
            return this.domains ? _.sortBy(this.domains.filter(function (i) {
                return i.images.length > 0;
            }), function (i) {
                return i.name;
            }) : null;
        },
        domainImages: function domainImages() {
            return this.domain ? _.sortBy(this.domain.images, function (i) {
                return i.name;
            }) : [];
        },
        domainUserVolumes: function domainUserVolumes() {
            return this.domain ? _.sortBy(this.domain.userVolumes, function (i) {
                return i.name;
            }) : null;
        },
        domainDataVolumes: function domainDataVolumes() {
            return this.domain ? _.sortBy(this.domain.volumes, function (i) {
                return i.name;
            }) : null;
        },
        domainDescription: function domainDescription() {
            return this.domain ? this.domain.description : null;
        },
        imageDescription: function imageDescription() {
            return this.image ? this.image.description : null;
        },
        newImageInfo: function newImageInfo() {
            return {
                domain: parseInt(_.get(this.domain, 'publisherDID', ''), 10),
                name: _.get(this.image, 'name'),
                userVolumes: this.userVols.map(function (i) {
                    return i.id;
                }),
                dataVolumes: this.dataVols.map(function (i) {
                    return i.publisherDID;
                }),
                cachedContainer: this.containerId ? parseInt(this.containerId, 10) : null
            };
        },
        imageInfoModified: function imageInfoModified() {
            if (!this.currentImageInfo) {
                return true;
            }
            if (this.newImageInfo.domain !== _.get(this.currentImageInfo, 'domain')) {
                return true;
            }
            if (this.newImageInfo.name !== _.get(this.currentImageInfo, 'name')) {
                return true;
            }
            if (_.xor(_.get(this.newImageInfo, 'userVolumes', []), _.get(this.currentImageInfo, 'userVolumes', [])).length !== 0) {
                return true;
            }
            if (_.xor(_.get(this.newImageInfo, 'dataVolumes', []), _.get(this.currentImageInfo, 'dataVolumes', [])).length !== 0) {
                return true;
            }
            if (this.containerId && this.containerId !== _.get(this.currentImageInfo, 'cachedContainer', '').toString()) {
                return true;
            }
            console.log(this.newImageInfo);
            return false;
        },
        isApplyable: function isApplyable() {
            if (!this.imageInfoModified) {
                return false;
            }
            return this.newImageInfo.name && this.newImageInfo.domain;
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isAdmin'])),
    methods: {
        startDialog: function startDialog() {
            var _this = this;

            this.focused = true;
            this.open = true;
            this.domains = this.$store.state.compute.userComputeDomains;
            if (this.domains && this.currentImageInfo) {
                this.domain = this.domains.find(function (i) {
                    return i.publisherDID === _.get(_this.currentImageInfo, 'domain', '').toString();
                });
                this.resetForm();
            }
        },
        resetForm: function resetForm() {
            var _this2 = this;

            if (this.domain) {
                this.image = this.domain.images.find(function (i) {
                    return i.name === _.get(_this2.currentImageInfo, 'name');
                });
                console.log('image at startup: ', this.image);
                this.userVols = this.domain.userVolumes.filter(function (i) {
                    return _.get(_this2.currentImageInfo, 'userVolumes', []).includes(i.id);
                });
                this.dataVols = this.domain.volumes.filter(function (i) {
                    return _.get(_this2.currentImageInfo, 'dataVolumes', []).includes(i.publisherDID);
                });
            }
        },
        isSelected: function isSelected(i) {
            return i === this.selected;
        },
        applyImageInfo: function applyImageInfo() {
            if (this.imageInfoModified) {
                console.log('image info changed!');
                this.$emit('imageInfoModified', this.newImageInfo);
            }
            this.open = false;
            this.focused = false;
        }
    }
});

/***/ }),

/***/ "uGIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__("VXg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__ = __webpack_require__("KBYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_concat__ = __webpack_require__("NxPG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shareUserVolumeDialog__ = __webpack_require__("2V0b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shareVolumeContainer__ = __webpack_require__("eXj4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shareDockerImages__ = __webpack_require__("ddFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shareDatabaseContexts__ = __webpack_require__("OAwq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shareDataVolumeDialog__ = __webpack_require__("JtHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ResourceInfoDialog__ = __webpack_require__("a7Oi");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['selectedResources', 'collaboration', 'collabOwner', 'collabType'],
  components: {
    shareUserVolumeDialog: __WEBPACK_IMPORTED_MODULE_8__shareUserVolumeDialog__["a" /* default */],
    shareVolumeContainer: __WEBPACK_IMPORTED_MODULE_9__shareVolumeContainer__["a" /* default */],
    shareDockerImages: __WEBPACK_IMPORTED_MODULE_10__shareDockerImages__["a" /* default */],
    shareDatabaseContexts: __WEBPACK_IMPORTED_MODULE_11__shareDatabaseContexts__["a" /* default */],
    resourceInfoDialog: __WEBPACK_IMPORTED_MODULE_13__ResourceInfoDialog__["a" /* default */],
    shareDataVolume: __WEBPACK_IMPORTED_MODULE_12__shareDataVolumeDialog__["a" /* default */]
  },
  data: function data() {
    return {
      shareResource: "https://www.sciserver.org/support/how-to-use-sciserver/#shareview"
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sharedVolumes: function sharedVolumes() {
      if (this.isPublicGroup) {
        return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'VOLUMECONTAINER' }), 'name');
      }
      return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'VOLUMECONTAINER' }), 'name');
    },
    sharedImages: function sharedImages() {
      if (this.isPublicGroup) {
        return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'DockerImage' }), 'name');
      }
      return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'DOCKERIMAGE' }), 'name');
    },
    sharedDataVolumes: function sharedDataVolumes() {
      if (this.isPublicGroup) {
        return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'FileService.DataVolume' }), 'name');
      }
      return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'DATAVOLUME' }), 'name');
    },
    sharedUserVolumes: function sharedUserVolumes() {
      if (this.isPublicGroup) {
        return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'FileService.UserVolume' }), function (uv) {
          return uv.name.toLowerCase();
        });
      }
      return __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'USERVOLUME' }), function (uv) {
        return uv.name.toLowerCase();
      });
    },
    sharedDatabases: function sharedDatabases() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_concat___default()(this.casJobsDatabases, this.sciQueryDatabases);
    },
    casJobsDatabases: function casJobsDatabases() {
      return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { resourceType: 'Casjobs.DatabaseContext' }), 'name');
    },
    sciQueryDatabases: function sciQueryDatabases() {
      return this.uniqAndSortBy(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: 'DATABASE' }), 'name');
    },
    isWorkspace: function isWorkspace() {
      return this.collaboration.type === 'WORKSPACE';
    },
    isPublicGroup: function isPublicGroup() {
      return this.collaboration.type === 'PUBLIC GROUP';
    },
    isOwner: function isOwner() {
      return this.collabOwner.role === 'OWNER';
    },
    hasGrantableResource: function hasGrantableResource() {
      var _this = this;

      return function (resourceType) {
        return _this.getGrantableResources(resourceType).length > 0;
      };
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['getGrantableResources', 'getResourceDetails'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    uniqAndSortBy: function uniqAndSortBy(data, field) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(data, field).sort(function (a, b) {
        return a[field].localeCompare(b[field]);
      });
    },
    unshare: function unshare(items) {
      this.$emit('unshareResource', items);
    },
    openShareUserVolumeDialog: function openShareUserVolumeDialog() {
      this.$refs.shareUserVolumeDialog.startDialog();
    },
    openShareVolumeContainerDialog: function openShareVolumeContainerDialog() {
      this.$refs.shareVolumeContainerDialog.startDialog();
    },
    openShareDockerImagesDialog: function openShareDockerImagesDialog() {
      this.$refs.shareDockerImagesDialog.startDialog();
    },
    openShareDatabaseDialog: function openShareDatabaseDialog() {
      this.$refs.shareDatabaseDialog.startDialog();
    },
    openShareDataVolumeDialog: function openShareDataVolumeDialog() {
      this.$refs.shareDataVolumeDialog.startDialog();
    },
    addResources: function addResources(resources, privilege) {
      this.$emit('shareResources', resources, privilege, this.collaboration);
    },
    openInfo: function openInfo(dialogRef, info, groupInfo) {
      this.$refs[dialogRef].startDialog(info, groupInfo);
    },
    isGrantableThroughAnyMeans: function isGrantableThroughAnyMeans(type, entityId) {
      return __WEBPACK_IMPORTED_MODULE_4_lodash_some___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(this.getResourceDetails(type, entityId), 'allowedActions'), { category: 'G' });
    },
    allGroupInfos: function allGroupInfos(type, name, sortField) {
      return __WEBPACK_IMPORTED_MODULE_3_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(this.selectedResources, { type: type, name: name }), sortField);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(['loadResources'])),
  mounted: function mounted() {
    this.loadResources();
  }
});

/***/ }),

/***/ "uVBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbForFile_vue__ = __webpack_require__("6Iyg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7e280dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbForFile_vue__ = __webpack_require__("wzQC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BreadcrumbForFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7e280dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BreadcrumbForFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uWMP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterImage_vue__ = __webpack_require__("y2th");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cbbcb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterImage_vue__ = __webpack_require__("v5b2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64cbbcb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uYv6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);




var casjobsImgLink = __webpack_require__("zCUr");
var computeImgLink = __webpack_require__("TabH");
var jobsImgLink = __webpack_require__("A597");
var sciDriveImgLink = __webpack_require__("Fs7G");
var skyQueryImgLink = __webpack_require__("Zoh1");
var skyServerImgLink = __webpack_require__("7EyP");

var _ = __webpack_require__("M4fF");
var urljoin = __webpack_require__("mTx5");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'applicationConfiguration',
    components: {},
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        casJobs_URL: function casJobs_URL() {
            return urljoin("https://sciserver.sdcc.bnl.gov/sciserver/login-portal/", 'Account/Login?' + __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify({ callbackUrl: urljoin("", 'login.aspx?nexturl=SubmitJob.aspx') }));
        },
        skyquery_URL: function skyquery_URL() {
            return "";
        },
        skyserver_URL: function skyserver_URL() {
            return "";
        },
        scidrive_URL: function scidrive_URL() {
            return "";
        },
        sciquery_URL: function sciquery_URL() {
            return "https://sciserver.sdcc.bnl.gov/sciserver/sciquery-ui";
        },
        compute_URL: function compute_URL() {
            return urljoin("https://sciserver.sdcc.bnl.gov/sciserver/compute", 'login?' + __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify({ callbackUrl: "https://sciserver.sdcc.bnl.gov/sciserver/compute" }));
        },
        computeJobs_URL: function computeJobs_URL() {
            return urljoin("https://sciserver.sdcc.bnl.gov/sciserver/compute", 'login?' + __WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify({ callbackUrl: urljoin("https://sciserver.sdcc.bnl.gov/sciserver/compute", 'jobs') }));
        },
        appTiles: function appTiles() {
            if (_.size(null) > 0) {
                return null;
            }
            var tiles = [];
            if (false) {
                tiles.push({ name: 'CasJobs',
                    description: 'Search online big relational databases collection, store the results online, and share them.',
                    serviceUrl: this.casJobs_URL,
                    staticIcon: 'casjobs' });
            }
            if (true) {
                tiles.push({ name: 'Compute',
                    description: 'Analyze data with interactive Jupyter notebooks in Python, R and MATLAB.',
                    serviceUrl: this.compute_URL,
                    staticIcon: 'compute' });
                tiles.push({ name: 'Compute Jobs',
                    description: 'Asychronously run Jupyter notebooks in Python, R and MATLAB or commands.',
                    serviceUrl: this.computeJobs_URL,
                    staticIcon: 'jobs' });
            }
            if (false) {
                tiles.push({ name: 'SciDrive',
                    description: 'Drag-and-drop file hosting and sharing services.',
                    serviceUrl: this.scidrive_URL,
                    staticIcon: 'sciDrive' });
            }
            if (false) {
                tiles.push({ name: 'SkyServer',
                    description: 'Access the Sloan Digital Sky Survey data, tutorials and educational materials.',
                    serviceUrl: this.skyserver_URL,
                    staticIcon: 'skyServer' });
            }
            if (false) {
                tiles.push({ name: 'SkyQuery',
                    description: 'A scalable database system for cross-matching astronomical source catalogs.',
                    serviceUrl: this.skyquery_URL,
                    staticIcon: 'skyQuery' });
            }
            return tiles.concat(null || []);
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['token'])),
    data: function data() {
        return {
            alertClasses: 'alert alert-' + "danger",
            alertMessage: '' + "",
            version:  true ? '' + "2.1.2-329-g491200e8" : '',
            sciserver_Version: '' + "2.x",
            useIconsForActivities: '' + "true" === 'true',
            showApplicationAppRow: '' + "true" === 'true',
            applicationName: '' + "SciServer",
            applicationTagline: '' + "Data, Collaboration, Compute",
            applicationHomeUrl: '' + "https://www.sciserver.org/",
            oneclickNotebookPath: "",
            staticImages: { casjobs: casjobsImgLink,
                compute: computeImgLink,
                jobs: jobsImgLink,
                sciDrive: sciDriveImgLink,
                skyServer: skyServerImgLink,
                skyQuery: skyQueryImgLink }
        };
    },
    methods: {
        assignCSS: function assignCSS() {
            if (true) {
                document.querySelector(':root').style.setProperty('--navColor', '' + "#003466");
            }
            if (true) {
                document.querySelector('body').style.setProperty('font-family', '' + "Helvetica Neue, Helvetica, Arial, sans-serif");
            }
            if (!this.showApplicationAppRow) {
                var thumbnails = document.querySelectorAll('div.thumbnail.dashboard');
                thumbnails.forEach(function (thumbnail) {
                    thumbnail.querySelector('h4').style.setProperty('font-weight', 'bold');
                    thumbnail.querySelector('h4').style.setProperty('font-size', '20px');
                    thumbnail.querySelector('p:first-of-type').style.setProperty('font-weight', 'bold');
                    return thumbnail;
                });
            }
        }
    }
});

/***/ }),

/***/ "ucpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkedAccounts.length)?_c('div',[_vm._l((_vm.linkedAccounts),function(account){return _c('ul',{key:account.key,staticClass:"Box list-style-none",attrs:{"id":"settings-emails"}},[_c('li',{staticClass:"Box-row clearfix css-truncate settings-email"},[_c('span',{staticClass:"css-truncate-target",attrs:{"title":account.value}},[_vm._v(_vm._s(account.value))]),_vm._v(" "),_c('span',{staticClass:"email-actions"},[_c('button',{staticClass:"btn-link settings-remove-email",attrs:{"title":"unlink account"},on:{"click":function($event){_vm.unlinkAccount(account.key, account.value)}}},[_c('span',{staticClass:"fa fa-trash fa-lg"})])])])])}),_vm._v(" "),_c('p',{staticClass:"note"},[_vm._v("\n      To link other accounts, "),_c('a',{staticClass:"btn-link",attrs:{"href":_vm.signOutLink}},[_vm._v("logout")]),_vm._v(" from the dashboard. In the login screen, click 'Sign in with Globus' button.\n    ")])],2):_c('div',[_c('label',[_vm._v("There are no linked accounts.")]),_vm._v(" "),_c('p',{staticClass:"note"},[_vm._v("\n      To link other accounts, "),_c('a',{staticClass:"btn-link",attrs:{"href":_vm.signOutLink}},[_vm._v("logout")]),_vm._v(" from the dashboard. In the login screen, click 'Sign in with Globus' button.\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "upny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_profile_getter__ = __webpack_require__("N5D7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__changeUserPassword__ = __webpack_require__("Z1YT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__manageLinkedAccount__ = __webpack_require__("BSWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sharedComponents_listGroup__ = __webpack_require__("MoEu");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var jQuery = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileDialog',
  mixins: [__WEBPACK_IMPORTED_MODULE_5_vue_focus__["mixin"]],
  components: {
    changeUserPassword: __WEBPACK_IMPORTED_MODULE_6__changeUserPassword__["a" /* default */],
    manageLinkedAccounts: __WEBPACK_IMPORTED_MODULE_7__manageLinkedAccount__["a" /* default */],
    listGroup: __WEBPACK_IMPORTED_MODULE_8__sharedComponents_listGroup__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    manageLinkedAccountURL: function manageLinkedAccountURL() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'linked-accounts';
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token', 'configLinks'])),
  data: function data() {
    return {
      fullName: '',
      initialFullName: '',
      affiliation: '',
      initialAffiliation: '',
      open: false,
      focused: false,
      selected: 0
    };
  },
  methods: {
    startDialog: function startDialog() {
      this.focused = true;
      this.open = true;
      this.fullName = this.userProfile.fullname;
      this.initialFullName = this.userProfile.fullname;
      this.affiliation = this.userProfile.affiliation;
      this.initialAffiliation = this.userProfile.affiliation;
    },
    saveProfile: function saveProfile() {
      var updatedduser = jQuery.extend({}, this.userProfile);
      updatedduser.fullname = this.fullName;
      updatedduser.affiliation = this.affiliation;
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(updatedduser);
      var config = { headers: { 'X-Auth-Token': this.token, 'Content-Type': 'application/octet-stream' } };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.configLinks.manageUserProfileUrl, body, config).then(this.reloadProfile, this.error);
    },
    reloadProfile: function reloadProfile() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_4__user_profile_getter__["a" /* default */])().then(function (_ref) {
        var userProfile = _ref.userProfile;

        _this.$store.commit('setUserProfile', userProfile);
      });
    },
    isSelected: function isSelected(i) {
      return i === this.selected;
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utPj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainStep_vue__ = __webpack_require__("7vgu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4997c710_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainStep_vue__ = __webpack_require__("3/lP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DomainStep_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4997c710_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DomainStep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v5b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Register Compute Image","size":"lg","footer":false,"transition-duration":0},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[(!_vm.isSaving)?_c('image-configurer',{attrs:{"is-editing":false},on:{"on-save":_vm.saveImage,"cancel":_vm.closeDialog}}):_vm._e(),_vm._v(" "),(_vm.isSaving)?_c('image-saver',{ref:"imageSaver",attrs:{"racm-domain-id":_vm.racmDomainId,"compute-domain-id":_vm.computeDomainId,"image-model":_vm.imageModel}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vEkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  data: function data() {
    return {
      open: false,
      name: undefined,
      url: '',
      title: 'Delete ' + name,
      numFiles: 0
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  methods: {
    startDialog: function startDialog(name, url) {
      this.open = true;
      this.name = name;
      this.url = url;
    },
    deleteItem: function deleteItem() {
      var _this = this;

      this.open = false;
      var config = { headers: { 'X-Auth-Token': this.token } };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(this.url, config).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].notify({
          group: 'top_center_notify',
          text: 'Delete Successful!',
          duration: 1000,
          type: 'error',
          ignoreDuplicates: true
        });
        _this.$emit('itemDeleted');
      }, function (error) {
        alert('Error Message: ' + error.response.data.error);
      });
    }
  }
});

/***/ }),

/***/ "vV7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeVolumes_vue__ = __webpack_require__("+PNu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f5a5d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeVolumes_vue__ = __webpack_require__("YvPX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComputeVolumes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35f5a5d1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComputeVolumes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vW9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"terminalFrame",staticClass:"terminalBlock",attrs:{"id":"terminalFrame","src":_vm.computeTerminalUrl},on:{"load":_vm.terminalLoad}}),_vm._v(" "),(!_vm.ready)?_c('div',{staticClass:"terminalBlock",attrs:{"id":"terminalCurtain"}},[_vm._v(" loading terminal... ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vji+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__("WlNK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math_utils__ = __webpack_require__("jIKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComputeImages__ = __webpack_require__("r0il");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComputeVolumes__ = __webpack_require__("vV7J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ComputeNodes__ = __webpack_require__("0EwR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ComputeRootVolumes__ = __webpack_require__("SOcW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__compute_RegisterImage__ = __webpack_require__("uWMP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeDomain',
  components: {
    ComputeImages: __WEBPACK_IMPORTED_MODULE_4__ComputeImages__["a" /* default */],
    ComputeVolumes: __WEBPACK_IMPORTED_MODULE_5__ComputeVolumes__["a" /* default */],
    ComputeNodes: __WEBPACK_IMPORTED_MODULE_6__ComputeNodes__["a" /* default */],
    ComputeRootVolumes: __WEBPACK_IMPORTED_MODULE_7__ComputeRootVolumes__["a" /* default */],
    RegisterImage: __WEBPACK_IMPORTED_MODULE_8__compute_RegisterImage__["a" /* default */]
  },
  props: ['selectedId'],
  computed: {
    racmDomain: function racmDomain() {
      return this.$store.state.compute.racmComputeDomains[this.selectedId];
    },
    computeDomain: function computeDomain() {
      if (!this.racmDomain) return undefined;
      return this.$store.state.compute.computeComputeDomains[this.computeDomainId];
    },
    computeDomainId: function computeDomainId() {
      return parseInt(this.racmDomain.publisherDID, 10);
    },
    imagesNotInRACM: function imagesNotInRACM() {
      if (!this.computeImageIds) return [];
      return __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(this.computeImageIds, this.racmImagesPublisherDIDs);
    },
    computeImageIds: function computeImageIds() {
      if (!this.computeDomain) return [];
      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.$store.state.compute.computeImages, { domain_id: this.computeDomainId }), 'id');
    },
    racmImagesPublisherDIDs: function racmImagesPublisherDIDs() {
      var _this = this;

      if (!this.racmDomain) return [];
      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(this.racmDomain.images, function (imageId) {
        return parseInt(_this.$store.state.compute.racmImages[imageId].publisherDID, 10);
      });
    },
    volumeContainersNotInRACM: function volumeContainersNotInRACM() {
      if (!this.computeVolumeContainerIds) return [];
      return __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(this.computeVolumeContainerIds, this.racmVolumeContainerPublisherDIDs);
    },
    computeVolumeContainerIds: function computeVolumeContainerIds() {
      if (!this.computeDomain) return [];
      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.$store.state.compute.computeVolumeContainers, { domain_id: this.computeDomainId }), 'id');
    },
    racmVolumeContainerPublisherDIDs: function racmVolumeContainerPublisherDIDs() {
      var _this2 = this;

      if (!this.racmDomain) return [];
      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(this.racmDomain.volumes, function (volumeId) {
        return parseInt(_this2.$store.state.compute.racmVolumeContainers[volumeId].publisherDID, 10);
      });
    },
    nodeIds: function nodeIds() {
      if (!this.computeDomain) return [];
      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_filter___default()(this.$store.state.compute.computeNodes, { domain_id: this.computeDomainId }), 'id');
    }
  },
  methods: {
    newImage: function newImage() {
      this.$refs.registerNewImage.openDialog();
    }
  },
  filters: {
    humanReadableLimit: function humanReadableLimit(value) {
      if (value === 0) return 'No Limit';
      return __WEBPACK_IMPORTED_MODULE_3__math_utils__["default"].bytesToSize(value);
    }
  }
});

/***/ }),

/***/ "vzr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usersModal_vue__ = __webpack_require__("OKdt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bedc56b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usersModal_vue__ = __webpack_require__("lFIZ");
function injectStyle (ssrContext) {
  __webpack_require__("rKSB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bedc56b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usersModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bedc56b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usersModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0C8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase__ = __webpack_require__("GMGH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_trimStart__ = __webpack_require__("z6ge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_trimStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_trimStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ComputeImage',
  props: ['imageId'],
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    foundImage: function foundImage() {
      return this.racmImage || this.computeImage;
    },
    registeredInRACM: function registeredInRACM() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.imageId);
    },
    imageName: function imageName() {
      if (this.racmImage) return this.racmImage.name;
      if (this.computeImage) return this.computeImage.name;
      return undefined;
    },
    computeImageId: function computeImageId() {
      if (this.racmImage) {
        return parseInt(this.racmImage.publisherDID, 10);
      } else if (this.imageId) {
        return parseInt(__WEBPACK_IMPORTED_MODULE_3_lodash_trimStart___default()(this.imageId, 'compute:'), 10);
      }
      return undefined;
    },
    racmImage: function racmImage() {
      if (!this.registeredInRACM) return undefined;
      return this.$store.state.compute.racmImages[this.imageId];
    },
    computeImage: function computeImage() {
      if (!this.imageId) return undefined;
      return this.$store.state.compute.computeImages[this.computeImageId];
    },
    classForConsistency: function classForConsistency() {
      return {
        'alert-danger': !(this.racmImage && this.computeImage),
        'alert-success': this.racmImage && this.computeImage && this.consistentMetadata,
        'alert-warning': this.racmImage && this.computeImage && !this.consistentMetadata
      };
    },
    consistentMetadata: function consistentMetadata() {
      if (this.computeImage === undefined || this.racmImage === undefined) return false;
      return this.computeImage.name === this.racmImage.name && this.computeImage.description === this.racmImage.description && this.isGrantedToAdmin;
    },
    isGrantedToAdmin: function isGrantedToAdmin() {
      var _this = this;

      if (!this.myCollaborations || !this.registeredInRACM) return undefined;
      var adminGroup = this.myCollaborations.map(function (x) {
        return _this.collaborations[x];
      }).find(function (x) {
        return x.name === 'admin' && x.type === 'GROUP';
      });
      if (!adminGroup) return undefined;
      var thisImage = __WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(adminGroup.resources, { entityId: this.imageId, type: 'DOCKERIMAGE' });
      return thisImage ? thisImage.actions.includes('grant') : false;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["d" /* mapState */])(['collaborations', 'myCollaborations'])),
  filters: {
    abbrivExecutationManager: function abbrivExecutationManager(value) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_startCase___default()(value.split(/\./).pop());
    }
  }
});

/***/ }),

/***/ "w0ot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w3np":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Mark these root volumes as being accessible to users in this domain.")]),_vm._v(" "),_c('p',{staticClass:"text-warning"},[_vm._v("These root volumes must be mounted in the docker nodes to be mountable in Compute containers.")]),_vm._v(" "),_vm._l((_vm.myRootVolumeObjects),function(rootVolume,index){return _c('div',{key:index,staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rootVolumesOnCD),expression:"rootVolumesOnCD"}],attrs:{"type":"checkbox"},domProps:{"value":rootVolume,"checked":Array.isArray(_vm.rootVolumesOnCD)?_vm._i(_vm.rootVolumesOnCD,rootVolume)>-1:(_vm.rootVolumesOnCD)},on:{"change":function($event){var $$a=_vm.rootVolumesOnCD,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=rootVolume,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rootVolumesOnCD=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rootVolumesOnCD=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rootVolumesOnCD=$$c}}}}),_vm._v("\n      "+_vm._s(rootVolume.name)+" Root Volume"),_c('br'),_vm._v(" "),_c('small',[_vm._v("Hosted on \""+_vm._s(rootVolume.fileserviceObj.name)+"\"")]),_c('br'),_vm._v(" "),(_vm.rootVolumesOnCD.includes(rootVolume))?[_vm._v("\n        Where is this root volume mounted on the compute node?\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rootVolumePathOnCDs[rootVolume.id]),expression:"rootVolumePathOnCDs[rootVolume.id]"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"/srv/path/"},domProps:{"value":(_vm.rootVolumePathOnCDs[rootVolume.id])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rootVolumePathOnCDs, rootVolume.id, $event.target.value)}}})]:_vm._e()],2)])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wKU1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wW7X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"title":"Delete Dialog"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_c('p',[_vm._v("Are you sure you want to delete "+_vm._s(_vm.numFiles)+" files?")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.deleteItem}},[_vm._v("Yes")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){_vm.open = false}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfbM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'changePassword',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vue_focus__["mixin"]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    signOutLink: function signOutLink() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/logout?callbackUrl=' + window.location.href;
    },
    pass1EqualPass2: function pass1EqualPass2() {
      return this.password1 === this.password2;
    },
    blankPassField: function blankPassField() {
      return this.password1 === '' || this.password2 === '';
    },
    resetPassword: function resetPassword() {
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/change-password';
    },
    validPassword: function validPassword() {
      var re = new RegExp('.{8,}');
      return re.test(this.password1);
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isAdmin']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['userProfile', 'token'])),
  data: function data() {
    return {
      password1: '',
      password2: '',
      showPass: false,
      changePassLink: "https://www.sciserver.org/support/how-to-use-sciserver/#change",
      open: false,
      focused: false
    };
  },
  methods: {
    startDialog: function startDialog() {
      this.password1 = '';
      this.password2 = '';
      this.showPass = false;
      this.focused = true;
      this.open = true;
    },
    changePassword: function changePassword() {
      var config = { headers: { 'X-Auth-Token': this.$store.state.token, 'Content-Type': 'application/json', Accept: '*/*' } };
      var url = "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + 'api/password';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, { password: this.password2 }, config).then(this.redirect, this.error);
    },
    redirect: function redirect() {
      this.clearAll();
      alert('Your password has been updated successfully. You will be redirected to log in page.');
      window.location.replace(this.signOutLink);
    },
    clearAll: function clearAll() {
      this.password1 = '';
      this.password2 = '';
      this.open = false;
    },
    showHidePass: function showHidePass() {
      var x = document.getElementById('changePass1');
      var y = document.getElementById('changePass2');
      if (x.type === 'password') {
        x.type = 'text';
      } else {
        x.type = 'password';
      }
      if (y.type === 'password') {
        y.type = 'text';
      } else {
        y.type = 'password';
      }
    }
  }
});

/***/ }),

/***/ "whIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNotifications_vue__ = __webpack_require__("brZR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de87b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNotifications_vue__ = __webpack_require__("LvGO");
function injectStyle (ssrContext) {
  __webpack_require__("3H4Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-28de87b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideNotifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de87b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideNotifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wn4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"my-sciserver-modal-dialog",attrs:{"size":"sm"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(" Change Password\n        "),_c('a',{staticClass:"contextualHints",staticStyle:{"text-decoration":"none"},attrs:{"rel":"noopener","target":"_blank","href":_vm.changePassLink,"title":"More Info on Groups"}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("More Info on Groups")])])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-group"},[_vm._v("\n             New Password\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password1),expression:"password1"},{name:"focus",rawName:"v-focus",value:(_vm.focused),expression:"focused"}],staticClass:"form-control",attrs:{"name":"changePass1","type":"password","id":"changePass1"},domProps:{"value":(_vm.password1)},on:{"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"input":function($event){if($event.target.composing){ return; }_vm.password1=$event.target.value}}}),_vm._v("\n              Confirm New Password\n              "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password2),expression:"password2"}],staticClass:"form-control",attrs:{"name":"changePass2","type":"password","id":"changePass2"},domProps:{"value":(_vm.password2)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changePassword($event)},"input":function($event){if($event.target.composing){ return; }_vm.password2=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showPass),expression:"showPass"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showPass)?_vm._i(_vm.showPass,null)>-1:(_vm.showPass)},on:{"click":_vm.showHidePass,"change":function($event){var $$a=_vm.showPass,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showPass=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showPass=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showPass=$$c}}}}),(_vm.showPass)?_c('span',[_vm._v("Hide")]):_vm._e(),_vm._v(" "),(!_vm.showPass)?_c('span',[_vm._v("Show")]):_vm._e(),_vm._v(" Password\n             "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pass1EqualPass2),expression:"!pass1EqualPass2"}]},[_vm._v("**Password must match")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.validPassword),expression:"!validPassword"}]},[_vm._v("Your password must be a minimum of 8 characters long.")])])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal","disabled":!_vm.pass1EqualPass2 || _vm.blankPassField || !_vm.validPassword},on:{"click":_vm.changePassword}},[_vm._v("Update Password")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.clearAll}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wzQC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"title":"Main Directory","href":"#"},on:{"click":_vm.resetPath}},[_c('i',{staticClass:"fa fa-home fa-2x",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(_vm.currentUserVolume && _vm.currentUserVolume.type === 'uservolumes')?[_c('li',[_vm._v(_vm._s(_vm.currentUserVolume.rootVolumeObj.name))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.currentUserVolume.owner))]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.changeUV(_vm.currentUserVolume.id)}}},[_vm._v(_vm._s(_vm.currentUserVolume.name))])])]:_vm._e(),_vm._v(" "),(_vm.currentUserVolume && _vm.currentUserVolume.type === 'datavolumes')?[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.changeUV(_vm.currentUserVolume.id)}}},[_vm._v(_vm._s(_vm.currentUserVolume.name))])])]:_vm._e(),_vm._v(" "),(_vm.path)?_vm._l((_vm.path.split('/').filter(function (x) { return x; })),function(pathSegment,index){return _c('li',{key:index},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.showFiles(index + 1)}}},[_vm._v(_vm._s(pathSegment))])])}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x+a0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove_token_from_url__ = __webpack_require__("/8ks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jobs__ = __webpack_require__("TF2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__applicationConfiguration__ = __webpack_require__("uYv6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notebook_RecentNotebookList__ = __webpack_require__("Nj2m");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var $ = __webpack_require__("7t+N");
var _ = __webpack_require__("M4fF");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SciserverTab',
    mixins: [__WEBPACK_IMPORTED_MODULE_7__applicationConfiguration__["a" /* default */]],
    components: {
        RecentNotebookList: __WEBPACK_IMPORTED_MODULE_8__notebook_RecentNotebookList__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        appCSS: function appCSS() {
            var numRows = 2;
            var nApps = _.size(this.appTiles);
            if (nApps === 3) {
                numRows = 4;
            } else if (nApps === 6) {
                numRows = 2;
            } else if (nApps === 4) {
                numRows = 3;
            }
            return 'col-md-' + numRows + ' col-sm-12 col-xs-12 hero-feature';
        },
        tabclass: function tabclass() {
            if (this.getScienceDomainLoadStatus || !this.showApplicationAppRow) {
                return 'col-md-3 col-sm-6 col-xs-12 hero-feature';
            }
            return 'col-md-4 col-sm-6 col-xs-12 hero-feature';
        },
        sortedCollaborationIds: function sortedCollaborationIds() {
            var _this = this;

            return this.myCollaborations
            /* Only show groups. */
            .filter(function (id) {
                return _this.collaborations[id].type === 'GROUP';
            });
        },
        totalGroups: function totalGroups() {
            return this.getGroupIds.length;
        },
        invitedGroups: function invitedGroups() {
            var _this2 = this;

            return this.getGroupIds.filter(function (g) {
                return _this2.getStatusIn(g) === 'INVITED';
            }).length;
        },
        adminGroups: function adminGroups() {
            var _this3 = this;

            return this.getGroupIds.filter(function (g) {
                return _this3.getRoleIn(g) === 'ADMIN' && _this3.getStatusIn(g) === 'ACCEPTED';
            }).length;
        },
        ownerGroups: function ownerGroups() {
            var _this4 = this;

            return this.getGroupIds.filter(function (g) {
                return _this4.getRoleIn(g) === 'OWNER';
            }).length;
        },
        getSharedVolumes: function getSharedVolumes() {
            var _ref,
                _this5 = this;

            return (_ref = []).concat.apply(_ref, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myUserVolumeObjects)).filter(function (uv) {
                return uv.owner !== _this5.$store.state.userProfile.username;
            }).length;
        },
        getOwnedVolumes: function getOwnedVolumes() {
            var _ref2,
                _this6 = this;

            return (_ref2 = []).concat.apply(_ref2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.myUserVolumeObjects)).filter(function (uv) {
                return uv.owner === _this6.$store.state.userProfile.username;
            }).length;
        },
        jobs: function jobs() {
            return this.$store.state.jobs.jobs;
        },
        runningJobs: function runningJobs() {
            return __WEBPACK_IMPORTED_MODULE_6__jobs__["a" /* default */].runningJobs(this.jobs);
        },
        completedJobs: function completedJobs() {
            return __WEBPACK_IMPORTED_MODULE_6__jobs__["a" /* default */].completedJobs(this.jobs);
        },
        loggedIn: function loggedIn() {
            return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(this.$store.state.userActivities, function (l) {
                return l.task_name === 'LoginPortal.LogIn';
            });
        },
        loggedInTime: function loggedInTime() {
            var _this7 = this;

            if (this.loggedIn) {
                $.each(this.loggedIn, function (index0, text0) {
                    if (_this7.time === '' && text0.time) {
                        _this7.time = text0.time;
                    } else if (_this7.time < text0.time && text0.time) {
                        _this7.time = text0.time;
                    }
                });
            }
            return __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.time).format('DD MMM YYYY hh:mm:ss a');
        },
        scienceGroups: function scienceGroups() {
            return this.$store.state.science.scienceDomains;
        },
        numScienceGroups: function numScienceGroups() {
            return this.$store.state.science.scienceDomains.length;
        },
        isDisplayFilesTab: function isDisplayFilesTab() {
            return this.$store.state.files.hasFileService;
        },
        isNotebookFirstAlphaGroupMember: function isNotebookFirstAlphaGroupMember() {
            var _this8 = this;

            return _.find(this.getGroupIds, function (g) {
                return _.get(_this8.getCollaborationById(g), 'name') === '__SciserverNotebookFirstDemo__';
            }) !== undefined;
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapState */])(['myCollaborations', 'token', 'collaborationLoadingStatus', 'userProfile', 'collaborations', 'users', 'userActivities']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getCollaborationById', 'getGroupIds', 'getRoleIn', 'getStatusIn', 'myUserVolumeObjects', 'getScienceDomainLoadStatus', 'getTotalScienceDomains', 'getJoinedScienceDomains'])),
    data: function data() {
        return {
            totalUserVolumes: 0,
            time: ''
        };
    },
    updated: function updated() {
        this.assignCSS();
    },
    created: function created() {
        this.getTotalGroup();
        this.getActivity();
        this.getJobs();
        this.getScienceGroup();
        this.assignCSS();
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(__WEBPACK_IMPORTED_MODULE_5__remove_token_from_url__["a" /* default */]);
    },

    methods: {
        getTotalGroup: function getTotalGroup() {
            this.$store.dispatch('loadCollaborations');
        },
        getActivity: function getActivity() {
            this.$store.dispatch('loadUserActivities');
        },
        getJobs: function getJobs() {
            this.$store.dispatch('loadJobs');
        },
        getScienceGroup: function getScienceGroup() {
            this.$store.dispatch('loadScienceDomains', this.userProfile);
        }
    }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__ = __webpack_require__("sHmK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_drawer__ = __webpack_require__("MqxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_simple_drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userSettingsComponents_changePassword__ = __webpack_require__("KOqt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_userSettingsComponents_profileDialog__ = __webpack_require__("Qvo6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_userSettingsComponents_supportDialog__ = __webpack_require__("iPDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_files_tab_LoadingStatus__ = __webpack_require__("+W60");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_files_tab_Notifications__ = __webpack_require__("IIeo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_files_tab_SideNotifications__ = __webpack_require__("whIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__applicationConfiguration__ = __webpack_require__("uYv6");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var jQuery = __webpack_require__("7t+N");

window.$ = jQuery;
window.jQuery = jQuery;

__webpack_require__("FNwM");
__webpack_require__("BA3h");
__webpack_require__("8xBt");
__webpack_require__("bPCs");
__webpack_require__("aLt0");
__webpack_require__("dIAs");
__webpack_require__("gNGx");
__webpack_require__("A+g3");
__webpack_require__("PS+N");
__webpack_require__("i1NX");
__webpack_require__("GvmV");
__webpack_require__("EBpa");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mixins: [__WEBPACK_IMPORTED_MODULE_10__applicationConfiguration__["a" /* default */]],
  updated: function updated() {
    this.assignCSS();
  },
  created: function created() {
    this.assignCSS();
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isDisplayFilesTab: function isDisplayFilesTab() {
      return this.$store.state.files.hasFileService;
    },
    nameIcon: function nameIcon() {
      return 'sorted';
    },
    isLoggedIn: function isLoggedIn() {
      return this.token !== undefined;
    },
    signOutLink: function signOutLink() {
      var href = this.$router.resolve({ route: this.$route }).href;
      var callback = '' + window.location.origin + href;
      return "https://sciserver.sdcc.bnl.gov/sciserver/login-portal/" + '/logout?callbackUrl=' + callback;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isAdmin', 'getNumOfNotifications', 'getScienceDomainLoadStatus']), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])(['userProfile', 'token', 'numOfNotifications'])),
  components: {
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_burger_menu__["Slide"],
    Drawer: __WEBPACK_IMPORTED_MODULE_3_vue_simple_drawer___default.a,
    LoadingStatus: __WEBPACK_IMPORTED_MODULE_7__components_files_tab_LoadingStatus__["a" /* default */],
    changePassword: __WEBPACK_IMPORTED_MODULE_4__components_userSettingsComponents_changePassword__["a" /* default */],
    profileDialog: __WEBPACK_IMPORTED_MODULE_5__components_userSettingsComponents_profileDialog__["a" /* default */],
    supportDialog: __WEBPACK_IMPORTED_MODULE_6__components_userSettingsComponents_supportDialog__["a" /* default */],
    NotificationTab: __WEBPACK_IMPORTED_MODULE_8__components_files_tab_Notifications__["a" /* default */],
    SideNotification: __WEBPACK_IMPORTED_MODULE_9__components_files_tab_SideNotifications__["a" /* default */]
  },
  data: function data() {
    return {
      open: false
    };
  },
  methods: {
    toggle: function toggle() {
      this.open = !this.open;
    },
    openNav: function openNav() {
      jQuery('#mySidebar').style.width = '250px';
      jQuery('#app').style.width = '250px';
    },
    closeNav: function closeNav() {
      jQuery('#mySidebar').style.width = '0';
      jQuery('#app').style.width = '0';
    },
    openProfile: function openProfile() {
      this.$refs.profileDialog.startDialog();
    },
    openSupport: function openSupport() {
      this.$refs.supportDialog.startDialog();
    },
    changePassword: function changePassword() {
      this.$refs.changePassword.startDialog();
    }
  }
});

/***/ }),

/***/ "xavP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xtG+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumeConfigurer_vue__ = __webpack_require__("QJBd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7d4168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumeConfigurer_vue__ = __webpack_require__("Vr67");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VolumeConfigurer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7d4168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VolumeConfigurer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y2th":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_domain_wizard_ImageConfigurer__ = __webpack_require__("3h7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_domain_wizard_ImageSaver__ = __webpack_require__("ziXL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RegisterImage',
  components: {
    ImageConfigurer: __WEBPACK_IMPORTED_MODULE_1__new_domain_wizard_ImageConfigurer__["a" /* default */],
    ImageSaver: __WEBPACK_IMPORTED_MODULE_2__new_domain_wizard_ImageSaver__["a" /* default */]
  },
  data: function data() {
    return {
      open: false,
      loaded: false,
      imageModel: {},
      isSaving: false
    };
  },
  props: ['racmDomainId', 'computeDomainId'],
  methods: {
    saveImage: function saveImage(newImage) {
      this.imageModel = newImage;
      this.isSaving = true;
      var vm = this;

      // Need to run this after imageSaver has a chance to be
      // mounted after changing isSaving
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
        return vm.$refs.imageSaver.saveImage().then(function () {
          vm.$emit('on-save');
          vm.open = false;
          vm.isSaving = false;
          vm.imageModel = {};
          vm.loaded = false;
        });
      });
    },
    closeDialog: function closeDialog() {
      this.open = false;
      this.loaded = false;
    },
    openDialog: function openDialog() {
      this.open = true;
      this.loaded = true;
    }
  }
});

/***/ }),

/***/ "yBuX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"notebookApp",attrs:{"id":"NotebookTab"}},[_c('div',{attrs:{"id":"notebookSideBar"}},[_c('div',{staticClass:"sidebaritem sidebarheader"},[_c('router-link',{attrs:{"to":"/notebook"}},[_c('span',{staticClass:"headertitle"},[_vm._v(" Notebooks ")])]),_vm._v(" "),_c('span',{staticClass:"headerrel"},[_vm._v(" ALPHA ")]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"sidebaritem sidebartitle",class:{ nbwarning: _vm.isTempFile},attrs:{"id":"nbname","title":"click to rename/move notebook"},on:{"click":_vm.openMoveDialog}},[_c('span',{staticStyle:{"visibility":"hidden"}},[_vm._v("X")]),_vm._v(" "),(_vm.isTempFile)?_c('span',{staticClass:"glyphicon glyphicon-warning-sign",attrs:{"title":"this looks like a temporary notebook (in scratch volume or has default name), consider renaming/moving!"}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.notebookName)+"\n    ")]),_vm._v(" "),(_vm.notebookContents)?_c('div',[_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"btn-group btn-group-justified"},[_c('router-link',{staticStyle:{"color":"#333333"},attrs:{"to":((_vm.$route.path) + "?copy=true&empty=true"),"target":"_blank"}},[_c('button',{staticClass:"btn btn-default",staticStyle:{"margin-right":"1px"},attrs:{"title":"create new notebook in new tab"}},[_vm._v("\n              new "),_c('span',{staticClass:"glyphicon glyphicon-open-file"})])]),_vm._v(" "),_c('router-link',{staticStyle:{"color":"black"},attrs:{"to":((_vm.$route.path) + "?copy=true"),"target":"_blank"}},[_c('button',{staticClass:"btn btn-default",staticStyle:{"margin-right":"1px"},attrs:{"title":"copy this notebook and open in new tab"}},[_vm._v("\n              copy "),_c('span',{staticClass:"glyphicon glyphicon-duplicate"})])]),_vm._v(" "),_c('a',{staticStyle:{"color":"black"},attrs:{"href":"#"}},[_c('button',{staticClass:"btn btn-default",attrs:{"title":"get a live shareable link. Note the user must have at least read access to the containing volume"},on:{"click":function($event){_vm.getLink()}}},[_vm._v("\n              link "),_c('span',{staticClass:"glyphicon glyphicon-share"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"sidebaritem sidebarsection"},[_vm._v(" notebook information ")]),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle"},[_vm._v("path")]),_vm._v(" "+_vm._s(_vm.notebookDir)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle"},[_vm._v("edit mode")]),_vm._v(" "),(_vm.readOnlyMode)?_c('span',{staticStyle:{"color":"red","font-weight":"bold"}},[_vm._v(" Read Only ")]):_vm._e(),_vm._v(" "),(!_vm.readOnlyMode)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Read Write ")]):_vm._e(),_vm._v(" "),(_vm.ready && !_vm.writable)?_c('span',{staticStyle:{"color":"#888888"}},[_vm._v(" (no write-permission) ")]):_vm._e(),_vm._v(" "),(_vm.writable)?_c('span',{staticStyle:{"float":"right","margin-right":"8px","cursor":"pointer"},attrs:{"title":"toggle read mode"},on:{"click":_vm.toggleReadMode}},[_c('span',{staticClass:"glyphicon",class:[ _vm.readOnlyMode ? 'glyphicon-floppy-saved' : 'glyphicon-floppy-remove' ]})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sidebaritem sidebarsection"},[_vm._v(" compute environment ")]),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle"},[_vm._v(" domain ")]),_vm._v(" "+_vm._s(_vm.computeDomainName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle",attrs:{"title":"this is a test"}},[_vm._v(" image name ")]),_vm._v(" "+_vm._s(_vm.computeImageName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle"},[_vm._v(" user volumes ")]),_vm._v(" "),_vm._l((_vm.computeUserVolumes),function(uservol){return _c('div',[_vm._v("\n          -\n          "),_c('router-link',{attrs:{"to":("/files/uservolumes/" + (uservol.id)),"target":"_blank","title":"browse user volume in new tab"}},[_vm._v(" "+_vm._s(uservol.name)+" ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"20px"}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-copy",staticStyle:{"cursor":"pointer","float":"right","margin-right":"8px"},attrs:{"aria-hidden":"true","title":("copy " + (uservol.name) + " path to clipboard")},on:{"click":function($event){_vm.toClipboard(("/home/idies/workspace/" + (uservol.rootVolumeName) + "/" + (uservol.owner) + "/" + (uservol.name)))}}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('div',{staticClass:"sidebaritemtitle"},[_vm._v(" data volumes ")]),_vm._v(" "),_vm._l((_vm.computeDataVolumes),function(datavol){return _c('div',[_vm._v("\n          -\n          "),_c('router-link',{attrs:{"to":("/files/datavolumes/" + (_vm.computeDVtoFSId(datavol))),"target":"_blank","title":"browse data volume in new tab"}},[_vm._v(" "+_vm._s(datavol.name)+" ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-left":"20px"}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-copy",staticStyle:{"cursor":"pointer","float":"right","margin-right":"8px"},attrs:{"aria-hidden":"true","title":("copy " + (datavol.name) + " path to clipboard")},on:{"click":function($event){_vm.toClipboard(("/home/idies/workspace/" + (datavol.name)))}}})],1)})],2),_vm._v(" "),_c('div',{staticClass:"sidebaritem"},[_c('button',{staticClass:"btn btn-default",on:{"click":_vm.openImageChooser}},[_vm._v(" modify compute environment "),_c('span',{staticClass:"glyphicon glyphicon-tasks"})])]),_vm._v(" "),_c('div',{staticClass:"sidebaritem sidebarsection"})]):_vm._e(),_vm._v(" "),(_vm.ready)?_c('div',{staticClass:"sidebaritem"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.showTerminal = _vm.showTerminal ? false: true}}},[_vm._v("show terminal")]),_vm._v(" "),(_vm.isAdmin)?_c('a',{staticClass:"btn btn-default",attrs:{"href":_vm.computeNotebookUrl}},[_vm._v(" break out ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"id":"displayWrapper"}},[_c('div',{attrs:{"id":"terminalFrameWrapper"}},[_c('terminal',{ref:"terminal",attrs:{"computeId":_vm.computeId}})],1),_vm._v(" "),_c('div',{class:{shortened: _vm.showTerminal, nbwarning: _vm.warning},attrs:{"id":"notebookFrameWrapper"}},[_c('iframe',{ref:"notebookFrame",attrs:{"id":"notebookFrame","src":_vm.computeNotebookUrl},on:{"load":_vm.notebookLoad}})]),_vm._v(" "),(_vm.warning)?_c('div',{attrs:{"id":"warningBox"}},[_vm._v(_vm._s(_vm.warning))]):_vm._e(),_vm._v(" "),(!_vm.ready)?_c('div',{staticClass:"full-overlay",attrs:{"id":"notebookLoadingCurtain"}},[_c('div',{attrs:{"id":"loadingInfo"}},[(!_vm.ready && !_vm.error)?_c('img',{attrs:{"src":__webpack_require__("FbNc")}}):_vm._e(),_vm._v(" "),(_vm.loadMessage)?_c('div',{staticStyle:{"padding-top":"20px"}},[_vm._v(" "+_vm._s(_vm.loadMessage))]):_vm._e(),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"glyphicon glyphicon-warning-sign",staticStyle:{"font-size":"60px","margin":"auto","color":"#337ab7"}}):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticStyle:{"padding-top":"20px"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('recent-notebook-list',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"recentNotebookList",attrs:{"disabled":true}}),_vm._v(" "),_c('compute-domain-chooser',{ref:"imageChooser",attrs:{"currentImageInfo":_vm.imageInfo},on:{"imageInfoModified":_vm.imageInfoModified}}),_vm._v(" "),_c('rename-move-dialog',{ref:"moveDialog",attrs:{"currentVolume":_vm.sourceVolume,"currentPath":_vm.$route.params.path,"validVolumes":_vm.mountedVolumes,"autoExtension":'.ipynb'},on:{"renamed":_vm.moveNotebook}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"padding-left":"10px","color":"silver"},attrs:{"href":"#"}},[_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"title":"Limited availability. Sorry, no documentation yet, but please report issues!"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySHw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar navbar-default",staticStyle:{"margin-bottom":"0px","border-radius":"0px"},attrs:{"role":"navigation"}},[_c('div',{staticClass:"navbar-header"},[_c('span',{staticClass:"navbar-brand"},[_c('a',{attrs:{"href":_vm.applicationHomeUrl,"title":'Go to ' + _vm.applicationName,"rel":"noopener","target":"_blank"}},[_c('img',{staticStyle:{"max-height":"32px","margin-top":"-6px"},attrs:{"alt":_vm.applicationName + ' logo',"src":__webpack_require__("Zcb4")}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"page-navbar"}},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',[_c('router-link',{attrs:{"to":"/","title":"Home tab"}},[_vm._v("Home")])],1),_vm._v(" "),(_vm.isDisplayFilesTab)?_c('li',[_c('router-link',{attrs:{"to":"/files","title":"Files tab"}},[_vm._v("Files")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/groups","title":"Groups tab"}},[_vm._v("Groups")])],1),_vm._v(" "),(_vm.getScienceDomainLoadStatus)?_c('li',[_c('router-link',{attrs:{"to":"/science","title":"Science Domains"}},[_vm._v("Science Domains")])],1):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('li',{staticClass:"dropdown"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/admin/compute"}},[_vm._v("Compute")])],1)])]):_vm._e(),_vm._v(" "),_c('li',[(_vm.isAdmin)?_c('router-link',{attrs:{"to":"/resource","title":"Resources tab"}},[_vm._v("Resources")]):_vm._e()],1)]),_vm._v(" "),_c('notifications',{staticStyle:{"margin-top":"6px"},attrs:{"position":"top center","group":"top_center_notify","width":"200"}}),_vm._v(" "),(_vm.isLoggedIn)?_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","title":"User Profile DropDown","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n            "+_vm._s(_vm.userProfile.username)+"\n            "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#","title":"View Profile"},on:{"click":_vm.openProfile}},[_vm._v("My Account")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Help"},on:{"click":_vm.openSupport}},[_vm._v("Help")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#","title":"Change your password"},on:{"click":_vm.changePassword}},[_vm._v("Change Password")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.signOutLink,"title":"Sign Out"}},[_vm._v("Sign Out")])])])])]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":"/activity_log","title":"Activity Log"}},[_c('span',{staticClass:"fa fa-history fa-lg",attrs:{"aria-hidden":"true"}})])],1)]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',{staticClass:"dropdown"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",attrs:{"id":"sciserverLinks"}},[_c('li',{staticClass:"text-left"},[_c('router-link',{attrs:{"to":"/","title":"Home tab"}},[_c('div',{staticClass:"alert alert-primary",attrs:{"role":"alert"}},[_c('img',{staticStyle:{"max-height":"32px","margin-top":"-6px","margin-right":"10px"},attrs:{"alt":"SciServer logo","src":__webpack_require__("WCQg")}}),_vm._v(" Home\n                ")])])],1),_vm._v(" "),_vm._l((_vm.appTiles),function(app){return _c('li',{staticClass:"text-left"},[_c('a',{attrs:{"href":app.serviceUrl,"rel":"noopener","title":("Go to " + (app.name)),"target":"_blank"}},[_c('div',{staticClass:"alert alert-primary",attrs:{"role":"alert"}},[('iconUrl' in app)?_c('img',{staticStyle:{"max-height":"32px","margin-top":"-6px","margin-right":"10px"},attrs:{"alt":app.name,"src":app.iconUrl}}):('staticIcon' in app)?_c('img',{staticStyle:{"max-height":"32px","margin-top":"-6px","margin-right":"10px"},attrs:{"alt":app.name,"src":_vm.staticImages[app.staticIcon]}}):_c('span',{class:app.glyph || 'fa fa-asterisk fa-3x',staticStyle:{"color":"black","vertical-align":"middle"}}),_vm._v("\n                  "+_vm._s(app.name)+"\n                ")])])])})],2)])]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right",staticStyle:{"padding-right":"15px"}},[_c('notification-tab')],1)],1)]),_vm._v(" "),_c('change-password',{ref:"changePassword"}),_vm._v(" "),_c('profile-dialog',{ref:"profileDialog"}),_vm._v(" "),_c('support-dialog',{ref:"supportDialog"}),_vm._v(" "),_c('main',[(_vm.alertMessage)?_c('div',{class:_vm.alertClasses},[_vm._v("\n      "+_vm._s(_vm.alertMessage)+"\n    ")]):_vm._e(),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('span',[_vm._v(" "+_vm._s(_vm.applicationName)+" – "+_vm._s(_vm.sciserver_Version)+" "),_c('i',{staticClass:"text-muted"},[_vm._v("Dashboard - "+_vm._s(_vm.version)+" ")])]),_vm._v(" "),_vm._m(3)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle collapsed",attrs:{"type":"button","data-toggle":"collapse","data-target":"#page-navbar","aria-expanded":"false"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle Navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("Admin "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false","title":"SciServer Apps"}},[_c('span',{staticClass:"fa fa-th fa-lg",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logo-holder"},[_c('span',[_vm._v(" Powered by: ")]),_vm._v(" "),_c('a',{staticClass:"logo",attrs:{"href":"https://www.nsf.gov","rel":"noopener","title":"Go to National Science Foundation Website","target":"_blank"}},[_c('img',{staticStyle:{"max-height":"50px"},attrs:{"src":__webpack_require__("cVVO"),"alt":"National Science Foundation"}})]),_vm._v(" "),_c('a',{staticClass:"logo",attrs:{"href":"http://idies.jhu.edu","rel":"noopener","title":"Go to IDIES Website","target":"_blank"}},[_c('img',{staticStyle:{"max-height":"24px"},attrs:{"src":__webpack_require__("tYzz"),"alt":"IDIES"}})]),_vm._v(" "),_c('a',{staticClass:"logo",attrs:{"href":"https://jhu.edu","rel":"noopener","title":"Go to Johns Hopkins University Website","target":"_blank"}},[_c('img',{staticStyle:{"max-height":"32px"},attrs:{"src":__webpack_require__("gda6"),"alt":"Johns Hopkins University"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ylhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserVolumesStep',
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vuelidate__["validationMixin"]],
  data: function data() {
    return {
      rootVolumesOnCD: [],
      rootVolumePathOnCDs: {}
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['myRootVolumeObjects'])),
  validations: {
    rootVolumesOnCD: {},
    rootVolumePathOnCDs: {},
    form: ['rootVolumesOnCD', 'rootVolumePathOnCDs']
  },
  methods: {
    validate: function validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    }
  }
});

/***/ }),

/***/ "z+KZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDomainWizard_vue__ = __webpack_require__("dl6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1638369a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDomainWizard_vue__ = __webpack_require__("E9NE");
function injectStyle (ssrContext) {
  __webpack_require__("N+sN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1638369a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewDomainWizard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1638369a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewDomainWizard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z/ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NodeConfigurer',
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vuelidate__["validationMixin"]],
  props: {
    isEditing: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    if (this.initialData) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.initialData);
    }
    return {
      name: '',
      dockerApiUrl: '',
      proxyBaseUrl: '',
      proxyApiUrl: '',
      clientKey: '',
      clientCert: ''
    };
  },

  computed: {
    submitButtonMessage: function submitButtonMessage() {
      if (this.isEditing) {
        return 'Save Changes';
      }
      return 'Add Node';
    }
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    dockerApiUrl: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    proxyApiUrl: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    proxyBaseUrl: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    clientKey: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    clientCert: {
      required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
    },
    form: ['name', 'dockerApiUrl', 'proxyApiUrl', 'proxyBaseUrl', 'clientKey', 'clientCert']
  },
  methods: {
    attemptSave: function attemptSave() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      if (isValid) {
        this.$emit('on-save', this.$data);
      }
    }
  }
});

/***/ }),

/***/ "zBdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciserverTab_vue__ = __webpack_require__("x+a0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85b6d482_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciserverTab_vue__ = __webpack_require__("2ZeT");
function injectStyle (ssrContext) {
  __webpack_require__("/WPw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85b6d482"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciserverTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85b6d482_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciserverTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zCUr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/casjobs.ba408d1.png";

/***/ }),

/***/ "zMFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus__ = __webpack_require__("2jId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_focus__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_vue_focus__["mixin"]],
  props: ['buttonClasses'],
  data: function data() {
    return {
      open: false,
      name: '',
      description: '',
      focused: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isValid: function isValid() {
      return this.name;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])(['userProfile', 'token', 'collaborationLinks', 'publicGroups']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getGroupById'])),
  methods: {
    newGroup: function newGroup() {
      this.focused = true;
      this.open = true;
      this.name = '';
      this.description = '';
    },
    saveNewGroup: function saveNewGroup() {
      var _this = this;

      var group = {
        groupName: this.name,
        description: this.description,
        memberUsers: []
      };
      if (this.isDuplicateGroupName(group)) {
        alert('\'' + group.groupName + '\' name already exists. Pick another group name.');
      } else {
        this.open = false;
        var config = { headers: { 'X-Auth-Token': this.token } };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.collaborationLinks.createGroup.href, group, config).then(function () {
          _this.$store.dispatch('loadCollaborations').then(function () {
            // https://forum.vuejs.org/t/accessing-vuex-store-after-dispatch/14686/2
            _this.$emit('selectNewGroup', _this.name);
            __WEBPACK_IMPORTED_MODULE_2_vue__["default"].notify({
              group: 'top_center_notify',
              text: 'Successfully created ' + group.groupName + '!',
              duration: 1000,
              type: 'success'
            });
          });
        }, function (error) {
          alert('Error Message: ' + error.response.data.error);
        });
      }
    },
    isDuplicateGroupName: function isDuplicateGroupName(group) {
      var exists = false;
      var found = this.publicGroups.map(this.getGroupById).find(function (g) {
        return g.groupName.toLowerCase() === group.groupName.toLowerCase();
      });
      if (found) {
        exists = true;
      } else {
        exists = false;
      }
      return exists;
    }
  },
  watch: {
    open: function open() {
      if (!this.open) {
        this.$emit('closedModal', '');
      }
    }
  }
});

/***/ }),

/***/ "ziXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSaver_vue__ = __webpack_require__("kTU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f9ce85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSaver_vue__ = __webpack_require__("td1C");
function injectStyle (ssrContext) {
  __webpack_require__("3eRL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19f9ce85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageSaver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19f9ce85_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageSaver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "znjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},_vm._l((_vm.rootVolumeOnComputeDomainIds),function(volume){return _c('compute-root-volume',{key:volume,attrs:{"root-volume-on-compute-domain-id":volume}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.1d1a2226141a4f31bf57.js